export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	bulbasaur: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			block: ["5S3"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["6L27", "5L27", "4L27", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["6E", "5E", "4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["5S3"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["5S3"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6E", "5T", "5E", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			grasswhistle: ["6E", "5E", "4E", "3E"],
			grassyterrain: ["6E"],
			growl: ["6L3", "6S4", "6S5", "5L3", "5S2", "4L3", "3L4", "3S1"],
			growth: ["6L25", "5L25", "4L25", "3L32", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ingrain: ["6E", "5E", "4E"],
			knockoff: ["5T", "4T"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6L7", "6S4", "5L7", "5S2", "4L7", "3L7", "3S1"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			magicalleaf: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6E", "5E", "4E"],
			petaldance: ["6E", "5E", "4E", "3E"],
			poisonpowder: ["6L13", "6S4", "5L13", "4L13", "3L15"],
			powerwhip: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L19", "5L19", "4L19", "3L20"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6L37", "5T", "5L37", "4T", "4L37"],
			skullbash: ["6E", "5E", "4E", "3E"],
			sleeppowder: ["6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6E", "5E", "4E"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M", "3L46", "3S0"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L21", "5L21", "4L21", "3L25", "3S0"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L33", "5T", "5L33", "4T", "4L33", "3L39", "3S0"],
			tackle: ["6L1", "6S5", "5L1", "5S2", "4L1", "3L1", "3S1"],
			takedown: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L9", "6S4", "5L9", "5S2", "4L9", "3L10", "3S1"],
			weatherball: ["5S3"],
			worryseed: ["6L31", "5T", "5L31", "4T", "4L31"],
		},
	},
	ivysaur: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["6L31", "5L31", "4L31", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			growth: ["6L28", "5L28", "4L28", "3L38"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leechseed: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L15"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L20", "5L20", "4L20", "3L22"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeppowder: ["6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L44", "5M", "5L44", "4M", "4L44", "3M", "3L56"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L23", "5L23", "4L23", "3L29"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L39", "5T", "5L39", "4T", "4L39", "3L47"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L9", "5L9", "4L9", "3L10"],
			worryseed: ["6L36", "5T", "5L36", "4T", "4L36"],
		},
	},
	venusaur: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["6L31", "5L31", "4L31", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["6T", "6S0", "5T", "4T", "3T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "6S0", "5T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			growth: ["6L28", "5L28", "4L28", "3L41"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leechseed: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			outrage: ["5T", "4T"],
			petalblizzard: ["6L50"],
			petaldance: ["6L32", "5L32", "4L32"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L15"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L20", "5L20", "4L20", "3L22"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeppowder: ["6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L53", "6S0", "5M", "5L53", "4M", "4L53", "3M", "3L65"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L23", "5L23", "4L23", "3L29"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L45", "6S0", "5T", "5L45", "4T", "4L45", "3L53"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L1", "5L1", "4L1", "3L1"],
			worryseed: ["6L39", "5T", "5L39", "4T", "4L39"],
		},
	},
	charmander: {
		inherit: true,
		learnset: {
			acrobatics: ["5S6"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6E"],
			ancientpower: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "4E", "3E"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			bite: ["6E", "5E", "4E", "3E"],
			blastburn: ["5S6"],
			block: ["5S6"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T"],
			crunch: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E", "3E"],
			dragonpulse: ["6E", "5E"],
			dragonrage: ["6L16", "6S7", "5L16", "4L16", "3L43"],
			dragonrush: ["6E", "5E", "4E"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L7", "6S7", "5L7", "5S4", "4L7", "3L7", "3S0"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["5S6"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L25", "5L25", "4L25"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T", "4T", "3T"],
			firespin: ["6L43", "5L43", "4L37", "3L49"],
			flameburst: ["6L28", "5L28"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L37", "5M", "5L37", "4M", "4L34", "3M", "3L31"],
			flareblitz: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["6L1", "6S7", "6S8", "5L1", "5S4", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			honeclaws: ["6M", "5M"],
			howl: ["4S1", "4S2", "4S3", "4S5"],
			incinerate: ["6M", "5M"],
			inferno: ["6L46", "5L46"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["6E", "5E", "4E", "3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6E", "5T", "5E", "4E", "3E"],
			overheat: ["6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["4S1", "4S2", "4S3", "4S5"],
			rage: ["3L19"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L19", "5L19", "4L19", "3L25"],
			scratch: ["6L1", "6S8", "5L1", "5S4", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L34", "5L34", "4L28", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L10", "6S7", "5L10", "5S4", "4L10", "3L13"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	charmeleon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonrage: ["6L17", "5L17", "4L17", "3L48"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L28", "5L28", "4L28"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T", "4T", "3T"],
			firespin: ["6L50", "5L50", "4L43", "3L55"],
			flameburst: ["6L32", "5L32"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L43", "5M", "5L43", "4M", "4L39", "3M", "3L34"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L54", "5L54"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T"],
			overheat: ["6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["3L20"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L21", "5L21", "4L21", "3L27"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L39", "5L39", "4L32", "3L41"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L10", "5L10", "4L10", "3L13"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	charizard: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["6L1", "6S1", "6S2", "5L1", "4L1"],
			attract: ["6M", "5M", "4M", "3M"],
			blastburn: ["6T", "6S4", "5T", "4T", "3T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "6L1", "6S2", "5M", "5L1", "4M", "4L1", "3M"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L17", "6S2", "5L17", "4L17", "3L54", "3S0"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "6S5", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L28", "6S1", "6S2", "5L28", "4L28"],
			firepledge: ["6T", "6S4", "5T"],
			firepunch: ["5T", "4T", "3T"],
			firespin: ["6L56", "6S5", "5L56", "4L49", "3L64", "3S0"],
			flameburst: ["6L32", "6S1", "6S5", "5L32"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L47", "6S5", "5M", "5L47", "4M", "4L42", "3M", "3L34"],
			flareblitz: ["6L1", "6S4", "5L77", "4L66"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			focusblast: ["6M", "6S3", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6L1", "5T", "5L71", "4T", "4L59", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L62", "6S1", "5L62"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "6S3", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["3L20"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L21", "6S4", "5L21", "4L21", "3L27"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			skydrop: ["6M", "5M"],
			slash: ["6L41", "5L41", "4L32", "3L44", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6S3", "5M", "4M"],
			steelwing: ["6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			tailwind: ["5T", "4T"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			willowisp: ["6M", "5M", "4M"],
			wingattack: ["6L36", "5L36", "4L36", "3L36", "3S0"],
		},
	},
	squirtle: {
		inherit: true,
		learnset: {
			aquajet: ["6E", "5E", "4E"],
			aquaring: ["6E", "5E", "4E"],
			aquatail: ["6L28", "5T", "5L28", "4T", "4L28"],
			attract: ["6M", "5M", "4M", "3M"],
			aurasphere: ["6E"],
			bite: ["6L16", "5L16", "4L16", "3L18"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5S2"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["6E", "5E", "4M"],
			bubble: ["6L13", "6S3", "5L7", "5S1", "4L7", "3L7", "3S0"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["6E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E"],
			falseswipe: ["5S2"],
			flail: ["6E", "5E", "4E", "3E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["5S2"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydrocannon: ["5S2"],
			hydropump: ["6L40", "5L40", "4L37", "3L47"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L34", "5T", "5L34", "4T", "4L34"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "4E", "3E"],
			mist: ["6E", "5E", "4E", "3E"],
			muddywater: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L28"],
			raindance: ["6M", "6L37", "5M", "5L37", "4M", "4L34", "3M", "3L33"],
			rapidspin: ["6L19", "5L19", "4L19", "3L23"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["6L31", "5L31", "4L31", "3L40"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "6S4", "5L1", "5S1", "4L1", "3L1", "3S0"],
			tailwhip: ["6L4", "6S3", "6S4", "5L4", "5S1", "4L4", "3L4", "3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L7", "6S3", "5L13", "4L13", "3L13"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6L25", "5L25", "4M", "4L25", "3M"],
			waterspout: ["6E", "5E", "4E"],
			whirlpool: ["4M"],
			withdraw: ["6L10", "6S3", "5L10", "5S1", "4L10", "3L10", "3S0"],
			yawn: ["6E", "5E", "4E", "3E"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	wartortle: {
		inherit: true,
		learnset: {
			aquatail: ["6L32", "5T", "5L32", "4T", "4L32"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L16", "5L16", "4L16", "3L19"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["6L13", "5L1", "4L1", "3L1"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L48", "5L48", "4L44", "3L53"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L40", "5T", "5L40", "4T", "4L40"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L24", "5M", "5L24", "4M", "4L24", "3M", "3L31"],
			raindance: ["6M", "6L44", "5M", "5L44", "4M", "4L40", "3M", "3L37"],
			rapidspin: ["6L20", "5L20", "4L20", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["6L36", "5L36", "4L36", "3L45"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L13", "4L13", "3L13"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6L28", "5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["6L10", "5L10", "4L10", "3L10"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	blastoise: {
		inherit: true,
		learnset: {
			aquatail: ["6L32", "5T", "5L32", "4T", "4L32"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L16", "5L16", "4L16", "3L19"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["6L13", "5L1", "4L1", "3L1"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			darkpulse: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydrocannon: ["6T", "6S1", "5T", "4T", "3T"],
			hydropump: ["6L60", "6S1", "5L60", "4L53", "3L68", "3S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L46", "6S1", "5T", "5L46", "4T", "4L46"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L24", "5M", "5L24", "4M", "4L24", "3M", "3L31", "3S0"],
			raindance: ["6M", "6L53", "5M", "5L53", "4M", "4L46", "3M", "3L42", "3S0"],
			rapidspin: ["6L20", "5L20", "4L20", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			signalbeam: ["5T", "4T"],
			skullbash: ["6L39", "5L39", "4L39", "3L55", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L13", "4L13", "3L13"],
			waterpledge: ["6T", "6S1", "5T"],
			waterpulse: ["6L28", "5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["6L1", "5L1", "4L1", "3L1"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	caterpie: {
		inherit: true,
		learnset: {
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			electroweb: ["5T"],
			snore: ["5T", "4T"],
			stringshot: ["6L1", "5L1", "4T", "4L1", "3L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	metapod: {
		inherit: true,
		learnset: {
			bugbite: ["5T", "4T"],
			electroweb: ["5T"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			irondefense: ["5T", "4T"],
			stringshot: ["4T"],
		},
	},
	butterfree: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M", "3S0"],
			aircutter: ["5D", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L42", "5L42", "4L40"],
			captivate: ["6L40", "5L40", "4M", "4L36"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "5D", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L16", "5L16", "4L16", "3L28"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			poisonpowder: ["6L12", "5L12", "4L12", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L24", "5L24", "4L24", "3L34"],
			psychic: ["6M", "5M", "4M", "3M", "3S0"],
			psychup: ["6M", "5M", "4M"],
			quiverdance: ["6L46", "5L46"],
			ragepowder: ["6L34", "5L34"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "5D", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L36", "5M", "5L36", "4M", "4L34", "3M", "3L40"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["6L28", "5L28", "4M", "4L28", "3L47"],
			skillswap: ["5T", "4M", "3M"],
			sleeppowder: ["6L12", "5L12", "4L12", "3L15", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L12", "5L12", "4L12", "3L14"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L18", "5L18", "4L18", "3L18"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6L30", "5T", "5L30", "4T", "4L30"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			whirlwind: ["6L22", "5L22", "4L22", "3L23"],
		},
	},
	weedle: {
		inherit: true,
		learnset: {
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			electroweb: ["5T"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			stringshot: ["6L1", "5L1", "4T", "4L1", "3L1"],
		},
	},
	kakuna: {
		inherit: true,
		learnset: {
			bugbite: ["5T", "4T"],
			electroweb: ["5T"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			irondefense: ["5T", "4T"],
			stringshot: ["4T"],
		},
	},
	beedrill: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L31", "5L31", "4L31", "3L40"],
			aircutter: ["5D", "4T"],
			assurance: ["6L34", "5L34", "4L34"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			electroweb: ["5T"],
			endeavor: ["6L40", "5T", "5L40", "4T", "4L40", "3L45"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			fellstinger: ["6L45"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["6L13", "5L13", "4L13", "3L15"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L1", "5L1", "5D", "4L1", "3L1"],
			furycutter: ["5D", "4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pinmissile: ["6L28", "5L28", "4L28", "3L35"],
			poisonjab: ["6M", "6L37", "5M", "5L37", "4M", "4L37"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L22", "5L22", "4L22", "3L30"],
			rage: ["6L19", "5L19", "4L19", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M", "3S0"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T", "3S0"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L25", "5L25", "4L25"],
			twineedle: ["6L16", "5L16", "4L16", "3L20", "3S0"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	pidgey: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L29", "5L29", "4L29", "3L39"],
			aircutter: ["6E", "5E", "4T", "4E", "3E"],
			airslash: ["6L49", "6E", "5L49", "5E", "4L49", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bravebird: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6L25", "5L25", "4L25", "3L31"],
			feintattack: ["6E", "5E", "4E", "3E"],
			fly: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gust: ["6L9", "5L9", "5D", "4L9", "3L9"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L53", "5L53"],
			mimic: ["3T"],
			mirrormove: ["6L45", "5L45", "4L45", "3L47"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			quickattack: ["6L13", "5L13", "4L13", "3L13"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L37", "5T", "5L37", "4M", "4L37"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "5D", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "5D", "4M", "4E", "3M", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6L41", "5T", "5L41", "4T", "4L41"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L21", "5L21", "4T", "4L21"],
			uproar: ["6E", "5T", "5E", "4T", "4E"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L17", "5L17", "4L17", "3L19"],
			wingattack: ["6L33", "5L33", "4L33", "3L25"],
			workup: ["5M"],
		},
	},
	pidgeotto: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L32", "5L32", "4L32", "3L43"],
			aircutter: ["4T"],
			airslash: ["6L57", "5L57", "4L57"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6L27", "5L27", "4L27", "3L34", "3S0"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gust: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L62", "5L62"],
			mimic: ["3T"],
			mirrormove: ["6L52", "5L52", "4L52", "3L52"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L13", "4L13", "3L13"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L42", "5T", "5L42", "4M", "4L42"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6L47", "5T", "5L47", "4T", "4L47"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L22", "5L22", "4T", "4L22"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L17", "5L17", "4L17", "3L20"],
			wingattack: ["6L37", "5L37", "4L37", "3L27", "3S0"],
			workup: ["5M"],
		},
	},
	pidgeot: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L32", "5L32", "4L32", "3L48"],
			aircutter: ["4T"],
			airslash: ["6L62", "5L62", "4L62"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6L27", "5L27", "4L27", "3L34"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L1", "5L68"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["6L56", "5L56", "5S0", "4L56", "3L62"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L44", "5T", "5L44", "4M", "4L44"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["5T", "5S0", "4T", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6L50", "5T", "5L50", "4T", "4L50"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L22", "5L22", "4T", "4L22"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L17", "5L17", "5S0", "4L17", "3L20"],
			wingattack: ["6L38", "5L38", "5S0", "4L38", "3L27"],
			workup: ["5M"],
		},
	},
	rattata: {
		inherit: true,
		learnset: {
			assurance: ["6L25", "5L25", "4L25"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L10", "6E", "5L10", "5E", "4L10", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			covet: ["5T"],
			crunch: ["6L22", "5L22", "4L22"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L31", "5L31", "4L31", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endeavor: ["6L34", "5T", "5L34", "4T", "4L34", "3L41"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			finalgambit: ["6E", "5E"],
			flamewheel: ["6E", "5E", "4E", "3E"],
			focusenergy: ["6L7", "5L7", "4L7", "3L20"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperfang: ["6L16", "5L16", "4L16", "3L13"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "5D", "4M", "3M"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			mefirst: ["6E", "5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L13", "5L13", "4L13", "3L27"],
			quickattack: ["6L4", "5L4", "5D", "4L4", "3L7"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E"],
			reversal: ["6E", "5E", "4E", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L19", "5L19", "4T", "4L19"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["6L28", "5T", "5L28", "4T", "4L28", "3L34"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6E", "5T", "5E", "4E", "3E"],
			uturn: ["6M", "5M", "4M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	raticate: {
		inherit: true,
		learnset: {
			assurance: ["6L29", "5L29", "4L29"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L10", "5L10", "4L10"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crunch: ["6L24", "5L24", "4L24"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L39", "5L39", "4L39", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endeavor: ["6L44", "5T", "5L44", "4T", "4L44", "3L50"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hyperfang: ["6L16", "5L16", "4L16", "3L13", "3S0"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L13", "5L13", "4L13", "3L30"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L20", "5L20", "4L20", "3L20", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L19", "5L19", "4T", "4L19"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["6L34", "5T", "5L34", "4T", "4L34", "3L40", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T"],
			uturn: ["6M", "5M", "4M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	spearow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L25", "3S0"],
			agility: ["6L25", "5L25", "4L25", "3L43"],
			aircutter: ["4T"],
			assurance: ["6L29", "5L29", "4L29"],
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6L37", "5L37", "4L37", "3L37"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4E", "3E", "3S0"],
			featherdance: ["6E", "5E", "4E"],
			feintattack: ["6E", "5E", "5D", "4E", "3E"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L9", "5L9", "4L9", "3L13"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			leer: ["6L5", "5L5", "4L5", "3L7", "3S0"],
			mimic: ["3T"],
			mirrormove: ["6L21", "5L21", "4L21", "3L31"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L13", "5L13", "4L13", "3L19"],
			quickattack: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6E", "5E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L33", "5T", "5L33", "4M", "4L33"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "5D", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6E", "5E", "4E", "3E"],
			twister: ["4T"],
			uproar: ["6E", "5T", "5E", "4E"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6E", "5E", "4E"],
			workup: ["5M"],
		},
	},
	fearow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M"],
			agility: ["6L29", "5L29", "4L29", "3L47"],
			aircutter: ["4T"],
			assurance: ["6L35", "5L35", "4L35"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6L47", "5L47", "4L47", "3L40"],
			drillrun: ["6L1", "5T", "5L53"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L1", "5L1", "4L1", "3L1"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mirrormove: ["6L23", "5L23", "4L23", "3L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L13", "5L13", "4L13", "3L26"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L41", "5T", "5L41", "4M", "4L41"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T"],
			uturn: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	ekans: {
		inherit: true,
		learnset: {
			acid: ["6L20", "5L20", "4L20", "3L32"],
			acidspray: ["6L28", "5L28"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "5D", "4E", "3E"],
			belch: ["6L38"],
			bind: ["5T"],
			bite: ["6L9", "5L9", "4L9", "3L13", "3S0"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			coil: ["6L44", "5L44"],
			confide: ["6M"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L36", "5T", "5L36", "4T", "4L33"],
			gigadrain: ["5T", "4M", "3M"],
			glare: ["6L12", "5L12", "4L12", "3L20"],
			gunkshot: ["6L49", "5T", "5L49", "4T", "4L41"],
			haze: ["6L41", "5L41", "4L36", "3L44"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudbomb: ["6L33", "5L33", "4L28"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonfang: ["6E", "5E", "4E", "3E"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L4", "5L4", "5D", "4L4", "3L8", "3S0", "3S1"],
			poisontail: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E", "4E"],
			screech: ["6L17", "5L17", "4L17", "3L25"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snatch: ["6E", "5T", "5E", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			spitup: ["6L25", "5L25", "4L25", "3L37"],
			stockpile: ["6L25", "5L25", "4L25", "3L37"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L25", "5L25", "4L25", "3L37"],
			switcheroo: ["6E", "5E", "4E"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			wrap: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	arbok: {
		inherit: true,
		learnset: {
			acid: ["6L20", "5L20", "4L20", "3L38"],
			acidspray: ["6L32", "5L32"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L48"],
			bind: ["5T"],
			bite: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			coil: ["6L56", "5L56"],
			confide: ["6M"],
			crunch: ["6L22", "5L22", "4L22"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L44", "5T", "5L44", "4T", "4L42"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			glare: ["6L12", "5L12", "4L12", "3L20", "3S0"],
			gunkshot: ["6L63", "5T", "5L63", "4T", "4L56"],
			haze: ["6L51", "5L51", "4L48", "3L56"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L1", "5L1", "4L1"],
			infestation: ["6M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudbomb: ["6L39", "5L39", "4L34"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			screech: ["6L17", "5L17", "4L17", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M", "3S0"],
			sludgewave: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			spitup: ["6L27", "5L27", "4L28", "3L46"],
			stockpile: ["6L27", "5L27", "4L28", "3L46"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L27", "5L27", "4L28", "3L46"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			wrap: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	pichu: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bestow: ["6E", "5E"],
			bide: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["6E", "5E", "4E", "4S5", "3E"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			defensecurl: ["3T"],
			disarmingvoice: ["6E"],
			doubleedge: ["3T"],
			doubleslap: ["6E", "5E", "4E", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6E", "5E", "4E", "3E"],
			endeavor: ["4S5"],
			endure: ["6E", "5E", "4M", "4S5", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E"],
			flail: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			followme: ["3S3"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M", "4S4"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L18", "5L18", "4L18"],
			naturalgift: ["4M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "4S4", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L10", "5L13", "4L13", "3L11"],
			swift: ["4T", "3T"],
			tailwhip: ["6L5", "5L5", "4L5", "3L6"],
			teeterdance: ["3S2"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "4S4", "3M"],
			thunderpunch: ["6E", "5E", "4E"],
			thundershock: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			thunderwave: ["6M", "6L13", "5M", "5L10", "4M", "4L10", "3T", "3L8"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			voltswitch: ["6M", "5M"],
			volttackle: ["6E", "5E", "4E", "4S4", "4S5", "3E"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E", "3S1"],
		},
	},
	pichuspikyeared: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L1"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			headbutt: ["4T"],
			helpinghand: ["4T", "4S0"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["4L18"],
			naturalgift: ["4M"],
			painsplit: ["4S0"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			swagger: ["4M", "4S0"],
			sweetkiss: ["4L13"],
			swift: ["4T"],
			tailwhip: ["4L5"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "4L10"],
			toxic: ["4M"],
			uproar: ["4T"],
			volttackle: ["4S0"],
		},
	},
	pikachu: {
		inherit: true,
		learnset: {
			agility: ["6L37", "6S41", "5L37", "4L34", "3L33", "3S0", "3S8"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "5S26", "4M", "3M"],
			captivate: ["4M"],
			celebrate: ["6S31", "6S41"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			discharge: ["6L42", "5L42", "4L37"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L21", "6S32", "5M", "5L21", "4M", "4L18", "4S13", "3M", "3L15"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L18", "6S32", "6S37", "5L18", "5S23", "5S24", "5S30"],
			encore: ["6S39", "5S23"],
			endure: ["4M", "3T"],
			extremespeed: ["5S26"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L34", "5L34", "5S29", "4L29"],
			flash: ["6M", "6S40", "5M", "4M", "4S13", "3M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6S41", "5S24", "5S27", "3S2", "3S4", "3S6"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "5S25", "5S26", "5S27", "4M", "4S13"],
			growl: ["6L5", "6S31", "5L1", "4L1", "3L1", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			headbutt: ["5S28", "4T"],
			heartstamp: ["6S34"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			holdhands: ["6S33", "6S34", "6S35", "6S40", "6S42"],
			irontail: ["6S37", "5T", "5S24", "5S30", "4M", "4S21", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["4S18"],
			lightscreen: ["6M", "6L45", "5M", "5L45", "4M", "4L42", "4S11", "3M", "3L50", "3S0", "3S6", "3S7", "3S8"],
			magnetrise: ["5T", "4T"],
			megakick: ["6S32", "3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nuzzle: ["6L23", "6S36", "6S38"],
			playnice: ["6L7", "6S31", "6S35", "6S36", "6S38", "6S40", "6S42"],
			present: ["4S12", "4S15", "4S17", "4S18", "4S20", "4S22"],
			protect: ["6M", "5M", "5S27", "4M", "4S14", "4S16", "3M"],
			quickattack: ["6L10", "6S31", "6S32", "6S33", "6S34", "6S37", "5L13", "5S24", "5S25", "5S29", "5S30", "4L13", "4S11", "4S12", "4S15", "4S17", "4S18", "4S20", "4S21", "4S22", "3L11"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "4S19", "3M"],
			return: ["6M", "6S42", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["5S23"],
			slam: ["6L26", "5L26", "4L21", "3L20"],
			sleeptalk: ["6M", "5T", "4M", "4S19", "3T"],
			snore: ["5T", "4T", "4S19", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "6S35", "5M", "4M", "3T"],
			surf: ["6S33", "6S41", "4S9", "4S11", "4S14", "4S16", "3S3", "3S5", "3S7"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L1", "6S38", "5L5", "5S28", "4L5", "4S9", "4S12", "4S15", "4S17", "4S20", "4S22", "3L6", "3S1", "3S2", "3S3", "3S4", "3S10"],
			teeterdance: ["6S38", "5S23"],
			thunder: ["6M", "6L50", "6S35", "5M", "5L50", "5S25", "4M", "4L45", "4S14", "4S16", "3M", "3L41", "3S0", "3S6", "3S7", "3S8"],
			thunderbolt: ["6M", "6L29", "6S33", "6S34", "6S37", "5M", "5L29", "5S26", "5S27", "5S30", "4M", "4L26", "4S11", "4S13", "4S18", "4S21", "3M", "3L26", "3S0", "3S6", "3S7", "3S8"],
			thunderpunch: ["5T", "4T", "3T"],
			thundershock: ["6L1", "5L1", "5S28", "4L1", "4S12", "4S15", "4S20", "4S22", "3L1", "3S1", "3S5", "3S10"],
			thunderwave: ["6M", "6L13", "5M", "5L10", "5S28", "4M", "4L10", "4S9", "4S17", "3T", "3L8", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M", "5S29"],
			volttackle: ["6S39", "5S25", "5S29", "4S9", "4S21"],
			wildcharge: ["6M", "5M"],
			yawn: ["4S19"],
		},
	},
	pikachucosplay: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			hiddenpower: ["6M"],
			lightscreen: ["6M", "6L53"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thundershock: ["6L1", "6S0"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachurockstar: {
		inherit: true,
		learnset: {
			meteormash: ["6R"],
		},
	},
	pikachubelle: {
		inherit: true,
		learnset: {
			iciclecrash: ["6R"],
		},
	},
	pikachupopstar: {
		inherit: true,
		learnset: {
			drainingkiss: ["6R"],
		},
	},
	pikachuphd: {
		inherit: true,
		learnset: {
			electricterrain: ["6R"],
		},
	},
	pikachulibre: {
		inherit: true,
		learnset: {
			flyingpress: ["6R"],
		},
	},
	raichu: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunderpunch: ["5T", "4T", "3T"],
			thundershock: ["6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	sandshrew: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D", "4E", "3T", "3E"],
			covet: ["5T"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L1", "5L3", "4L3", "3T", "3L6", "3S0"],
			dig: ["6M", "6L30", "5M", "5L30", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L46", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L14", "5L25", "4T", "4L25", "3T"],
			furyswipes: ["6L20", "5L19", "4L19", "3L37"],
			gyroball: ["6M", "6L34", "5M", "5L33", "4M", "4L33"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			magnitude: ["6L17", "5L17"],
			metalclaw: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mudshot: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "4E"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L5", "5L9", "4L9", "3L17", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L9", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["6E", "5E", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L7", "5L21", "4T", "4L21", "3T"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			sandattack: ["6L3", "5L7", "5D", "4L7", "3L11", "3S0"],
			sandstorm: ["6M", "6L42", "5M", "5L37", "4M", "4L37", "3M", "3L53"],
			sandtomb: ["6L23", "5L27", "4L27", "3L45"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L26", "5L31", "4L31", "3L23"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "5D", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L11", "5L15", "4T", "4L15", "3T", "3L30"],
			swordsdance: ["6M", "6L38", "5M", "5L38", "4M", "4E", "3T", "3E"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	sandslash: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crushclaw: ["6L22", "5L22", "4L22"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "6L30", "5M", "5L30", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L46", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L14", "5L28", "4T", "4L28", "3T"],
			furyswipes: ["6L20", "5L19", "4L19", "3L42"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "6L34", "5M", "5L45", "4M", "4L45"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			magnitude: ["6L17", "5L17"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L9", "4L9", "3L17"],
			protect: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L9", "5L13", "4L13"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L7", "5L21", "4T", "4L21", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["6M", "6L42", "5M", "5L52", "4M", "4L52", "3M", "3L62"],
			sandtomb: ["6L23", "5L33", "4L33", "3L52"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L26", "5L40", "4L40", "3L24"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L11", "5L15", "4T", "4L15", "3T", "3L33"],
			swordsdance: ["6M", "6L38", "5M", "5L38", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	nidoranf: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "4E", "3E"],
			bite: ["6L21", "5L21", "4L21", "3L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["6L43", "5L43", "4M", "4L43"],
			charm: ["6E", "5E", "4E", "3E"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crunch: ["6L37", "5L37", "4L37", "3L47"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flatter: ["6L33", "5L33", "4L33", "3L38"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L19", "5L19", "4L19", "3L30"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["6L25", "5T", "5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["6L45", "5L45", "4L45"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L13", "5L13", "4L13", "3L17"],
			poisontail: ["6E", "5E"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "5D", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			skullbash: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["5D"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "5D", "4T"],
			supersonic: ["6E", "5E", "4E", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L7", "5L7", "4L7", "3L8"],
			takedown: ["6E", "5E", "4E", "3E"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L31", "5L31", "4L31"],
			venomdrench: ["6E"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorina: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L23", "5L23", "4L23", "3L22"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["6L50", "5L50", "4M", "4L50"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L43", "5L43", "4L43", "3L53"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flatter: ["6L38", "5L38", "4L38", "3L43"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L20", "5L20", "4L20", "3L34"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["6L28", "5T", "5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["6L58", "5L58", "4L58"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L13", "5L13", "4L13", "3L18"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L7", "5L7", "4L7", "3L8"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L35", "5L35", "4L35"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoqueen: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L35", "6S0", "5L35", "4L23", "3T", "3L22"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L23", "5L23"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L1", "6S0", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["6L43", "5T", "5L43", "4T", "4L43"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "6S0", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			superpower: ["6L1", "5T", "5L58", "4T", "4L58", "3L43"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L1", "6S0", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	nidoranm: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["6L43", "5L43", "4M", "4L43"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			confusion: ["6E", "5E", "4E", "3E"],
			counter: ["6E", "5E", "5D", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flatter: ["6L33", "5L33", "4L33", "3L38"],
			focusenergy: ["6L7", "5L7", "4L7", "3L8"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L19", "5L19", "4L19", "3L30"],
			headbutt: ["4T"],
			headsmash: ["6E", "5E", "4E"],
			helpinghand: ["6L25", "5T", "5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hornattack: ["6L21", "5L21", "4L21", "3L20"],
			horndrill: ["6L45", "5L45", "4L45", "3L47"],
			icebeam: ["6M", "5M", "4M", "3M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["6M", "6L37", "5M", "5L37", "4M", "4L37"],
			poisonsting: ["6L13", "5L13", "4L13", "3L17"],
			poisontail: ["6E", "5E"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E", "4T", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "5D", "4T"],
			supersonic: ["6E", "5E", "4E", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6E", "5E", "4E", "3E"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L31", "5L31", "4L31"],
			venomdrench: ["6E"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorino: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["6L50", "5L50", "4M", "4L50"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flatter: ["6L38", "5L38", "4L38", "3L43"],
			focusenergy: ["6L7", "5L7", "4L7", "3L8"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L20", "5L20", "4L20", "3L34"],
			headbutt: ["4T"],
			helpinghand: ["6L28", "5T", "5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hornattack: ["6L23", "5L23", "4L23", "3L22"],
			horndrill: ["6L58", "5L58", "4L58", "3L53"],
			icebeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["6M", "6L43", "5M", "5L43", "4M", "4L43"],
			poisonsting: ["6L13", "5L13", "4L13", "3L18"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L35", "5L35", "4L35"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoking: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L23", "5L23"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			drillrun: ["5T"],
			dynamicpunch: ["3T"],
			earthpower: ["6L43", "5T", "5L43", "4T", "4L43"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			megahorn: ["6L1", "5L58", "4L58", "3L43"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L35", "5L35", "4L23", "3L22"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	cleffa: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6E", "5E", "4E", "3E"],
			aromatherapy: ["6E", "5E", "5D", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "4L1", "3L1"],
			confide: ["6M"],
			copycat: ["6L13", "5L13", "4L13"],
			counter: ["3T"],
			covet: ["6E", "5T", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L4", "5L4", "5D", "4L4", "3L4"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "4E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			healpulse: ["6E"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magicalleaf: ["6L16", "5L16", "4L16", "3L17"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6E", "5E", "4E", "3T", "3E"],
			mimic: ["6E", "5E", "4E", "3T", "3E"],
			mistyterrain: ["6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["6L7", "5L7", "4L7", "3L8"],
			sleeptalk: ["6M", "5T", "5D", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			splash: ["6E", "5E", "4E", "3E"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L10", "5L10", "4L10", "3L13"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			wish: ["6E", "5E", "4E", "3E"],
			wonderroom: ["5T"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	clefairy: {
		inherit: true,
		learnset: {
			afteryou: ["6L1", "5T", "5L52"],
			attract: ["6M", "5M", "4M", "3M"],
			bestow: ["6L19", "5L25"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L40", "5L40", "3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cosmicpower: ["6L34", "5L28", "4L25", "3L33"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L13", "5L13", "4L13", "3T", "3L25"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["6L1"],
			doubleedge: ["3T"],
			doubleslap: ["6L10", "5L10", "4L10", "3L13"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L1", "5L4", "4L4", "3L5"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["6L16", "5L16", "4L16", "3L17"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6L49", "5T", "5L37", "4T", "4L34"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healingwish: ["6L1", "5L49", "4L46"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "5L46", "4M", "4L40", "3M", "3L41"],
			luckychant: ["6L37", "5L31", "4L28"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["6L50", "5L55", "4L43", "3L45"],
			metronome: ["6L31", "5L34", "4L31", "3T", "3L29"],
			mimic: ["3T"],
			minimize: ["6L25", "5L19", "4L19", "3L21"],
			moonblast: ["6L46"],
			moonlight: ["6L43", "5L40", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["6L7", "5L7", "4L7", "3L9"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			storedpower: ["6L28", "5L43"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			wakeupslap: ["6L22", "5L22", "4L22"],
			waterpulse: ["4M", "3M"],
			wonderroom: ["5T"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	clefable: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["6L1"],
			doubleedge: ["3T"],
			doubleslap: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6L1", "5L1", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			minimize: ["6L1", "5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			wonderroom: ["5T"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	vulpix: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			babydolleyes: ["6L9"],
			bodyslam: ["3T"],
			captivate: ["6L47", "6E", "5L41", "4M", "4L37"],
			charm: ["3S1"],
			confide: ["6M"],
			confuseray: ["6L15", "5L17", "4L17", "3L21"],
			covet: ["5T"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			dig: ["6M", "5M", "4M", "3M", "3S1"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4E"],
			extrasensory: ["6L39", "6E", "5L51", "5E", "4L44", "4E"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L20", "6E", "5L20", "5E", "4E", "3E"],
			fireblast: ["6M", "6L42", "5M", "5L54", "4M", "4L47", "3M"],
			firespin: ["6L12", "5L14", "4L34", "3L41"],
			flail: ["6E", "5E", "4E", "3E"],
			flameburst: ["6L23", "5L24"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L34", "5M", "5L37", "4M", "4L24", "3M", "3L29"],
			flareblitz: ["6E", "5E", "4E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			grudge: ["6L44", "5L47", "4L41", "3L37"],
			headbutt: ["4T"],
			heatwave: ["6E", "5T", "5E", "5D", "4T", "4E", "3E", "3S1"],
			hex: ["6L28", "6E", "5L28", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6E", "5E", "4E", "3E"],
			hypnosis: ["6E", "5E", "4E", "3E"],
			imprison: ["6L18", "5L21", "4L21", "3L25"],
			incinerate: ["6M", "5M"],
			inferno: ["6L50", "5L44"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L31", "5M", "5L34", "4M", "4L31"],
			powerswap: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3E"],
			quickattack: ["6L10", "5L11", "4L11", "3L13", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L7", "5M", "5L7", "5D", "4M", "4L7", "3M", "3L9", "3S0"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L36", "5M", "5L27", "4M", "4L27", "3M", "3L33"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailslap: ["6E", "5E"],
			tailwhip: ["6L4", "5L4", "4L4", "3L5", "3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "6L26", "5M", "5L31", "4M", "4L14", "3L17", "3S0"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	ninetales: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L1", "5L1", "4L1", "3L1"],
			covet: ["5T"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firespin: ["3L45"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L1", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "5S0", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			imprison: ["6L1"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			nastyplot: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M", "5S0"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "5S0", "4M"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "5S0", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	igglybuff: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			captivate: ["6E", "5E", "4M"],
			charm: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			confide: ["6M"],
			copycat: ["6L17", "5L17", "4L17"],
			counter: ["3T"],
			covet: ["6E", "5T", "5E", "4E"],
			defensecurl: ["6L5", "5L5", "4L5", "3T", "3L4", "3S0"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "5D", "4E", "3E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6E", "5T", "5E", "4T", "4E"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healpulse: ["6E"],
			helpinghand: ["5T", "5D", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mistyterrain: ["6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			perishsong: ["6E", "5E", "4E", "3E"],
			pound: ["6L9", "5L9", "4L9", "3L9"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			punishment: ["6E", "5E"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L13", "5L13", "4L13", "3L14"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			tickle: ["3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
		},
	},
	jigglypuff: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L33", "5L33", "4L29", "3T", "3L34"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L5", "5L5", "4L5", "3T", "3L4"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L13", "5L13", "4L13", "3L14"],
			disarmingvoice: ["6L50"],
			doubleedge: ["6L53", "5L53", "4L49", "3T", "3L49"],
			doubleslap: ["6L25", "5L25", "4L21", "3L24"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L37", "5M", "5L37", "4M", "4L33"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["6L48", "5T", "5L49", "4L45", "3L44"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["6L45", "5L45", "4L41", "3T", "3L39"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			playnice: ["6L10"],
			pound: ["6L7", "5L9", "4L9", "3L9"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L29", "5M", "5L29", "4M", "4L25", "3M", "3L29"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollout: ["6L21", "5L21", "4T", "4L17", "3T", "3L19"],
			round: ["6M", "6L17", "5M", "5L17"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			wakeupslap: ["6L41", "5L41", "4L37"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	wigglytuff: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["6L1", "3T"],
			doubleslap: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			playrough: ["6L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	zubat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L30", "5M", "5L33"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6L26", "5L25", "4T", "4L25", "3L31"],
			airslash: ["6L45", "5L45", "4L41"],
			astonish: ["6L8", "5L9", "4L9", "3L6"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L12", "5L13", "4L13", "3L16"],
			bravebird: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L19", "5L21", "4L21", "3L26"],
			curse: ["6E", "5E", "4E", "3E"],
			defog: ["6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6E", "5E", "4E", "3E"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6E", "5T", "5E", "4M", "3M"],
			gust: ["6E", "5E", "4E", "3E"],
			haze: ["6L41", "5L41", "4L37", "3L46"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6E", "5E", "5D", "4E"],
			leechlife: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L34", "5L29", "4L29", "3L36"],
			mimic: ["3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["6L37", "5L37", "4L33", "3L41"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			quickattack: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "5D", "4T"],
			supersonic: ["6L4", "5L5", "5D", "4L5", "3L6"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L23", "5L24", "4T", "3T"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			venomdrench: ["6E"],
			venoshock: ["6M", "5M"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			wingattack: ["6L15", "5L17", "4L17", "3L21"],
			zenheadbutt: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	golbat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L33", "5M", "5L39"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6L28", "5L27", "4T", "4L27", "3L35"],
			airslash: ["6L52", "5L57", "4L51"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L12", "5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L19", "5L21", "4L21", "3L28"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			haze: ["6L47", "5L51", "4L45", "3L56"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leechlife: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L38", "5L33", "4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["6L42", "5L45", "4L39", "3L49"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L24", "5L24", "4T", "3T"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			wingattack: ["6L15", "5L17", "4L17", "3L21"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	crobat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L33", "5M", "5L39"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6L28", "5L27", "4T", "4L27", "3L35"],
			airslash: ["6L52", "5L57", "4L51", "4S0"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L12", "5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L19", "5L21", "4L21", "3L28"],
			crosspoison: ["6L1", "5L1", "4L1"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			haze: ["6L47", "5L51", "4L45", "3L56"],
			heatwave: ["5T", "4T", "4S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leechlife: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L38", "5L33", "4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["6L42", "5L45", "4L39", "3L49"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			skyattack: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "4S0", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T", "4S0"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L24", "5L24", "4T", "3T"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			wingattack: ["6L15", "5L17", "4L17", "3L21"],
			xscissor: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	oddish: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			acid: ["6L9", "5L9", "4L9", "3L23", "3S0"],
			afteryou: ["6E", "5T", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["6L37", "5T", "5L37", "5D", "4M", "4L37", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6L45"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			ingrain: ["6E", "5E", "4E", "3E"],
			leechseed: ["3S1"],
			luckychant: ["6L25", "5L25", "4L25"],
			megadrain: ["6L21", "5L21", "4L21"],
			mimic: ["3T"],
			moonlight: ["6L33", "5L33", "4L33", "3L32"],
			naturalgift: ["6L29", "5L29", "4M", "4L29"],
			naturepower: ["6M", "6E", "5E"],
			petaldance: ["6L41", "5L41", "4L41", "3L39"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L14", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeppowder: ["6L17", "5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L15", "5L15", "4L15", "3L16", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L5", "5L5", "5D", "4L5", "3L7"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			synthesis: ["6E", "5T", "5E", "4T", "4E", "3E"],
			teeterdance: ["6E", "5E", "5D", "4E"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	gloom: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			acid: ["6L1", "5L1", "4L1", "3L24", "3S0"],
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["6L47", "5T", "5L47", "4M", "4L47", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6L56"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			luckychant: ["6L29", "5L29", "4L29"],
			megadrain: ["6L23", "5L23", "4L23"],
			mimic: ["3T"],
			moonlight: ["6L41", "5L41", "4L41", "3L35", "3S0"],
			naturalgift: ["6L35", "5L35", "4M", "4L35"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["6L53", "5L53", "4L53", "3L44", "3S0"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeppowder: ["6L17", "5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L15", "5L15", "4L15", "3L16"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	vileplume: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			afteryou: ["5T"],
			aromatherapy: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			megadrain: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["6L53", "5L53", "4L53", "3L44"],
			poisonpowder: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L65", "5M", "5L65", "4M", "4L65", "3M"],
			stunspore: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	bellossom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leafblade: ["6L1", "5L1", "4L1"],
			leafstorm: ["6L1", "5L53", "4L53"],
			magicalleaf: ["6L23", "5L23", "4L23", "3L1"],
			megadrain: ["6L1", "5L1", "4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["3L44"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M", "3L55"],
			stunspore: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	paras: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["5T"],
			agility: ["6E", "5E", "4E"],
			aromatherapy: ["6L43", "5L43", "4L38", "3L49"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["6E", "5T", "5E", "4T", "4E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crosspoison: ["6E", "5E", "5D", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M", "4E", "3E", "3S0"],
			fellstinger: ["6E"],
			flail: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L17", "5L17", "4T", "3T"],
			gigadrain: ["6L38", "5T", "5L38", "4M", "4L33", "3M", "3L43"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L33", "5L33", "4L27", "3L37"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			knockoff: ["5T", "4T"],
			leechlife: ["6L11", "5L11", "4L11", "3L19"],
			leechseed: ["6E", "5E"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			metalclaw: ["6E", "5E", "4E"],
			mimic: ["3T"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M"],
			poisonpowder: ["6L6", "5L6", "4L6", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E"],
			pursuit: ["6E", "5E", "4E", "3E"],
			ragepowder: ["6L49", "5L49"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			slash: ["6L27", "5L27", "4L22", "3L31", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spore: ["6L22", "5L22", "4L17", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L6", "5L6", "5D", "4L6", "3L7"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6E", "5E", "4E", "3E"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "5D", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			wideguard: ["6E"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "6L54", "5M", "5L54", "4M", "4L43"],
		},
	},
	parasect: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["5T"],
			aromatherapy: ["6L51", "5L51", "4L47", "3L59"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T", "4T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crosspoison: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L17", "5L17", "4T", "3T"],
			gigadrain: ["6L44", "5T", "5L44", "4M", "4L39", "3M", "3L51"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L37", "5L37", "4L30", "3L43"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leechlife: ["6L1", "5L1", "4L1", "3L19"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poisonpowder: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			ragepowder: ["6L59", "5L59"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			slash: ["6L29", "5L29", "4L22", "3L35"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spore: ["6L22", "5L22", "4L17", "3L27"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "6L66", "5M", "5L66", "4M", "4L55"],
		},
	},
	venonat: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "5D", "4E", "3E"],
			bugbite: ["6E", "5T", "5E", "4T", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L11", "5L11", "4L11", "3L17"],
			disable: ["6L1", "5L1", "5D", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6E", "5T", "5E", "4M", "4E", "3M", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechlife: ["6L17", "5L17", "4L17", "3L25"],
			mimic: ["3T"],
			morningsun: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			poisonfang: ["6L41", "5L41", "4L41"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L20"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L25", "5L25", "4L25", "3L33"],
			psychic: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L41"],
			ragepowder: ["6E", "5E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			signalbeam: ["6L35", "6E", "5T", "5L35", "5E", "4T", "4L35", "4E", "3E"],
			skillswap: ["6E", "5T", "5E", "5D", "4M", "3M"],
			sleeppowder: ["6L29", "5L29", "4L29", "3L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L23", "5L23", "4L23", "3L28"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L5", "5L5", "4L5", "3L9"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6E", "5E", "4E"],
			venoshock: ["6M", "5M"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	venomoth: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L1", "5L59", "4L59"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L11", "5L11", "4L11", "3L17"],
			defog: ["4M"],
			disable: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L31", "5L31", "4L31", "3L31"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechlife: ["6L17", "5L17", "4L17", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonfang: ["6L47", "5L47", "4L47"],
			poisonpowder: ["6L13", "5L13", "4L13", "3L20"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L25", "5L25", "4L25", "3L36"],
			psychic: ["6M", "6L55", "5M", "5L55", "4M", "4L55", "3M", "3L52", "3S0"],
			quiverdance: ["6L1", "5L63"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6L37", "5T", "5L37", "4T", "4L37"],
			silverwind: ["6L1", "5L1", "4M", "4L1", "3L1", "3S0"],
			skillswap: ["5T", "4M", "3M"],
			sleeppowder: ["6L29", "5L29", "4L29", "3L42"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L23", "5L23", "4L23", "3L28"],
			substitute: ["6M", "5M", "4M", "3T", "3S0"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			zenheadbutt: ["6L41", "5T", "5L41", "4T", "4L41"],
		},
	},
	diglett: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6E", "5E", "4E", "3E"],
			astonish: ["6L7", "6E", "5L7", "5E", "4L7", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "5D", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "6L18", "5M", "5L18"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "6L34", "5M", "5L34", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L29", "5T", "5L29", "4T", "4L26"],
			earthquake: ["6M", "6L40", "5M", "5L40", "4M", "4L37", "3M", "3L41"],
			echoedvoice: ["6M", "5M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6E", "5E", "4E", "3E"],
			finalgambit: ["6E", "5E"],
			fissure: ["6L45", "5L45", "4L40", "3L49"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["3L21"],
			growl: ["6L4", "5L4", "4L4", "3L5"],
			headbutt: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			magnitude: ["6L15", "5L15", "4L12", "3L9"],
			memento: ["6E", "5E"],
			mimic: ["3T"],
			mudbomb: ["6L26", "6E", "5L26", "5E", "4L29", "4E"],
			mudslap: ["6L12", "5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "5D", "4L1", "3L1"],
			sandstorm: ["6M", "5M", "4M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L37", "5L37", "4L34", "3L33"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "5D", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L23", "5L23", "4T", "4L23"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6E", "5T", "5E", "4E", "3E"],
		},
	},
	dugtrio: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			astonish: ["6L7", "5L7", "4L7"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "6L18", "5M", "5L18"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "6L40", "5M", "5L40", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L33", "5T", "5L33", "4T", "4L28"],
			earthquake: ["6M", "6L50", "5M", "5L50", "4M", "4L45", "3M", "3L51", "3S0"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6L57", "5L57", "4L50", "3L64"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["3L21"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			magnitude: ["6L15", "5L15", "4L12", "3L9"],
			mimic: ["3T"],
			mudbomb: ["6L28", "5L28", "4L33"],
			mudslap: ["6L12", "5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["6M", "5M", "4M", "3S0"],
			sandtomb: ["6L26", "5L26", "4L26", "3L26"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L45", "5L45", "4L40", "3L38"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L23", "5L23", "4T", "4L23"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			uproar: ["5T"],
		},
	},
	meowth: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6E", "5E", "4E", "3E"],
			assist: ["6E", "5E", "4E", "4S5", "3E"],
			assurance: ["6L41", "5L41", "4L41"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L6", "6S7", "5L6", "4L6", "4S4", "3L10", "3S2", "3S3"],
			bodyslam: ["3T"],
			captivate: ["6L46", "5L46", "4M", "4L46"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L9", "6S7", "5L9", "4L9", "4S4", "4S5", "3L43"],
			feint: ["6L50", "5L54", "4L54"],
			feintattack: ["6L22", "5L22", "4L22", "3L25"],
			flail: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6E", "5T", "5E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L14", "5L14", "5S6", "4L14", "4S4", "3L36"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["5T"],
			hypnosis: ["6E", "5E", "5D", "4E", "3E"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L38", "5L38", "5S6", "4L38"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["6L49", "5L49", "4L49"],
			odorsleuth: ["6E", "5E", "4E"],
			payback: ["6M", "5M", "4M"],
			payday: ["6L30", "5L30", "4L30", "4S5", "3L18", "3S3"],
			petaldance: ["3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "5D", "4L1", "4S5", "3L1", "3S0", "3S1", "3S2"],
			screech: ["6L17", "6S7", "5L17", "4L17", "4S4", "3L31"],
			secretpower: ["6M", "5D", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sing: ["5S6", "3S3"],
			slash: ["6L33", "5L33", "4L33", "3L40", "3S3"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["6E", "5T", "5E", "5S6", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T", "3L45"],
			swift: ["4T", "3T"],
			tailwhip: ["6E", "5E", "4E"],
			taunt: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	persian: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			assurance: ["6L49", "5L49", "4L49"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["6L56", "5L56", "4M", "4L56"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L1", "5L1", "4L1", "3L55"],
			feint: ["6L65", "5L68", "4L68"],
			feintattack: ["6L22", "5L22", "4L22", "3L25"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L14", "5L14", "4L14", "3L42"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L44", "5L44", "4L44"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["6L61", "5L61", "4L61"],
			payback: ["6M", "5M", "4M"],
			payday: ["3L18"],
			playrough: ["6L1"],
			powergem: ["6L32", "5L32", "4L32"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L17", "5L17", "4L17", "3L34"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["6L37", "5L37", "4L37", "3L49"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T", "3L61"],
			swift: ["6L28", "5L28", "4T", "3T"],
			switcheroo: ["6L1", "5L1", "4L1"],
			taunt: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	psyduck: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6L43", "5L48", "4L44"],
			aquatail: ["6L32", "5T", "5L32", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["5D", "4M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["6E"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			confusion: ["6L15", "5L18", "4L18", "3L16", "3S0"],
			counter: ["3T"],
			crosschop: ["6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L11", "5L14", "4L14", "3L10", "3S0"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["6E", "5E", "5D", "4E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L22", "5L27", "4L27", "3L40"],
			futuresight: ["6E", "5E", "4E", "3E"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L46", "5L53", "4L48", "3L50"],
			hypnosis: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S1"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E"],
			psychic: ["6M", "5M", "4M", "4E", "3E"],
			psychup: ["6M", "6L39", "5M", "5L40", "4M", "4L35", "3T", "3L31"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			screech: ["6L25", "5L31", "4L31", "3L23", "3S0"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			simplebeam: ["6E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L36", "5L35"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["6E", "5E"],
			tailwhip: ["6L4", "5L5", "4L5", "3L5", "3S0", "3S1"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L8", "5L9", "4L9"],
			waterpulse: ["6L18", "5L22", "4M", "4L22", "3M"],
			watersport: ["6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			whirlpool: ["4M"],
			wonderroom: ["6L50", "5T", "5L57"],
			worryseed: ["5T", "4T"],
			yawn: ["6E", "5E", "4E"],
			zenheadbutt: ["6L29", "5T", "5L44", "4T", "4L40"],
		},
	},
	golduck: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6L49", "5L56", "4L50"],
			aquajet: ["6L1", "5L1", "4L1"],
			aquatail: ["6L32", "5T", "5L32", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M", "3S0"],
			brine: ["4M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["6M"],
			confusion: ["6L15", "5L18", "4L18", "3L16"],
			counter: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L11", "5L14", "4L14", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L22", "5L27", "4L27", "3L44"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L54", "5L63", "4L56", "3L58"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "6L43", "5M", "5L44", "4M", "4L37", "3T", "3L31", "3S0"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L25", "5L31", "4L31", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L38", "5L37"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M", "3S0"],
			watergun: ["6L1", "5L1", "4L1"],
			waterpulse: ["6L18", "5L22", "4M", "4L22", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wonderroom: ["6L60", "5T", "5L69"],
			worryseed: ["5T", "4T"],
			zenheadbutt: ["6L29", "5T", "5L50", "4T", "4L44"],
		},
	},
	mankey: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			assurance: ["6L25", "5L25", "4L25"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6L49", "6E", "5L49", "5E", "4L49", "4E"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			covet: ["6L1", "5T", "5L1", "4L1"],
			crosschop: ["6L37", "5L37", "4L37", "3L31"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "4E"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			finalgambit: ["6L53", "5L53"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L21"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L9", "5L9", "4L9", "3L16"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			karatechop: ["6L13", "5L13", "4L13", "3L11"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6L1", "5T", "5L1", "5D", "4T", "4L1", "3L6"],
			lowsweep: ["6M", "5M"],
			meditate: ["6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["6L45", "5L45", "4L45"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E", "4E", "3E"],
			reversal: ["6E", "5E", "5D", "4E", "3E"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L21", "5L21", "4L21", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["6L17", "5L17", "4L17", "3T", "3L26"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			smackdown: ["6M", "5M"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snore: ["3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L36"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L41", "5L41", "4L41", "3L46"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "5D", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["5M"],
		},
	},
	primeape: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			assurance: ["6L25", "5L25", "4L25"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6L59", "5L59", "4L59"],
			confide: ["6M"],
			covet: ["5T"],
			crosschop: ["6L41", "5L41", "4L41", "3L35", "3S0"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			finalgambit: ["6L1", "5L63"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L21", "3S0"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L9", "5L9", "4L9", "3L16"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			karatechop: ["6L13", "5L13", "4L13", "3L11"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["6L53", "5L53", "4L53"],
			rage: ["6L28", "5L28", "4L28", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["3S0"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L21", "5L21", "4L21", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["6L17", "5L17", "4L17", "3T", "3L26"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["3T"],
			spite: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L35", "5M", "5L35", "4M", "4L35", "3T", "3L44"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L47", "5L47", "4L47", "3L62"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["5M"],
		},
	},
	growlithe: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L30", "5L42", "4L39", "3L43"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "5D", "4L1", "3L1", "3S1", "3S2"],
			bodyslam: ["6E", "5E", "5D", "4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["3S2"],
			closecombat: ["6E", "5E"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			crunch: ["6L39", "6E", "5L45", "5E", "4L42", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doublekick: ["6E", "5E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L6", "5L6", "4L6", "3L7", "3S1"],
			endure: ["5D", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L21", "5L28", "4L28"],
			firespin: ["6E", "5E", "4E", "3E"],
			flameburst: ["6L28", "5L31"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L34", "5M", "5L39", "4M", "4L34", "3M", "3L49", "3S2"],
			flamewheel: ["6L17", "5L20", "4L20", "3L31", "3S0"],
			flareblitz: ["6L45", "6E", "5L56", "5E", "4L48", "4E"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["6L41", "6E", "5T", "5L51", "5E", "4T", "4L45", "4E", "3E"],
			helpinghand: ["6L12", "5T", "5L17", "4T", "4L17", "3L37"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			leer: ["6L8", "5L9", "4L9", "3L13", "3S0"],
			mimic: ["3T"],
			morningsun: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L10", "5L14", "4L14", "3L19", "3S0"],
			outrage: ["6L43", "5T", "5L43"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "6L32", "5M", "5L48"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6L19", "5L25", "4L25"],
			roar: ["6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M", "3L1", "3S1"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["6L23", "5L34", "4L31", "3L25", "3S0", "3S2"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	arcanine: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			ember: ["3L1"],
			endure: ["4M", "3T"],
			extremespeed: ["6L34", "5L39", "4L39", "4S0", "3L49"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L1", "5L1", "4L1", "3L1"],
			outrage: ["5T"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1", "4S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	poliwag: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6L31", "5L31", "4L31", "3L37"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L21", "5L21", "4L21", "3T", "3L31"],
			bubble: ["6L11", "5L5", "4L5", "3L1", "3S0"],
			bubblebeam: ["6L25", "6E", "5L25", "5E", "4L25", "4E", "3E"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["6L15", "5L15", "4L15", "3L19"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "4E"],
			endeavor: ["6E", "5T", "5E", "4E"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L38", "5L38", "4L38", "3L43"],
			hypnosis: ["6L8", "5L8", "5D", "4L8", "3L7"],
			iceball: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			mimic: ["3T"],
			mindreader: ["6E", "5E", "4E", "3E"],
			mist: ["6E", "5E", "5D", "4E", "3E"],
			mudbomb: ["6L41", "5L41", "4L41"],
			mudshot: ["6L28", "6E", "5L28", "5E", "4L28", "4E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L25"],
			refresh: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "5D", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			splash: ["6E", "5E", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			wakeupslap: ["6L35", "5L35", "4L35"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L5", "5L11", "4L11", "3L13"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			watersport: ["6L1", "6E", "5L1", "5E", "4L1", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	poliwhirl: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6L37", "5L37", "4L37", "3L43"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L21", "5L21", "4L21", "3T", "3L35"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubble: ["6L11", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L27", "5L27", "4L27"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["6L15", "5L15", "4L15", "3L19"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L48", "5L48", "4L48", "3L51"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudbomb: ["6L53", "5L53", "4L53"],
			mudshot: ["6L32", "5L32", "4L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L27"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			wakeupslap: ["6L43", "5L43", "4L43"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L11", "4L11", "3L1"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L1", "5L1", "4L1"],
			whirlpool: ["4M"],
		},
	},
	poliwrath: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M", "3S0"],
			bubblebeam: ["6L1", "5L1", "4L1"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			circlethrow: ["6L1", "5L53"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["6L32", "5L32", "4L43", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["3S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["6L43", "5L43", "4L53", "3L51"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	politoed: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6L37", "5T", "5L37", "4T", "4L37"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubblebeam: ["6L1", "5L1", "4L1"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["6L48", "5T", "5L48", "4L48"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			icebeam: ["6M", "5M", "5S0", "4M", "3M"],
			icepunch: ["5T"],
			icywind: ["5T", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			perishsong: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "5S0", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M", "5S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3T", "3L51"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	abra: {
		inherit: true,
		learnset: {
			allyswitch: ["6E", "5M"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			encore: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "5D", "4T"],
			guardsplit: ["6E", "5E"],
			guardswap: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["6E", "5T", "5E", "4T", "4E", "3E"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powertrick: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychoshift: ["6E"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["6E", "5T", "5E", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["6L1", "5L1", "5D", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	kadabra: {
		inherit: true,
		learnset: {
			allyswitch: ["6L24", "5M", "5L24"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			disable: ["6L18", "5L18", "4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L48", "5L48", "4L42", "3L30"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			kinesis: ["6L1", "5L1", "4L1", "3L1"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["6L22", "5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L28", "5L28", "4L24", "3L21"],
			psychic: ["6M", "6L46", "5M", "5L46", "4M", "4L40", "3M", "3L36"],
			psychocut: ["6L40", "5L40", "4L34"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L36", "5L36", "4L30", "3L25"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "6L30", "5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["6L42", "5T", "5L42", "4T", "4L36", "3L33"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["6L34", "5M", "5L34"],
			teleport: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6L50", "5T", "5L52", "4T", "4L46", "3L43"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	alakazam: {
		inherit: true,
		learnset: {
			allyswitch: ["6L24", "5M", "5L24"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "6L42", "5M", "5L42", "4M", "4L36", "3M", "3L33", "3S0"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			disable: ["6L18", "5L18", "4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L48", "5L48", "4L42", "3L30", "3S0"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			kinesis: ["6L1", "5L1", "4L1", "3L1"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["6L22", "5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L28", "5L28", "4L24", "3L21"],
			psychic: ["6M", "6L46", "5M", "5L46", "4M", "4L40", "3M", "3L36", "3S0"],
			psychocut: ["6L40", "5L40", "4L34"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L36", "5L36", "4L30", "3L25"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "6L30", "5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["6L34", "5M", "5L34"],
			teleport: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6L50", "5T", "5L52", "4T", "4L46", "3L43", "3S0"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	machop: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6E", "5E", "5D", "4E"],
			captivate: ["4M"],
			closecombat: ["6E", "5E", "4E"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crosschop: ["6L43", "5L43", "4L37", "3L40"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["6L31", "5T"],
			dynamicpunch: ["6L49", "5L49", "4L46", "3T", "3L49"],
			earthquake: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["6E", "5T", "5E", "4T", "4E", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L7", "5L7", "4L7", "3L7"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L19", "5L19", "4L13", "3L22"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["6E", "5E"],
			helpinghand: ["5T", "5D", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["6L10", "5L10", "4L10", "3L13"],
			knockoff: ["6E", "5T", "5E"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			lowkick: ["6L1", "5T", "5L1", "5D", "4T", "4L1", "3L1"],
			lowsweep: ["6M", "6L13", "5M", "5L13"],
			meditate: ["6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			powertrick: ["6E", "5E", "4E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L25", "5L25", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollingkick: ["6E", "5E", "4E", "3E"],
			round: ["6M", "5M"],
			scaryface: ["6L46", "5L46", "4L43", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L22", "5L22", "4L19", "3T", "3L19"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["6L34", "5L34", "4L31", "3L37"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E", "3T"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["6L31", "5L31", "4L25", "3L31"],
			wakeupslap: ["6L37", "5L37", "4L34"],
			workup: ["5M"],
		},
	},
	machoke: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crosschop: ["6L44", "5L44", "4L40", "3L46"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["6L33", "5T"],
			dynamicpunch: ["6L55", "5L55", "4L51", "3T", "3L59"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L19", "5L19", "5S0", "4L13", "3L22"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["6L1", "5L1", "4L10", "3L13"],
			knockoff: ["6L21", "5T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			lowkick: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["6M", "6L13", "5M", "5L13", "5S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L25", "5L25", "5S0", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scaryface: ["6L51", "5L51", "4L44", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L22", "5L22", "5S0", "4L19", "3T", "3L19"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["6L36", "5L36", "4L32", "3L41"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["6L32", "5L32", "4L25", "3L33"],
			wakeupslap: ["6L40", "5L40", "4L36"],
			workup: ["5M"],
		},
	},
	machamp: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crosschop: ["6L44", "5L44", "4L40", "3L46"],
			dig: ["6M", "6S2", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["6L33", "5T"],
			dynamicpunch: ["6L55", "6S1", "6S2", "5L55", "4L51", "3T", "3L59"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "6S2", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L19", "5L19", "4L13", "3L22", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["6L1", "5L1", "4L10", "3L13"],
			knockoff: ["6L21", "6S1", "5T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			lowkick: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["6M", "6L13", "5M", "5L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L25", "5L25", "4L22", "3L25", "3S0"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scaryface: ["6L51", "5L51", "4L44", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L22", "6S2", "5L22", "4L19", "3T", "3L19", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "6S1", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["6L36", "5L36", "4L32", "3L41"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["6L32", "5L32", "4L25", "3L33", "3S0"],
			wakeupslap: ["6L40", "5L40", "4L36"],
			wideguard: ["6L1", "6S1", "5L1"],
			workup: ["5M"],
		},
	},
	bellsprout: {
		inherit: true,
		learnset: {
			acid: ["6L23", "5L23", "4L23", "3L23"],
			acidspray: ["6E"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6E"],
			bind: ["5T"],
			bulletseed: ["6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L35", "5T", "5L35", "4T", "4L35"],
			gigadrain: ["6E", "5T", "5E", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L7", "5L7", "4L7", "3L6", "3S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			ingrain: ["6E", "5E", "4E", "3E"],
			knockoff: ["6L27", "5T", "5L27", "4T", "4L27"],
			leechlife: ["6E", "5E", "4E", "3E"],
			magicalleaf: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M"],
			poisonpowder: ["6L15", "5L15", "4L15", "3L17"],
			powerwhip: ["6E", "5E"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L39", "5L39", "4L39", "3L37"],
			reflect: ["6M", "5M", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "5D", "4T"],
			slam: ["6L41", "5L41", "4L41", "3L45"],
			sleeppowder: ["6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L17", "5L17", "4L17", "3L19"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L29", "5L29", "4L29", "3L30"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			synthesis: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			teeterdance: ["3S0"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			weatherball: ["6E", "5E", "4E"],
			worryseed: ["6E", "5T", "5E", "4T", "4E"],
			wrap: ["6L11", "5L11", "4L11", "3L11"],
			wringout: ["6L47", "5L47", "4L47"],
		},
	},
	weepinbell: {
		inherit: true,
		learnset: {
			acid: ["6L23", "5L23", "4L23", "3L24"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			bugbite: ["5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L35", "5T", "5L35", "4T", "4L35"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			knockoff: ["6L27", "5T", "5L27", "4T", "4L27"],
			magicalleaf: ["3S0"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poisonpowder: ["6L15", "5L15", "4L15", "3L17"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L39", "5L39", "4L39", "3L42"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			slam: ["6L41", "5L41", "4L41", "3L54"],
			sleeppowder: ["6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M", "3S0"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L17", "5L17", "4L17", "3L19"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L29", "5L29", "4L29", "3L33", "3S0"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L1", "5L1", "4L1", "3L1"],
			worryseed: ["5T", "4T"],
			wrap: ["6L1", "5L1", "4L1", "3L1"],
			wringout: ["6L47", "5L47", "4L47"],
		},
	},
	victreebel: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			bodyslam: ["3T"],
			bugbite: ["5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			leafblade: ["6L47", "5L47", "4L47"],
			leafstorm: ["6L47", "5L47", "4L47"],
			leaftornado: ["6L27", "5L27"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L1", "5L1", "4L1", "3L1"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeppowder: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L1", "5L1", "4L1", "3L1"],
			stockpile: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L1", "5L1", "4L1", "3L1"],
			sweetscent: ["6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			vinewhip: ["6L1", "5L1", "4L1", "3L1"],
			worryseed: ["5T", "4T"],
		},
	},
	tentacool: {
		inherit: true,
		learnset: {
			acid: ["6L12", "5L12", "4L12", "3L19"],
			acidspray: ["6L26", "5L26"],
			acupressure: ["6E", "5E", "5D", "4E"],
			aquaring: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6E", "5E", "4E", "3E"],
			barrier: ["6L29", "5L29", "4L26", "3L36"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6L34", "4M"],
			bubble: ["6E", "5E"],
			bubblebeam: ["6L19", "5L19", "4L19", "3L25"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E", "3E"],
			constrict: ["6L8", "5L8", "4L8", "3L12"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			hex: ["6L43", "5L43"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L47", "5L47", "4L40", "3L49"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			knockoff: ["6E", "5T", "5E", "4T", "4E"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "4E", "3E"],
			muddywater: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L36", "5M", "5L36", "4M", "4L33"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			scald: ["6M", "5M"],
			screech: ["6L40", "5L40", "4L36", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "6L50", "5M", "5L50"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L5", "5L5", "5D", "4L5", "3L6"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L15", "5L15", "4L15"],
			venoshock: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L33", "5L33", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["6L22", "5L22", "4L22", "3L30"],
			wringout: ["6L54", "5L54", "4L43"],
		},
	},
	tentacruel: {
		inherit: true,
		learnset: {
			acid: ["6L12", "5L12", "4L12", "3L19"],
			acidspray: ["6L26", "5L26"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6L29", "5L29", "4L26", "3L38"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6L36", "4M"],
			bubblebeam: ["6L19", "5L19", "4L19", "3L25"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hex: ["6L47", "5L47"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L52", "5L52", "4L49", "3L55"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L38", "5M", "5L38", "4M", "4L36"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			scald: ["6M", "5M"],
			screech: ["6L43", "5L43", "4L42", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "6L56", "5M", "5L56"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L15", "5L15", "4L15"],
			venoshock: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L34", "5L34", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["6L22", "5L22", "4L22", "3L30"],
			wringout: ["6L1", "5L61", "4L55"],
		},
	},
	geodude: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6E", "5E"],
			block: ["6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6L32", "5M", "5L32"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E"],
			defensecurl: ["6L1", "5L1", "5D", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L46", "5L46", "4L36", "3T", "3L46"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L39", "5M", "5L39", "4M", "4L29", "3M", "3L36"],
			endure: ["6E", "5E", "4M", "3T"],
			explosion: ["6M", "6L43", "5M", "5L43", "4M", "4L32", "3T", "3L41"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6E", "5E", "4E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			magnitude: ["6L15", "5L15", "4L15", "3L16"],
			megapunch: ["6E", "5E", "4E", "3T", "3E"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L4", "5L4", "4L4", "3L6"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L22", "5L22", "4L25", "3L31"],
			rockclimb: ["6E", "5E", "5D", "4M"],
			rockpolish: ["6M", "6L8", "5M", "5L8", "4M", "4L8"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L18", "5L11", "4L11", "3L11"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L11", "5L18", "4T", "4L22", "3T", "3L26"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["6L29", "5L29", "4L18", "3T", "3L21"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "6L25", "5M", "5L25"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6L36", "5T", "5L36", "5D", "4M"],
			stoneedge: ["6M", "6L50", "5M", "5L50", "4M", "4L39"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			wideguard: ["6E"],
		},
	},
	graveler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6L36", "5M", "5L36"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L58", "5L58", "4L44", "3T", "3L62"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L47", "5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L53", "5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			magnitude: ["6L15", "5L15", "4L15", "3L16"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L22", "5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L18", "5L11", "4L11", "3L1"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L11", "5L18", "4T", "4L22", "3T", "3L29"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["6L31", "5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "6L27", "5M", "5L27"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6L42", "5T", "5L42", "4M"],
			stoneedge: ["6M", "6L64", "5M", "5L64", "4M", "4L49"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	golem: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6L36", "5M", "5L36"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L58", "5L58", "4L44", "3T", "3L62"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L47", "5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L53", "5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["6L1", "5L69"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["5T", "4T"],
			magnitude: ["6L15", "5L15", "4L15", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L22", "5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L18", "5L11", "4L11", "3L1"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L29"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["6L31", "5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "6L27", "5M", "5L27"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6L42", "5T", "5L42", "4M"],
			steamroller: ["6L11", "5L18"],
			stoneedge: ["6M", "6L64", "5M", "5L64", "4M", "4L49"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	ponyta: {
		inherit: true,
		learnset: {
			agility: ["6L37", "5L37", "4L33", "3L38"],
			allyswitch: ["6E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6L45", "5T", "5L45", "4T", "4L42", "3L45"],
			captivate: ["6E", "5E", "4M"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doublekick: ["6E", "5E", "4E", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L9", "5L9", "4L10", "3L14"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L41", "5M", "5L41", "4M", "4L37", "3M", "3L53"],
			firespin: ["6L25", "5L25", "4L24", "3L25"],
			flamecharge: ["6M", "6L21", "5M", "5L21"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flamewheel: ["6L13", "6E", "5L13", "5E", "4L15", "4E", "3E"],
			flareblitz: ["6L49", "5L49", "4L46"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L5"],
			headbutt: ["4T"],
			heatwave: ["5T", "5D", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			horndrill: ["6E", "5E", "4E"],
			hypnosis: ["6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			inferno: ["6L33", "5L33"],
			irontail: ["5T", "4M", "3M"],
			lowkick: ["6E", "5T", "5E"],
			mimic: ["3T"],
			morningsun: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L17", "5L17", "4L19", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5D", "4L1", "3L1"],
			tailwhip: ["6L4", "5L4", "4L6", "3L9"],
			takedown: ["6L29", "5L29", "4L28", "3L31"],
			thrash: ["6E", "5E", "5D", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	rapidash: {
		inherit: true,
		learnset: {
			agility: ["6L37", "5L37", "4L33", "3L38"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			bounce: ["6L45", "5T", "5L45", "4T", "4L47", "3L50"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L41", "5M", "5L41", "4M", "4L37", "3M", "3L63"],
			firespin: ["6L25", "5L25", "4L24", "3L25"],
			flamecharge: ["6M", "6L21", "5M", "5L21"],
			flamethrower: ["6M", "5M", "4M", "3M", "3S0"],
			flamewheel: ["6L13", "5L13", "4L15"],
			flareblitz: ["6L49", "5L49", "4L56"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L40", "5L40", "4L40", "3L40"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L33", "5L33"],
			irontail: ["5T", "4M", "3M"],
			lowkick: ["5T"],
			megahorn: ["6L1", "5L1", "4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			poisonjab: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M", "3S0"],
			stomp: ["6L17", "5L17", "4L19", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L29", "5L29", "4L28", "3L31"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	slowpoke: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L41", "5L41", "4L43", "3L36"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6E"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["6E", "5T", "5E", "5D", "4T", "4E"],
			bodyslam: ["3T"],
			brine: ["5D", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L14", "5L14", "5S2", "4L15", "3L17", "3S0"],
			curse: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L19", "5L19", "5S2", "4L20", "3L24", "3S0"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L5", "5L5", "4L6", "3L6", "3S1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["6L23", "5L23", "5S2", "4T", "4L25", "3L29", "3S0"],
			healpulse: ["6L58", "5L58"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			mefirst: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L45", "5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["6M", "6L54", "5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "6L49", "5M", "5L49", "4M", "4L53", "3M"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "4E", "3M", "3E"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			slackoff: ["6L36", "5L36", "4L39"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			stomp: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			watergun: ["6L9", "5L9", "4L11", "3L13", "3S0"],
			waterpulse: ["6L28", "5L28", "5S2", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["6E", "5T", "5E"],
			yawn: ["6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			zenheadbutt: ["6L32", "6E", "5T", "5L32", "5E", "4T", "4L34", "4E"],
		},
	},
	slowbro: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			afteryou: ["5T"],
			amnesia: ["6L43", "5L43", "4L47", "3L36"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L14", "5L14", "4L15", "3L17"],
			counter: ["3T"],
			curse: ["6L1", "5L1", "4L1", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L19", "5L19", "4L20", "3L24"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["6L23", "5L23", "4T", "4L25", "3L29"],
			healpulse: ["6L1", "5L68"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			irontail: ["6S0", "5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L49", "5M", "5L49", "4M", "4L54", "3M", "3L44"],
			psychup: ["6M", "6L62", "5M", "5L62", "4M", "4L67", "3T", "3L55"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "6L55", "5M", "5L55", "4M", "4L61", "3M"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "6S0", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			slackoff: ["6L36", "6S0", "5L36", "4L41"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "6S0", "5M", "4M"],
			watergun: ["6L9", "5L9", "4L11", "3L13"],
			waterpulse: ["6L28", "5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			withdraw: ["6L37", "5L37", "4L37", "3L37"],
			wonderroom: ["5T"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
			zenheadbutt: ["6L32", "5T", "5L32", "4T", "4L34"],
		},
	},
	slowking: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L14", "5L14", "4L15", "3L17"],
			counter: ["3T"],
			curse: ["6L1", "5L1", "4L1", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L19", "5L19", "4L20", "3L24"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L5", "5L5", "4L6", "3L6"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["6L23", "5L23", "4T", "4L25", "3L29"],
			healpulse: ["6L1", "5L58"],
			hiddenpower: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L36", "5L36", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powergem: ["6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L45", "5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["6M", "6L54", "5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["6M", "5M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L41", "5M", "5L41", "4M", "4L43", "3T", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			trumpcard: ["6L49", "5L49", "4L53"],
			watergun: ["6L9", "5L9", "4L11", "3L13"],
			waterpulse: ["6L28", "5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["5T"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
			zenheadbutt: ["6L32", "5T", "5L32", "4T", "4L34"],
		},
	},
	magnemite: {
		inherit: true,
		learnset: {
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			discharge: ["6L43", "5L43", "4L38"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroball: ["6L32", "5L27"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "6L35", "5M", "5L35", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gravity: ["5T", "5D", "4T"],
			gyroball: ["6M", "6L53", "5M", "5L54", "4M", "4L49"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irondefense: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			lockon: ["6L46", "5L30", "4L27", "3L32"],
			magiccoat: ["5T", "4T"],
			magnetbomb: ["6L18", "5L18", "4L30"],
			magnetrise: ["6L49", "5T", "5L49", "4T", "4L46"],
			metalsound: ["6L29", "5L1", "5D", "4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["6L25", "5L46", "4L43"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "5D", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6L39", "5L38", "4L33", "3L44"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			sonicboom: ["6L11", "5L14", "4L14", "3L16"],
			spark: ["6L21", "5L22", "4L22", "3L26"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L4", "5L11", "4L11", "3L11"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T", "3L38"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thundershock: ["6L7", "5L6", "5D", "4L6", "3L6"],
			thunderwave: ["6M", "6L15", "5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L57", "5L59", "4L54", "3L50"],
		},
	},
	magneton: {
		inherit: true,
		learnset: {
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			discharge: ["6L51", "5L46", "4L40"],
			doubleedge: ["3T", "3S0"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electricterrain: ["6L11"],
			electroball: ["6L34", "5L27"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "6L39", "5M", "5L39", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L67", "5M", "5L60", "4M", "4L54"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			lockon: ["6L56", "5L30", "4L27", "3L35"],
			magiccoat: ["5T", "4T"],
			magnetbomb: ["6L18", "5L34", "4L30"],
			magnetrise: ["6L62", "5T", "5L54", "4T", "4L50"],
			metalsound: ["6L29", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["6L25", "5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M", "3S0"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6L45", "5L40", "4L34", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			sonicboom: ["6L1", "5L14", "4L14", "3L16"],
			spark: ["6L21", "5L22", "4L22", "3L26"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M", "3S0"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thundershock: ["6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["6M", "6L15", "5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6L1", "5L1", "4L1", "3L44"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1", "5L66", "4L60", "3L62"],
		},
	},
	magnezone: {
		inherit: true,
		learnset: {
			barrier: ["6L1", "5L1", "4L1"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			discharge: ["6L51", "5L46", "4L40"],
			doubleteam: ["6M", "5M", "4M"],
			electricterrain: ["6L11"],
			electroball: ["6L34", "5L27"],
			electroweb: ["5T"],
			endure: ["4M"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "6L39", "5M", "5L39", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L67", "5M", "5L60", "4M", "4L54"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			lockon: ["6L56", "5L30", "4L27"],
			magiccoat: ["5T", "4T"],
			magnetbomb: ["6L18", "5L34", "4L30"],
			magneticflux: ["6L1"],
			magnetrise: ["6L62", "5T", "5L54", "4T", "4L50"],
			metalsound: ["6L29", "5L1", "4L1"],
			mirrorcoat: ["6L1", "5L1", "4L1"],
			mirrorshot: ["6L25", "5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			screech: ["6L45", "5L40", "4L34"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			sonicboom: ["6L1", "5L14", "4L14"],
			spark: ["6L21", "5L22", "4L22"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			supersonic: ["6L1", "5L1", "4L1"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thundershock: ["6L7", "5L1", "4L1"],
			thunderwave: ["6M", "6L15", "5M", "5L17", "4M", "4L17"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1", "5L66", "4L60"],
		},
	},
	farfetchd: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L37", "5M", "5L37"],
			aerialace: ["6M", "6L9", "5M", "5L13", "4M", "4L13", "3M", "3S1"],
			agility: ["6L31", "5L31", "4L31", "3L36"],
			aircutter: ["6L21", "5L21", "4T", "4L21"],
			airslash: ["6L49", "5L49", "4L37"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			bravebird: ["6L1", "5L55"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E", "4E"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L45", "5M", "5L45", "4M", "4L43", "3L46"],
			featherdance: ["6E", "5E", "4E", "3E"],
			feint: ["6L43", "5L43", "4L43"],
			flail: ["6E", "5E", "4E", "3E"],
			fly: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L7", "5L7", "4L7", "3L16"],
			furycutter: ["6L1", "5L1", "5D", "4T", "4L1", "3L26"],
			gust: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["6L13", "5T", "5L9", "4T", "4L9", "3L21"],
			lastresort: ["5T", "4T"],
			leafblade: ["6E", "5E", "5D", "4E"],
			leer: ["6L1", "5L1", "4L1", "3L11"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "4E", "3E"],
			mudslap: ["6E", "5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6L33", "6E", "5L33", "5E", "4L33", "4E"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			poisonjab: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quickattack: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E"],
			roost: ["6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L6"],
			secretpower: ["6M", "4M", "3M"],
			simplebeam: ["6E"],
			skyattack: ["5T"],
			slash: ["6L19", "5L19", "4L19", "3L41", "3S1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "4M", "4E", "3M", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L31", "3S1"],
			tailwind: ["5T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6E", "5E"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			wish: ["3S0"],
			workup: ["5M"],
			yawn: ["3S0"],
		},
	},
	doduo: {
		inherit: true,
		learnset: {
			acupressure: ["6L28", "5L28", "4L28"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L37", "5L37", "4L37", "3L45"],
			aircutter: ["4T"],
			assurance: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bravebird: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doublehit: ["6L32", "5L32", "4L32"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6L41", "5L41", "4L41", "3L37"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L46", "6E", "5T", "5L46", "5E", "4T", "4L46", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6E", "5E", "4E", "3E"],
			flail: ["6E", "5E", "5D", "4E", "3E"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L14", "5L14", "4L14", "3L13"],
			growl: ["6L1", "5L1", "5D", "4L1", "3L1"],
			haze: ["6E", "5E", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["6L21", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L19", "5L19", "4L19", "3L9"],
			quickattack: ["6L5", "6E", "5L5", "5E", "4L5", "4E", "3E"],
			rage: ["6L10", "5L10", "4L10", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "5D", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6E", "5E", "4E", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L50", "5L50"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["3L21"],
			uproar: ["6L23", "5T", "5L23", "4T", "4L23", "3L33"],
			workup: ["5M"],
		},
	},
	dodrio: {
		inherit: true,
		learnset: {
			acupressure: ["6L28", "5L28", "4L28"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L41", "5L41", "4L41", "3L60", "3S0"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6L47", "5L47", "4L47", "3L47", "3S0"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L54", "5T", "5L54", "4T", "4L54"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L14", "5L14", "4L14", "3L1"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L19", "5L19", "4L19", "3L1"],
			quickattack: ["6L1", "5L1", "4L1"],
			rage: ["6L1", "5L1", "4L1", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L60", "5L60"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6L34", "5L34", "4L34", "3L21", "3S0"],
			uproar: ["6L23", "5T", "5L23", "4T", "4L23", "3L38"],
			workup: ["5M"],
		},
	},
	seel: {
		inherit: true,
		learnset: {
			aquajet: ["6L31", "5L31", "4L31"],
			aquaring: ["6L23", "5L23", "4L23"],
			aquatail: ["6L43", "5T", "5L43", "4T", "4L43"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L27", "5L27", "4L27", "3L21"],
			belch: ["6E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["6L33", "5L33", "4M", "4L33"],
			captivate: ["4M"],
			confide: ["6M"],
			disable: ["6E", "5E", "4E", "3E"],
			dive: ["6M", "6L41", "5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L13", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			endure: ["4M", "3T"],
			entrainment: ["6E"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E", "3E"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L3", "5L3", "4L3", "3L9"],
			hail: ["6M", "6L53", "5M", "5L53", "4M", "3M"],
			headbutt: ["6L1", "5L1", "5D", "4T", "4L1", "3L1"],
			helpinghand: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			horndrill: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L41", "3S0"],
			iceshard: ["6L17", "5L17", "4L17"],
			iciclespear: ["6E", "5E", "5D", "4E", "3E"],
			icywind: ["6L11", "5T", "5L11", "4T", "4L11", "3T", "3L17"],
			irontail: ["6E", "5T", "5E"],
			lick: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			perishsong: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L21", "5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L51", "5M", "5L51", "4M", "4L51", "3M", "3L49", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "5D", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E"],
			stockpile: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E"],
			takedown: ["6L37", "5L37", "4L37", "3L37"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			watersport: ["6L7", "5L7", "4L7"],
			whirlpool: ["4M"],
		},
	},
	dewgong: {
		inherit: true,
		learnset: {
			aquajet: ["6L31", "5L31", "4L31"],
			aquaring: ["6L23", "5L23", "4L23"],
			aquatail: ["6L49", "5T", "5L49", "4T", "4L43"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L27", "5L27", "4L27", "3L1"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["6L33", "5L33", "4M", "4L33"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "6L45", "5M", "5L45", "4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L13", "5L13", "4L13"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "6L65", "5M", "5L65", "4M", "3M"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "6L55", "5M", "5L55", "4M", "4L47", "3M", "3L51"],
			iceshard: ["6L17", "5L17", "4L17"],
			icywind: ["6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			irontail: ["5T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L21", "5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L61", "5M", "5L61", "4M", "4L51", "3M", "3L64"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L34", "5L34", "4L34", "3L34"],
			signalbeam: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6L39", "5L39", "4L37", "3L42"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	grimer: {
		inherit: true,
		learnset: {
			acidarmor: ["6L40", "5L39", "4L39", "3L34"],
			acidspray: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L46"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L12", "5L12", "4L12", "3L8"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L29", "5M", "5L28", "4M", "4L28"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gunkshot: ["6L43", "5T", "5L49", "4T", "4L44"],
			harden: ["6L4", "5L4", "4L4", "3L4"],
			haze: ["6E", "5E", "5D", "4E", "3E"],
			helpinghand: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			imprison: ["6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			lick: ["6E", "5E", "4E", "3E"],
			meanlook: ["6E", "5E", "4E", "3E"],
			memento: ["6L48", "5L52", "4L49", "3L53"],
			mimic: ["3T"],
			minimize: ["6L18", "5L17", "4L17", "3L19", "3S0"],
			mudbomb: ["6L21", "5L23", "4L23"],
			mudslap: ["6L7", "5L7", "4T", "4L7", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisongas: ["6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["6M", "5M", "4M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E"],
			screech: ["6L32", "5L33", "4L33", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M"],
			shadowpunch: ["6E", "5E", "4E", "3E", "3S0"],
			shadowsneak: ["6E", "5E", "5D", "4E"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L15", "5L20", "4L20", "3L13"],
			sludgebomb: ["6M", "6L26", "5M", "5L36", "4M", "4L36", "3M", "3L43", "3S0"],
			sludgewave: ["6M", "6L37", "5M", "5L44"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E"],
			stockpile: ["6E", "5E", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
		},
	},
	muk: {
		inherit: true,
		learnset: {
			acidarmor: ["6L43", "5L42", "4L44", "3L34"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L53"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L12", "5L12", "4L12", "3L8"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L29", "5M", "5L28", "4M", "4L28"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["6L49", "5T", "5L58", "4T", "4L54"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			memento: ["6L57", "5L64", "4L65", "3L61"],
			mimic: ["3T"],
			minimize: ["6L18", "5L17", "4L17", "3L19"],
			mudbomb: ["6L21", "5L23", "4L23"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisongas: ["6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["6M", "5M", "4M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6L32", "5L33", "4L33", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L15", "5L20", "4L20", "3L13"],
			sludgebomb: ["6M", "6L26", "5M", "5L36", "4M", "4L36", "3M", "3L47"],
			sludgewave: ["6M", "6L37", "5M", "5L50"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
		},
	},
	shellder: {
		inherit: true,
		learnset: {
			aquaring: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L37", "5L37", "4L32", "3L17", "3S0", "3S2"],
			avalanche: ["6E", "5E"],
			barrier: ["6E", "5E", "5D", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6L44", "5L44", "4M", "4L44"],
			bubblebeam: ["6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			clamp: ["6L25", "5L25", "4L25", "3L41"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L61", "5L61"],
			icebeam: ["6M", "6L52", "5M", "5L52", "4M", "4L49", "3M", "3L49"],
			iceshard: ["6L28", "5L28", "4L28"],
			iciclespear: ["6L13", "6E", "5L13", "5E", "4L13", "4E", "3L8", "3E", "3S0", "3S1"],
			icywind: ["5T", "5D", "4T", "3T"],
			irondefense: ["6L49", "5T", "5L49", "4T", "4L40"],
			leer: ["6L20", "5L20", "4L20", "3L33"],
			mimic: ["3T"],
			mudshot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "6L16", "5M", "5L16", "4M", "4L16", "3M", "3L25"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			razorshell: ["6L32", "5L32"],
			refresh: ["3S2"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6E", "5E", "4E"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["6L56", "5L56"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L8", "5L8", "4L8", "3L9", "3S0"],
			surf: ["6M", "5M", "4M", "3M", "3S2"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			takedown: ["6E", "5E", "4E", "3E", "3S2"],
			toxic: ["6M", "5M", "4M", "3M"],
			twineedle: ["6E", "5E"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["6L40", "5L40", "4M", "4L37"],
			withdraw: ["6L4", "5L4", "5D", "4L4", "3L1", "3S0", "3S1"],
		},
	},
	cloyster: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L1", "5L1", "4L1", "3L1"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "5S0", "4M", "3M"],
			hydropump: ["6L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			iciclecrash: ["6L50", "5L52"],
			iciclespear: ["5S0"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorshell: ["5S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["5S0"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["6L1"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spikecannon: ["6L13", "5L13", "4L40", "3L41"],
			spikes: ["6L28", "5L28", "4L28", "3L33"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L1", "5L1", "4L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	gastly: {
		inherit: true,
		learnset: {
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			confuseray: ["6L19", "5L19", "4L19", "3L21"],
			curse: ["6L12", "5L12", "4L12", "3L13"],
			darkpulse: ["6M", "6L36", "5T", "5L36", "4M", "4L36"],
			dazzlinggleam: ["6M"],
			destinybond: ["6L40", "5L40", "4L40", "3L33"],
			disable: ["6E", "5E", "5D", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L28"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["6E", "5T", "5E", "4T", "4E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			grudge: ["6E", "5E", "4E", "3E"],
			haze: ["6E", "5E", "4E", "3E"],
			hex: ["6L43", "5L43"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "5D", "4L1", "3L1"],
			icepunch: ["6E", "5T", "5E", "4T", "4E"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L8", "5L8", "4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["6L47", "5L47", "4L43", "3T", "3L41"],
			nightshade: ["6L15", "5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L26", "5M", "5L26", "4M", "4L26"],
			perishsong: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psywave: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L36"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["5D"],
			smog: ["6E", "5E"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6L5", "5T", "5L5", "4T", "4L5", "3L8"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L22", "5L22", "4T", "4L22"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M", "4E", "3E"],
			wonderroom: ["5T"],
		},
	},
	haunter: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L19", "5L19", "5S0", "4L19", "3L21"],
			curse: ["6L12", "5L12", "4L12", "3L13"],
			darkpulse: ["6M", "6L44", "5T", "5L44", "4M", "4L44"],
			dazzlinggleam: ["6M"],
			destinybond: ["6L50", "5L50", "4L50", "3L39"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3T", "3L31"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T"],
			fling: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			hex: ["6L55", "5L55"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L8", "5L8", "4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["6L61", "5L61", "4L55", "3T", "3L53"],
			nightshade: ["6L15", "5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L28", "5M", "5L28", "5S0", "4M", "4L28"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["6M", "5M", "4M"],
			shadowpunch: ["6L25", "5L25", "5S0", "4L25", "3L25"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L22", "5L22", "5S0", "4T", "4L22"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
		},
	},
	gengar: {
		inherit: true,
		learnset: {
			astonish: ["6S4"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L19", "6S1", "6S2", "6S4", "5L19", "4L19", "3L21", "3S0"],
			counter: ["3T"],
			curse: ["6L12", "5L12", "4L12", "3L13", "3S0"],
			darkpulse: ["6M", "6L44", "5T", "5L44", "4M", "4L44"],
			dazzlinggleam: ["6M"],
			destinybond: ["6L50", "6S3", "5L50", "4L50", "3L39"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3T", "3L31"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hex: ["6L55", "5L55"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6S5", "6S6", "5M", "4M", "3M"],
			hypnosis: ["6L1", "6S5", "6S6", "5L1", "4L1", "3L1"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L8", "6S5", "6S6", "5L8", "4L8", "3L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["6L61", "5L61", "4L55", "3T", "3L53"],
			nightshade: ["6L15", "6S2", "5L15", "4L15", "3L16", "3S0"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L28", "5M", "5L28", "4M", "4L28"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6S1", "6S5", "6S6", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "6L33", "6S3", "6S4", "5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["6M", "5M", "4M"],
			shadowpunch: ["6L25", "6S1", "6S2", "5L25", "4L25", "3L25"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "6S3", "5M", "4M", "3M"],
			sludgewave: ["6S4"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6L1", "5T", "5L1", "4T", "4L1", "3L1", "3S0"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L22", "6S1", "6S2", "5L22", "4T", "4L22"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			willowisp: ["6M", "6S3", "5M", "4M"],
			wonderroom: ["5T"],
		},
	},
	onix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["6L1", "5T", "5L1", "5D", "4L1", "3L8"],
			block: ["6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6L4", "5L46", "4L38"],
			defensecurl: ["6E", "5E", "4E"],
			dig: ["6M", "6L43", "5M", "5L43", "4M", "3M"],
			doubleedge: ["6L49", "5L57", "4L46", "3T", "3L56"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6L25", "5L41", "4L33", "3L30"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "6L20", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			heavyslam: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ironhead: ["5T", "4T"],
			irontail: ["6L40", "5T", "5L49", "4M", "4L38", "3M", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			rage: ["6L13", "5L14", "4L14", "3L23"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockblast: ["6E", "5E", "4E"],
			rockclimb: ["6E", "5E", "5D", "4M"],
			rockpolish: ["6M", "6L19", "5M", "5L30", "4M", "4L30"],
			rockslide: ["6M", "6L34", "5M", "5L34", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L7", "5L9", "4L9", "3L12"],
			rocktomb: ["6M", "6L10", "5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["6E", "5E", "4T", "4E"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L52", "5M", "5L25", "4M", "4L22", "3M", "3L33"],
			sandtomb: ["6L37", "5L54", "4L41", "3L49"],
			screech: ["6L31", "5L6", "4L6", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["6L28", "5L33", "4L25", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "6L22", "5M", "5L22"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6L16", "6E", "5T", "5L38", "5E", "5D", "4M"],
			stoneedge: ["6M", "6L46", "5M", "5L62", "4M", "4L49"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	steelix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L19", "5L30"],
			bind: ["6L1", "5T", "5L1", "4L1", "3L8"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L37", "5L54", "4L41", "3L49"],
			curse: ["6L4", "5L46", "4L38"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "6L43", "5M", "5L43", "4M", "3M"],
			doubleedge: ["6L49", "5L57", "4L46", "3T", "3L56"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6L25", "5L41", "4L33", "3L30"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "6L20", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L1", "5L1", "4L1"],
			ironhead: ["5T", "4T"],
			irontail: ["6L40", "5T", "5L49", "4M", "4L38", "3M", "3L45"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M"],
			rage: ["6L13", "5L14", "4L14", "3L23"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M", "4L30"],
			rockslide: ["6M", "6L34", "5M", "5L34", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L7", "5L9", "4L9", "3L12"],
			rocktomb: ["6M", "6L10", "5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L52", "5M", "5L25", "4M", "4L22", "3M", "3L33"],
			screech: ["6L31", "5L6", "4L6", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["6L28", "5L33", "4L25", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "6L22", "5M", "5L22"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6L16", "5T", "5L38", "4M"],
			stoneedge: ["6M", "6L46", "5M", "5L62", "4M", "4L49"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	drowzee: {
		inherit: true,
		learnset: {
			assist: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			bellydrum: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L9", "5L9", "4L9", "3L11"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			disable: ["6L5", "5L5", "4L7", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "5D", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L61", "5L61", "4L53", "3L45"],
			grassknot: ["6M", "5M", "4M"],
			guardswap: ["6E", "5E", "4E"],
			headbutt: ["6L13", "5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "5D", "4L1", "3L1"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meditate: ["6L21", "5L21", "4L21", "3L27"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["6L53", "6E", "5L53", "5E", "4L43", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisongas: ["6L17", "5L17", "4L18", "3L21"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L25", "5L25", "4L26"],
			psychic: ["6M", "6L49", "5M", "5L49", "4M", "4L40", "3M", "3L31"],
			psychocut: ["6E", "5E", "5D", "4E"],
			psychup: ["6M", "6L33", "5M", "5L33", "4M", "4L29", "3T", "3L37"],
			psyshock: ["6M", "6L57", "5M", "5L57"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["6E", "5T", "5E", "4T", "4E", "3E"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L45", "5M", "5L45", "4M", "4L37", "3T", "3L41"],
			synchronoise: ["6L37", "5L37"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wish: ["3S0"],
			zenheadbutt: ["6L41", "5T", "5L41", "4T", "4L50"],
		},
	},
	hypno: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			disable: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L1", "5L61", "4L69", "3L57"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["6L13", "5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			icepunch: ["5T", "4T", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meditate: ["6L21", "5L21", "4L21", "3L29", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["6L1", "5L53", "4L55"],
			naturalgift: ["4M"],
			nightmare: ["6L1", "5L1", "4L1", "3T", "3L1"],
			poisongas: ["6L17", "5L17", "4L18", "3L21"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L25", "5L25", "4L28"],
			psychic: ["6M", "6L49", "5M", "5L49", "4M", "4L50", "3M", "3L35", "3S0"],
			psychup: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L43"],
			psyshock: ["6M", "6L57", "5M", "5L57"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M", "3S0"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "3T", "3L49"],
			switcheroo: ["6L1", "5L1", "4L1"],
			synchronoise: ["6L37", "5L37"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			zenheadbutt: ["6L41", "5T", "5L41", "4T", "4L64"],
		},
	},
	krabby: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			allyswitch: ["6E"],
			amnesia: ["6E", "5E", "5D", "4E", "3E"],
			ancientpower: ["6E", "5E", "4T", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6E", "5E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["6L39", "5L39", "4M", "4L39"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L15", "5L15", "4L15"],
			captivate: ["4M"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			crabhammer: ["6L41", "5L41", "4L41", "3L45"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "4E", "3M", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flail: ["6L45", "6E", "5L45", "5E", "4L45", "4E", "3L49", "3E"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["6L31", "5L31", "4L31", "3L34"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L11", "5L11", "4L11", "3L16"],
			haze: ["6E", "5E", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["6E", "5T", "5E", "4T", "4E", "3E"],
			leer: ["6L9", "5L9", "4L9", "3L5"],
			metalclaw: ["6L21", "5L21", "4L21"],
			mimic: ["3T"],
			mudshot: ["6L19", "5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L38"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "5D", "4M", "3M"],
			slam: ["6L35", "6E", "5L35", "5E", "4L35", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stomp: ["6L25", "5L25", "4L25", "3L27"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			visegrip: ["6L5", "5L5", "5D", "4L5", "3L12"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	kingler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["6L51", "5L51", "4M", "4L51"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L15", "5L15", "4L15"],
			captivate: ["4M"],
			confide: ["6M"],
			crabhammer: ["6L56", "5L56", "4L56", "3L57"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flail: ["6L63", "5L63", "4L63", "3L65"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			guillotine: ["6L37", "5L37", "4L37", "3L38"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L11", "5L11", "4L11", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L9", "3L1"],
			metalclaw: ["6L21", "5L21", "4L21", "3L1"],
			mimic: ["3T"],
			mudshot: ["6L19", "5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L42"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			slam: ["6L44", "5L44", "4L44"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stomp: ["6L25", "5L25", "4L25", "3L27"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			visegrip: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wideguard: ["6L1", "5L1"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	voltorb: {
		inherit: true,
		learnset: {
			charge: ["6L1", "5L1", "5D", "4L1", "3L1"],
			chargebeam: ["6M", "6L22", "5M", "5L22", "4M", "4L26"],
			confide: ["6M"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			eerieimpulse: ["6L10"],
			electroball: ["6L29", "5L29"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L47", "5M", "5L47", "4M", "4L43", "3T", "3L46"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "6L43", "5M", "5L43", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			lightscreen: ["6M", "6L26", "5M", "5L26", "4M", "4L22", "3M", "3L37"],
			magiccoat: ["5T", "4T"],
			magnetrise: ["6L40", "5T", "5L40", "4T", "4L36"],
			mimic: ["3T"],
			mirrorcoat: ["6L50", "5L50", "4L47", "3L49", "3S0"],
			naturalgift: ["5D", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["6L15", "5L15", "4T", "4L15", "3T", "3L32"],
			round: ["6M", "5M"],
			screech: ["6L19", "5L19", "4L19", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L33", "5L33", "4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "5D", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			sonicboom: ["6L8", "5L8", "4L8", "3L15"],
			spark: ["6L12", "5L12", "4L12", "3L21", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L36", "5L36", "4T", "4L33", "3T", "3L42", "3S0"],
			tackle: ["6L5", "5L5", "4L5", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	electrode: {
		inherit: true,
		learnset: {
			charge: ["6L1", "5L1", "4L1", "3L1"],
			chargebeam: ["6M", "6L22", "5M", "5L22", "4M", "4L26"],
			confide: ["6M"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			eerieimpulse: ["6L8"],
			electroball: ["6L29", "5L29"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L57", "5M", "5L57", "4M", "4L51", "3T", "3L54"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "6L51", "5M", "5L51", "4M", "4L46"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			lightscreen: ["6M", "6L26", "5M", "5L26", "4M", "4L22", "3M", "3L41"],
			magiccoat: ["5T", "4T"],
			magneticflux: ["6L1"],
			magnetrise: ["6L46", "5T", "5L46", "4T", "4L40"],
			mimic: ["3T"],
			mirrorcoat: ["6L62", "5L62", "4L57", "3L59"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["6L15", "5L15", "4T", "4L15", "3T", "3L34"],
			round: ["6M", "5M"],
			screech: ["6L19", "5L19", "4L19", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L35", "5L35", "4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			sonicboom: ["6L1", "5L1", "4L1", "3L1"],
			spark: ["6L1", "5L1", "4L1", "3L21"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L40", "5L40", "4T", "4L35", "3T", "3L48"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	exeggcute: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			barrage: ["6L1", "5L1", "5D", "4L1", "3L1"],
			bestow: ["6L50", "5L53"],
			block: ["6E", "5T", "5E"],
			bulletseed: ["6L17", "5L17", "4M", "4L17", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L27", "5L27", "4L27", "3L19"],
			curse: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			extrasensory: ["6L47", "5L47"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6E", "5T", "5E", "5D", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6E"],
			gravity: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1"],
			infestation: ["6M"],
			ingrain: ["6E", "5E", "4E", "3E"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6L11", "5L11", "4L11", "3L13"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E", "4E"],
			mimic: ["3T"],
			moonlight: ["6E", "5E", "4E", "3E"],
			naturalgift: ["6L37", "6E", "5L37", "5E", "4M", "4L37"],
			naturepower: ["6M", "6E", "5E", "4E"],
			nightmare: ["3T"],
			poisonpowder: ["6L21", "5L21", "4L21", "3L31"],
			powerswap: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "5L47", "4M", "4L47", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			reflect: ["6M", "6L7", "5M", "5L7", "4M", "4L7", "4E", "3M", "3L7", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeppowder: ["6L23", "5L23", "4L23", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			strength: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L19", "5L19", "4L19", "3L25"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["3S0"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			wish: ["3S0"],
			worryseed: ["6L33", "5T", "5L33", "4T", "4L33"],
		},
	},
	exeggutor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			barrage: ["6L1", "5L1", "4L1", "3L1"],
			block: ["5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			eggbomb: ["6L27", "5L27", "4L27", "3L31"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			infestation: ["6M"],
			leafstorm: ["6L47", "5L47", "4L47"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M", "3S0"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "6L17", "5M", "5L17"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6L1", "5T", "5L1", "4T", "4L1"],
			selfdestruct: ["3T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L1", "5L1", "4L1", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trickroom: ["6M", "5M", "4M"],
			woodhammer: ["6L37", "5L37", "4L37"],
			worryseed: ["5T", "4T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	cubone: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["6L7", "5L7", "5D", "4L7", "3L9"],
			bonemerang: ["6L21", "5L21", "4L21", "3L25"],
			bonerush: ["6L37", "5L37", "4L37", "3L41"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			counter: ["3T"],
			detect: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L43", "5L43", "4L43", "3T", "3L45"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L41", "5T", "5L41", "4T", "4L41"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3L33"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L33", "5M", "5L33", "4M", "4L33"],
			focusenergy: ["6L17", "5L17", "4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["6L11", "5L11", "4T", "4L11", "3L13"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["6E", "5T", "5E", "4E"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leer: ["6L13", "5L13", "4L13", "3L17"],
			lowkick: ["5T", "5D", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["6E", "5E", "5D", "4E", "3E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L23", "5L23", "4L23", "3L29"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "6L47", "5M", "5L47"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["6L3", "5L3", "4L3", "3L5"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L31", "5L31", "4L31", "3L37"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	marowak: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["6L1", "5L1", "4L1", "3L1"],
			bonemerang: ["6L21", "5L21", "4L21", "3L25"],
			bonerush: ["6L43", "5L43", "4L43", "3L53"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L53", "5L53", "4L53", "3T", "3L61"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M", "3S0"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L49", "5T", "5L49", "4T", "4L49"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3L39"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L37", "5M", "5L37", "4M", "4L37"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L17", "5L17", "4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leer: ["6L13", "5L13", "4L13", "3L17"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L23", "5L23", "4L23", "3L32"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "6L59", "5M", "5L59"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T", "3S0"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sing: ["3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T", "3S0"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L33", "5L33", "4L33", "3L46"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	tyrogue: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L1", "5L1", "5D", "4L1"],
			feint: ["6E", "5E", "5D"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6L1", "6E", "5T", "5L1", "5E", "4T", "4L1", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			highjumpkick: ["6E", "5E", "4E", "3E"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6E", "5E", "5D", "4E", "3E"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			vacuumwave: ["6E", "5E", "4T", "4E"],
			workup: ["5M"],
		},
	},
	hitmonlee: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blazekick: ["6L45", "5L45", "4L41"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L20"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6L1", "5L57", "4L53"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doublekick: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6L49", "5L49", "4M", "4L45", "3T", "3L41"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L25", "5L25", "4L25"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L21", "5L21", "4L21", "3L21"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L37", "5L37", "4L37", "3L36"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			highjumpkick: ["6L29", "5L29", "4L29", "3L26", "3S0"],
			jumpkick: ["6L13", "5L13", "4L13", "3L16"],
			knockoff: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			meditate: ["6L5", "5L5", "4L5", "3L6"],
			megakick: ["6L1", "5L53", "4L49", "3T", "3L46", "3S0"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["6L33", "5L33", "4L33", "3L31", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L1", "5L1", "4L1", "3L1"],
			reversal: ["6L1", "5L61", "4L57", "3L51"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollingkick: ["6L9", "5L9", "4L9", "3L11"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			wideguard: ["6L41", "5L41"],
			workup: ["5M"],
		},
	},
	hitmonchan: {
		inherit: true,
		learnset: {
			agility: ["6L6", "5L6", "4L6", "3L7"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6L16", "5L16", "4L16"],
			captivate: ["4M"],
			closecombat: ["6L1", "5L66", "4L56"],
			cometpunch: ["6L1", "5L1", "4L1", "3L1"],
			confide: ["6M"],
			counter: ["6L1", "5L61", "4L51", "3T", "3L50"],
			covet: ["5T"],
			detect: ["6L50", "5L51", "4L46", "3L44"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L21", "5L21", "4L21"],
			firepunch: ["6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["6L1", "5L56", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6L16", "5L16", "4L16", "3L20"],
			megakick: ["3T"],
			megapunch: ["6L46", "5L46", "4L41", "3T", "3L38", "3S0"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L11", "5L11", "4L11", "3L13"],
			quickguard: ["6L31", "5L31"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L1", "5L1", "4L1", "3L1"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			skyuppercut: ["6L41", "5L41", "4L36", "3L32", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["6L26", "5L26", "4T", "4L26"],
			workup: ["5M"],
		},
	},
	hitmontop: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			agility: ["6L37", "5L37", "4L37", "3L37"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6L1", "5L55", "5S0", "4L51"],
			confide: ["6M"],
			counter: ["6L28", "5L28", "4L28", "3T", "3L31"],
			covet: ["5T"],
			detect: ["6L50", "5L51", "4L46", "3L43"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["6L1", "5T", "5L60", "4T", "4L55", "3L49"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["5S0"],
			feint: ["6L33", "5L33", "4L33"],
			focusenergy: ["6L6", "5L6", "4L6", "3L7"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "6L42", "5M", "5L42", "4M", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["5T", "5S0", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L10", "5L10", "4L10", "3L13"],
			quickattack: ["6L15", "5L15", "4L15", "3L19"],
			quickguard: ["6L46", "5L46"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L24", "5L24", "4L24", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L1", "5L1", "4L1", "3L1"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollingkick: ["6L1", "5L1", "4L1", "3L1"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["5S0", "4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			triplekick: ["6L19", "5L19", "4L19", "3L20"],
			twister: ["4T"],
			vacuumwave: ["4T"],
			wideguard: ["6L46", "5L46"],
			workup: ["5M"],
		},
	},
	lickitung: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6E"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L37", "5L37"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L9", "5L9", "4L9", "3T", "3L12", "3S1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6L25", "5L25", "4L25", "3L34"],
			doubleedge: ["3T", "3S1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			helpinghand: ["3S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["6L13", "5T", "5L13", "4T", "4L13", "3L18"],
			lick: ["6L1", "5L1", "5D", "4L1", "3L1"],
			magnitude: ["6E", "5E", "4E", "3E"],
			mefirst: ["6L41", "5L41", "4L37"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			muddywater: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			powerwhip: ["6L53", "5L53", "4L49"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6L45", "5L45", "4L41", "3L51"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L33", "5L33", "4T", "4L33", "3T", "3S1"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			screech: ["6L49", "5L49", "4L45", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["6L29", "5L29", "4L29", "3L40"],
			sleeptalk: ["6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L21", "5L21", "4L21", "3L23"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L5", "5L5", "4L5", "3L7"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["5M"],
			wrap: ["6L17", "5L17", "4L17", "3L29"],
			wringout: ["6L57", "5L57", "4L53"],
			zenheadbutt: ["6E", "5T", "5E", "4T"],
		},
	},
	lickilicky: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M"],
			block: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L37", "5L37"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6L9", "5L9", "4L9"],
			dig: ["6M", "5M", "4M"],
			disable: ["6L25", "5L25", "4L25"],
			doubleteam: ["6M", "5M", "4M"],
			dragontail: ["6M", "5M"],
			dreameater: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "6L61", "5M", "5L61", "4M", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			knockoff: ["6L13", "5T", "5L13", "4T", "4L13"],
			lick: ["6L1", "5L1", "4L1"],
			mefirst: ["6L41", "5L41", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			powerwhip: ["6L1", "5L53", "4L49"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			refresh: ["6L45", "5L45", "4L41"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["6L33", "5L33", "4T", "4L33"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			screech: ["6L49", "5L49", "4L45"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			slam: ["6L29", "5L29", "4L29"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stomp: ["6L21", "5L21", "4L21"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			supersonic: ["6L5", "5L5", "4L5"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			wrap: ["6L17", "5L17", "4L17"],
			wringout: ["6L1", "5L57", "4L53"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	koffing: {
		inherit: true,
		learnset: {
			assurance: ["6L12", "5L15", "4L15"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L42"],
			captivate: ["4M"],
			clearsmog: ["6L15", "5L19"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			destinybond: ["6L40", "6E", "5L51", "5E", "4L46", "4E", "3L45", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L37", "5M", "5L42", "4M", "4L37", "3T", "3L41"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grudge: ["6E", "5E", "4E"],
			gyroball: ["6M", "6L29", "5M", "5L37", "4M", "4L33"],
			haze: ["6L26", "5L33", "4L28", "3L33"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			memento: ["6L45", "5L55", "4L51", "3L49"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["6E", "5T", "5E", "4T", "4E", "3E"],
			payback: ["6M", "5M", "4M"],
			poisongas: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E"],
			psywave: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L23", "5L24", "4L19", "3T", "3L17"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L18", "5L28", "4L24", "3L21"],
			sludgebomb: ["6M", "6L34", "5M", "5L46", "4M", "4L42", "3M"],
			sludgewave: ["5D"],
			smog: ["6L4", "5L6", "5D", "4L6", "3L9"],
			smokescreen: ["6L7", "5L10", "4L10", "3L25"],
			snore: ["5T", "4T", "3T"],
			spite: ["6E", "5T", "5E", "4T", "4E"],
			spitup: ["6E", "5E"],
			stockpile: ["6E", "5E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6E"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M", "4E", "3E"],
		},
	},
	weezing: {
		inherit: true,
		learnset: {
			assurance: ["6L12", "5L15", "4L15"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L50"],
			captivate: ["4M"],
			clearsmog: ["6L15", "5L19"],
			confide: ["6M"],
			darkpulse: ["6M", "5T", "4M"],
			destinybond: ["6L46", "5L59", "4L55", "3L51"],
			doublehit: ["6L29", "5L39", "4L33"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L40", "5M", "5L46", "4M", "4L40", "3T", "3L44"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			haze: ["6L26", "5L33", "4L28", "3L33"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			memento: ["6L54", "5L65", "4L63", "3L58"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisongas: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L23", "5L24", "4L19", "3T", "3L1"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L18", "5L28", "4L24", "3L21"],
			sludgebomb: ["6M", "6L34", "5M", "5L52", "4M", "4L48", "3M"],
			smog: ["6L1", "5L1", "4L1", "3L1"],
			smokescreen: ["6L1", "5L1", "4L1", "3L25"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	rhyhorn: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "6L30", "5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["6L34", "5L34"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D", "4E", "3T", "3E"],
			crunch: ["6E", "5E", "4E", "3E"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			curse: ["6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["5D", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragonrush: ["6E", "5E", "4E"],
			drillrun: ["6L45", "5T", "5L45"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L56", "5M", "5L56", "4M", "4L49", "3M", "3L52"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6E", "5E", "4E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L12", "5L12", "4L13", "3L15"],
			guardsplit: ["6E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L1", "5L1", "5D", "4L1", "3L1"],
			horndrill: ["6L63", "5L63", "4L37", "3L38"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6E", "5E", "4E"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			magnitude: ["6E", "5E", "4E", "3E"],
			megahorn: ["6L67", "5L67", "4L57", "3L57"],
			metalburst: ["6E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			roar: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L23", "5L23", "4L25", "3L29"],
			rockclimb: ["6E", "5E", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L19", "5L19", "4L21", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			skullbash: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L8", "5L8", "4L9", "3L10"],
			stoneedge: ["6M", "6L52", "5M", "5L52", "4M", "4L45"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L41", "5L41", "4L33", "3L43"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	rhydon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6L30", "5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["6L34", "5L34"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			drillrun: ["6L47", "5T", "5L47"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L62", "5M", "5L62", "4M", "4L49", "3M", "3L58", "3S0"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L1", "5L1", "4L1", "3L1"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hammerarm: ["6L42", "5L42", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L1", "5L1", "4L1", "3L1"],
			horndrill: ["6L1", "5L71", "4L37", "3L38"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			megahorn: ["6L1", "5L77", "4L57", "3L66", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L23", "5L23", "4L25", "3L29"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L19", "5L19", "4L21", "3L24", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L1", "5L1", "4L1", "3L1"],
			stoneedge: ["6M", "6L56", "5M", "5L56", "4M", "4L45"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L41", "5L41", "4L33", "3L46"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			whirlpool: ["4M"],
		},
	},
	rhyperior: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			block: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L30", "5L30"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			drillrun: ["6L47", "5T", "5L47"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L62", "5M", "5L62", "4M", "4L49"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6L1", "5L1", "4L1"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			hammerarm: ["6L42", "5L42", "4L42"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hornattack: ["6L1", "5L1", "4L1"],
			horndrill: ["6L1", "5L71", "4L37"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			megahorn: ["6L1", "5L77", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockblast: ["6L23", "5L23", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rockwrecker: ["6L1", "5L86", "4L61"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L19", "5L19", "4L21"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L1", "5L1", "4L1"],
			stoneedge: ["6M", "6L56", "5M", "5L56", "4M", "4L45"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			tailwhip: ["6L1", "5L1", "4L1"],
			takedown: ["6L41", "5L41", "4L33"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			whirlpool: ["4M"],
		},
	},
	happiny: {
		inherit: true,
		learnset: {
			aromatherapy: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "4L1"],
			confide: ["6M"],
			copycat: ["6L5", "5L5", "4L5"],
			counter: ["6E", "5E", "4E"],
			covet: ["5T"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["6E", "5E", "4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6E", "5T", "5E", "4T", "4E"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6E", "5T", "5E", "4T", "4E"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["6M", "5M", "4M"],
			metronome: ["6E", "5E", "4E"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["6E", "5E", "4M"],
			pound: ["6L1", "5L1", "4L1"],
			present: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			refresh: ["6L9", "5L9", "4L9"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "4E"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			sweetkiss: ["6L12", "5L12", "4L12"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	chansey: {
		inherit: true,
		learnset: {
			aromatherapy: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bestow: ["6L20", "5L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D", "4E", "3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L1", "5L1", "4L31", "3T", "3L41"],
			doubleedge: ["6L1", "5L54", "4L46", "3T", "3L57"],
			doubleslap: ["6L12", "5L12", "4L16", "3L17"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			eggbomb: ["6L42", "5L42", "4L38", "3L35"],
			endeavor: ["5T", "4T"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L34", "5M", "5L34", "4M", "4L27"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6E", "5T", "5E", "4T", "4E"],
			growl: ["6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["6E", "5T", "5E", "4T", "4E", "3E"],
			healingwish: ["6L50", "5L50", "4L42"],
			healpulse: ["6L38", "5L38"],
			helpinghand: ["6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "6L46", "5M", "5L46", "4M", "4L34", "3M", "3L49"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6E", "5E", "4E", "3T", "3E"],
			mimic: ["3T"],
			minimize: ["6L23", "5L23", "4L20", "3L23"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			pound: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			poweruppunch: ["6M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			refresh: ["6L9", "5L9", "4L9", "3L9", "3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6E", "3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["6L31", "5L31", "4L23", "3L29"],
			skillswap: ["5T", "4M", "3M", "3S2"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["6L16", "5L16", "4L12", "3T", "3L13", "3S2"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["3S2"],
			sweetscent: ["3S0"],
			tailwhip: ["6L5", "5L5", "4L5", "3L5", "3S1"],
			takedown: ["6L27", "5L27"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M", "3S2"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			wish: ["3S0"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	blissey: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bestow: ["6L20", "5L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L1", "5L1", "4L31", "3T", "3L33"],
			doubleedge: ["6L1", "5L54", "4L46", "3T", "3L47"],
			doubleslap: ["6L12", "5L12", "4L16", "3L13"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			eggbomb: ["6L42", "5L42", "4L38", "3L28"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L34", "5M", "5L34", "4M", "4L27"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			growl: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healingwish: ["6L50", "5L50", "4L42"],
			healpulse: ["6L38", "5L38"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "6L46", "5M", "5L46", "4M", "4L34", "3M", "3L40"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			minimize: ["6L23", "5L23", "4L20", "3L18"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			refresh: ["6L9", "5L9", "5S0", "4L9", "3L7"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["6L31", "5L31", "4L23", "3L23"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["6L16", "5L16", "4L12", "3T", "3L10"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L5", "5L5", "5S0", "4L5", "3L4"],
			takedown: ["6L27", "5L27"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	tangela: {
		inherit: true,
		learnset: {
			absorb: ["6L10", "5L8", "4L8", "3L10"],
			amnesia: ["6E", "5E", "4E", "3E"],
			ancientpower: ["6L38", "5L36", "4T", "4L33"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["6L17", "5T", "5L22", "4L22", "3L28"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6E", "5E", "4E", "3E"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endeavor: ["6E", "5T", "5E", "4E"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L36", "6E", "5T", "5L36", "5E", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6L48"],
			growth: ["6L20", "5L12", "4L12", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			ingrain: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			knockoff: ["6L27", "5T", "5L33", "4T", "4L36"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6E", "5E", "5D", "4E", "3E"],
			megadrain: ["6L23", "6E", "5L26", "5E", "4L26", "4E", "3L31", "3E"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["6L33", "6E", "5L40", "5E", "4M", "4L40"],
			naturepower: ["6E", "5E", "4E", "3E"],
			painsplit: ["5T", "4T"],
			poisonpowder: ["6L14", "5L15", "4L15", "3L19"],
			powerswap: ["6E", "5E", "4E"],
			powerwhip: ["6L50", "5L54", "4L54"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			ragepowder: ["6E", "5E"],
			reflect: ["6M", "5M", "4M", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "5D", "4T"],
			shockwave: ["4M"],
			slam: ["6L41", "5L43", "4L43", "3L40"],
			sleeppowder: ["6L4", "5L5", "5D", "4L5", "3L4"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M", "3S0"],
			stunspore: ["6L30", "5L29", "4L29", "3L37"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6L44", "5L47", "4L47", "3L46"],
			toxic: ["6M", "5M", "4M", "3M"],
			vinewhip: ["6L7", "5L19", "4L19", "3L22"],
			worryseed: ["5T", "4T"],
			wringout: ["6L46", "5L50", "4L50"],
		},
	},
	tangrowth: {
		inherit: true,
		learnset: {
			absorb: ["6L10", "5L8", "4L8"],
			aerialace: ["6M", "5M", "4M"],
			ancientpower: ["6L40", "5L36", "4T", "4L33", "4S0"],
			attract: ["6M", "5M", "4M"],
			bind: ["6L17", "5T", "5L22", "4L22"],
			block: ["6L1", "5T", "5L57", "4T", "4L57"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endeavor: ["5T"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["6L36", "5T", "5L36", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6L50"],
			growth: ["6L20", "5L12", "4L12"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			ingrain: ["6L1", "5L1", "4L1"],
			knockoff: ["6L27", "5T", "5L33", "4T", "4L36"],
			megadrain: ["6L23", "5L26", "4L26"],
			mudslap: ["4T"],
			naturalgift: ["6L33", "5L40", "4M", "4L40", "4S0"],
			naturepower: ["6M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poisonpowder: ["6L14", "5L15", "4L15"],
			powerwhip: ["6L53", "5L54", "4L54"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shockwave: ["4M"],
			slam: ["6L43", "5L43", "4L43"],
			sleeppowder: ["6L4", "5L5", "4L5"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			stunspore: ["6L30", "5L29", "4L29"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M", "4S0"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M"],
			tickle: ["6L46", "5L47", "4L47"],
			toxic: ["6M", "5M", "4M"],
			vinewhip: ["6L7", "5L19", "4L19"],
			worryseed: ["5T", "4T"],
			wringout: ["6L49", "5L50", "4L50"],
		},
	},
	kangaskhan: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L13", "5L13", "4L13", "3L7", "3S1"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L31", "5L31"],
			circlethrow: ["6E", "5E"],
			cometpunch: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D", "4E", "3T", "3E"],
			covet: ["5T"],
			crunch: ["6L37", "5L37", "4L31"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E", "3E"],
			dizzypunch: ["6L34", "5L34", "4L25", "3L43", "3S2"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doublehit: ["6L19", "5L19", "4L43"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "5D", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "6S3", "5M", "4M", "3M", "3S2"],
			endeavor: ["6E", "5T", "5E", "4T", "4E"],
			endure: ["6L43", "5L43", "4M", "4L34", "3T", "3L37"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L7", "6S3", "5L7", "5D", "4L7", "3L19"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["6L25", "5L25", "4L19", "3T", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6L46", "5T", "5L46", "4T", "4L37"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L22", "5L22", "4L22", "3L31"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "6S3", "5M", "4M", "3M"],
			reversal: ["6L50", "5L55", "4L49", "3L49"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sing: ["3S2"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stomp: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["6L49", "6S3", "5L49", "4T", "4L46"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L10", "5L10", "4L10", "3L13", "3S2"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6E", "5E"],
			uproar: ["6E", "5T", "5E", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["5M"],
			yawn: ["3S0"],
		},
	},
	horsea: {
		inherit: true,
		learnset: {
			agility: ["6L23", "5L23", "4L23", "3L36"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6L30", "5L30", "5D", "4M", "4L30"],
			bubble: ["6L11", "5L1", "5D", "5S0", "4L1", "3L1"],
			bubblebeam: ["6L18", "5L18", "4L18"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			disable: ["6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6E", "5E", "4E", "3E"],
			dragondance: ["6L38", "5L38", "4L38", "3L50"],
			dragonpulse: ["6L42", "5T", "5L42", "4M", "4L42"],
			dragonrage: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6L14", "5L14", "4L14"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L35", "5L35", "4L35", "3L43"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			leer: ["6L8", "5L8", "4L8", "3L15"],
			mimic: ["3T"],
			muddywater: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			octazooka: ["6E", "5E", "5D", "4E", "3E"],
			outrage: ["6E", "5T", "5E", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L4", "5L4", "4L4", "3L8"],
			snore: ["5T", "4T", "3T"],
			splash: ["6E", "5E", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L26", "5L26", "4T", "4L26", "3L29"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L11", "4L11", "3L22"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	seadra: {
		inherit: true,
		learnset: {
			agility: ["6L23", "5L23", "4L23", "3L40", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6L30", "5L30", "4M", "4L30"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6L48", "5L48", "4L48", "3L62"],
			dragonpulse: ["6L57", "5T", "5L57", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6L14", "5L14", "4L14"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L40", "5L40", "4L40", "3L51"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L26", "5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	kingdra: {
		inherit: true,
		learnset: {
			agility: ["6L23", "5L23", "4L23", "3L40", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brine: ["6L30", "5L30", "4M", "4L30"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "5S1", "4T"],
			dragondance: ["6L48", "5L48", "4L48", "3L62"],
			dragonpulse: ["6L1", "5T", "5L57", "5S1", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6L14", "5L14", "4L14"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L40", "5L40", "4L40", "3L51"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			muddywater: ["5S1"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "5S1", "4M", "3M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L26", "5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["6L1", "5L1", "4L1"],
		},
	},
	goldeen: {
		inherit: true,
		learnset: {
			agility: ["6L47", "5L47", "4L47", "3L52"],
			aquaring: ["6L27", "5L27", "4L27"],
			aquatail: ["6E", "5T", "5E", "4T", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E"],
			bounce: ["5T", "4T"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L21", "5L21", "4L21", "3L24"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L31", "5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L11", "5L11", "4L11", "3L15"],
			horndrill: ["6L41", "5L41", "4L41", "3L43"],
			hydropump: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			knockoff: ["5T", "4T"],
			megahorn: ["6L57", "5L57", "4L51", "3L57"],
			mimic: ["3T"],
			mudshot: ["6E", "5E"],
			mudslap: ["6E", "5E", "4T", "4E"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "5D", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E"],
			skullbash: ["6E", "5E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L50", "5L51"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L7", "5L7", "4L7", "3L10"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L38"],
			waterpulse: ["6L17", "5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	seaking: {
		inherit: true,
		learnset: {
			agility: ["6L56", "5L56", "4L56", "3L61"],
			aquaring: ["6L27", "5L27", "4L27"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			endure: ["5D", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L21", "5L21", "4L21", "3L24"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L31", "5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L11", "5L11", "4L11", "3L15"],
			horndrill: ["6L47", "5L47", "4L47", "3L49"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			knockoff: ["5T", "4T"],
			megahorn: ["6L1", "5L72", "4L63", "3L69"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T", "5D", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L63", "5L63"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L41"],
			waterpulse: ["6L17", "5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	staryu: {
		inherit: true,
		learnset: {
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6L36", "5L36", "4M"],
			bubblebeam: ["6L22", "5L28", "4L28", "3L28"],
			camouflage: ["6L15", "5L19", "4L19", "3L19"],
			confide: ["6M"],
			cosmicpower: ["6L48", "5L55", "4L51", "3L42", "3S0"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L30", "5M", "5L37", "4M", "4L37"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L52", "5L60", "4L55", "3L46", "3S0"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "5D", "4T", "3T"],
			lightscreen: ["6M", "6L33", "5M", "5L42", "4M", "4L42", "3M", "3L37", "3S0"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			minimize: ["6L25", "5L33", "4L33", "3L33", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			powergem: ["6L43", "5L51", "4L46"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L10", "5L10", "4L10", "3L10", "3S1"],
			recover: ["6L12", "5L15", "4L15", "3L15", "3S1"],
			recycle: ["5T", "5D", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6L40", "5L46"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L18", "5L24", "4T", "4L24", "3T", "3L24"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L6", "5L6", "5D", "4L6", "3L6", "3S1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	starmie: {
		inherit: true,
		learnset: {
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			confide: ["6M"],
			confuseray: ["6L22", "5L28", "4L28", "3L33"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M", "3S0"],
			icywind: ["5T", "4T", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L1", "5L1", "4L1", "3L1"],
			recover: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M", "3S0"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["5T"],
		},
	},
	mimejr: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			barrier: ["6L1", "5L1", "4L1"],
			batonpass: ["6L46", "5L46", "4L46"],
			brickbreak: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6E", "5E", "4E"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			confusion: ["6L1", "5L1", "4L1"],
			copycat: ["6L4", "5L4", "4L4"],
			covet: ["5T"],
			doubleslap: ["6L11", "5L15", "4L15"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M"],
			encore: ["6L18", "5L11", "4L11"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6E", "5E", "4E"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["6E", "5E", "4E"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hypnosis: ["6E", "5E", "4E"],
			icywind: ["6E", "5T", "5E"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			magiccoat: ["5T", "4T"],
			magicroom: ["6E", "5T", "5E"],
			meditate: ["6L8", "5L8", "4L8"],
			mimic: ["6L15", "6E", "5L18", "5E", "4L18", "4E"],
			mudslap: ["4T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			powersplit: ["6E", "5E"],
			protect: ["6M", "5M", "4M"],
			psybeam: ["6L25", "5L25", "4L25"],
			psychic: ["6M", "6L39", "5M", "5L39", "4M", "4L39"],
			psychup: ["6M", "5M", "4M", "4E"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["6L32", "5T", "5L32", "4M", "4L32"],
			reflect: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roleplay: ["6L43", "5T", "5L43", "4T", "4L43"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L50", "5M", "5L50", "4M", "4L50"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "6L29", "5M", "5L29", "4M", "4L29"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			teeterdance: ["6E", "5E", "4E"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			tickle: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["6L36", "6E", "5T", "5L36", "5E", "4T", "4L36", "4E"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			wakeupslap: ["6E", "5E", "4E"],
			wonderroom: ["5T"],
		},
	},
	mrmime: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6L1", "5L1", "5D", "4L1", "3L1"],
			batonpass: ["6L46", "5L46", "4L46", "3L47"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			confusion: ["6L1", "5L1", "4L1", "3L5"],
			copycat: ["6L4", "5L4", "4L4"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleslap: ["6L11", "5L15", "4L15", "3L15"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			encore: ["6L18", "5L11", "4L11", "3L25", "3S0"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E", "3E"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S0"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			guardswap: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6E", "5E", "4E", "3E"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["6E", "5T", "5E"],
			infestation: ["6M"],
			irondefense: ["5T", "4T"],
			lightscreen: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L19"],
			magicalleaf: ["6L1", "5L1", "4L1", "3L22"],
			magiccoat: ["5T", "4T"],
			magicroom: ["6E", "5T", "5E"],
			meditate: ["6L8", "5L8", "4L8", "3L12"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["6L15", "6E", "5L18", "5E", "4L18", "4E", "3T", "3E"],
			mistyterrain: ["6L1"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			powersplit: ["6E", "5E"],
			powerswap: ["6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L25", "5L25", "4L25", "3L29"],
			psychic: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L43", "3S0"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			psywave: ["6L15", "5L15"],
			quickguard: ["6L1", "5L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["6L32", "5T", "5L32", "4M", "4L32", "3L33"],
			reflect: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L19"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["6L43", "5T", "5L43", "4T", "4L43", "3L40"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L50", "5M", "5L50", "4M", "4L50", "3M", "3L50"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3T", "3L8"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			teeterdance: ["6E", "5E", "5D", "4E"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T", "3S0"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6L36", "6E", "5T", "5L36", "5E", "4T", "4L36", "4E", "3L36", "3E"],
			trickroom: ["6M", "5M", "4M"],
			wakeupslap: ["6E", "5E", "4E"],
			wideguard: ["6L1", "5L1"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	scyther: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L17", "5L17", "5S2", "4L17", "3L21"],
			airslash: ["6L50", "5L53", "4L53"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "5D", "4E", "3E"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["6E", "5E", "4M"],
			doubleedge: ["3T"],
			doublehit: ["6L49", "5L49", "4L49"],
			doubleteam: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L41"],
			endure: ["6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L13", "5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["6L61", "5L61", "4L61"],
			focusenergy: ["6L5", "5L5", "4L5", "3L6", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L25", "5L25", "5S2", "4T", "4L25", "3T", "3L46"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			mimic: ["3T"],
			morningsun: ["3S1"],
			naturalgift: ["4M"],
			nightslash: ["6L45", "6E", "5L45", "5E", "4L45", "4E"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L9", "5L9", "4L9", "3L11"],
			quickattack: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6L33", "6E", "5L33", "5E", "4L33", "4E", "3E", "3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["6E", "5E", "4M", "4E", "3E", "3S1"],
			slash: ["6L29", "5L29", "5S2", "4L29", "3L31", "3S1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L57", "5M", "5L57", "4M", "4L57", "3T", "3L36"],
			tailwind: ["5T", "5D", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["6L1", "5L1", "4L1"],
			wingattack: ["6L21", "5L21", "5S2", "4L21", "3L26"],
			xscissor: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
		},
	},
	scizor: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "6S5", "5M", "4M", "3M"],
			agility: ["6L17", "6S5", "6S6", "5L17", "4L17", "4S1", "3L21"],
			attract: ["6M", "5M", "4M", "3M"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T", "5S2", "4T"],
			bulletpunch: ["6L1", "6S7", "5L1", "5S2", "4L1"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["6L49", "6S4", "5L49", "4L49"],
			doubleteam: ["6M", "5M", "4M", "3M", "3L41"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L13", "6S5", "6S6", "5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["6L1", "5L61", "4L61"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusenergy: ["6L5", "5L5", "5S3", "4L5", "3L6"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L25", "6S5", "6S6", "5L25", "4T", "4L25", "3T", "3L46", "3S0"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["6L37", "5T", "5L37", "4T", "4L37", "4S1", "3L41"],
			ironhead: ["6L50", "6S4", "5T", "5L53", "4T", "4L53"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "5S3", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			metalclaw: ["6L21", "6S6", "5L21", "4L21", "3L26", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["6L45", "6S4", "5L45", "4L45"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L9", "5L9", "5S3", "4L9", "3L11"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6L33", "5L33", "4L33"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6S7", "5T", "5S2", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["4M"],
			slash: ["6L29", "5L29", "4L29", "3L31", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "5S3", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L57", "6S7", "5M", "5L57", "5S2", "4M", "4L57", "4S1", "3T", "3L36", "3S0"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "6S7", "5M", "4M"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "6L41", "6S4", "5M", "5L41", "4M", "4L41", "4S1"],
		},
	},
	smoochum: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6L35", "5L35", "4M", "4L31"],
			blizzard: ["6M", "6L48", "5M", "5L48", "4M", "4L45", "3M", "3L57"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["6E", "5E", "5D", "4M"],
			confide: ["6M"],
			confusion: ["6L15", "5L15", "4L15", "3L21"],
			copycat: ["6L41", "5L41", "4L38"],
			counter: ["3T"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E", "3E"],
			faketears: ["6L28", "5L28", "4L25", "3L37"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			healbell: ["5T", "4T"],
			heartstamp: ["6L21", "5L21"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			icywind: ["5T", "4T", "3T"],
			lick: ["6L5", "5L5", "4L5", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L31", "5L31", "4L28"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meanlook: ["6L25", "5L25", "4L21", "3L33"],
			meditate: ["6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			perishsong: ["6L45", "5L45", "4L41", "3L49"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			powdersnow: ["6L11", "5L11", "4L11", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L38", "5M", "5L38", "4M", "4L35", "3M", "3L45"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["6L18", "5L18", "4L18", "3L25"],
			skillswap: ["5T", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L8", "5L8", "5D", "4L8", "3L9"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			wakeupslap: ["6E", "5E"],
			waterpulse: ["4M", "3M"],
			wish: ["6E", "5E", "4E", "3E"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	jynx: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6L39", "5L39", "4M", "4L33"],
			blizzard: ["6M", "6L60", "5M", "5L60", "4M", "4L55", "3M", "3L67"],
			bodyslam: ["6L44", "5L44", "4L39", "3T", "3L51"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doubleslap: ["6L15", "5L15", "4L15", "3L21"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainingkiss: ["6L1"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6L28", "5L28", "4L25", "3L41"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			heartstamp: ["6L21", "5L21"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6L18", "5T", "5L18", "4T", "4L18", "3T", "3L25"],
			icywind: ["5T", "4T", "3T"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lovelykiss: ["6L1", "5L1", "4L1", "3L1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meanlook: ["6L25", "5L25", "4L21", "3L35"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			perishsong: ["6L1", "5L55", "4L49", "3L57"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wakeupslap: ["6L33", "5L33", "4L28"],
			waterpulse: ["4M", "3M"],
			wringout: ["6L49", "5L49", "4L44"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	elekid: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crosschop: ["6E", "5E", "5D", "4E", "3E", "3S0"],
			discharge: ["6L33", "5L41", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["6E", "5E", "4E", "3T"],
			electroball: ["6L22", "5L31"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6E", "5E", "4E"],
			firepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hammerarm: ["6E", "5E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E", "3S0"],
			karatechop: ["6E", "5E", "4E", "3E"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "6L26", "5M", "5L26", "4M", "4L25", "3M", "3L17"],
			lowkick: ["6L8", "5T", "5L11", "4T", "4L10"],
			magnetrise: ["5T", "5D", "4T"],
			meditate: ["6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollingkick: ["6E", "5E", "4E", "3E"],
			round: ["6M", "5M"],
			screech: ["6L36", "5L51", "4L43", "3L33"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6L15", "5L21", "4M", "4L19", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L12", "5L16", "4T", "4L16", "3T", "3L25"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "6L43", "5M", "5L56", "4M", "4L46", "3M", "3L49"],
			thunderbolt: ["6M", "6L40", "5M", "5L46", "4M", "4L37", "3M", "3L41"],
			thunderpunch: ["6L29", "5T", "5L36", "4T", "4L28", "3T", "3L9", "3S0"],
			thundershock: ["6L5", "5L6", "5D", "4L7"],
			thunderwave: ["6M", "6L19", "5M", "5L19", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	electabuzz: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crosschop: ["3S1"],
			discharge: ["6L36", "5L44", "4L37"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			electroball: ["6L22", "5L32"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["6M", "6L26", "6S4", "5M", "5L26", "5S3", "4M", "4L25", "4S2", "3M", "3L17"],
			lowkick: ["6L8", "6S4", "5T", "5L11", "5S3", "4T", "4L10", "4S2"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6L42", "5L56", "4L52", "3L36"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6L15", "6S4", "5L21", "5S3", "4M", "4L19", "4S2", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L12", "5L16", "5S3", "4T", "4L16", "3T", "3L25"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "6L55", "5M", "5L62", "4M", "4L58", "3M", "3L58"],
			thunderbolt: ["6M", "6L49", "5M", "5L50", "4M", "4L43", "3M", "3L47", "3S1"],
			thunderpunch: ["6L29", "6S4", "5T", "5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			thundershock: ["6L1", "5L1", "4L1"],
			thunderwave: ["6M", "6L19", "5M", "5L19", "4M", "3T", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	electivire: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			crosschop: ["4S0"],
			dig: ["6M", "5M", "4M"],
			discharge: ["6L36", "5L44", "4L37", "4S1"],
			doubleteam: ["6M", "5M", "4M"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M", "4S0"],
			electricterrain: ["6L1"],
			electroball: ["6L22", "5L32"],
			electroweb: ["5T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "6L62", "5M", "5L68", "4M", "4L67"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T", "4S0"],
			iondeluge: ["6L1"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "6L26", "5M", "5L26", "4M", "4L25", "4S1"],
			lowkick: ["6L1", "5T", "5L1", "4T", "4L1"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			screech: ["6L42", "5L56", "4L52"],
			secretpower: ["6M", "4M"],
			shockwave: ["6L15", "5L21", "4M", "4L19"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L12", "5L16", "4T", "4L16"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "6L55", "5M", "5L62", "4M", "4L58"],
			thunderbolt: ["6M", "6L49", "5M", "5L50", "4M", "4L43", "4S1"],
			thunderpunch: ["6L29", "5T", "5L38", "4T", "4L28", "4S0", "4S1"],
			thundershock: ["6L1", "5L1", "4L1"],
			thunderwave: ["6M", "6L19", "5M", "5L19", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	magby: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			belch: ["6E"],
			bellydrum: ["6E", "5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["6L19", "5L19"],
			confide: ["6M"],
			confuseray: ["6L26", "5L25", "4L25", "3L43"],
			counter: ["3T"],
			covet: ["5T"],
			crosschop: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["6E", "5E", "4E", "3T"],
			ember: ["6L5", "5L7", "5D", "4L7", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L12", "5L16", "4L16"],
			fireblast: ["6M", "6L43", "5M", "5L49", "4M", "4L46", "3M", "3L49"],
			firepunch: ["6L29", "5T", "5L34", "4T", "4L28", "3T", "3L19"],
			firespin: ["6L15", "5L19", "4L19"],
			flameburst: ["6L22", "5L28"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L40", "5M", "5L43", "4M", "4L37", "3M", "3L37"],
			flareblitz: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			focusenergy: ["6E", "5E"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["5T", "5D", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			karatechop: ["6E", "5E", "4E", "3E"],
			lavaplume: ["6L33", "5L37", "4L34"],
			leer: ["6L1", "5L1", "4L1", "3L7"],
			machpunch: ["6E", "5E", "4E"],
			megakick: ["3T"],
			megapunch: ["6E", "5E", "4E", "3T", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			powerswap: ["6E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smog: ["6L1", "5L1", "4L1", "3L13"],
			smokescreen: ["6L8", "5L10", "4L10", "3L25"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L36", "5M", "5L46", "4M", "4L43", "3M", "3L31"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6E", "5T", "5E", "5D", "4T", "4E", "3T", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	magmar: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["6L19", "5L19"],
			confide: ["6M"],
			confuseray: ["6L26", "6S4", "5L26", "5S3", "4L25", "4S2", "3L49"],
			counter: ["3T"],
			covet: ["5T"],
			crosschop: ["3S1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			ember: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L12", "5L16", "5S3", "4L16"],
			fireblast: ["6M", "6L55", "5M", "5L62", "4M", "4L54", "3M", "3L57", "3S1"],
			firepunch: ["6L29", "6S4", "5T", "5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			firespin: ["6L15", "6S4", "5L21", "5S3", "4L19", "4S2"],
			flameburst: ["6L22", "5L32"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L49", "5M", "5L50", "4M", "4L41", "3M", "3L41"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lavaplume: ["6L36", "5L44", "4L36"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smog: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			smokescreen: ["6L8", "6S4", "5L11", "5S3", "4L10", "4S2", "3L25"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L42", "5M", "5L56", "4M", "4L49", "3M", "3L33"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	magmortar: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["6L19", "5L19"],
			confide: ["6M"],
			confuseray: ["6L26", "5L26", "4L25", "4S1"],
			covet: ["5T"],
			doubleteam: ["6M", "5M", "4M"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			ember: ["6L1", "5L1", "4L1"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L12", "5L16", "4L16"],
			fireblast: ["6M", "6L55", "5M", "5L62", "4M", "4L58"],
			firepunch: ["6L29", "5T", "5L38", "4T", "4L28", "4S1"],
			firespin: ["6L15", "5L21", "4L19"],
			flameburst: ["6L22", "5L32"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L49", "5M", "5L50", "4M", "4L43", "4S0", "4S1"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "6L62", "5M", "5L68", "4M", "4L67", "4S0"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			lavaplume: ["6L36", "5L44", "4L37", "4S1"],
			leer: ["6L1", "5L1", "4L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M", "4S0"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smog: ["6L1", "5L1", "4L1"],
			smokescreen: ["6L1", "5L1", "4L1"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M", "4S0"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "6L42", "5M", "5L56", "4M", "4L52"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	pinsir: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["6L4", "5T", "5L4", "4L4", "3L7"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "6L18", "5M", "5L21", "4M", "4L21", "3M", "3L31"],
			bugbite: ["6E", "5T", "5E"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6E", "5E", "5D", "4E"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "6S1", "6S2", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M", "4E", "3E", "3S0"],
			feint: ["6E", "6S2", "5E", "4E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			flail: ["6E", "5E", "4E", "3E"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6E", "5E", "4E", "3E"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			guillotine: ["6L47", "5L47", "4L47", "3L37", "3S0"],
			harden: ["6L11", "5L13", "4L13", "3L19"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			mefirst: ["6E", "5E", "5D"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6E", "6S2", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "6S1", "5M", "4M", "3M"],
			revenge: ["6L15", "5L18", "4L18", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L8", "5L8", "4L8", "3T", "3L13"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6S1", "5M", "4M"],
			stormthrow: ["6L33", "5L33"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			submission: ["6L26", "5L42", "4L42", "3L43", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6L43", "6E", "5T", "5L52", "5E", "4T", "4L52"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "6L40", "6S2", "5M", "5L38", "4M", "4L38", "3T", "3L49"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L36", "5L35", "4L35"],
			toxic: ["6M", "5M", "4M", "3M"],
			visegrip: ["6L1", "5L1", "5D", "4L1", "3L1"],
			vitalthrow: ["6L22", "5L25", "4L25"],
			xscissor: ["6M", "6L29", "6S1", "5M", "5L30", "4M", "4L30"],
		},
	},
	tauros: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T", "3S2"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M", "3S2"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "6L63", "5M", "5L63", "4M", "4L55"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L8", "5L8", "4L8", "3L8", "3S0", "3S1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "5D", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			payback: ["6M", "6L24", "5M", "5L24", "4M", "4L24"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L15", "5L15", "4L15", "3L19", "3S0"],
			rage: ["6L5", "5L5", "5D", "4L5", "3L4", "3S0", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S2"],
			rest: ["6M", "6L19", "5M", "5L19", "4M", "4L19", "3M", "3L34"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L11", "5L11", "4L11", "3L13", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L48", "5M", "5L48", "4M", "4L41", "3T", "3L26"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			tailwhip: ["6L3", "5L3", "4L3", "3L1", "3S1", "3S2"],
			takedown: ["6L41", "5L41", "4L35", "3L53"],
			thrash: ["6L50", "5L55", "4L48", "3L43"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["6M", "5M"],
			workup: ["6L29", "5M", "5L29"],
			zenheadbutt: ["6L35", "5T", "5L35", "4T", "4L29"],
		},
	},
	magikarp: {
		inherit: true,
		learnset: {
			bounce: ["5T", "5D", "5S5", "4T"],
			flail: ["6L30", "5L30", "5S5", "4L30", "3L30"],
			hydropump: ["5S5"],
			splash: ["6L1", "6S6", "5L1", "5D", "5S5", "4L1", "4S0", "4S1", "4S2", "4S3", "4S4", "3L1"],
			tackle: ["6L15", "5L15", "4L15", "3L15"],
		},
	},
	gyarados: {
		inherit: true,
		learnset: {
			aquatail: ["6L35", "5T", "5L35", "4T", "4L35"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L20", "6S1", "5L20", "4L20", "3L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			darkpulse: ["6M", "5T", "4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6L44", "6S0", "5L44", "4L44", "3L50"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L23", "5L23", "4L23", "3L25"],
			dragontail: ["6M", "5M"],
			earthquake: ["6M", "6S0", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L41", "5L41", "4L41", "3L40"],
			hyperbeam: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L55"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L32", "6S0", "6S1", "5L32", "4L32"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6S1", "5T", "4T"],
			irontail: ["5T"],
			leer: ["6L26", "5L26", "4L26", "3L30"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L38", "5M", "5L38", "4M", "4L38", "3M", "3L45"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thrash: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L29", "5L29", "4T", "4L29", "3L35"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "6S0", "6S1", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lapras: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6E", "5E", "4M"],
			blizzard: ["6M", "5M", "4M", "3M", "3S0"],
			block: ["5T", "4T"],
			bodyslam: ["6L18", "5L18", "4L18", "3T", "3L13"],
			brine: ["6L37", "5L37", "4M", "4L37"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L7", "5L7", "5D", "4L7", "3L19"],
			curse: ["6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E", "3E"],
			dragonpulse: ["6E", "5T", "5E", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillrun: ["5T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6E", "5E", "4E"],
			foresight: ["6E", "5E", "4E", "3E"],
			freezedry: ["6E"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			horndrill: ["6E", "5E", "5D", "4E", "3E"],
			hydropump: ["6L47", "5L49", "4L49", "3L49", "3S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L31"],
			iceshard: ["6L10", "5L10", "4L10"],
			icywind: ["5T", "5D", "4T", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mist: ["6L4", "5L4", "4L4", "3L7"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["5T", "4T"],
			perishsong: ["6L27", "5L27", "4L27", "3L25"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L37", "3S0"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L50", "5L55", "4L55", "3L55"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			tickle: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6L14", "5L14", "4M", "4L14", "3M"],
			whirlpool: ["6E", "5E", "4M", "4E"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	ditto: {
		inherit: true,
		learnset: {
			transform: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	eevee: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "5S2", "4M", "4S0", "3M"],
			babydolleyes: ["6L9", "6S3", "6S4"],
			batonpass: ["6L33", "5L36", "4L36", "3L36"],
			bite: ["6L17", "5L29", "4L29", "4S0", "3L30"],
			bodyslam: ["3T"],
			captivate: ["6E", "4M"],
			celebrate: ["6S3"],
			charm: ["6L29", "6E", "5L29", "5E", "5D", "4E", "3E"],
			confide: ["6M"],
			covet: ["6L23", "6E", "5T", "5L21", "5E", "4E", "4S0"],
			curse: ["6E", "5E", "4E", "3E"],
			detect: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L37", "5L37", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M", "5S2"],
			endure: ["6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "4E"],
			flail: ["6E", "5E", "4E", "4S1", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L15", "4L15", "3L16"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "6S4", "5T", "5L1", "4T", "4L1", "4S0", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M", "4S1", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "6S4", "5L22", "4L22", "4S1", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6L20"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "5S2", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S3", "5L8", "5D", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sing: ["5S2"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L10", "6S3", "6S4", "5D", "4T", "3T"],
			synchronoise: ["6E", "5E"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L25", "5L43", "4L43", "3L42"],
			tickle: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6L45", "5L57", "4L57", "4S1"],
			wish: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
			yawn: ["6E", "5E", "4E"],
		},
	},
	vaporeon: {
		inherit: true,
		learnset: {
			acidarmor: ["6L29", "5L64", "4L64", "3L47"],
			aquaring: ["6L25", "5L43", "4L43"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L20", "5L36", "4L36", "3L36"],
			bite: ["5L29", "4L29", "3L30"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6L33", "5L57", "4L57", "3L42"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L45", "5L71", "4L71", "3L52"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			mimic: ["3T"],
			muddywater: ["6L37", "5L78", "4L78"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L22", "4L22", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L9", "6S1", "5L15", "4L15", "3L16"],
			waterpulse: ["6L17", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	jolteon: {
		inherit: true,
		learnset: {
			agility: ["6L29", "5L64", "4L64", "3L47"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M", "3M"],
			discharge: ["6L37", "5L78", "4L78"],
			doubleedge: ["3T"],
			doublekick: ["6L17", "5L29", "4L29", "3L30"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pinmissile: ["6L25", "5L36", "4L36", "3L36"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L22", "4L22", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			thunder: ["6M", "6L45", "5M", "5L71", "4M", "4L71", "3M", "3L52"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L20", "5L43", "4L43"],
			thundershock: ["6L9", "6S1", "5L15", "4L15", "3L16"],
			thunderwave: ["6M", "6L33", "5M", "5L57", "4M", "4L57", "3T", "3L42"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	flareon: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L17", "5L29", "4L29", "3L30"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L9", "6S1", "5L15", "4L15", "3L16"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "5L71", "4M", "4L71", "3M"],
			firefang: ["6L20", "5L43", "4L43"],
			firespin: ["6L25", "5L36", "4L36", "3L36"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M", "3L52"],
			flareblitz: ["6L45"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			lavaplume: ["6L37", "5L78", "4L78"],
			leer: ["3L47"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L22", "4L22", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			scaryface: ["6L29", "5L64", "4L64"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smog: ["6L33", "5L57", "4L57", "3L42"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	espeon: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			celebrate: ["6S2"],
			confide: ["6M"],
			confusion: ["6L9", "6S2", "5L15", "4L15", "3L16"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L25", "5L43", "4L43"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mimic: ["3T"],
			morningsun: ["6L33", "5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerswap: ["6L45", "5L78", "4L78"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L20", "5L36", "4L36", "3L36", "3S0"],
			psychic: ["6M", "6L37", "5M", "5L64", "4M", "4L64", "3M", "3L47", "3S0"],
			psychup: ["6M", "6L29", "5M", "5L57", "4M", "4L57", "3T", "3L42", "3S0"],
			psyshock: ["6M", "5M"],
			quickattack: ["6L13", "5L22", "4L22", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S2", "5L8", "5S1", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L17", "5L29", "4T", "4L29", "3T", "3L30"],
			tackle: ["6L1", "5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["6L1", "6S2", "5L1", "5S1", "4L1", "3L1"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	umbreon: {
		inherit: true,
		learnset: {
			assurance: ["6L25", "5L43", "4L43"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			celebrate: ["6S2"],
			confide: ["6M"],
			confuseray: ["6L17", "5L29", "4L29", "3L30"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L20", "5L36", "4L36", "3L36", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			guardswap: ["6L45", "5L78", "4L78"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			meanlook: ["6L37", "5L57", "4L57", "3L42", "3S0"],
			mimic: ["3T"],
			moonlight: ["6L33", "5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6L9", "6S2", "5L15", "4L15", "3L16"],
			quickattack: ["6L13", "5L22", "4L22", "3L23"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S2", "5L8", "5S1", "4L8", "3L8"],
			screech: ["6L29", "5L64", "4L64", "3L47", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["6L1", "6S2", "5L1", "5S1", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			wonderroom: ["5T"],
			workup: ["5M"],
		},
	},
	leafeon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["6L25", "5T", "5L43", "4M", "4L43"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L17", "5L57", "4L57"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			leafblade: ["6L45", "5L71", "4L71"],
			magicalleaf: ["6L20", "5L36", "4L36"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L13", "5L22", "4L22"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6L9", "6S1", "5L15", "4L15"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S1", "5L8", "5S0", "4L8"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "6L37", "5M", "5L64", "4M", "4L64"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "6L29", "5M", "5L78", "4M", "4L78"],
			synthesis: ["6L33", "5T", "5L29", "4T", "4L29"],
			tackle: ["6L1", "5L1", "5S0", "4L1"],
			tailwhip: ["6L1", "6S1", "5L1", "5S0", "4L1"],
			toxic: ["6M", "5M", "4M"],
			workup: ["5M"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	glaceon: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			barrier: ["6L29", "5L78", "4L78"],
			bite: ["6L17", "5L29", "4L29"],
			blizzard: ["6M", "6L45", "5M", "5L71", "4M", "4L71"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["6M"],
			covet: ["5T"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "6L37", "5M", "5L64", "4M", "4L64"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			icefang: ["6L20", "5L43", "4L43"],
			iceshard: ["6L25", "5L36", "4L36"],
			icywind: ["6L9", "6S1", "5T", "5L15", "4T", "4L15"],
			irontail: ["5T", "4M"],
			lastresort: ["6L41", "5T", "5L50", "4T", "4L50"],
			mirrorcoat: ["6L33", "5L57", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L13", "5L22", "4L22"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "6S1", "5L8", "5S0", "4L8"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "5S0", "4L1"],
			tailwhip: ["6L1", "6S1", "5L1", "5S0", "4L1"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	porygon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L12", "5L12", "4L12", "3L9"],
			blizzard: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			conversion: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			conversion2: ["6L1", "5L1", "4L1", "3L1"],
			discharge: ["6L40", "5L40", "4L40"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lockon: ["6L45", "5L45", "4L45", "3L32"],
			magiccoat: ["6L56", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["6L23", "5T", "5L23", "4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L7", "5L7", "5S0", "4L7", "3L12"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L18", "5L18", "4L18", "3L20"],
			recycle: ["6L34", "5T", "5L34", "4M", "4L34", "3L44"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sharpen: ["6L1", "5L1", "5S0", "4L1", "3L24"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L29", "5T", "5L29", "4T", "4L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6L50", "5L51", "4L51", "3L36"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zapcannon: ["6L62", "5L62", "4L62", "3L48"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	porygon2: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L12", "5L12", "4L12", "3L9"],
			blizzard: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			conversion: ["6L1", "5L1", "4L1", "3L1"],
			conversion2: ["6L1", "5L1", "4L1", "3L1"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L24"],
			discharge: ["6L40", "5L40", "4L40"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L67", "5M", "5L67", "4M", "4L67", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lockon: ["6L45", "5L45", "4L45", "3L32"],
			magiccoat: ["6L1", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["6L23", "5T", "5L23", "4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L7", "5L7", "4L7", "3L12"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L18", "5L18", "4L18", "3L20"],
			recycle: ["6L34", "5T", "5L34", "4M", "4L34", "3L44"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L29", "5T", "5L29", "4T", "4L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["6L50", "5L51", "4L51", "3L36"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zapcannon: ["6L1", "5L62", "4L62", "3L48"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	porygonz: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			agility: ["6L12", "5L12", "4L12"],
			blizzard: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			conversion: ["6L1", "5L1", "4L1"],
			conversion2: ["6L1", "5L1", "4L1"],
			darkpulse: ["6M", "5T", "4M"],
			discharge: ["6L40", "5L40", "4L40"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			electroweb: ["5T"],
			embargo: ["6M", "6L34", "5M", "5L34", "4M", "4L34"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "6L67", "5M", "5L67", "4M", "4L67"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			irontail: ["5T", "4M"],
			lastresort: ["5T", "4T"],
			lockon: ["6L45", "5L45", "4L45"],
			magiccoat: ["6L1", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["6L23", "5T", "5L23", "4L23"],
			nastyplot: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M"],
			psybeam: ["6L7", "5L7", "4L7"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recover: ["6L18", "5L18", "4L18"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["6L29", "5T", "5L29", "4T", "4L29"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			triattack: ["6L50", "5L51", "4L51"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			uproar: ["5T", "4T"],
			wonderroom: ["5T"],
			zapcannon: ["6L1", "5L62", "4L62"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	omanyte: {
		inherit: true,
		learnset: {
			ancientpower: ["6L37", "5L37", "4T", "4L37", "3L49"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6E", "5E", "4E", "3E"],
			bide: ["6E", "5E"],
			bind: ["5T"],
			bite: ["6L7", "5L7", "5D", "5S0", "4L7", "3L13"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["6L28", "5L28", "4M", "4L28"],
			bubblebeam: ["6E", "5E", "5S0", "4E", "3E"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L55", "5L55", "4L52", "3L55"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "5D", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["6E", "5T", "5E", "4T", "4E"],
			leer: ["6L19", "5L19", "4L19", "3L31"],
			mimic: ["3T"],
			muddywater: ["6E", "5E", "5D", "4E"],
			mudshot: ["6L25", "5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L46", "5L46", "4L46"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L16", "5L16", "4T", "4L16", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["6L50", "5L52"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spikes: ["6E", "5E", "4E", "3E"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6E", "5E", "5S0", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6L43", "5L43", "4L43", "3L43"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6E", "5E", "4E"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "4L10", "3L19"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["6E", "5E", "4M"],
			withdraw: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			wringout: ["6E", "5E", "4E"],
		},
	},
	omastar: {
		inherit: true,
		learnset: {
			ancientpower: ["6L37", "5L37", "4T", "4L37", "3L55"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["6L28", "5L28", "4M", "4L28"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L1", "5L75", "4L67", "3L65"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leer: ["6L19", "5L19", "4L19", "3L31"],
			mimic: ["3T"],
			mudshot: ["6L25", "5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L56", "5L56", "4L56"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L16", "5L16", "4T", "4L16", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shellsmash: ["6L67", "5L67"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spikecannon: ["6L40", "5L40", "4L40", "3L40"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6L48", "5L48", "4L48", "3L46"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "4L10", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	kabuto: {
		inherit: true,
		learnset: {
			absorb: ["6L6", "5L6", "5D", "4L6", "3L13"],
			aerialace: ["3M"],
			ancientpower: ["6L46", "5L46", "4T", "4L46", "3L55"],
			aquajet: ["6L31", "5L31", "4L31"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "5S0", "4E", "3E"],
			dig: ["6M", "5M", "5S0", "4M", "4E", "3M", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["6L26", "5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "5D", "4E", "3E"],
			foresight: ["6E", "5E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6E", "5T", "5E", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["6E", "5T", "5E", "4T", "4E", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["6E", "5T", "5E", "4T", "4E", "3E"],
			leer: ["6L11", "5L11", "4L11", "3L19"],
			megadrain: ["6L36", "5L36", "4L36", "3L49"],
			metalsound: ["6L41", "5L41", "4L41", "3L43"],
			mimic: ["3T"],
			mudshot: ["6L16", "6E", "5L16", "5E", "4L16", "4E", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandattack: ["6L21", "5L21", "4L21", "3L31"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			scratch: ["6L1", "5L1", "5S0", "4L1", "3L1"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "5D", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6E"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["6L50", "5L51", "4L51"],
		},
	},
	kabutops: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6L54", "5L54", "4T", "4L54", "3L65"],
			aquajet: ["6L31", "5L31", "4L31"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["6L26", "5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T", "3L1"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megadrain: ["6L36", "5L36", "4L36", "3L55"],
			megakick: ["3T"],
			metalsound: ["6L45", "5L45", "4L45", "3L46"],
			mimic: ["3T"],
			mudshot: ["6L16", "5L16", "4L16", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			nightslash: ["6L1", "5L72", "4L72"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandattack: ["6L21", "5L21", "4L21", "3L31"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			slash: ["6L40", "5L40", "4L40", "3L40"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["6L63", "5L63", "4L63"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	aerodactyl: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L17", "5L17", "4L17", "3L8"],
			aircutter: ["4T"],
			ancientpower: ["6L25", "5L25", "4T", "4L25", "3L29"],
			aquatail: ["5T", "4T"],
			assurance: ["6E", "5E", "5D", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "5D", "4L1", "3L15"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L33", "5L33", "4L33"],
			curse: ["6E", "5E", "4E", "3E"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6E", "5E", "4E", "3E"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "5S0", "4L1"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "6L81", "5M", "5L81", "4M", "4L73"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L65", "5M", "5L65", "4M", "4L57", "3M", "3L50"],
			icefang: ["6L1", "5L1", "5S0", "4L1"],
			incinerate: ["6M", "5M"],
			ironhead: ["6L1", "5T", "5L57", "4T", "4L49"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L9", "5M", "5L9", "4M", "4L9", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L73", "5M", "5L73", "4M", "4L65", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6E", "5T", "5E", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L1", "5L1", "4L1", "3L36"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			skydrop: ["6M", "6L49", "5M", "5L49"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "5D", "4M"],
			steelwing: ["6M", "6E", "5E", "5S0", "4M", "4E", "3M", "3E"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L1", "5L1", "4L1", "3L22"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6E", "5T", "5E", "4T"],
			takedown: ["6L41", "5L41", "4L41", "3L43"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "5S0", "4L1"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			wideguard: ["6E"],
			wingattack: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	munchlax: {
		inherit: true,
		learnset: {
			afteryou: ["6E", "5T", "5E"],
			amnesia: ["6L9", "5L9", "4L9"],
			attract: ["6M", "5M", "4M"],
			belch: ["6E"],
			bellydrum: ["6L44"],
			blizzard: ["6M", "5M", "4M"],
			bodyslam: ["6L25", "5L36", "4L33"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6E", "5E", "4E"],
			chipaway: ["6L17", "5L25"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			covet: ["5T"],
			curse: ["6E", "5E", "4E", "4S1"],
			defensecurl: ["6L4", "5L4", "4L4", "4S0"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "6L41", "5M", "5L41", "4M", "4L36"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6L1", "5T", "5L57", "4T", "4L49"],
			lick: ["6L1", "6E", "5L12", "5E", "4L12", "4E"],
			metronome: ["6L1", "5L1", "4L1", "4S0", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["6L49", "6E", "5L49", "5E", "4M", "4L44"],
			odorsleuth: ["6L1", "5L1", "4L1", "4S1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["6L1", "5T", "5L17", "4M", "4L17"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["6L36", "5L44", "4T", "4L41"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			screech: ["6L20", "5L20", "4L20"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["6E", "5E", "4S0"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["6L1", "5T", "5L52"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stockpile: ["6L28", "5L28", "4L25"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "4E"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6L33", "5L33", "4L28"],
			tackle: ["6L1", "5L1", "4L1", "4S0", "4S1"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			whirlwind: ["6E", "5E", "4E"],
			workup: ["5M"],
			zenheadbutt: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	snorlax: {
		inherit: true,
		learnset: {
			afteryou: ["6E", "5T", "5E"],
			amnesia: ["6L9", "5L9", "5D", "4L9", "3L5"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6E"],
			bellydrum: ["6L44", "5L17", "4L17", "3L13"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["6L41", "5T", "5L41", "4T", "4L36", "3L37"],
			bodyslam: ["6L25", "5L36", "4L33", "3T", "3L33", "3S0"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6E", "5E", "4E", "3E"],
			chipaway: ["6L17", "5L25"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T"],
			covet: ["5T", "3L42"],
			crunch: ["6L49", "5L49", "4L44"],
			curse: ["6E", "5E", "4E", "3E", "3S0"],
			defensecurl: ["6L4", "5L4", "4L4", "3T", "3L9"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "5D", "4T", "3T"],
			fissure: ["6E", "5E", "4E", "3E", "3S0"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "6L57", "5M", "5L57", "4M", "4L49"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T", "3L17"],
			heavyslam: ["6L50", "5L52"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M", "3L51"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lick: ["6L12", "6E", "5L12", "5E", "4L12", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "5D", "4M"],
			refresh: ["3S0"],
			rest: ["6M", "6L28", "5M", "5L28", "4M", "4L25", "3M", "3L25"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L36", "5L44", "4T", "4L41", "3T", "3L46"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6L33", "5T", "5L33", "4M", "4L28", "3T", "3L37"],
			smackdown: ["6M", "5M"],
			snore: ["6L28", "5T", "5L28", "4T", "4L28", "3T", "3L28"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			whirlwind: ["6E", "5E", "4E"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			yawn: ["6L20", "5L20", "4L20", "3L21"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	articuno: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L36", "5L36", "4L36", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["6L29", "5L29", "4T", "4L29"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L71", "5M", "5L71", "4M", "4L71", "3M", "3L73"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			freezedry: ["6L1", "6S6"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			haze: ["3S2"],
			healbell: ["3S2"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L1", "5L92"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "6L43", "6S5", "6S6", "5M", "5L43", "4M", "4L43", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			iceshard: ["6L15", "5L15", "4L15"],
			icywind: ["5T", "4T", "3T"],
			mimic: ["3T"],
			mindreader: ["6L22", "5L22", "4L22", "4S4", "3L37", "3S0", "3S1"],
			mist: ["6L8", "5L8", "4L8", "4S4", "3L13", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "6L50", "6S5", "6S6", "5M", "5L50", "4M", "4L50", "4S3", "3M", "3L61", "3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L1", "5L78", "4L78", "3L85"],
			signalbeam: ["5T", "4T"],
			skyattack: ["5T", "4T", "3T"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6L1", "6S5", "5T", "5L64", "4T", "4L64"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	zapdos: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L43", "6S5", "6S6", "5L43", "4L43", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["6L29", "5L29", "4T", "4L29"],
			batonpass: ["3S2"],
			charge: ["6L36", "5L36", "4L36", "4S3", "3L61", "3S1"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			defog: ["4M"],
			detect: ["6L15", "5L15", "4L15", "4S4", "3L37", "3S0", "3S1"],
			discharge: ["6L50", "6S5", "6S6", "5L50", "4L50", "4S3"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6L1", "5L71", "4L71", "4S4", "3L49", "3S0", "3S1"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			lightscreen: ["6M", "6L64", "6S5", "5M", "5L64", "4M", "4L64", "3M", "3L73"],
			metalsound: ["3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["6L22", "5M", "5L22", "4M", "4L22"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skyattack: ["5T", "4T", "3T"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thunder: ["6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L85"],
			thunderbolt: ["6M", "5M", "4M", "3M", "3S2"],
			thundershock: ["6L1", "6S6", "5L1", "4L1", "3L1"],
			thunderwave: ["6M", "6L8", "5M", "5L8", "4M", "4L8", "4S4", "3T", "3L13", "3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1", "5L92"],
		},
	},
	moltres: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L15", "5L15", "4L15", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			airslash: ["6L50", "6S5", "5L50", "4L50", "4S3"],
			ancientpower: ["6L29", "5L29", "4T", "4L29"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["6L22", "5L22", "4M", "4L22", "4S4", "3T", "3L37", "3S0", "3S1"],
			extrasensory: ["3S2"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firespin: ["6L8", "5L8", "4L8", "4S4", "3L13", "3S0"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			heatwave: ["6L1", "6S5", "6S6", "5T", "5L64", "4T", "4L64", "3L73"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L1", "5L92"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			mimic: ["3T"],
			morningsun: ["3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L43", "6S5", "6S6", "5M", "5L43", "4M", "4L43", "4S3", "3M", "3L61", "3S1"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["6L1", "6S6", "5T", "5L78", "4T", "4L78", "3T", "3L85"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L71", "5M", "5L71", "4M", "4L71"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M", "4M", "3S2"],
			wingattack: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	dratini: {
		inherit: true,
		learnset: {
			agility: ["6L25", "5L25", "4L25", "3L36"],
			aquajet: ["6E", "5E"],
			aquatail: ["6L35", "5T", "5L35", "4T", "4L31"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6E", "5E", "5D", "4E", "3E"],
			dragondance: ["6L51", "6E", "5L51", "5E", "4L45", "4E", "3E"],
			dragonpulse: ["6E", "5T", "5E", "4M"],
			dragonrage: ["6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["6L41", "6E", "5L41", "5E", "4L35", "4E"],
			dragontail: ["6M", "6L31", "5M", "5L31"],
			endure: ["4M", "3T"],
			extremespeed: ["6E", "5E", "4E"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L61", "5M", "5L61", "4M", "4L55", "3M", "3L57"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			mimic: ["3T"],
			mist: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			outrage: ["6L55", "5T", "5L55", "4T", "4L51", "3L50"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L45", "5M", "5L45", "4M", "4L41", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["6L21", "5L21", "4L21", "3L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "6L5", "5M", "5L5", "5D", "4M", "4L5", "3T", "3L8"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L11", "5L11", "4T", "4L11", "3L15"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6E", "5E", "5D", "4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	dragonair: {
		inherit: true,
		learnset: {
			agility: ["6L25", "5L25", "4L25", "3L38"],
			aquatail: ["6L39", "5T", "5L39", "4T", "4L33"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragondance: ["6L61", "5L61", "4L53"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["6L47", "5L47", "4L39"],
			dragontail: ["6M", "6L33", "5M", "5L33"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L75", "5M", "5L75", "4M", "4L67", "3M", "3L65"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["6L67", "5T", "5L67", "4T", "4L61", "3L56"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L53", "5M", "5L53", "4M", "4L47", "3M", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["6L21", "5L21", "4L21", "3L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L1", "5L1", "4T", "4L1", "3L1"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	dragonite: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L25", "6S8", "5L25", "4L25", "3L38", "3S0"],
			aircutter: ["4T"],
			aquatail: ["6L39", "5T", "5L39", "4T", "4L33"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T", "4S2"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragondance: ["6L61", "6S7", "5L61", "5S3", "4L53", "4S2", "3S1"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["6L47", "5L47", "5S4", "5S5", "4L39"],
			dragontail: ["6M", "6L33", "5M", "5L33"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M", "3S1"],
			endure: ["4M", "3T"],
			extremespeed: ["6S7", "5S3", "5S5"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "5S6", "4M", "3M"],
			firepunch: ["6L1", "5T", "5L1", "5S3", "4T", "4L1", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hurricane: ["6L1", "6S7", "5L81"],
			hyperbeam: ["6M", "6L75", "6S8", "5M", "5L75", "5S6", "4M", "4L73", "3M", "3L75", "3S1"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["6L67", "6S7", "5T", "5L67", "5S3", "5S6", "4T", "4L64", "4S2", "3L61", "3S0"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L1", "5T", "5L1", "4M", "4L1"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L53", "5M", "5L53", "5S4", "5S5", "5S6", "4M", "4L47", "3M", "3L47", "3S0"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			skydrop: ["6M", "5M"],
			slam: ["6L21", "6S8", "5L21", "4L21", "3L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "4S2", "3M"],
			thunderpunch: ["6L1", "5T", "5L1", "5S4", "4T", "4L1", "3T"],
			thunderwave: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L1", "5L1", "4T", "4L1", "3L1"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wingattack: ["6L55", "5L55", "5S4", "5S5", "4L55", "3L55", "3S0"],
			wrap: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	mewtwo: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6L79", "5L50", "4L57", "4S1", "3L77"],
			aquatail: ["5T", "4T"],
			aurasphere: ["6L70", "6S4", "6S5", "5L93", "5S2", "4L100"],
			avalanche: ["4M"],
			barrier: ["6L64", "6S4", "5L1", "4L8", "3L11"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			counter: ["3T"],
			disable: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			electroball: ["5S2"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L15", "5L15", "4L22", "3L44"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			guardswap: ["6L43", "5L57", "4L64", "4S1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healpulse: ["5S3"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["5S3"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "5S3", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mefirst: ["6L93", "5L71", "4L79"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["6L29", "5L29", "4L36"],
			mist: ["6L86", "5L36", "4L43", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisonjab: ["6M", "5M", "4M"],
			powerswap: ["6L43", "5L57", "4L64", "4S1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L57", "6S4", "6S5", "5M", "5L64", "4M", "4L71", "3M", "3L66", "3S0"],
			psychocut: ["6L36", "5L43", "4L50", "4S1"],
			psychup: ["6M", "6L22", "5M", "5L22", "4M", "4L29", "3T", "3L33"],
			psyshock: ["6M", "5M"],
			psystrike: ["6L100", "6S5", "5L100", "5S2", "5S3"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L50", "6S4", "6S5", "5L79", "4L86", "3L44", "3S0"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L1", "5M", "5L86", "4M", "4L93", "3M", "3L55", "3S0"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "5S2", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L8", "5L8", "4T", "4L15", "3T", "3L22", "3S0"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	mew: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["5T"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			amnesia: ["6L60", "5L60", "4L60", "4S17"],
			ancientpower: ["6L50", "5L50", "4T", "4L50", "4S14", "3L50"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			aurasphere: ["6L100", "5L100", "4L100", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19"],
			avalanche: ["4M"],
			barrier: ["6L40", "5L40", "4L40", "4S15"],
			batonpass: ["6L80", "5L80", "4L80"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bugbite: ["5T", "4T"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillrun: ["5T"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			electroweb: ["5T"],
			embargo: ["6M", "5M", "4M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["3S2", "3S3"],
			falseswipe: ["6M", "5M", "4M"],
			feintattack: ["3S4", "3S5"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["5T", "4T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gunkshot: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["4S20", "3S6", "3S7"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			magnetrise: ["5T", "4T"],
			mefirst: ["6L70", "5L70", "4L70"],
			megakick: ["3T"],
			megapunch: ["6L10", "5L10", "4L10", "4S16", "3T", "3L20", "3S0"],
			metronome: ["6L20", "5L20", "4L20", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "3T", "3L30", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L90", "5L90", "4L90"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			nightmare: ["3T"],
			nightshade: ["3S8", "3S9"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			pound: ["6L1", "6S22", "5L1", "4L1", "4S21", "3L1", "3S0", "3S1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L30", "5M", "5L30", "4M", "4L30", "4S19", "3M", "3L40"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6L1", "5L1"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "4S20", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T", "3S10", "3S11"],
			rollout: ["4T", "3T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["5T", "4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			steelwing: ["6M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T", "4S20"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "4S20"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			transform: ["6L1", "5L1", "4L1", "4S18", "3L10", "3S0", "3S1"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			workup: ["5M"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "5M", "4M"],
			zapcannon: ["3S12", "3S13"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	chikorita: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E", "3E", "3S1"],
			aromatherapy: ["6L42", "6E", "5L42", "5E", "4L42", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L34", "6E", "5L34", "5E", "4L34", "4E", "3T", "3L29"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			grasswhistle: ["6E", "5E", "4E", "3E"],
			grassyterrain: ["6E"],
			growl: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			healpulse: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ingrain: ["6E", "5E", "4E", "3E"],
			irontail: ["5T", "4M", "3M"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6E", "5E", "4E", "3E"],
			lightscreen: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L36"],
			magicalleaf: ["6L20", "5L20", "4L20"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L23", "5L23", "4M", "4L23"],
			naturepower: ["6M", "6E", "5E", "4E", "3E"],
			poisonpowder: ["6L9", "5L9", "4L9", "3L15"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L6", "5L6", "4L6", "3L8", "3S0"],
			reflect: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L12"],
			refresh: ["6E", "5E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "3M", "3L50"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L28", "5L28", "4L28"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L12", "5T", "5L12", "4T", "4L12", "3L22"],
			tackle: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			vinewhip: ["6E", "5E", "4E", "3E"],
			worryseed: ["5T", "4T"],
			wringout: ["6E", "5E", "4E"],
		},
	},
	bayleef: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["6L50", "5L50", "4L50"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L40", "5L40", "4L40", "3T", "3L31"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L39"],
			magicalleaf: ["6L22", "5L22", "4L22"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L26", "5L26", "4M", "4L26"],
			naturepower: ["6M"],
			poisonpowder: ["6L1", "5L1", "4L1", "3L15"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L1", "5L1", "4L1", "3L1"],
			reflect: ["6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L54", "5M", "5L54", "4M", "4L54", "3M", "3L55"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L32", "5L32", "4L32"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L12", "5T", "5L12", "4T", "4L12", "3L23"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
		},
	},
	meganium: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["6L60", "5L60", "4L60"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L46", "6S0", "5L46", "4L46", "3T", "3L31"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["6T", "5T", "4T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L41"],
			magicalleaf: ["6L22", "5L22", "4L22"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L26", "5L26", "4M", "4L26"],
			naturepower: ["6M"],
			outrage: ["5T", "4T"],
			petalblizzard: ["6L1"],
			petaldance: ["6L32", "5L32", "4L32"],
			poisonpowder: ["6L1", "5L1", "4L1", "3L15"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L1", "5L1", "4L1", "3L1"],
			reflect: ["6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L54", "5M", "5L54", "4M", "4L54", "3M", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L66", "6S0", "5M", "5L66", "4M", "4L66", "3M", "3L61"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6S0", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L34", "5L34", "4L34"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L12", "6S0", "5T", "5L12", "4T", "4L12", "3L23"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
		},
	},
	cyndaquil: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E", "4E", "3E"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L22", "5L22", "4L22", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L55", "6E", "5L55", "5E", "4L46", "4E", "3T"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L10", "5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["6L58", "5L58", "4L49"],
			extrasensory: ["6E", "5E", "4E"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			flameburst: ["6E", "5E"],
			flamecharge: ["6M", "6L28", "5M", "5L28"],
			flamethrower: ["6M", "6L40", "5M", "5L40", "4M", "4L37", "3M", "3L46"],
			flamewheel: ["6L19", "5L19", "4L19", "3L27"],
			flareblitz: ["6E", "5E", "4E"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			inferno: ["6L46", "5L46"],
			lavaplume: ["6L37", "5L37", "4L31"],
			leer: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6E", "5E"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "6E", "5L13", "5E", "4L13", "4E", "3L19", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E", "3S1"],
			rollout: ["6L49", "5L49", "4T", "4L40", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L6", "5L6", "4L4", "3L6", "3S0"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L31", "5L31", "4T", "4L28", "3T", "3L36"],
			tackle: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			thrash: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	quilava: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L24", "5L24", "4L24", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L64", "5L64", "4L53", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L10", "5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["6L68", "5L68", "4L57"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			flamecharge: ["6M", "6L35", "5M", "5L35"],
			flamethrower: ["6M", "6L46", "5M", "5L46", "4M", "4L42", "3M", "3L54"],
			flamewheel: ["6L20", "5L20", "4L20", "3L31"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L53", "5L53"],
			lavaplume: ["6L42", "5L42", "4L35"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L13", "4L13", "3L21"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["6L57", "5L57", "4T", "4L46", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L31", "5L31", "4T", "4L31", "3T", "3L42"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	typhlosion: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			blastburn: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L24", "5L24", "4L24", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L1", "5L69", "4L53", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["6L1", "5L74", "4L57"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T", "4T", "3T"],
			flamecharge: ["6M", "6L35", "6S1", "5M", "5L35"],
			flamethrower: ["6M", "6L48", "5M", "5L48", "4M", "4L42", "3M", "3L60", "3S0"],
			flamewheel: ["6L20", "6S1", "5L20", "4L20", "3L31", "3S0"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L56", "5L56"],
			lavaplume: ["6L43", "5L43", "4L35"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "6S1", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L13", "4L13", "3L21", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["6L61", "5L61", "4T", "4L46", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smokescreen: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L31", "6S1", "5L31", "4T", "4L31", "3T", "3L45", "3S0"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	totodile: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			aquajet: ["6E", "5E", "4E"],
			aquatail: ["6L43", "5T", "5L43", "4T", "4L36"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L13", "5L13", "4L13", "3L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["6E", "5T", "5E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["6L29", "5L29"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L27", "6E", "5L27", "5E", "4L27", "4E", "3E", "3S1"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4E", "3E"],
			dragondance: ["6E", "5E", "4E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E"],
			flail: ["6L22", "5L22", "4L22"],
			flatter: ["6E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L50", "6E", "5L50", "5E", "4L43", "4E", "3L52", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L20", "5L20", "4L20"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L8", "5L8", "4L8", "3L7", "3S0"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L15", "5L15", "4L15", "3L27"],
			scratch: ["6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			screech: ["6L36", "5L36", "4L34", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L34", "5L34", "4L29", "3L35"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6L48", "5T", "5L48", "4T", "4L41"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thrash: ["6L41", "6E", "5L41", "5E", "4L22", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L6", "5L6", "4L6", "3L13"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			watersport: ["6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	croconaw: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["6L51", "5T", "5L51", "4L42"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L13", "5L13", "4L13", "3L21"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["6L33", "5L33"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L30", "5L30", "4L30"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L24", "5L24", "4L24"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L60", "5L60", "4L51", "3L55"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L21", "5L21", "4L21"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L8", "5L8", "4L8", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L15", "5L15", "4L15", "3L28"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L42", "5L42", "4L39", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L39", "5L39", "4L33", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6L57", "5T", "5L57", "4T", "4L48"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thrash: ["6L48", "5L48", "4L24"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L13"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	feraligatr: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L30", "5L30", "4L30"],
			ancientpower: ["4T"],
			aquatail: ["6L63", "5T", "5L63", "4T", "4L50"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L13", "5L13", "4L13", "3L21"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L37", "5L37"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L32", "6S0", "5L32", "4L32"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L24", "5L24", "4L24"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["6T", "5T", "4T"],
			hydropump: ["6L76", "5L76", "4L63", "3L58"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L21", "5L21", "4L21"],
			icepunch: ["6S0", "5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L15", "5L15", "4L15", "3L28"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L50", "6S0", "5L50", "4L45", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L45", "5L45", "4L37", "3L38"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6L71", "5T", "5L71", "4T", "4L58"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thrash: ["6L58", "5L58", "4L24"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "6S0", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	sentret: {
		inherit: true,
		learnset: {
			amnesia: ["6L36", "5L36", "4L36", "3L49"],
			aquatail: ["5T", "4T"],
			assist: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L39", "5L39", "4L39"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["6E", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6E", "5E", "4E"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E", "5D", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L4", "5L4", "4L4", "3T", "3L4"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["5D", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			focuspunch: ["4M", "3M"],
			followme: ["6L19", "5L19", "4L19", "3L31"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L13", "5L13", "4L13", "3L12"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6L16", "5T", "5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6L47", "5T", "5L47", "4L47"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			mefirst: ["6L42", "5L42", "4L42"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			quickattack: ["6L7", "5L7", "4L7", "3L7"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L40"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "5D", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["6L25", "5L25", "4L25", "3L24"],
			slash: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["6L31", "5L31", "4T", "4L31"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "4E", "3E"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	furret: {
		inherit: true,
		learnset: {
			amnesia: ["6L42", "5L42", "4L42", "3L59"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L46", "5L46", "4L46"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["6L21", "5L21", "4L21", "3L37"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L13", "5L13", "4L13", "3L12"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6L17", "5T", "5L17", "4T", "4L17", "3L19"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["6L56", "5T", "5L56", "4L56"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			mefirst: ["6L50", "5L50", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L48"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["6L28", "5L28", "4L28", "3L28"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L36", "5L36", "4T", "4L36"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	hoothoot: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6E", "5E", "4E"],
			aircutter: ["4T"],
			airslash: ["6L33", "5L33", "4L29"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L21", "5L21", "4L21", "3L34"],
			defog: ["6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "6L57", "5M", "5L57", "4M", "4L49", "3T", "3L48"],
			echoedvoice: ["6M", "6L25", "5M", "5L25"],
			endure: ["4M", "3T"],
			extrasensory: ["6L45", "5L45", "4L37"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6E", "5E", "4E", "3E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			flash: ["3M"],
			fly: ["6M", "5M", "4M", "3M"],
			foresight: ["6L1", "5L1", "5D", "4L1", "3L6", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L5", "5L5", "4L5", "3L16"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6E", "5E", "5D", "4E"],
			ominouswind: ["4T"],
			peck: ["6L9", "5L9", "4L9", "3L11"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychoshift: ["6L49", "5L49", "4L41"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "5D", "4M"],
			reflect: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L22"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L53", "5T", "5L53", "4M", "4L45"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6E", "5E", "4E", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["6L41", "5L41"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwind: ["5T", "4T"],
			takedown: ["6L29", "5L29", "4L25", "3L28"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6L13", "5T", "5L13", "4T", "4L13"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			wingattack: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L33"],
		},
	},
	noctowl: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["6L37", "5L37", "4L32"],
			attract: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L22", "5L22", "4L22", "3L41"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "6L1", "5M", "5L67", "4M", "4L57", "3T", "3L57"],
			echoedvoice: ["6M", "6L27", "5M", "5L27"],
			endure: ["4M", "3T"],
			extrasensory: ["6L52", "5L52", "4L42"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["3M"],
			fly: ["6M", "5M", "4M", "3M"],
			foresight: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L1", "5L1", "4L1", "3L16"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			peck: ["6L9", "5L9", "4L9", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychoshift: ["6L57", "5L57", "4L47"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L25"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L62", "5T", "5L62", "4M", "4L52"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["6L1", "5T", "5L1", "4T", "4L1", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["6L47", "5L47"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "4T"],
			takedown: ["6L32", "5L32", "4L27", "3L33"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6L13", "5T", "5L13", "4T", "4L13"],
			workup: ["5M"],
			zenheadbutt: ["6L42", "5T", "5L42", "4T", "4L37"],
		},
	},
	ledyba: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M", "3S0"],
			agility: ["6L30", "5L30", "4L30", "3L43"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L22", "5L22", "4L22", "3L29"],
			bide: ["6E", "5E", "4E", "3E"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["6E", "5T", "5E", "5D", "4T", "4E"],
			bugbuzz: ["6L41", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			cometpunch: ["6L9", "5L9", "5D", "4L9", "3L15"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M", "3M"],
			dizzypunch: ["6E", "5E"],
			doubleedge: ["6L38", "5L38", "4L38", "3T", "3L50"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["6E", "5T", "5E", "4M"],
			dynamicpunch: ["3T"],
			encore: ["6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			infestation: ["6M"],
			knockoff: ["6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			machpunch: ["6L17", "5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E", "3S0"],
			reflect: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["6L25", "6E", "5L25", "5E", "4M", "4L25", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L6", "5L6", "4L6", "3L8", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L33", "5L33", "4T", "4L33", "3T", "3L36"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6E", "5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "5D", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
		},
	},
	ledian: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L36", "5L36", "4L36", "3L51"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L24", "5L24", "4L24", "3L33"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L53", "5L53", "4L53"],
			captivate: ["4M"],
			cometpunch: ["6L1", "5L1", "4L1", "3L15"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L48", "5L48", "4L48", "3T", "3L60"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			machpunch: ["6L17", "5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["6L29", "5L29", "4M", "4L29"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L41", "5L41", "4T", "4L41", "3T", "3L42"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
		},
	},
	spinarak: {
		inherit: true,
		learnset: {
			agility: ["6L33", "5L33", "4L33", "3L45"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			bugbite: ["5T", "5D", "4T"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L8", "5L8", "4L8", "3L11"],
			crosspoison: ["6L47", "5L47"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroweb: ["6E", "5T", "5E", "5D"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L22", "5L22", "4L22", "3L30"],
			gigadrain: ["5T", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			infestation: ["6M"],
			leechlife: ["6L12", "5L12", "4L12", "3L23"],
			megahorn: ["6E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["6L15", "5L15", "4L15", "3L17", "3S0"],
			nightslash: ["6E", "5E"],
			pinmissile: ["6L36", "5L36", "4L36"],
			poisonjab: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "4E"],
			poisonsting: ["6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E"],
			psychic: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L53"],
			pursuit: ["6E", "5E", "4E", "3E"],
			ragepowder: ["6E", "5E"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L5", "5L5", "4L5", "3L6"],
			secretpower: ["6M", "4M", "3M"],
			shadowsneak: ["6L19", "5L19", "4L19"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E", "3E", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			sonicboom: ["6E", "5E", "4E", "3E"],
			spiderweb: ["6L29", "5L29", "4L29", "3L37"],
			stickyweb: ["6L50"],
			stringshot: ["6L1", "5L1", "4T", "4L1", "3L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L26", "5L26", "4T", "4L26"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6E", "5E", "4E"],
			twineedle: ["6E", "5E"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	ariados: {
		inherit: true,
		learnset: {
			agility: ["6L37", "5L37", "4L37", "3L53"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			bugbite: ["6L1", "5T", "5L1", "4T", "4L1"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			crosspoison: ["6L55", "5L55"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fellstinger: ["6L1"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L23", "5L23", "4L23", "3L34"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechlife: ["6L12", "5L12", "4L12", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["6L15", "5L15", "4L15", "3L17"],
			pinmissile: ["6L41", "5L41", "4L41"],
			poisonjab: ["6M", "6L50", "5M", "5L50", "4M", "4L50"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L63"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowsneak: ["6L19", "5L19", "4L19"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spiderweb: ["6L32", "5L32", "4L32", "3L43"],
			stickyweb: ["6L58"],
			stringshot: ["6L1", "5L1", "4T", "4L1", "3L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L28", "5L28", "4T", "4L28"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venomdrench: ["6L1"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	chinchou: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			amnesia: ["6E", "5E", "5D", "4E", "3E"],
			aquaring: ["6L42", "5L42", "4L39"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6E", "5E", "4M"],
			bubble: ["6L12", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L31", "5L31", "4L28"],
			captivate: ["4M"],
			charge: ["6L50", "5L50", "4L45", "3L49"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L17", "5L12", "4L17", "3L29"],
			dazzlinggleam: ["6M"],
			discharge: ["6L39", "5L39", "4L34"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroball: ["6L28", "5L28"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L9", "6E", "5L9", "5E", "4L9", "4E", "3L13", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L45", "5L45", "4L42", "3L41"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T"],
			iondeluge: ["6L47"],
			mimic: ["3T"],
			mist: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6E", "5E", "5D", "4M", "3M"],
			signalbeam: ["6L34", "5T", "5L34", "4T", "4L31"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6E"],
			spark: ["6L20", "5L20", "4L20", "3L25"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["6L1", "5L1", "4L1", "3L5"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6L23", "5L23", "4L23", "3L37"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "6L6", "5M", "5L6", "5D", "4M", "4L6", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L17", "4L12", "3L17"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["6E", "5E", "4M", "4E"],
			wildcharge: ["6M", "5M"],
		},
	},
	lanturn: {
		inherit: true,
		learnset: {
			aquaring: ["6L52", "5L52", "4L47"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bubble: ["6L12", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L35", "5L35", "4L30"],
			captivate: ["4M"],
			charge: ["6L64", "5L64", "4L57", "3L61"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L17", "5L17", "4L17", "3L32"],
			dazzlinggleam: ["6M"],
			discharge: ["6L47", "5L47", "4L40"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			eerieimpulse: ["6L1"],
			electroball: ["6L30", "5L30"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L9", "5L9", "4L9", "3L13"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L57", "5L57", "4L52", "3L50"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T"],
			iondeluge: ["6L60"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L40", "5T", "5L40", "4T", "4L35"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L20", "5L20", "4L20", "3L25"],
			spitup: ["6L27", "5L27", "4L27"],
			stockpile: ["6L27", "5L27", "4L27"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["6L1", "5L1", "4L1", "3L1"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L27", "5L27", "4L27"],
			takedown: ["6L23", "5L23", "4L23", "3L43"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L12", "4L12", "3L17"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["6M", "5M"],
		},
	},
	togepi: {
		inherit: true,
		learnset: {
			afteryou: ["6L53", "5T", "5L53"],
			ancientpower: ["6L33", "5L33", "4T", "4L33", "3L21", "3S1"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L41", "5L41", "4L42", "3L41"],
			bestow: ["6L25", "5L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["6L45", "5L45", "4L46", "3T", "3L37"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L17", "5L17", "4L19", "3L17"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			extrasensory: ["6E", "5E", "4E"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			followme: ["6L21", "5L21", "4L24", "3L25", "3S1"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6L49", "5T", "5L49", "4T", "4L51"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E", "5D", "4E"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6L5", "5L5", "5D", "4L6", "3T", "3L4", "3S0"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "4E", "3E"],
			morningsun: ["6E", "5E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			peck: ["6E", "5E", "4E", "3E"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychoshift: ["6E", "5E", "4E"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L9", "5L9", "4L10", "3L9", "3S0"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			triattack: ["3S1"],
			trick: ["5T", "4T"],
			uproar: ["5T", "5D", "4T"],
			waterpulse: ["4M", "3M"],
			wish: ["6L29", "5L29", "4L28", "3L29"],
			workup: ["5M"],
			yawn: ["6L13", "5L13", "4L15", "3L13", "3S0"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	togetic: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["6L53", "5T", "5L53"],
			aircutter: ["4T"],
			ancientpower: ["6L33", "5L33", "4T", "4L33", "3L21"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L41", "5L41", "4L42", "3L41"],
			bestow: ["6L25", "5L25"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "4L1", "3L1"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["6L45", "5L45", "4L46", "3T", "3L37"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L17", "5L17", "4L19", "3L17"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fairywind: ["6L14"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			focuspunch: ["4M", "3M"],
			followme: ["6L21", "5L21", "4L24", "3L25"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6L49", "5T", "5L49", "4T", "4L51"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magicalleaf: ["6L1", "5L1", "4L1", "3L1"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6L1", "5L1", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L1", "5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			twister: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["6L29", "5L29", "4L28", "3L29"],
			workup: ["5M"],
			yawn: ["6L13", "5L13", "4L15", "3L13"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	togekiss: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			afteryou: ["6L1"],
			aircutter: ["4T"],
			airslash: ["6L1", "5L1", "5S0", "4L1"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M"],
			aurasphere: ["6L1", "5L1", "5S0", "4L1"],
			brickbreak: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defog: ["4M"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			extremespeed: ["6L1", "5L1", "5S0", "4L1"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			present: ["5S0"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["4T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			skyattack: ["6L1", "5T", "5L1", "4T", "4L1"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			steelwing: ["6M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			twister: ["4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	natu: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M", "3S0"],
			aircutter: ["4T"],
			allyswitch: ["6E", "5M"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L23", "5L23", "4L23", "3L40"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillpeck: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6E", "5E", "5D", "4E", "3E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L36", "5L36", "4L36", "3L30", "3S0"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			guardswap: ["6L47", "5L47", "4L44"],
			haze: ["6E", "5E", "4E", "3E"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L12", "5L12", "4L12"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mefirst: ["6L20", "5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["6L17", "5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L6", "5L6", "5D", "4L6", "3L10", "3S0"],
			ominouswind: ["6L44", "5L44", "4T", "4L39"],
			painsplit: ["5T", "4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["6L47", "5L47", "4L44"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L50", "5M", "5L50", "4M", "4L47", "3M", "3L50"],
			psychoshift: ["6L33", "5L33", "4L33"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			quickattack: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6E", "5T", "5E", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			simplebeam: ["6E"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "6E", "5E", "4M", "4E", "3M", "3E"],
			storedpower: ["6L39", "5L39"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E", "4T", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["6E", "5E"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			teleport: ["6L9", "5L9", "4L9", "3L20"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			wish: ["6L28", "5L28", "4L28", "3L30"],
			zenheadbutt: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	xatu: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			attract: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L23", "5L23", "4L23", "3L50"],
			dazzlinggleam: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L42", "5L42", "4L42", "3L35"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			guardswap: ["6L59", "5L59", "4L54"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L12", "5L12", "4L12"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mefirst: ["6L20", "5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["6L17", "5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L6", "5L6", "4L6", "3L10"],
			ominouswind: ["6L54", "5L54", "4T", "4L47"],
			painsplit: ["5T", "4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["6L54", "5L54", "4L54"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L66", "5M", "5L66", "4M", "4L59", "3M", "3L65"],
			psychoshift: ["6L37", "5L37", "4L37"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["5T", "4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "4M", "3M"],
			storedpower: ["6L47", "5L47"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6L27", "5T", "5L27", "4T", "4L27"],
			telekinesis: ["5M"],
			teleport: ["6L9", "5L9", "4L9", "3L20"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			wish: ["6L30", "5L30", "4L30", "3L35"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	mareep: {
		inherit: true,
		learnset: {
			afteryou: ["6E", "5T", "5E"],
			agility: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E", "3S2"],
			captivate: ["4M"],
			charge: ["6L15", "6E", "5L23", "5E", "4L23", "4E", "3E"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L25", "5L25"],
			cottonguard: ["6L36", "5L32"],
			cottonspore: ["6L11", "5L19", "4L19", "3L23", "3S0"],
			defensecurl: ["3T"],
			discharge: ["6L32", "5L37", "4L28"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			eerieimpulse: ["6E"],
			electricterrain: ["6E"],
			electroball: ["6L22", "5L28"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L5", "4L5", "3L1", "3S1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T", "3S2"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			lightscreen: ["6M", "6L43", "5M", "5L46", "4M", "4L37", "3M", "3L30"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6E", "5E", "4E", "3E"],
			powergem: ["6L29", "5L50", "4L41"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["5D", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			sandattack: ["6E", "5E", "4E"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["5D", "4M", "3M"],
			signalbeam: ["6L39", "5T", "5L41", "4T", "4L32"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "6S3", "5L1", "4L1", "3L1", "3S1"],
			takedown: ["6L18", "6E", "5L18", "5E", "4E", "3E"],
			thunder: ["6M", "6L46", "5M", "5L55", "4M", "4L46", "3M", "3L37", "3S0"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thundershock: ["6L8", "6S3", "5L10", "5D", "4L10", "3L9", "3S0", "3S1", "3S2"],
			thunderwave: ["6M", "6L4", "6S3", "5M", "5L14", "4M", "4L14", "3T", "3L16", "3S0", "3S2"],
			toxic: ["6M", "5M", "4M", "3M"],
			wildcharge: ["6M", "5M"],
		},
	},
	flaaffy: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charge: ["6L16", "5L25", "4L25"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L29", "5L29"],
			cottonguard: ["6L43", "5L36"],
			cottonspore: ["6L11", "5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["6L38", "5L42", "4L31"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L25", "5L31"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "6L52", "5M", "5L53", "4M", "4L42", "3M", "3L36"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powergem: ["6L34", "5L59", "4L47"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L47", "5T", "5L47", "4T", "4L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L20", "5L20"],
			thunder: ["6M", "6L56", "5M", "5L65", "4M", "4L53", "3M", "3L45"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thundershock: ["6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["6M", "6L1", "5M", "5L14", "4M", "4L14", "3T", "3L18"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
		},
	},
	ampharos: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charge: ["6L16", "5L25", "4L25"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L29", "5L29"],
			cottonguard: ["6L46", "5L40"],
			cottonspore: ["6L11", "5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["6L40", "5L48", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["6L1"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L25", "5L33"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			iondeluge: ["6L1"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "6L57", "5M", "5L63", "4M", "4L51", "3M", "3L42"],
			magneticflux: ["6L1"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			powergem: ["6L35", "5L71", "4L59"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L51", "5T", "5L55", "4T", "4L42"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L20", "5L20"],
			thunder: ["6M", "6L62", "5M", "5L79", "4M", "4L68", "3M", "3L57"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6L30", "5T", "5L30", "4T", "4L30", "3T", "3L30"],
			thundershock: ["6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1"],
		},
	},
	azurill: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T"],
			bounce: ["6L23", "5T", "5L23"],
			bubble: ["6L7", "5L10", "4L10", "3L10"],
			bubblebeam: ["6L13", "5L13"],
			camouflage: ["6E"],
			captivate: ["4M"],
			charm: ["6L10", "5L2", "4L2", "3L3"],
			confide: ["6M"],
			copycat: ["6E"],
			covet: ["5T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6L16", "5T", "5L16", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M"],
			mimic: ["3T"],
			muddywater: ["6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["6E", "5E", "4E", "3E"],
			slam: ["6L20", "6E", "5L15", "5E", "4L15", "4E", "3L15", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6E", "5E"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["6L2", "5L7", "4L7", "3L6"],
			tickle: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L18", "4L18", "3L21"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L5", "6E", "5L5", "5E"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	marill: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E", "3E"],
			aquajet: ["6E", "5E", "5D", "4E"],
			aquaring: ["6L28", "5L23", "4L23"],
			aquatail: ["6L20", "5T", "5L37", "4T", "4L37"],
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T"],
			bounce: ["5T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubble: ["6L7", "5L1"],
			bubblebeam: ["6L13", "5L18", "4L18", "3L21"],
			camouflage: ["6E"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			defensecurl: ["6L10", "5L2", "5D", "4L2", "3T", "3L3"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["6L23", "5L27", "4L27", "3T", "3L28"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6L16", "5T", "5L16", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L40", "5L42", "4L42", "3L45"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "5D", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			muddywater: ["6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["6E", "5E", "4E", "3E"],
			playrough: ["6L45"],
			poweruppunch: ["6M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L31", "5M", "5L32", "4M", "4L32", "3M", "3L36"],
			refresh: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["6L10", "5L15", "4T", "4L15", "3T", "3L15"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			superpower: ["6L37", "6E", "5T", "5L37", "5E", "4T", "4E"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L2", "5L7", "4L7", "3L6"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L10", "4L10", "3L10"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L5", "6E", "5L5", "5E"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	azumarill: {
		inherit: true,
		learnset: {
			aquaring: ["6L31", "5L27", "4L27"],
			aquatail: ["6L21", "5T", "5L47", "4T", "4L47"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubble: ["6L7", "5L1"],
			bubblebeam: ["6L13", "5L20", "4L20", "3L24"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			defensecurl: ["6L10", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["6L25", "5L33", "4L33", "3T", "3L34"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6L16", "5T", "5L16", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L46", "5L54", "4L54", "3L57"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			playrough: ["6L50"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L35", "5M", "5L40", "4M", "4L40", "3M", "3L45"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["6L10", "5L15", "4T", "4L15", "3T", "3L15"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6L42", "5T", "5L42", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L1", "5L1"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	bonsly: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M"],
			block: ["6L26", "5T", "5L22", "4T", "4L22"],
			brickbreak: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			copycat: ["6L1", "5L1", "4L1"],
			counter: ["6L33"],
			covet: ["5T"],
			curse: ["6E", "5E"],
			defensecurl: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["6L40", "5L46", "4L46"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			endure: ["6E", "5E", "4M"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			faketears: ["6L1", "5L1", "4L1"],
			feintattack: ["6L19", "5L25", "4L25"],
			flail: ["6L5", "5L6", "4L6"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			harden: ["6E", "5E", "4E"],
			headbutt: ["6E", "5E", "4T", "4E"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			lowkick: ["6L8", "5T", "5L9", "4T", "4L9"],
			mimic: ["6L15", "5L17", "4L17"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L29", "5M", "5L33", "4M", "4L33"],
			rockthrow: ["6L12", "5L14", "4L14"],
			rocktomb: ["6M", "6L22", "5M", "5L30", "4M", "4L30"],
			roleplay: ["5T", "4T"],
			rollout: ["6E", "5E", "4T", "4E"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			sandtomb: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			selfdestruct: ["6E", "5E", "4E"],
			slam: ["5L38", "4L38"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L36", "5L41", "4T", "4L41"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
		},
	},
	sudowoodo: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["6L26", "5T", "5L22", "4T", "4L22", "3L33"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			copycat: ["6L1", "5L1", "4L1"],
			counter: ["6L33", "5L33", "3T"],
			covet: ["5T"],
			curse: ["6E", "5E"],
			defensecurl: ["6E", "5E", "4E", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L40", "5L46", "4L46", "3T", "3L57"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L19", "5L25", "4L25", "3L41"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6L1", "5L1", "5D", "4L1", "3L9"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			hammerarm: ["6L47", "5L49", "4L49"],
			harden: ["6E", "5E", "4E"],
			headbutt: ["6E", "5E", "4T", "4E"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			lowkick: ["6L1", "5T", "5L1", "4T", "4L1", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["6L15", "5L17", "4L17", "3T", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L29", "5M", "5L33", "4M", "4L33", "3T", "3L25"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L1", "5L1", "4L1", "3L1"],
			rocktomb: ["6M", "6L22", "5M", "5L30", "4M", "4L30", "3M"],
			roleplay: ["5T", "5D", "4T"],
			rollout: ["6E", "5E", "5D", "4T", "4E", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			sandtomb: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["6E", "5E", "4E", "3T", "3E"],
			slam: ["6L15", "5L38", "4L38", "3L49"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			stoneedge: ["6M", "6L43", "5M", "5L43", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L36", "5L41", "4T", "4L41"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M", "3M"],
			woodhammer: ["6L1", "5L1", "4L1"],
		},
	},
	hoppip: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L28", "5M", "5L28"],
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6E", "5E", "4E", "3E"],
			aromatherapy: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bounce: ["6L46", "5T", "5L46", "5D", "4T", "4L40"],
			bulletseed: ["6L19", "5L19", "5D", "4M", "4L19", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6E", "5E", "4E", "3E"],
			cottonguard: ["6E", "5E"],
			cottonspore: ["6L34", "5L34", "4L28", "3L25"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			encore: ["6E", "5E", "5D", "4E", "3E"],
			endure: ["6E", "5E", "4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fairywind: ["6L10"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L43", "5T", "5L43", "4M", "4L37", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6E"],
			headbutt: ["4T"],
			helpinghand: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechseed: ["6L22", "5L22", "4L22", "3L20"],
			megadrain: ["6L25", "5L25", "4L25", "3L30"],
			memento: ["6L49", "5L49", "4L43"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["6L12", "5L12", "4L12", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4E", "3E"],
			ragepowder: ["6L31", "5L31"],
			reflect: ["6M", "5M", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6E", "5T", "5E", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["6L16", "5L16", "4L16", "3L17"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			stunspore: ["6L14", "5L14", "4L14", "3L15"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L4", "5T", "5L4", "5D", "4T", "4L4", "3L5"],
			tackle: ["6L8", "5L10", "4L10", "3L10"],
			tailwhip: ["6L6", "5L7", "4L7", "3L5"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "6L37", "5M", "5L37", "4M", "4L31"],
			worryseed: ["6L40", "6E", "5T", "5L40", "5E", "4T", "4L34", "4E"],
		},
	},
	skiploom: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L32", "5M", "5L32"],
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bounce: ["6L56", "5T", "5L56", "4T", "4L48"],
			bulletseed: ["6L20", "5L20", "4M", "4L20", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6L40", "5L40", "4L32", "3L29"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fairywind: ["6L10"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L52", "5T", "5L52", "4M", "4L44", "3M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechseed: ["6L24", "5L24", "4L24", "3L22"],
			megadrain: ["6L28", "5L28", "4L28", "3L36"],
			memento: ["6L60", "5L60", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["6L12", "5L12", "4L12", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M"],
			ragepowder: ["6L36", "5L36"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["6L16", "5L16", "4L16", "3L17"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			stunspore: ["6L14", "5L14", "4L14", "3L15"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "6L44", "5M", "5L44", "4M", "4L36"],
			worryseed: ["6L48", "5T", "5L48", "4T", "4L40"],
		},
	},
	jumpluff: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L34", "5M", "5L34"],
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bounce: ["6L64", "5T", "5L64", "4T", "4L48"],
			bulletseed: ["6L20", "5L20", "5S0", "4M", "4L20", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6L44", "5L44", "4L32", "3L33"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fairywind: ["6L10"],
			falseswipe: ["5S0"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L59", "5T", "5L59", "4M", "4L44", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			leechseed: ["6L24", "5L24", "5S0", "4L24", "3L22"],
			megadrain: ["6L29", "5L29", "4L28", "3L44"],
			memento: ["6L69", "5L69", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["6L12", "5L12", "4L12", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M"],
			ragepowder: ["6L39", "5L39"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["6L16", "5L16", "5S0", "4L16", "3L17"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			stunspore: ["6L14", "5L14", "4L14", "3L15"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "6L49", "5M", "5L49", "4M", "4L36"],
			worryseed: ["6L54", "5T", "5L54", "4T", "4L40"],
		},
	},
	aipom: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L29", "6E", "5L29", "5E", "4L29", "4E", "3L50", "3E"],
			astonish: ["6L8", "5L8", "4L8", "3L13"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L11", "5L11", "4L11", "3L18"],
			beatup: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["6E", "5T", "5E", "4T", "4E"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			covet: ["6E", "5T", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["6L32", "5L32", "4L32"],
			doubleslap: ["6E", "5E", "4E", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "5D", "4E"],
			firepunch: ["5T", "5D", "4T", "3T"],
			fling: ["6M", "6L36", "5M", "5L36", "4M", "4L36"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L18", "5L18", "4L18", "3L31"],
			grassknot: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L43", "5T", "5L43", "4T", "4L43"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L39", "5L39", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L4", "5L4", "4L4", "3L6", "3S0"],
			scratch: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			screech: ["6L25", "6E", "5L25", "5E", "4L25", "4E", "3L43", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L22", "5L22", "4T", "4L22", "3T", "3L38"],
			switcheroo: ["6E", "5E"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			tickle: ["6L15", "5L15", "4L15", "3L25"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	ambipom: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M"],
			agility: ["6L29", "5L29", "4L29"],
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			batonpass: ["6L11", "5L11", "4L11"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doublehit: ["6L32", "5L32", "4L32"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			fling: ["6M", "6L36", "5M", "5L36", "4M", "4L36"],
			focuspunch: ["4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L18", "5L18", "4L18"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L43", "5T", "5L43", "4T", "4L43"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["6L39", "5L39", "4L39"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			scratch: ["6L1", "5L1", "4L1"],
			screech: ["6L25", "5L25", "4L25"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L22", "5L22", "4T", "4L22"],
			tailwhip: ["6L1", "5L1", "4L1"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			tickle: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	sunkern: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6E", "5E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L37", "5L37", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "5D", "4T"],
			encore: ["6E", "5E", "4E", "3E"],
			endeavor: ["6L25", "5T", "5L21", "4T", "4L21", "3L25"],
			endure: ["6E", "5E", "4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L22", "5T", "5L41", "4M", "4L41", "3M", "3L42"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L7", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			grassyterrain: ["6E"],
			growth: ["6L1", "5L1", "4L1", "3L6", "3S0"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ingrain: ["6L4", "6E", "5L9", "5E", "4L9", "4E", "3L18"],
			leechseed: ["6L13", "6E", "5L17", "5E", "4L17", "4E", "3E"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			megadrain: ["6L10", "5L5", "5D", "4L5", "3L13"],
			mimic: ["3T"],
			morningsun: ["6E", "5E"],
			naturalgift: ["6L31", "6E", "5L31", "5E", "4M"],
			naturepower: ["6M", "6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L16", "5L29", "4L29"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6L43", "5T", "5L45", "4T", "4L45"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L34", "5M", "5L34", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6E", "5E", "5D", "4E"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L28", "5T", "5L33", "4T", "4L33", "3L37"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			worryseed: ["6L19", "5T", "5L25", "4T", "4L25"],
		},
	},
	sunflora: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			bulletseed: ["6L25", "5L21", "4M", "4L21", "3M", "3L25"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L37", "5L37", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flowershield: ["6L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L22", "5T", "5L22", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L7", "5L13", "4L13"],
			growth: ["6L1", "5L1", "4L1", "3L6"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			ingrain: ["6L4", "5L9", "4L9", "3L18"],
			leafstorm: ["6L43", "5L45", "4L43"],
			leechseed: ["6L13", "5L17", "4L17"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			megadrain: ["6L10", "5L5", "4L5"],
			mimic: ["3T"],
			naturalgift: ["6L31", "5L31", "4M"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["6L28", "5L33", "4L33", "3L37"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L16", "5L29", "4L29", "3L13"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L34", "5M", "5L41", "4M", "4L41", "3M", "3L42"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			worryseed: ["6L19", "5T", "5L25", "4T", "4L25"],
		},
	},
	yanma: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["6L54", "5L54", "4L54"],
			ancientpower: ["6L33", "5L33", "4T", "4L33"],
			attract: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L57", "5L57", "4L57"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			detect: ["6L17", "5L17", "4L17", "3L25"],
			doubleedge: ["6E", "5E", "3T"],
			doubleteam: ["6M", "6L11", "5M", "5L11", "4M", "4L11", "3M", "3L12"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6E", "5E", "5D", "4E"],
			feintattack: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L38", "5L38", "4L38", "3L23"],
			leechlife: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L30", "6E", "5L30", "5E", "4L30", "4E"],
			quickattack: ["6L6", "5L6", "5D", "4L6", "3L6"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			screech: ["6L46", "5L46", "4L46", "3L49"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E", "3E"],
			silverwind: ["6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			sonicboom: ["6L14", "5L14", "4L14", "3L17"],
			steelwing: ["6M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L22", "5L22", "4L22", "3L31"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L27", "5T", "5L27", "4T", "4L27", "3L34"],
			uturn: ["6M", "6L49", "5M", "5L49", "4M", "4L49"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			wingattack: ["6L43", "5L43", "4L43", "3L39"],
		},
	},
	yanmega: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["6L1", "5L54", "4L49"],
			ancientpower: ["6L33", "5L33", "4T", "4L33"],
			attract: ["6M", "5M", "4M"],
			bugbite: ["6L1", "5T", "5L1", "4T", "4L1"],
			bugbuzz: ["6L1", "5L57", "4L54"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			detect: ["6L17", "5L17", "4L17"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L1", "4L1"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			pursuit: ["6L30", "5L30", "4L30"],
			quickattack: ["6L1", "5L1", "4L1"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			screech: ["6L46", "5L46", "4L43"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			slash: ["6L43", "5L43", "4L38"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			sonicboom: ["6L14", "5L14", "4L14"],
			steelwing: ["6M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			supersonic: ["6L22", "5L22", "4L22"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["6L27", "5T", "5L27", "4T", "4L27"],
			uturn: ["6M", "6L49", "5M", "5L49", "4M", "4L46"],
		},
	},
	wooper: {
		inherit: true,
		learnset: {
			acidspray: ["6E", "5E"],
			afteryou: ["6E", "5T", "5E"],
			amnesia: ["6L23", "5L23", "4L23", "3L21"],
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			aquatail: ["5T", "5D", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3M", "3L36"],
			eerieimpulse: ["6E"],
			encore: ["6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			guardswap: ["6E"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6L43", "5L43", "4L43", "3L51"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mist: ["6L43", "5L43", "4L43", "3L51"],
			mudbomb: ["6L19", "5L19", "4L19"],
			muddywater: ["6L47", "5L47", "4L47"],
			mudshot: ["6L9", "5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L5", "6E", "5L5", "5E", "4L5", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L41"],
			recover: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4E", "3E"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			slam: ["6L15", "5L15", "4L15", "3L11"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E", "3E"],
			stockpile: ["6E", "5E", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E", "3E"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "5D", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["6L29", "5L29", "4L29", "3L31"],
		},
	},
	quagsire: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L24", "5L24", "4L24", "3L23"],
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L42"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6L48", "5L48", "4L48", "3L61"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			irontail: ["5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["6L48", "5L48", "4L48", "3L61"],
			mudbomb: ["6L19", "5L19", "4L19"],
			muddywater: ["6L53", "5L53", "4L53"],
			mudshot: ["6L9", "5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3M", "3L49"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			slam: ["6L15", "5L15", "4L15", "3L11"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["6L31", "5L31", "4L31", "3L35"],
		},
	},
	murkrow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			assurance: ["6L25", "6E", "5L25", "5E", "4L25"],
			astonish: ["6L1", "5L1", "4L1", "3L9", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			bravebird: ["6E", "5E", "4E"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "5D", "4E", "3E"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillpeck: ["6E", "5E", "4E", "3E"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6E", "5E", "4E", "3E"],
			feintattack: ["6L35", "6E", "5L35", "5E", "4L35", "4E", "3L35"],
			flatter: ["6E"],
			fly: ["6M", "5M", "4M", "3M"],
			foulplay: ["6L45", "5T", "5L45"],
			frustration: ["6M", "5M", "4M", "3M"],
			haze: ["6L11", "5L11", "4L11", "3L22"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			meanlook: ["6L41", "5L41", "4L41", "3L48"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L21", "5L21", "4L21", "3L27"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			perishsong: ["6E", "5E", "4E", "3E"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M"],
			psychoshift: ["6E", "5E", "4E"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6L5", "5L5", "4L5", "3L14"],
			quash: ["6M", "6L65", "5M", "5L65"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			skyattack: ["6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["3T"],
			spite: ["5T", "4T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L55", "5L55", "4T", "4L45"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6L50", "5T", "5L51", "4T"],
			taunt: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L40"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "6L61", "5M", "5L61", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			wingattack: ["6L15", "6E", "5L15", "5E", "4L15", "4E", "3E"],
		},
	},
	honchkrow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			darkpulse: ["6M", "6L75", "5T", "5L75", "4M", "4L55"],
			defog: ["4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M"],
			foulplay: ["6L45", "5T", "5L45"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			haze: ["6L1", "5L1", "4L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icywind: ["5T"],
			incinerate: ["6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["6L35", "5L35", "4L35"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L55", "4L45"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			pursuit: ["6L1", "5L1", "4L1"],
			quash: ["6M", "6L65", "5M", "5L65"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			skyattack: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M"],
			spite: ["5T", "4T"],
			steelwing: ["6M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L1", "4T"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "6L25", "5M", "5L25", "4M", "4L25"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			wingattack: ["6L1", "5L1", "4L1"],
		},
	},
	misdreavus: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			astonish: ["6L10", "5L10", "4L10", "3L11"],
			attract: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L14", "5L14", "4L14", "3L17"],
			curse: ["6E", "5E", "4E"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			destinybond: ["6E", "5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			grudge: ["6L50", "5L50", "4L46", "3L53"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hex: ["6L23", "5L23"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T"],
			imprison: ["6E", "5E", "4E", "3E"],
			inferno: ["5D"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meanlook: ["6L19", "5L19", "4L19", "3L23"],
			mefirst: ["6E"],
			memento: ["6E", "5E", "4E"],
			mimic: ["3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["6E", "5E", "4T", "4E"],
			painsplit: ["6L32", "5T", "5L32", "4T", "4L28", "3L37"],
			payback: ["6M", "6L37", "5M", "5L37", "4M", "4L32"],
			perishsong: ["6L46", "5L46", "4L41", "3L45"],
			powergem: ["6L55", "5L55", "4L50"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L28", "5L28", "4L23", "3L30"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psywave: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "6L41", "5M", "5L41", "4M", "4L37", "3M"],
			shadowsneak: ["6E", "5E", "4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6L5", "6E", "5T", "5L5", "5E", "4T", "4L5", "4E", "3L6", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E", "4T", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["6E", "5T", "5E"],
		},
	},
	mismagius: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T"],
			luckychant: ["6L1", "5L1", "4L1"],
			magicalleaf: ["6L1", "5L1", "4L1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			phantomforce: ["6L1"],
			powergem: ["6L1"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psywave: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["6L1", "5T", "5L1", "4T", "4L1"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
		},
	},
	unown: {
		inherit: true,
		learnset: {
			hiddenpower: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	wynaut: {
		inherit: true,
		learnset: {
			charm: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			counter: ["6L15", "5L15", "4L15", "3L15"],
			destinybond: ["6L15", "5L15", "4L15", "3L15"],
			encore: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			mirrorcoat: ["6L15", "5L15", "4L15", "3L15"],
			safeguard: ["6M", "6L15", "5L15", "4L15", "3L15"],
			splash: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			tickle: ["3S0"],
		},
	},
	wobbuffet: {
		inherit: true,
		learnset: {
			charm: ["5D"],
			counter: ["6L1", "6S2", "6S3", "5L1", "4L1", "3L1", "3S0", "3S1"],
			destinybond: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			encore: ["5D"],
			mirrorcoat: ["6L1", "6S3", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			safeguard: ["6M", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	girafarig: {
		inherit: true,
		learnset: {
			agility: ["6L14", "5L14", "4L14", "3L31"],
			amnesia: ["6E", "5E", "4E", "3E"],
			assurance: ["6L28", "5L28", "4L28"],
			astonish: ["6L1", "5L1", "4L1", "3L7"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L23", "5L23", "4L23", "3L37"],
			beatup: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "5D", "4L1", "3L13"],
			crunch: ["6L46", "5L46", "4L46", "3L49"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doublehit: ["6L32", "5L32", "4L32"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			guardswap: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["6E", "5T", "5E", "4T", "4E", "3E"],
			meanlook: ["6E", "5E"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["6L5", "5L5", "4L5", "3L25"],
			powerswap: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L19", "5L19", "4L19", "3L43"],
			psychic: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6E", "5E", "4E"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["6E", "5T", "5E", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stomp: ["6L10", "5L10", "4L10", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6E", "5E", "4E", "3E"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			wish: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["6L41", "5T", "5L41", "4T", "4L41"],
		},
	},
	pineco: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L20", "5L20", "4L17", "3L29"],
			bodyslam: ["3T"],
			bugbite: ["6L9", "5T", "5L9", "4T", "4L9"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E", "3S1"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L45", "6E", "5L45", "5E", "4L42", "4E", "3T", "3L50"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			explosion: ["6M", "6L34", "5M", "5L34", "4M", "4L31", "3T", "3L36"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gravity: ["5T", "5D", "4T"],
			gyroball: ["6M", "6L42", "5M", "5L42", "4M", "4L39"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irondefense: ["6L39", "5T", "5L39", "4T", "4L34"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["6L23", "5L23", "4M", "4L20"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L31", "5M", "5L31", "4M", "4L28"],
			pinmissile: ["6E", "5E", "4E", "3E", "3S1"],
			powertrick: ["6E", "5E", "4E"],
			protect: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			rapidspin: ["6L17", "5L17", "4L12", "3L22"],
			reflect: ["6M", "5M", "4M", "4E", "3M", "3E"],
			refresh: ["3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E", "4E"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			sandtomb: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L6", "5L6", "5D", "4L6", "3T", "3L8", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6L28", "5L28", "4L23", "3L43", "3S1"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6E", "5E", "4E", "3E"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			takedown: ["6L12", "5L12", "4L9", "3L15"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6E", "5E", "5D", "4E"],
			venoshock: ["6M", "5M"],
		},
	},
	forretress: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L32", "5L32"],
			bide: ["6L20", "5L20", "4L17", "3L29"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bugbite: ["6L1", "5T", "5L1", "4T", "4L1"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L56", "5L56", "4L50", "3T", "3L59"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L42", "5M", "5L42", "4M", "4L33", "3T", "3L39"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L50", "5M", "5L50", "4M", "4L45"],
			headbutt: ["4T"],
			heavyslam: ["6L1", "5L70"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["6L46", "5T", "5L46", "4T", "4L38"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magnetrise: ["6L1", "5T", "5L60", "4T", "4L57"],
			mimic: ["3T"],
			mirrorshot: ["6L31", "5L31", "4L31"],
			naturalgift: ["6L23", "5L23", "4M", "4L20"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L36", "5M", "5L36", "4M", "4L28"],
			protect: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rapidspin: ["6L17", "5L17", "4L12", "3L22"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L1", "5L1", "4L1", "3T", "3L1"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6L28", "5L28", "4L23", "3L49"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L12", "5L12", "4L1", "3L15"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L1", "5L1", "4L1"],
			venoshock: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			zapcannon: ["6L1", "5L64", "4L62", "3L31"],
		},
	},
	dunsparce: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			ancientpower: ["6L19", "6E", "5L48", "5E", "4T", "4L41", "4E", "3E"],
			aquatail: ["5T", "4T"],
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6E", "5E", "4E", "3E"],
			bind: ["5T"],
			bite: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			coil: ["6L37", "5L43"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["6L1", "5L4", "5D", "4L5", "3T", "3L4"],
			dig: ["6M", "6L31", "5M", "5L53", "4M", "4L45", "3M"],
			doubleedge: ["6L34", "5L34", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillrun: ["6L43", "5T", "5L43"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["6L46", "5T", "5L58", "4T", "4L49", "3L41"],
			endure: ["6L40", "5L40", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flail: ["6L49", "5L63", "4L53", "3L44"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			glare: ["6L28", "5L12", "4L13", "3L14"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["6E", "5E", "4T", "4E", "3E"],
			hex: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			magiccoat: ["6E", "5T", "5E", "5D", "4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6L10", "5L24", "4L25", "3L24"],
			rage: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L4", "5L16", "4T", "4L17", "3T", "3L21"],
			roost: ["6M", "6L25", "5T", "5L33", "4M", "4L33"],
			round: ["6M", "5M"],
			screech: ["6L13", "5L28", "4L29", "3L31"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["6L7", "5T", "5L20", "4T", "4L21", "3L21"],
			stealthrock: ["5T", "5D", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6L22", "5L38", "4L37", "3L34"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6E", "5E", "4E"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			yawn: ["6L16", "5L8", "4L9", "3L11"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	gligar: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L22", "5M", "5L27"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6E", "5E", "4E"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crosspoison: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			feint: ["6E", "5E", "5D", "4E"],
			feintattack: ["6L19", "5L23", "4L23", "3L28"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L16", "5L20", "4T", "4L20", "3T"],
			guillotine: ["6L55", "5L49", "4L45", "3L52"],
			harden: ["6L7", "5L9", "4L9", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["6L10", "5T", "5L12", "4T", "4L12"],
			metalclaw: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "4E"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			poisontail: ["6E", "5E"],
			powertrick: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L13", "5L16", "4L16", "3L20"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["6E", "5E"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L4", "5L5", "5D", "4L5", "3L6", "3S0"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			sandtomb: ["6E", "5E", "4E", "3E"],
			screech: ["6L35", "5L31", "4L27", "3L44"],
			secretpower: ["6M", "4M", "3M"],
			skyuppercut: ["6L45", "5L45"],
			slash: ["6L27", "5L34", "4L31", "3L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			steelwing: ["6M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L50", "5M", "5L38", "4M", "4L34", "3T"],
			tailwind: ["5T", "5D", "4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "6L30", "5M", "5L42", "4M", "4L38"],
			venoshock: ["6M", "5M"],
			wingattack: ["6E", "5E", "4E", "3E"],
			xscissor: ["6M", "6L40", "5M", "5L45", "4M", "4L42"],
		},
	},
	gliscor: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L22", "5M", "5L27"],
			aerialace: ["6M", "5M", "4M"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "5M", "4M"],
			feintattack: ["6L19", "5L23", "4L23"],
			firefang: ["6L1", "5L1", "4L1"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["6L16", "5L20", "4T", "4L20"],
			gigaimpact: ["6M", "5M", "4M"],
			guillotine: ["6L1", "5L49", "4L45"],
			harden: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			icefang: ["6L1", "5L1", "4L1"],
			irontail: ["5T", "4M"],
			knockoff: ["6L1", "5T", "5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L27", "5L34", "4L31"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L13", "5L16", "4L16"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			sandstorm: ["6M", "5M", "4M"],
			screech: ["6L35", "5L31", "4L27"],
			secretpower: ["6M", "4M"],
			skyattack: ["5T", "4T"],
			skyuppercut: ["6L45", "5L45"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			steelwing: ["6M", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "6L50", "5M", "5L38", "4M", "4L34"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uturn: ["6M", "6L30", "5M", "5L42", "4M", "4L38"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "6L40", "5M", "5L45", "4M", "4L42"],
		},
	},
	snubbull: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L7", "5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "5D", "4L1", "3L8", "3S0"],
			closecombat: ["6E", "5E", "5D", "4E"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crunch: ["6L49", "6E", "5L49", "5E", "4L49", "4E", "3L53", "3E"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "5D", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["6L19", "5L19", "4T", "4L19"],
			healbell: ["6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icefang: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			icepunch: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["5T", "4T"],
			lick: ["6L13", "5L13", "4L13", "3L19"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["6E", "5E", "4E", "3T", "3E"],
			mimic: ["6E", "5E", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "6L43", "5M", "5L43", "4M", "4L43"],
			playrough: ["6L37"],
			poweruppunch: ["6M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L31", "5L31", "4L31", "3L34"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L26"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snarl: ["6M", "5M"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwhip: ["6L1", "5L1", "4L1", "3L4", "3S0"],
			takedown: ["5L37", "4L37", "3L43"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	granbull: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L7", "5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6L1", "5L1", "4L1", "3L8"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crunch: ["6L59", "5L59", "4L59", "3L61"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["6L19", "5L19", "4T", "4L19"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icefang: ["6L1", "5L1", "4L1"],
			icepunch: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lick: ["6L13", "5L13", "4L13", "3L19"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6L1", "5T", "5L67"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "6L51", "5M", "5L51", "4M", "4L51"],
			playrough: ["6L43"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L35", "5L35", "4L35", "3L38"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L28"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L4"],
			takedown: ["5L43", "4L43", "3L49"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	qwilfish: {
		inherit: true,
		learnset: {
			acidspray: ["6E", "5E"],
			aquajet: ["6E", "5E", "5D", "4E"],
			aquatail: ["6L45", "5T", "5L45", "4T", "4L45"],
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6L33", "6E", "5L33", "5E", "4M", "4L33"],
			bubble: ["6L13"],
			bubblebeam: ["6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			destinybond: ["6L1", "5L53", "4L53", "3L45"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fellstinger: ["6L1"],
			flail: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L9", "5L9", "4L9", "3L9", "3S0"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L1", "5L57", "4L57", "3L37"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			mimic: ["3T"],
			minimize: ["6L9", "5L9", "4L9", "3L9", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			pinmissile: ["6L37", "5L37", "4L37", "3L21"],
			poisonjab: ["6M", "6L49", "5M", "5L49", "4M", "4L49", "4E"],
			poisonsting: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L29", "5L29", "4L29", "3L25"],
			rollout: ["6L17", "5L17", "4T", "4L17", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "5D", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spikes: ["6L1", "5L1", "4L1", "3L1"],
			spitup: ["6L25", "5L25", "4L25"],
			stockpile: ["6L25", "5L25", "4L25"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			takedown: ["6L41", "5L41", "4L41", "3L33"],
			taunt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			toxicspikes: ["6L21", "5L21", "4L21"],
			venoshock: ["6M", "5M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L13", "4L13", "3L13"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	shuckle: {
		inherit: true,
		learnset: {
			acid: ["6E", "5E"],
			acupressure: ["6E", "5E", "4E"],
			afteryou: ["5T"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L1", "5L1", "4L1", "3L28"],
			bind: ["5T"],
			bodyslam: ["3T"],
			bugbite: ["6L42", "5T", "5L49", "4T", "4L40"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			encore: ["6L5", "5L7", "5D", "4L9", "3L14", "3S1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			finalgambit: ["6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L27", "5T", "5L31", "4T", "4L35"],
			guardsplit: ["6L45", "5L55"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			knockoff: ["6E", "5T", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["6E", "5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			powersplit: ["6L45", "5L55"],
			powertrick: ["6L31", "5L43", "4L48"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L20", "5M", "5L25", "4M", "4L27", "3M", "3L37"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6E", "5E"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L38", "5M", "5L38", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L23", "5L23"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L1", "5L37", "4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L16", "5M", "5L19", "4M", "4L14", "3M", "3L23"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			sandtomb: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["6L34", "5L34", "5D"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M", "3S1"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stickyweb: ["6L1"],
			stoneedge: ["6M", "6L49", "5M", "5L49", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "6L12", "5M", "5L1"],
			substitute: ["6M", "5M", "4M", "3T", "3S1"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M", "3S1"],
			venoshock: ["6M", "5M"],
			withdraw: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			wrap: ["6L9", "5L13", "4L22", "3L9", "3S0"],
		},
	},
	heracross: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L10", "5M", "5L13", "4M", "4L13"],
			armthrust: ["6L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "6L25", "5M", "5L19", "4M", "4L19", "3M", "3L23"],
			bugbite: ["5T", "4T"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["6L1", "6S0", "6S1"],
			captivate: ["4M"],
			chipaway: ["6L16", "5L16"],
			closecombat: ["6L34", "6S0", "5L37", "4L37"],
			confide: ["6M"],
			counter: ["6L19", "5L25", "4L25", "3T", "3L30"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "6S1", "5M", "4M", "3M"],
			endure: ["6L1", "5L1", "4M", "4L1", "3T", "3L11"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4E", "3E"],
			feint: ["6L37", "5L49", "4L49"],
			flail: ["6E", "5E", "5D", "4E", "3E"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "5D", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L7", "5L7", "4L7", "3L17"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			harden: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L1", "5L1", "5D", "4L1", "3L6"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megahorn: ["6L46", "6E", "6S0", "5L55", "5E", "4L55", "3L53"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L1", "4L1"],
			pinmissile: ["6L31", "6S0", "6S1"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E", "4E"],
			reversal: ["6L43", "5L43", "4L43", "3L45"],
			rockblast: ["6E", "6S1"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6E", "5E", "3T"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L28", "5L31", "4L31", "3L37"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	sneasel: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L20", "5L24", "4L24", "3L36"],
			assist: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6E", "5E", "4M"],
			beatup: ["6L28", "5L42", "4L38", "3L57"],
			bite: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E", "3E"],
			falseswipe: ["6M", "5M", "4M"],
			feint: ["6E", "5E"],
			feintattack: ["6L10", "5L14", "4L14", "3L22"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L16", "5L21", "4L21", "3L29"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "6L25", "5M", "5L35"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "5D", "4T", "4E", "3T"],
			iceshard: ["6L47", "6E", "5L51", "5E", "4L49", "4E"],
			iciclecrash: ["6E"],
			icywind: ["6L14", "5T", "5L28", "4T", "4L28", "3T", "3L43"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["5T", "5D", "4T"],
			lowsweep: ["6M", "5M"],
			metalclaw: ["6L22", "5L49", "4L42", "3L64"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			punishment: ["6L44", "6E", "5L44", "5E", "4E"],
			pursuit: ["6E", "5E", "4E"],
			quickattack: ["6L8", "5L8", "4L8", "3L8", "3S0"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			screech: ["6L32", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L35", "5L38", "4L35", "3L50"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["6L40", "5T", "5L40", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M", "3L1", "3S0"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	weavile: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			assurance: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "6S1", "5M", "4M", "4S0"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "6L47", "5T", "5L51", "4M", "4L49"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			embargo: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["4S0"],
			falseswipe: ["6M", "5M", "4M"],
			feintattack: ["6L10", "5L14", "4L14"],
			fling: ["6M", "6L28", "5M", "5L42", "4M", "4L38"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L16", "5L21", "4L21"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "6L25", "5M", "5L35"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["6S1", "5T", "4T"],
			iceshard: ["4S0"],
			icywind: ["6L14", "5T", "5L28", "4T", "4L28"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			metalclaw: ["6L22", "5L49", "4L42"],
			mudslap: ["4T"],
			nastyplot: ["6L20", "5L24", "4L24"],
			naturalgift: ["4M"],
			nightslash: ["6L35", "6S1", "5L35", "4L35", "4S0"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			punishment: ["6L44"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6L1", "5L1", "4L1"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1"],
			screech: ["6L32", "5L10", "4L10"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snarl: ["6M", "5M"],
			snatch: ["6L40", "5T", "5L40", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			whirlpool: ["4M"],
			xscissor: ["6M", "6S1", "5M", "4M"],
		},
	},
	teddiursa: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			babydolleyes: ["6L1"],
			bellydrum: ["6E", "5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6L36", "5L36", "4L36"],
			chipaway: ["6E", "5E"],
			closecombat: ["6E", "5E", "4E"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			covet: ["6L1", "5T", "5L1", "4L1"],
			crosschop: ["6E", "5E", "4E"],
			crunch: ["6E", "5E", "5D", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6L1", "6E", "5L1", "5E", "5D", "4L1", "4E", "3L19", "3E"],
			feintattack: ["6L15", "5L15", "4L15", "3L25"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "6L1", "5M", "5L57", "4M", "4L57"],
			focuspunch: ["5D", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L8", "5L8", "4L8", "3L13"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["5T"],
			icepunch: ["5T", "4T", "3T"],
			lastresort: ["5T", "4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lick: ["6L1", "5L1", "4L1", "3L7", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["6E", "5E", "4E", "3E", "3S1"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "4E"],
			payback: ["6M", "5M", "4M"],
			playnice: ["6L25"],
			playrough: ["6E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L31"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M", "3S1"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["6E", "5E", "4E", "3T", "3E"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L29", "5L29", "4L29", "3L37"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["6L43", "5T", "5L43", "4T", "4L43", "3T", "3L43"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L22", "5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			takedown: ["6E", "5E", "4E", "3E"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L50", "5L50", "4L50", "3L49"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			workup: ["5M"],
			yawn: ["6E", "5E", "4E", "3E"],
		},
	},
	ursaring: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["6L1", "5T", "5L1", "4L1"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6L1", "5L1", "4L1", "3L19"],
			feintattack: ["6L15", "5L15", "4L15", "3L25"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L8", "5L8", "4L8", "3L1"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			hammerarm: ["6L1", "5L67", "4L67"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icepunch: ["5T", "4T", "3T"],
			lastresort: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			playnice: ["6L25"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L31"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scaryface: ["6L38", "5L38", "4L38"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L29", "5L29", "4L29", "3L37"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["6L49", "5T", "5L49", "4T", "4L49", "3T", "3L43"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L22", "5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L58", "5L58", "4L58", "3L49"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			workup: ["5M"],
		},
	},
	slugma: {
		inherit: true,
		learnset: {
			acidarmor: ["6E", "5E", "4E", "3E"],
			afteryou: ["5T"],
			amnesia: ["6L32", "5L32", "4L31", "3L29"],
			ancientpower: ["6L28", "5L28", "4T", "4L26"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L46", "5L46", "4L46", "3T", "3L50"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L55", "6E", "5T", "5L55", "5E", "4T", "4L56"],
			ember: ["6L5", "5L5", "5D", "4L8", "3L8"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flameburst: ["6L23", "5L23"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L50", "5M", "5L50", "4M", "4L53", "3M", "3L36"],
			frustration: ["6M", "5M", "4M", "3M"],
			guardswap: ["6E"],
			harden: ["6L14", "5L14", "4L16", "3L22"],
			heatwave: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["6E", "5E", "5D"],
			infestation: ["6M"],
			irondefense: ["5T", "4T"],
			lavaplume: ["6L37", "5L37", "4L38"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			memento: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			recover: ["6L19", "5L19", "4L23"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3T", "3L43"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L10", "5L10", "4L11", "3L15"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["6E", "5E", "4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smog: ["6L1", "5L1", "4L1", "3L1"],
			smokescreen: ["6E", "5E", "4E"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E"],
			stockpile: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	magcargo: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L32", "5L32", "4L31", "3L29"],
			ancientpower: ["6L28", "5L28", "4T", "4L26"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L52", "5L52", "4L52", "3T", "3L60"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L1", "5T", "5L67", "4T", "4L66"],
			earthquake: ["6M", "5M", "4M", "3M", "3S0"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flameburst: ["6L23", "5L23"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L59", "5M", "5L59", "4M", "4L61", "3M", "3L36", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			harden: ["6L14", "5L14", "4L16", "3L22"],
			heatwave: ["5T", "4T", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T", "4T"],
			lavaplume: ["6L37", "5L37", "4L40"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			recover: ["6L19", "5L19", "4L23"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L44", "5M", "5L44", "4M", "4L45", "3T", "3L48"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L1", "5L1", "4L1", "3L1"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["6L38", "5L38"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			smog: ["6L1", "5L1", "4L1", "3L1"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	swinub: {
		inherit: true,
		learnset: {
			amnesia: ["6L48", "5L49", "4L49", "3L55"],
			ancientpower: ["6E", "5E", "5D", "4T", "4E", "3E", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6E", "5E"],
			bite: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "6L44", "5M", "5L44", "4M", "4L44", "3M", "3L46"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["6L14", "5L16", "4M", "4L16", "3T", "3L19"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6E", "5E", "4E"],
			flail: ["6L40", "5L40"],
			freezedry: ["6E"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			iceshard: ["6L24", "5L28", "4L28"],
			iciclecrash: ["6E", "5E"],
			iciclespear: ["6E", "5E", "5D", "4E", "3E"],
			icywind: ["6L21", "5T", "5L25", "4T", "4L25", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["6L35", "5L40", "4L40", "3L37", "3S0"],
			mudbomb: ["6L18", "5L20", "4L20"],
			mudshot: ["6E", "5E", "4E", "3E", "3S0"],
			mudslap: ["6L11", "5L13", "4T", "4L13", "3T"],
			mudsport: ["6L5", "5L4", "4L4"],
			naturalgift: ["4M"],
			odorsleuth: ["6L1", "5L1", "5D", "4L1", "3L1"],
			powdersnow: ["6L8", "5L8", "4L8", "3L10"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L28", "6E", "5L32", "5E", "4L32", "4E", "3L28", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	piloswine: {
		inherit: true,
		learnset: {
			amnesia: ["6L58", "5L65", "4L65", "3L70"],
			ancientpower: ["6L1", "5L1", "4T", "4L1"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L52", "5M", "5L56", "4M", "4L56", "3M", "3L56"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L40", "4M", "4L40", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["6L14", "5L16", "4M", "4L16", "3T", "3L1"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L33", "5L33", "4L33", "3L33"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["3L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L24", "5L28", "4L28"],
			icywind: ["6L21", "5T", "5L25", "4T", "4L25", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["6L37", "5L48", "4L48", "3L42"],
			mudbomb: ["6L18", "5L20", "4L20"],
			mudslap: ["6L11", "5L13", "4T", "4L13", "3T"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["6L1", "5L1", "4L1", "3L1"],
			peck: ["6L1", "5L1", "4L1"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6L28", "5L32", "4L32", "3L28"],
			thrash: ["6L41", "5L41"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	mamoswine: {
		inherit: true,
		learnset: {
			ancientpower: ["6L1", "5L1", "4T", "4L1"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L52", "5M", "5L56", "4M", "4L56"],
			block: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M"],
			doublehit: ["6L33", "5L33", "5S0", "4L33"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "6S1", "5M", "5L40", "4M", "4L40"],
			endeavor: ["5T", "4T"],
			endure: ["6L14", "5L16", "4M", "4L16"],
			facade: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "6L21", "5M", "5L25", "5S0", "4M", "4L25"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icefang: ["6L24", "5L28", "5S0", "4L28"],
			iciclecrash: ["6S1"],
			iciclespear: ["6S1"],
			icywind: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			mist: ["6L37", "5L48", "4L48"],
			mudbomb: ["6L18", "5L20", "4L20"],
			mudslap: ["6L11", "5L13", "4T", "4L13"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["6L1", "5L1", "4L1"],
			peck: ["6L1", "5L1", "4L1"],
			powdersnow: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "6S1", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L1", "5L65", "4L65"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			takedown: ["6L28", "5L32", "5S0", "4L32"],
			thrash: ["6L41", "5L41"],
			toxic: ["6M", "5M", "4M"],
		},
	},
	corsola: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E", "3E"],
			ancientpower: ["6L20", "5L32", "4T", "4L32", "3L45"],
			aquaring: ["6L38", "6E", "5L37", "5E", "4L37", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			bide: ["6E", "5E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["6L27", "4M"],
			bubble: ["6L8", "5L8", "5D", "4L8", "3L12"],
			bubblebeam: ["6L17", "5L25", "4L25", "3L23"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			camouflage: ["6E"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "5D", "4E", "3E"],
			curse: ["6E", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L47", "5T", "5L53", "4T", "4L53"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["6L35", "5L35", "4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L50", "5L52"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L4", "5L4", "4L4", "3L6"],
			headbutt: ["4T"],
			headsmash: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			iciclespear: ["6E", "5E", "4E", "3E"],
			icywind: ["5T", "4T"],
			ingrain: ["6E", "5E", "4E", "3E"],
			irondefense: ["6L29", "5T", "5L29"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L23", "5L28", "4L28"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["6L45", "5L48", "4L48", "3L39"],
			mist: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6E", "5E", "4E"],
			powergem: ["6L41", "5L44", "4L44"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L10", "5L13", "4L13", "3L17"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["6L13", "5L16", "4L16", "3L17"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L31", "5L20", "4L20", "3L34"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spikecannon: ["6L27", "5L40", "4L40", "3L28"],
			stealthrock: ["5T", "5D", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	remoraid: {
		inherit: true,
		learnset: {
			acidspray: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L14", "6E", "5L14", "5E", "4L14", "4E", "3L22", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["5D", "4M"],
			bubblebeam: ["6L18", "5L19", "4L19", "3L22"],
			bulletseed: ["6L38", "5L27", "4M", "4L27"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			entrainment: ["6E"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L22", "5L23", "4L23", "3L33"],
			frustration: ["6M", "5M", "4M", "3M"],
			gunkshot: ["5T", "4T"],
			haze: ["6E", "5E", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L42", "5L42"],
			hyperbeam: ["6M", "6L46", "5M", "5L45", "4M", "4L45", "3M", "3L55"],
			icebeam: ["6M", "6L34", "5M", "5L40", "4M", "4L40", "3M", "3L44"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			lockon: ["6L6", "5L6", "5D", "4L6", "3L11"],
			mimic: ["3T"],
			mudshot: ["6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L10", "5L10", "4L10", "3L22"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6E", "5E", "5D", "4E", "3E"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			screech: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			signalbeam: ["6L30", "5T", "5L36", "4T", "4L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T"],
			soak: ["6L50", "5L49"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6E", "5E", "4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "4E", "3T", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6L26", "6E", "5L32", "5E", "4M", "4L32", "3M"],
			waterspout: ["6E", "5E", "4E"],
			whirlpool: ["4M"],
		},
	},
	octillery: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L1", "5L1", "4L1", "3L22"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bubblebeam: ["6L18", "5L19", "4L19", "3L22"],
			bulletseed: ["6L46", "5L29", "4M", "4L29", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1", "3L11"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6L22", "5L23", "4L23", "3L38"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["6L1", "5T", "5L1", "4T", "4L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L52", "5L52"],
			hyperbeam: ["6M", "6L58", "5M", "5L55", "4M", "4L55", "4S0", "3M", "3L70"],
			icebeam: ["6M", "6L40", "5M", "5L48", "4M", "4L48", "4S0", "3M", "3L54"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["6L25", "5L25", "4L25", "4S0", "3L25"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L1", "5L1", "4L1", "3L22"],
			psychic: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L1", "5L1", "4L1"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			signalbeam: ["6L34", "5T", "5L42", "4T", "4L42", "4S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L64", "5L61"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["6L28", "5L36", "4L36"],
		},
	},
	delibird: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6E", "5E", "4E", "3E"],
			avalanche: ["4M"],
			bestow: ["6E", "5E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defog: ["4M"],
			destinybond: ["6E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			focuspunch: ["5D", "4M", "3M"],
			freezedry: ["6E"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			gunkshot: ["5T", "4T"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			iceball: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6E", "5T", "5E", "4E"],
			iceshard: ["6E", "5E", "5D", "4E"],
			icywind: ["6E", "5T", "5E", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			poweruppunch: ["6M"],
			present: ["6L1", "6S1", "5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			signalbeam: ["5T", "4T"],
			skyattack: ["5T", "4T", "3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["3T"],
			spikes: ["6E"],
			splash: ["6E", "5E", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	mantyke: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M"],
			agility: ["6L32", "5L19", "4L19"],
			aircutter: ["4T"],
			airslash: ["6L36", "5L36"],
			amnesia: ["6E", "5E"],
			aquaring: ["6L39", "5L46", "4L46"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["6L46", "5T", "5L40", "4T", "4L40"],
			bubble: ["6L1", "5L1", "4L1"],
			bubblebeam: ["6L7", "5L10", "4L10"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L11", "5L37", "4L37"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M"],
			haze: ["6E", "5E", "4E"],
			headbutt: ["6L16", "5L13", "4T", "4L13"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hydropump: ["6L49", "6E", "5L49", "5E", "4L49", "4E"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			mirrorcoat: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			mudsport: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4E"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6E", "5T", "5E", "4E"],
			slam: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			splash: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M"],
			supersonic: ["6L3", "5L4", "4L4"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			tailwind: ["6E"],
			takedown: ["6L27", "5L31", "4L31"],
			toxic: ["6M", "5M", "4M"],
			twister: ["6E", "5E", "4E"],
			waterfall: ["6M", "5M", "4M"],
			waterpulse: ["6L19", "5L28", "4M", "4L28"],
			watersport: ["6E", "5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["6L23", "6E", "5L23", "5E"],
			wingattack: ["6L14", "5L22", "4L22"],
		},
	},
	mantine: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L32", "5L19", "4L19", "3L29"],
			aircutter: ["5D", "4T"],
			airslash: ["6L36", "5L36"],
			amnesia: ["6E", "5E"],
			aquaring: ["6L39", "5L46", "4L46"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6L46", "5T", "5L40", "4T", "4L40"],
			brine: ["4M"],
			bubble: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["6L1", "5L1", "4L1", "3L15"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["6L1", "5L1", "4M", "4L1"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L11", "5L37", "4L37", "3L50"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E", "3E"],
			headbutt: ["6L16", "5L13", "4T", "4L13"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L49", "6E", "5L49", "5E", "4L49", "4E", "3E"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3E"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			signalbeam: ["6L1", "5T", "5L1", "4T", "4L1"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			splash: ["6E", "5E", "4E"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L1", "5L1", "5D", "4L1", "3L8", "3S0"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwind: ["5T", "4T"],
			takedown: ["6L27", "5L31", "4L31", "3L22"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6E", "5E", "4E", "3E"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L19", "5L28", "4M", "4L28", "3M", "3L43"],
			watersport: ["6E", "5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["6L23", "6E", "5L23", "5E"],
			wingattack: ["6L14", "5L22", "4L22", "3L36"],
		},
	},
	skarmory: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L12", "5L12", "4L12", "3L16"],
			aircutter: ["6L23", "5L23", "4T", "4L23", "3L29"],
			airslash: ["6L42", "5L42", "4L39"],
			assurance: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L39", "5L39"],
			bravebird: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drillpeck: ["6E", "5E", "5D", "4E", "3E"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L20", "5L20", "4L20"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L17", "5L17", "4L17", "3L26"],
			furycutter: ["4T"],
			guardswap: ["6E", "5E", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			metalsound: ["6L31", "5L31", "4L31", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6L50", "5L50", "4L45"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "5D", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L6", "5L6", "4L6", "3L10"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			skydrop: ["6M", "5M"],
			slash: ["6L45", "5L45", "4L42"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spikes: ["6L28", "5L28", "4L27", "3L42"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			steelwing: ["6M", "6L34", "5L34", "4M", "4L34", "3M", "3L32"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L9", "5L9", "4T", "4L9", "3T", "3L13"],
			swordsdance: ["6M", "5M", "4M"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["6E", "5E", "4E", "3E"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	houndour: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6L25", "6E", "5L25", "5E", "4L27", "4E", "3E"],
			bite: ["6L16", "5L16", "4L17", "3L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["3S1"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crunch: ["6L49", "5L49", "4L48", "3L49"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			destinybond: ["6E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			embargo: ["6M", "6L37", "5M", "5L37", "4M", "4L40"],
			ember: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6E", "5E", "5D", "4E"],
			feintattack: ["6L32", "5L32", "4L35", "3L37", "3S1"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L28", "6E", "5L28", "5E", "4L30", "4E"],
			firespin: ["6E", "5E", "4E", "3E"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L44", "5M", "5L44", "4M", "4L43", "3M", "3L43"],
			foulplay: ["6L40", "5T", "5L40"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L4", "5L4", "5D", "4L4", "3L7", "3S0"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			inferno: ["6L56", "5L56"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L52", "6E", "5L52", "5E", "4L53", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["6L20", "5L20", "4L22", "3L31"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			punishment: ["6E", "5E", "4E"],
			pursuit: ["6E", "5E", "4E", "3E"],
			rage: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			roar: ["6M", "6L13", "5M", "5L13", "4M", "4L14", "3M", "3L19", "3S1"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			smog: ["6L8", "5L8", "4L9", "3L13"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E", "4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6E", "5E", "4E"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M", "4E", "3E"],
		},
	},
	houndoom: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6L26", "5L26", "4L28"],
			bite: ["6L16", "5L16", "4L17", "3L27"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L56", "5L56", "4L54", "3L59"],
			darkpulse: ["6M", "6S0", "5T", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			embargo: ["6M", "6L41", "5M", "5L41", "4M", "4L44"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L35", "5L35", "4L38", "3L43"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L30", "5L30", "4L32"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L50", "6S0", "5M", "5L50", "4M", "4L48", "3M", "3L51"],
			foulplay: ["6L45", "5T", "5L45"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			inferno: ["6L1", "5L65"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L1", "5L60", "4L60"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["6L20", "5L20", "4L22", "3L35"],
			overheat: ["6M", "5M", "4M", "3M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L13", "5M", "5L13", "4M", "4L14", "3M", "3L19"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "6S0", "5M", "4M", "3M"],
			smog: ["6L1", "5L1", "4L1", "3L13"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6S0", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	phanpy: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["6L33", "5L33", "4L33"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L9"],
			doubleedge: ["6L42", "5L42", "4L42", "3T", "3L49"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6E", "5T", "5E", "4T", "4E"],
			endure: ["6L28", "5L28", "4M", "4L28", "3T", "3L41"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6E", "5E", "4E", "3E"],
			flail: ["6L6", "5L6", "5D", "4L6", "3L17"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			headsmash: ["6E", "5E", "4E"],
			heavyslam: ["6E", "5E", "5D"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			iceshard: ["6E", "5E", "4E"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L37", "5T", "5L37", "4L37"],
			mimic: ["3T"],
			mudslap: ["6E", "5E", "4T", "3T"],
			naturalgift: ["6L19", "5L19", "4M", "4L19"],
			odorsleuth: ["6L1", "5L1", "4L1", "3L1"],
			playrough: ["6E"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L15", "5L15", "4T", "4L15", "3T", "3L33"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "5D", "4T"],
			slam: ["6L24", "5L24", "4L24"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L10", "5L10", "4L10", "3L25"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	donphan: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			assurance: ["6L31", "5L31", "4L31"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			bulldoze: ["6M", "6L1", "5M", "5L1"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L9"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L49"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			flail: ["4L1", "3L17"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L25", "5L25", "4L25", "3L25"],
			gigaimpact: ["6M", "6L54", "5M", "5L54", "4M", "4L54"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hornattack: ["6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			irondefense: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["6L10", "5T", "5L10", "4T", "4L10"],
			lastresort: ["5T"],
			magnitude: ["6L19", "5L19", "4L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["3L1"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L6", "5L6", "4L6", "3L41"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L15", "5L15", "4T", "4L15", "3T", "3L33"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L39", "5L39", "4L39"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			slam: ["6L24", "5L24", "4L24"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunderfang: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	stantler: {
		inherit: true,
		learnset: {
			astonish: ["6L7", "5L7", "4L7", "3L11"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L47"],
			captivate: ["6L50", "5L53", "4M", "4L49"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L23", "5L23", "4L23", "3L41"],
			disable: ["6E", "5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			extrasensory: ["6E", "5E", "4E", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L10", "5L10", "4L10", "3L17"],
			imprison: ["6L49", "5L49", "4L43"],
			irontail: ["5T", "4M", "3M"],
			jumpkick: ["6L43", "5L43"],
			lastresort: ["5T", "4T"],
			leer: ["6L3", "5L3", "4L3", "3L7", "3S0"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magicroom: ["5T"],
			mefirst: ["6L1", "6E", "5L55", "5E", "4L53"],
			megahorn: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["6M", "5M"],
			rage: ["6E", "5E"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			roleplay: ["6L33", "5T", "5L33", "4T", "4L33", "3L31"],
			round: ["6M", "5M"],
			sandattack: ["6L16", "5L16", "4L16", "3L27"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["6E", "5T", "5E", "4T", "4E", "3E"],
			stomp: ["6L13", "5L13", "4L13", "3L21"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			takedown: ["6L21", "5L21", "4L21", "3L37"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6E", "5E", "4E"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["6L38", "6E", "5T", "5L38", "5E", "4T", "4L38", "4E"],
		},
	},
	smeargle: {
		inherit: true,
		learnset: {
			captivate: ["5D"],
			falseswipe: ["5S1"],
			meanlook: ["5S1"],
			odorsleuth: ["5S1"],
			sketch: ["6L1", "6S2", "5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["5D"],
			spore: ["5S1"],
		},
	},
	miltank: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "6S0", "5M", "4M", "3M"],
			belch: ["6E"],
			bide: ["6L15", "5L15", "4L15", "3L26"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["6L24", "5L24", "4L24", "3T", "3L43"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["6L35", "5L35", "4M", "4L35"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "5D", "4E", "3E"],
			defensecurl: ["6L5", "5L5", "5D", "4L5", "3T", "3L8"],
			dizzypunch: ["6E", "5E", "4E"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L3", "5L3", "4L3", "3L4"],
			gyroball: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			healbell: ["6L48", "5T", "5L48", "4T", "4L48", "3L53"],
			heartstamp: ["6E", "5E"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "5D", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			milkdrink: ["6L11", "6S0", "5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			poweruppunch: ["6M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L19", "6S0", "5L19", "4T", "4L19", "3T", "3L34"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6E", "5E", "4E", "3T", "3E"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L8", "6S0", "5L8", "4L8", "3L13"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			wakeupslap: ["6L50", "5L55", "4L55"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["6L29", "5T", "5L29", "4T", "4L29"],
		},
	},
	raikou: {
		inherit: true,
		learnset: {
			aurasphere: ["4S3"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			crunch: ["6L43", "6S4", "5L43", "4L43", "3L61", "3S1"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			discharge: ["6L1", "5L57", "4L57"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["6L1", "5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quash: ["6M", "5M"],
			quickattack: ["6L22", "5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			raindance: ["6M", "6L71", "5M", "5L71", "4M", "4L71", "3M"],
			reflect: ["6M", "6L36", "6S4", "5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L29", "6S4", "5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["6M", "6L85", "5M", "5L85", "4M", "4L71", "3M", "3L71"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L50", "6S4", "5L50", "4L50"],
			thundershock: ["6L8", "5L8", "4L8", "3L11", "3S0"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			weatherball: ["4S3"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["4S3"],
		},
	},
	entei: {
		inherit: true,
		learnset: {
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			confide: ["6M"],
			crushclaw: ["4S3"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L8", "5L8", "4L8", "3L11", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["6L1", "5L85", "4L85"],
			extrasensory: ["6L1", "5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L71", "5M", "5L71", "4M", "4L71", "3M", "3L71"],
			firefang: ["6L50", "6S4", "5L50", "4L50"],
			firespin: ["6L22", "5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L36", "6S4", "5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			flareblitz: ["4S3"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["4S3"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			lavaplume: ["6L1", "5L57", "4L57"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sacredfire: ["6L1"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L29", "6S4", "5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L43", "6S4", "5M", "5L43", "4M", "4L43", "3T", "3L61", "3S1"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	suicune: {
		inherit: true,
		learnset: {
			airslash: ["4S4"],
			aquaring: ["4S4"],
			aurorabeam: ["6L29", "6S5", "5L29", "4L29", "4S3", "3L41", "3S0", "3S1"],
			avalanche: ["4M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "6L85", "5M", "5L85", "4M", "4L85", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["6L8", "5L8", "4L8", "3L11", "3S0"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["6L1", "5L64", "4L64"],
			extremespeed: ["4S4"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L22", "5L22", "4L22", "4S3", "3L31", "3S0", "3S1", "3S2"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L1", "5L71", "4L71", "3L71", "3S2"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L50", "6S5", "5L50", "4L50"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S2"],
			mimic: ["3T"],
			mirrorcoat: ["6L43", "6S5", "5L43", "4L43", "3L61", "3S1"],
			mist: ["6L36", "6S5", "5L36", "4L36", "4S3", "3L51", "3S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quash: ["6M", "5M"],
			raindance: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "4S3", "3M", "3L21", "3S0", "3S2"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M"],
			sheercold: ["4S4"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6L1", "5T", "5L57", "4T", "4L57"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	larvitar: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			assurance: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "5D", "5S1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L14", "5L14"],
			confide: ["6M"],
			crunch: ["6L41", "5L41", "4L37", "3L43"],
			curse: ["6E", "5E", "4E", "3E"],
			darkpulse: ["6M", "6L32", "5T", "5L32", "5D", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E", "3E", "3S0"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L46", "4M", "4L41", "3M", "3L50"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L55", "5M", "5L55", "4M", "4L50", "3M", "3L57"],
			irondefense: ["6E", "5T", "5E", "4E"],
			ironhead: ["6E", "5T", "5E", "4T", "4E"],
			irontail: ["6E", "5T", "5E"],
			leer: ["6L1", "5L1", "5S1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6E", "5T", "5E", "4E", "3E", "3S0"],
			payback: ["6M", "6L37", "5M", "5L37", "4M", "4L32"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L19", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L5", "5M", "5L5", "5S1", "4M", "4L5", "3M", "3L8", "3S0"],
			scaryface: ["6L23", "5L23", "4L19", "3L36"],
			screech: ["6L10", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["6E", "5T", "5E", "5D", "4M"],
			stomp: ["6E", "5E", "4E", "3E"],
			stoneedge: ["6M", "6L50", "5M", "5L50", "4M", "4L46"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "5S1", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thrash: ["6L28", "5L28", "4L23", "3L29"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	pupitar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L14", "5L14"],
			confide: ["6M"],
			crunch: ["6L47", "5L47", "4L41", "3L47"],
			darkpulse: ["6M", "6L34", "5T", "5L34", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L54", "5M", "5L54", "4M", "4L47", "3M", "3L56"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L67", "5M", "5L67", "4M", "4L60", "3M", "3L65"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T"],
			payback: ["6M", "6L41", "5M", "5L41", "4M", "4L34"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L19", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["6L23", "5L23", "4L19", "3L38"],
			screech: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L60", "5M", "5L60", "4M", "4L54"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thrash: ["6L28", "5L28", "4L23", "3L29"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	tyranitar: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L14", "5L14"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L47", "6S3", "6S4", "6S5", "6S6", "5L47", "5S1", "5S2", "4L41", "3L47", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "6L34", "5T", "5L34", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L54", "6S3", "6S4", "5M", "5L54", "5S2", "4M", "4L47", "3M", "3L61", "3S0"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "5S1", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "6L82", "5M", "5L82", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L73", "5M", "5L73", "4M", "4L70", "3M", "3L75"],
			icebeam: ["6M", "5M", "5S1", "4M", "3M"],
			icefang: ["6L1", "5L1", "4L1"],
			icepunch: ["6S3", "6S6", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6S5", "6S6", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["5T", "4T"],
			payback: ["6M", "6L41", "5M", "5L41", "5S2", "4M", "4L34"],
			poweruppunch: ["6M"],
			protect: ["6M", "6S5", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L19", "6S4", "6S5", "6S6", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["6L23", "5L23", "4L19", "3L38", "3S0"],
			screech: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["5S2", "3T"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L63", "6S3", "6S4", "5M", "5L63", "5S1", "4M", "4L54"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thrash: ["6L28", "5L28", "4L23", "3L29", "3S0"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lugia: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aeroblast: ["6L43", "6S5", "6S6", "5L43", "4L43", "4S2", "4S3", "3L77"],
			aircutter: ["4T"],
			ancientpower: ["6L57", "5L57", "4T", "4L57", "4S3", "3L88"],
			aquatail: ["5T", "4T"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L93", "5M", "5L93", "4M", "4L93", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragonrush: ["6L15", "6S6", "5L15", "4L15"],
			dragontail: ["6M", "5M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M", "3S1"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			extrasensory: ["6L23", "5L23", "4L23", "4S2"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["3S1"],
			flash: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L79", "5L79", "4L79", "3L99"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L9", "5L9", "4L9", "3L22"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L37", "6S5", "6S6", "5L37", "4L29", "4S2", "3L44", "3S0", "3S1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "6S6", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L85", "5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychoboost: ["3S1"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			punishment: ["6L50", "6S5", "5L50", "4L50", "4S3"],
			raindance: ["6M", "6L29", "6S5", "5M", "5L29", "4M", "4L29", "4S2", "3M", "3L55", "3S0"],
			recover: ["6L71", "5L71", "4L23", "3L33", "3S0"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L65", "5M", "5L65", "4M", "4L9", "4S3", "3M", "3L11"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			skyattack: ["6L99", "5T", "5L99", "4T", "4L99"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			weatherball: ["6L1", "5L1", "5S4", "4L1"],
			whirlpool: ["4M"],
			whirlwind: ["6L1", "5L1", "5S4", "4L1", "3L1"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	hooh: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			ancientpower: ["6L57", "5L57", "4T", "4L57", "4S2", "3L88"],
			bravebird: ["6L15", "6S5", "5L15", "4L15"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L93", "5M", "5L93", "4M", "4L93", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			extrasensory: ["6L23", "5L23", "4L23", "4S1"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L37", "6S4", "5M", "5L37", "4M", "4L29", "4S1", "3M", "3L44", "3S0"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L79", "5L79", "4L79", "3L99"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L9", "5L9", "4L9", "3L22"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L85", "5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			punishment: ["6L50", "6S4", "5L50", "4L50", "4S2"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L71", "6S5", "5L71", "4L23", "3L33", "3S0"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sacredfire: ["6L43", "6S4", "6S5", "5L43", "4L43", "4S1", "4S2", "3L77"],
			safeguard: ["6M", "6L65", "5M", "5L65", "4M", "4L9", "4S2", "3M", "3L11"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skyattack: ["6L99", "5T", "5L99", "4T", "4L99", "3T"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L29", "6S4", "5M", "5L29", "4M", "4L29", "4S1", "3M", "3L55", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["5T", "4T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			weatherball: ["6L1", "5L1", "5S3", "4L1"],
			whirlwind: ["6L1", "5L1", "5S3", "4L1", "3L1"],
			willowisp: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	celebi: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6L28", "5L28", "4T", "4L28", "3L20", "3S1", "3S3"],
			batonpass: ["6L37", "5L37", "4L37", "3L40", "3S1"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "6S6", "5L1", "4L1", "3L1", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthpower: ["5T", "4T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L64", "5L64", "4L64", "3L30", "3S1", "3S3"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			healbell: ["6L1", "6S5", "6S6", "5T", "5L1", "4T", "4L1", "3L1", "3S0", "3S2", "3S3"],
			healblock: ["6L55", "5L55", "4L55"],
			healingwish: ["6L73", "5L73", "4L73", "4S4"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			holdback: ["6S5"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			lastresort: ["5T", "4T"],
			leafstorm: ["6L82", "5L82", "4L82", "4S4"],
			leechseed: ["6L1", "5L1", "4L1", "3L1", "3S2"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magicalleaf: ["6L19", "5L19", "4L19"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4S4"],
			naturalgift: ["6L46", "5L46", "4M", "4L46"],
			naturepower: ["6M"],
			nightmare: ["3T"],
			perishsong: ["6L91", "5L91", "4L91", "3L50", "3S1"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L1", "6S5", "6S6", "5L1", "4L1", "4S4", "3L1", "3S0", "3S2"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L10", "6S5", "6S6", "5M", "5L10", "4M", "4L10", "3M", "3L10", "3S0", "3S2", "3S3"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			wonderroom: ["5T"],
			worryseed: ["5T", "4T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	treecko: {
		inherit: true,
		learnset: {
			absorb: ["6L6", "5L6", "5S1", "4L6", "3L6", "3S0"],
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L31", "5L31", "4L31", "3L31"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulletseed: ["6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6E", "5E", "4E", "3E"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["6L41", "5L41", "4L41", "3L41"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6E", "5E", "4E", "3E"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			endeavor: ["6E", "5T", "5E", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["6M", "6L50", "5M", "5L51", "4M", "4L51"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6L46", "5T", "5L46", "4M", "4L46", "3M", "3L46"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			grasswhistle: ["6E", "5E", "4E"],
			grassyterrain: ["6E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6E", "5E", "4E", "3E"],
			leer: ["6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			lowkick: ["5T", "4T"],
			magicalleaf: ["6E", "5E", "4E"],
			megadrain: ["6L26", "5L26", "4L26", "3L26"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M"],
			pound: ["6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L16", "5L16", "4L16", "3L16"],
			quickattack: ["6L11", "5L11", "4L11", "3L11"],
			razorwind: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			screech: ["6L21", "5L21", "4L21", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			slam: ["6L36", "5L36", "4L36", "3L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6E", "5T", "5E", "4T", "4E"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	grovyle: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L35", "5L35", "4L35", "3L35"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["6L47", "5L47", "4L47", "3L47"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L53", "5M", "5L53", "4M", "4L53", "3L53"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L16", "5L16", "4T", "4L16", "3T", "3L16"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leafblade: ["6L29", "5L29", "4L29", "3L29"],
			leafstorm: ["6L59", "5L59", "4L59"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L17", "5L17", "4L17", "3L17"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			screech: ["6L23", "5L23", "4L23", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			slam: ["6L41", "5L41", "4L41", "3L41"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	sceptile: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L35", "5L35", "4L35", "3L35"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["6L51", "5L51", "4L51", "3L51"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "5S0", "4M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L59", "5M", "5L59", "4M", "4L59", "3L59"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "5S0", "4M"],
			focuspunch: ["4M", "3M"],
			frenzyplant: ["6T", "5T", "4T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L16", "4T", "3T", "3L16"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leafblade: ["6L29", "5L29", "4L29", "3L29"],
			leafstorm: ["6L1", "5L67", "5S0", "4L67"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			nightslash: ["6L1", "5L1", "4L1"],
			outrage: ["5T", "4T"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L17", "5L17", "4L17", "3L17"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "5S0", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			screech: ["6L23", "5L23", "4L23", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			slam: ["6L43", "5L43", "4L43", "3L43"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "6L16", "5M", "5L16", "4M", "4L16"],
		},
	},
	torchic: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crushclaw: ["6E", "5E", "4E"],
			curse: ["6E", "5E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L10", "6S2", "5L10", "5S1", "5S2", "4L10", "3L10", "3S0"],
			endure: ["6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["6E", "5E", "4E"],
			feint: ["6E", "5E", "4E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			firespin: ["6L25", "5L25", "4L25", "3L25"],
			flameburst: ["6E", "5E"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			focusenergy: ["6L7", "6S2", "5L7", "5S1", "5S2", "4L7", "3L7", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "6S2", "5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			lowkick: ["6E", "5T", "5E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["6L37", "5L37", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "4E"],
			overheat: ["6M", "5M", "4M", "3M"],
			peck: ["6L16", "5L16", "4L16", "3L16"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L28", "5L28", "4L28", "3L28"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E", "5E", "4E", "3E"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L19", "5L19", "4L19", "3L19"],
			scratch: ["6L1", "6S2", "5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L34", "5L34", "4L34", "3L34"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	combusken: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L16", "5L16", "4L16", "3L16"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T", "4T", "3T"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flareblitz: ["6L54", "5L54", "4L54"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			lastresort: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["6L43", "5L43", "4L43", "3L43"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			peck: ["6L17", "5L17", "4L17", "3L17"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L32", "5L32", "4L32", "3L32"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L21", "5L21", "4L21", "3L21"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			skyuppercut: ["6L50", "5L50", "4L50", "3L50"],
			slash: ["6L39", "5L39", "4L39", "3L39"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	blaziken: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			blastburn: ["6T", "5T", "4T"],
			blazekick: ["6L36", "5L36", "4L36", "3L36", "3S0"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			bravebird: ["6L49", "5L49", "4L49"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L28"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["6L16", "5L16", "4L16", "3L16"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dualchop: ["5T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepledge: ["6T", "5T"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flareblitz: ["6L1", "5L66", "5S1", "4L66"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			highjumpkick: ["6L1", "5L1", "5S1"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["3L49", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			peck: ["6L17", "5L17", "4L17", "3L17"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L32", "5L32", "4L32", "3L32"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L21", "5L21", "4L21", "3L21"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			skyuppercut: ["6L59", "5L59", "4L59", "3L59", "3S0"],
			slash: ["6L42", "5L42", "4L42", "3L42", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			stoneedge: ["6M", "5M", "5S1", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thunderpunch: ["5T", "5S1", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	mudkip: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6E", "5E"],
			barrier: ["6E"],
			bide: ["6L15", "5L15", "4L15", "3L15"],
			bite: ["6E", "5E", "4E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L46", "5T", "5L46", "4T", "4L46", "3L46"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			foresight: ["6L19", "5L19", "4L19", "3L19"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L42", "5L42", "4L42", "3L42"],
			iceball: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lowkick: ["5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "4E", "3E"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["6L6", "5L6", "5S1", "4T", "4L6", "3T", "3L6", "3S0"],
			mudsport: ["6L24", "5L24", "4L24", "3L24"],
			naturalgift: ["4M"],
			protect: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6E", "5E", "4E"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stomp: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			takedown: ["6L28", "5L28", "4L28", "3L28"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6E", "5E", "4E", "3E"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "5S1", "4L10", "3L10", "3S0"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["6L33", "6E", "5L33", "5E", "4M", "4L33", "4E", "3L33"],
			wideguard: ["6E", "5E"],
			yawn: ["6E", "5E", "4E"],
		},
	},
	marshtomp: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L15", "5L15", "4L15", "3L15"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L46"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L53", "5T", "5L53", "4T", "4L53", "3L53"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			foresight: ["6L20", "5L20", "4L20", "3L20"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["6L25", "5L25", "4L25"],
			muddywater: ["6L37", "5L37", "4L37", "3L37"],
			mudshot: ["6L16", "5L16", "4L16", "3L16"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L42", "5M", "5L42", "4M", "4L42", "3M", "3L42"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L31", "5L31", "4L31", "3L31"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	swampert: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["6L15", "5L15", "4L15", "3L15"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L52", "5M", "5L52", "5S0", "4M", "4L52", "3M", "3L52"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L61", "5T", "5L61", "4T", "4L61", "3L61"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L20", "5L20", "4L20", "3L20"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			hammerarm: ["6L1", "5L69", "5S0", "4L69"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydrocannon: ["6T", "5T", "4T"],
			hydropump: ["5S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "5S0", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["6L25", "5L25", "4L25"],
			muddywater: ["6L39", "5L39", "4L39", "3L39"],
			mudshot: ["6L16", "5L16", "4L16", "3L16"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L46"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L31", "5L31", "4L31", "3L31"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	poochyena: {
		inherit: true,
		learnset: {
			assurance: ["6L29", "5L29", "4L29"],
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L13", "5L13", "4L13", "3L13"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["6E", "5T", "5E", "4E", "3E"],
			crunch: ["6L53", "5L53", "4L53", "3L41"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6E", "5E", "4E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L5", "5L5", "5D", "4L5", "3L5", "3S0"],
			hypervoice: ["5T"],
			icefang: ["6E", "5E", "4E"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6E", "5E", "4E", "3E"],
			mefirst: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L17", "5L17", "4L17", "3L17"],
			payback: ["6M", "5M", "4M"],
			playrough: ["6E"],
			poisonfang: ["6E", "5E", "5D", "4E", "3E", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L21", "5M", "5L21", "4M", "4L21", "3M", "3L21"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L9", "5L9", "4L9", "3L9"],
			scaryface: ["6L33", "5L33", "4L33", "3L29"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["6E", "5T", "5E", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L49", "6E", "5L49", "5E", "4T", "4L49", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L25"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L45", "5L45", "4L45", "3L33"],
			taunt: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			thief: ["6M", "5M", "4M", "3M", "3L45"],
			thunderfang: ["6E", "5E", "4E"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			yawn: ["6E", "5E", "4E", "3E"],
		},
	},
	mightyena: {
		inherit: true,
		learnset: {
			assurance: ["6L32", "5L32", "4L32"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			covet: ["5T"],
			crunch: ["6L1", "3L47"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "6L47", "5M", "5L47", "4M", "4L47"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L17", "5L17", "4L17", "3L17"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			scaryface: ["6L37", "5L37", "4L37", "3L32"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L62", "5L62", "4T", "4L62"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3T", "3L27"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L52", "5L52", "4L52", "3L37"],
			taunt: ["6M", "6L42", "5M", "5L42", "4M", "4L42", "3M", "3L42"],
			thief: ["6M", "6L57", "5M", "5L57", "4M", "4L57", "3M", "3L52"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	zigzagoon: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			babydolleyes: ["6L11"],
			bellydrum: ["6L45", "5L45", "4L41", "3L41"],
			bestow: ["6L33", "5L33"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			covet: ["6L29", "5T", "5L29", "4L29", "3L29"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			extremespeed: ["3S1"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L37", "5L37", "4L33", "3L33"],
			fling: ["6M", "6L49", "5M", "5L49", "4M", "4L45"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			gunkshot: ["5T", "4T"],
			headbutt: ["6L9", "5L9", "4T", "4L9", "3L9"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "5D", "4T"],
			mimic: ["3T"],
			mudslap: ["6E", "5E", "4T", "4E", "3T"],
			mudsport: ["6L21", "5L21", "4L21", "3L21"],
			naturalgift: ["4M"],
			odorsleuth: ["6L17", "5L17", "4L17", "3L17"],
			pinmissile: ["6L25", "5L25", "4L25", "3L25"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L41", "5M", "5L41", "4M", "4L37", "3M", "3L37"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["6E", "5E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandattack: ["6L13", "5L13", "4L13", "3L13"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			simplebeam: ["6E", "5E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			tailwhip: ["6L5", "5L5", "4L5", "3L5", "3S0", "3S1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			tickle: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	linoone: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6L59", "5L59", "4L53", "3L53"],
			bestow: ["6L41", "5L41"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["6L35", "5T", "5L35", "4L35", "3L35"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L35", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L65", "5M", "5L65", "4M", "4L59"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L29", "5L29", "4L29", "3L29"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["5T", "4T"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			helpinghand: ["6S0", "5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L23", "5L23", "4L23", "3L23"],
			naturalgift: ["4M"],
			odorsleuth: ["6L17", "5L17", "4L17", "3L17"],
			playrough: ["6L1"],
			protect: ["6M", "6S0", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L53", "5M", "5L53", "4M", "4L47", "3M", "3L47"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			sandattack: ["6L13", "5L13", "4L13", "3L13"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["6L47", "5L47", "4L41", "3L41"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			switcheroo: ["6L1", "5L1", "4L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	wurmple: {
		inherit: true,
		learnset: {
			bugbite: ["6L15", "5T", "5L15", "5D", "4T", "4L15"],
			electroweb: ["5T"],
			poisonsting: ["6L5", "5L5", "5D", "4L5", "3L5"],
			snore: ["5T", "5D", "4T"],
			stringshot: ["6L1", "5L1", "4T", "4L1", "3L1"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	silcoon: {
		inherit: true,
		learnset: {
			bugbite: ["5T", "4T"],
			electroweb: ["5T"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			irondefense: ["5T", "4T"],
			stringshot: ["4T"],
		},
	},
	beautifly: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6L20", "4T"],
			attract: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L41", "5L41", "4L41"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L38", "5T", "5L38", "4M", "4L38", "3M", "3L38"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L13", "5L13", "4L13", "3L13"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			megadrain: ["6L24", "5L24", "4L24", "3L24"],
			mimic: ["3T"],
			morningsun: ["6L20", "5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			quiverdance: ["6L45", "5L45"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["6L34", "5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L17", "5L17", "4L17", "3L17"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			whirlwind: ["6L27", "5L27", "4L27", "3L27"],
		},
	},
	cascoon: {
		inherit: true,
		learnset: {
			bugbite: ["5T", "4T"],
			electroweb: ["5T"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			irondefense: ["5T", "4T"],
			stringshot: ["4T"],
		},
	},
	dustox: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L41", "5L41", "4L41"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electroweb: ["5T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L13", "5L13", "4L13", "3L13"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			mimic: ["3T"],
			moonlight: ["6L20", "5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L17"],
			psybeam: ["6L24", "5L24", "4L24", "3L24"],
			psychic: ["6M", "5M", "4M", "3M"],
			quiverdance: ["6L45", "5L45"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["6L34", "5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "6L38", "5M", "5L38", "4M", "4L38", "3M", "3L38"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			whirlwind: ["6L27", "5L27", "4L27", "3L27"],
		},
	},
	lotad: {
		inherit: true,
		learnset: {
			absorb: ["6L5", "5L5", "5D", "4L5", "3L7", "3S0"],
			astonish: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bubblebeam: ["6L25", "5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "6L45", "5M", "5L45", "4M", "4L43"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6E", "5T", "5E", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L3", "5L3", "4L3", "3L3", "3S0"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			leechseed: ["6E", "5E", "5D", "4E", "3E"],
			megadrain: ["6L19", "5L19", "4L19", "3L43"],
			mimic: ["3T"],
			mist: ["6L11", "5L11", "4L11", "3L21"],
			naturalgift: ["6L15", "5L15", "4M", "4L15"],
			naturepower: ["6M", "6L7", "5L7", "4L7", "3L13"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "6L37", "5M", "5L37", "4M", "4L35", "3M", "3L31"],
			razorleaf: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6E", "5E", "4E", "3E"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6E", "5T", "5E", "4T", "4E", "3E"],
			teeterdance: ["6E", "5E"],
			thief: ["6M", "5M", "4M", "3M"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			watergun: ["6E", "5E", "4E", "3E"],
			waterpulse: ["5D", "4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["6L31", "5T", "5L31", "4T", "4L27"],
		},
	},
	lombre: {
		inherit: true,
		learnset: {
			absorb: ["6L5", "5L5", "4L5", "3L7"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubblebeam: ["6L25", "5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L11", "5L11", "4L11", "3L19"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyswipes: ["6L15", "5L15", "4L15", "3L25"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L3", "5L3", "4L3", "3L3"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L45", "5L45", "4L43", "3L49"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6L7", "5L7", "4L7", "3L13"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M", "3L37"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L37", "5T", "5L37", "4T", "4L35", "3L43"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L19", "5L19", "4L19", "3L31"],
			whirlpool: ["4M"],
			zenheadbutt: ["6L31", "5T", "5L31", "4T", "4L27"],
		},
	},
	ludicolo: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["5S0"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "5S0", "5S1", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["5S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "5S0", "5S1", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			megadrain: ["6L1", "5L1", "4L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M", "5S1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "5S1", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	seedot: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			beatup: ["6E", "5E"],
			bide: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulletseed: ["6E", "5E", "5D", "4M", "3M", "3S1"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			defog: ["6E", "5E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3T", "3L43"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6E", "5T", "5E", "5D"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M", "3S1"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6E"],
			growth: ["6L7", "5L7", "5D", "4L7", "3L7", "3S0"],
			harden: ["6L3", "5L3", "4L3", "3L3", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			leechseed: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6L13", "5L13", "4L13", "3L13"],
			powerswap: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6E", "5E", "4E", "3E"],
			razorwind: ["6E", "5E", "4E", "3E"],
			refresh: ["3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M", "3S1"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L21", "5T", "5L21", "4T", "4L21", "3L21"],
			takedown: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	nuzleaf: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			extrasensory: ["6L49", "5L49", "4L49", "3L49"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L19", "5L19", "4L19", "3L19"],
			falseswipe: ["6M", "5M"],
			feintattack: ["6L31", "5L31", "4L31", "3L31"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L7", "5L7", "4L7", "3L7"],
			harden: ["6L3", "5L3", "4L3", "3L3"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M", "6L13", "5L13", "4L13", "3L13"],
			payback: ["6M", "5M", "4M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			razorleaf: ["6L1", "5L1", "4L1"],
			razorwind: ["6L37", "5L37", "4L37", "3L37"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3T", "3L43"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L25"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
		},
	},
	shiftry: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M"],
			feintattack: ["6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["3L1"],
			harden: ["3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leafstorm: ["6L49", "5L49", "4L49"],
			leaftornado: ["6L19", "5L19"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["6M", "3L1"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pound: ["3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			razorleaf: ["6L1", "5L1", "4L1"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["6L1", "5L1", "4L1"],
			worryseed: ["5T", "4T"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	taillow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L34"],
			agility: ["6L43", "5L43", "4L43", "3L43"],
			aircutter: ["4T"],
			airslash: ["6L53", "5L53", "4L53"],
			attract: ["6M", "5M", "4M", "3M"],
			boomburst: ["6E"],
			bravebird: ["6E", "5E", "5D", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defog: ["6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L19", "5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L26", "5T", "5L26", "4T", "4L26", "3L26"],
			endure: ["5D", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			featherdance: ["3S0"],
			fly: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L4", "5L4", "4L4", "3L4", "3S0"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["6E", "5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			quickattack: ["6L7", "5L8", "4L8", "3L8"],
			rage: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6E", "5T", "5E", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["6E", "5E", "4E", "3T", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "6E", "5E", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6E", "5E", "4E", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "5D", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6E", "5E", "4E"],
			wingattack: ["6L13", "5L13", "4L13", "3L13"],
			workup: ["5M"],
		},
	},
	swellow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L38", "5M", "5L38", "4M", "4L38", "3M", "3L38"],
			agility: ["6L49", "5L49", "4L49", "3L49", "3S0"],
			aircutter: ["4T"],
			airslash: ["6L1", "5L61", "4L61"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L19", "5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L28", "5T", "5L28", "4T", "4L28", "3L28"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M", "3S0"],
			fly: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			pluck: ["6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["5T", "4T", "3T", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			wingattack: ["6L13", "5L13", "4L13", "3L13"],
			workup: ["5M"],
		},
	},
	wingull: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L42", "5M", "5L42", "4M", "4L42", "3M"],
			agility: ["6L38", "6E", "5L37", "5E", "4L37", "4E", "3L55", "3E"],
			aircutter: ["6L33", "5L33", "4T"],
			airslash: ["6L46", "5L47", "4L47"],
			aquaring: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gust: ["6E", "5E", "4E", "3E"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L49", "5L50"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			knockoff: ["6E", "5T", "5E", "4T", "4E"],
			mimic: ["3T"],
			mist: ["6L14", "6E", "5L16", "5E", "4L16", "4E", "3L21", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L30", "5L34", "4L34", "3L43"],
			quickattack: ["6L22", "5L24", "4L24", "3L31"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L26", "6E", "5T", "5L29", "5E", "4M", "4L29"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["5D", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6E"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L6", "5L6", "4L6", "3L7"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6E", "5E", "5D", "4T", "4E", "3E"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			watergun: ["6L1", "5L1", "5D", "4L1", "3L1"],
			waterpulse: ["6L17", "5L19", "4M", "4L19", "3M"],
			watersport: ["6E", "5E", "4E", "3E"],
			wideguard: ["6E"],
			wingattack: ["6L9", "5L11", "4L11", "3L13"],
		},
	},
	pelipper: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6L34", "5L34", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L46", "5M", "5L43", "4M", "4L43"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["5T", "4T"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hurricane: ["6L63", "5L63"],
			hydropump: ["6L1", "5L57", "4L57", "3L61"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			knockoff: ["5T", "4T"],
			mimic: ["3T"],
			mist: ["6L14", "5L16", "4L16", "3L21"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "6L22", "5M", "5L24", "4M", "4L24"],
			pluck: ["5M", "4M"],
			protect: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L25"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6L28", "5T", "5L31", "4M", "4L31"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			shockwave: ["4M", "3M"],
			skyattack: ["5T", "4T", "3T"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			soak: ["6L1", "5L1"],
			spitup: ["6L39", "5L38", "4L38", "3L47"],
			steelwing: ["6M", "4M", "3M"],
			stockpile: ["6L39", "5L38", "4L38", "3L33"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6L6", "5L6", "4L6", "3L7"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L39", "5L38", "4L38", "3L33"],
			swift: ["4T", "3T"],
			tailwind: ["6L1", "5T", "5L50", "4T", "4L50"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6L17", "5L19", "4M", "4L19", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wingattack: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	ralts: {
		inherit: true,
		learnset: {
			allyswitch: ["6E", "5M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "6L28", "5M", "5L28", "4M", "4L23", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L43", "5L43", "4L39", "3S1"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			confusion: ["6L6", "5L6", "5D", "4L6", "3L6", "3S2"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			destinybond: ["6E", "5E", "5D", "4E", "3E"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L10", "5M", "5L10", "4M", "4L10", "3M", "3L11"],
			dreameater: ["6M", "6L49", "5M", "5L50", "4M", "4L45", "3T", "3L46"],
			echoedvoice: ["6M", "5M"],
			encore: ["6E", "6S3", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L39", "5L39", "4L34", "3L36"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "6S3", "5L1", "4L1", "3L1", "3S0", "3S1"],
			grudge: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			healpulse: ["6L23", "5L23"],
			helpinghand: ["5T", "5D", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L45", "5L45", "4L43", "3L41"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			imprison: ["6L34", "5L34", "4L32", "3L31"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L17", "5L17", "4L17"],
			magicalleaf: ["6L21", "5L21", "4L21"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meanlook: ["6E", "5E", "4E", "3E"],
			memento: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mistyterrain: ["6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L32", "5M", "5L32", "4M", "4L28", "3M", "3L26"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M", "3S2"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowsneak: ["6E", "5E", "4E"],
			shockwave: ["4M", "3M", "3S2"],
			signalbeam: ["5T", "4T"],
			sing: ["3S2"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			storedpower: ["6L54", "5L54"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T"],
			synchronoise: ["6E", "5E"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["6L12", "5L12", "4L12", "3L16"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M", "4E", "3E"],
			wish: ["3S0"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	kirlia: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "6L31", "5M", "5L31", "4M", "4L25", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L50", "5L50", "4L45"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			dreameater: ["6M", "6L59", "5M", "5L59", "4M", "4L53", "3T", "3L54"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L45", "5L45", "4L39", "3L40"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healpulse: ["6L25", "5L25"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L53", "5L53", "4L50", "3L47"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			imprison: ["6L39", "5L39", "4L36", "3L33"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6L17", "5L17", "4L17"],
			magicalleaf: ["6L22", "5L22", "4L22", "3L1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L36", "5M", "5L36", "4M", "4L31", "3M", "3L26"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			storedpower: ["6L64", "5L64"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	gardevoir: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "6L33", "6S1", "5M", "5L33", "4M", "4L25", "3M", "3L21"],
			captivate: ["6L60", "5L60", "4M", "4L53"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			dazzlinggleam: ["6M", "6S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			dreameater: ["6M", "6L73", "5M", "5L73", "4M", "4L65", "3T", "3L60"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "5S0", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L53", "5L53", "4L45", "3L42"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healingwish: ["6L1", "5L1", "4L1"],
			healpulse: ["6L25", "5L25"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L65", "5L65", "5S0", "4L60", "3L51"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			imprison: ["6L45", "5L45", "4L40", "3L33"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magicalleaf: ["6L22", "5L22", "4L22"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mimic: ["3T"],
			mistyterrain: ["6L1"],
			moonblast: ["6L1", "6S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L40", "5M", "5L40", "5S0", "4M", "4L33", "3M", "3L26"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			storedpower: ["6L1", "6S1", "5L80"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "5S0", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M"],
			wish: ["6L17", "5L17", "4L17"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	gallade: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			allyswitch: ["5M"],
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			closecombat: ["6L1", "5L59", "4L53"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "6L50", "5M", "5L50", "4M", "4L45"],
			feint: ["6L45", "5L45", "4L39"],
			firepunch: ["5T", "4T"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["6L17", "5L17", "4T", "4L17"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["6L25", "5L25"],
			helpinghand: ["6L39", "5T", "5L39", "4T", "4L36"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icepunch: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			leafblade: ["6L1", "5L1", "4L1"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L1", "4L1"],
			painsplit: ["5T", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L53", "5M", "5L53", "4M", "4L50"],
			psychic: ["6M", "5M", "4M"],
			psychocut: ["6L36", "5L36", "4L31"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			slash: ["6L22", "5L22", "4L22"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			storedpower: ["6L1", "5L64"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "6L31", "5M", "5L31", "4M", "4L25"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			teleport: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M"],
			wonderroom: ["5T"],
			workup: ["5M"],
			xscissor: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	surskit: {
		inherit: true,
		learnset: {
			agility: ["6L31", "5L31", "4L31", "3L31"],
			aquajet: ["6E", "5E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L43", "5L43", "4L43"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bubble: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			bubblebeam: ["6L25", "5L25", "4L25", "3L25"],
			bugbite: ["6E", "5T", "5E", "4T", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fellstinger: ["6E"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			haze: ["6L37", "5L37", "4L37", "3L37"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6E", "5E", "5D", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mindreader: ["6E", "5E", "4E", "3E"],
			mist: ["6L37", "5L37", "4L37", "3L37"],
			mudshot: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			powersplit: ["6E"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6E", "5E", "4E", "3E"],
			psychup: ["6M", "5M", "4M", "3T"],
			quickattack: ["6L7", "5L7", "4L7", "3L7", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stickyweb: ["6L46"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L13", "5L13", "4L13", "3L13"],
			swift: ["4T", "3T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L19", "5L19", "4L19", "3L19"],
		},
	},
	masquerain: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["6L22", "4T"],
			airslash: ["6L47", "5L47", "4L47"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L1", "5L61", "4L61"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L22", "5L22", "4L22", "3L26"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["6L1", "5L1", "4T", "4L1"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quickattack: ["6L1", "5L1", "4L1", "3L1"],
			quiverdance: ["6L1", "5L68"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L26", "5L26", "4L26", "3L33"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["6L40", "5L40", "4M", "4L40", "3L47"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["6L33", "5L33", "4L33", "3L40"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L1", "5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlwind: ["6L1", "5L54", "4L54", "3L53"],
		},
	},
	shroomish: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["6E", "5E", "5D", "4M", "3M"],
			captivate: ["4M"],
			charm: ["6E", "5E", "4E", "3E"],
			confide: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["6E", "5T", "5E"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "4E", "3E"],
			falseswipe: ["6M", "5M", "4E", "3E", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			focuspunch: ["6E", "5E", "5D"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["6L37", "5T", "5L37", "4M", "4L37", "3M", "3L45"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L33", "5L33", "4L33", "3L36"],
			headbutt: ["6L21", "5L21", "4T", "4L21", "3L22"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			leechseed: ["6L13", "5L13", "4L13", "3L10"],
			megadrain: ["6L17", "5L17", "4L17", "3L16", "3S0"],
			mimic: ["3T"],
			naturalgift: ["6E", "5E", "4M"],
			poisonpowder: ["6L25", "5L25", "4L25", "3L28"],
			protect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6L41", "6E", "5T", "5L41", "5E", "4T", "4L41", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spore: ["6L45", "5L45", "4L45", "3L54"],
			stunspore: ["6L9", "5L9", "5D", "4L9", "3L7", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			tackle: ["6L5", "5L5", "4L5", "3L4"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			wakeupslap: ["6E", "5E", "4E"],
			worryseed: ["6L29", "6E", "5T", "5L29", "5E", "4T", "4L29", "4E"],
		},
	},
	breloom: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6L25", "5L25", "4L25", "3T", "3L28"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["6L45", "5L45", "4L45", "3T", "3L54"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["6L29", "5L29", "4L29"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["6L21", "5L21", "4T", "4L21", "3L22"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leechseed: ["6L1", "5L1", "4L1", "3L1"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6L23", "5L23", "4L23", "3L23"],
			megadrain: ["6L17", "5L17", "4L17", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mindreader: ["6L37", "5L37", "4L37", "3L45"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6L41", "5T", "5L41", "4T", "4L41"],
			seismictoss: ["3T"],
			skyuppercut: ["6L33", "5L33", "4L33", "3L36"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stunspore: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["6M", "5M"],
			workup: ["5M"],
			worryseed: ["5T", "4T"],
		},
	},
	slakoth: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["6E", "5T", "5E"],
			amnesia: ["6L25", "5L25", "4L25", "3L25"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["6L37", "5L37"],
			confide: ["6M"],
			counter: ["6L43", "5L43", "4L37", "3T", "3L37"],
			covet: ["6L31", "5T", "5L31", "4L31", "3L31"],
			crushclaw: ["6E", "5E", "4E", "3E"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["6L7", "5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L19", "5L19", "4L19", "3L19"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6L49", "5L49", "4L43", "3L43"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gunkshot: ["5T", "4T"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "5D", "4E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slackoff: ["6L13", "5L13", "4L13", "3L13"],
			slash: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["5D", "4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			yawn: ["6L1", "5L1", "5D", "4L1", "3L1"],
		},
	},
	vigoroth: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["5T"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L43", "5L43"],
			confide: ["6M"],
			counter: ["6L37", "5L37", "4L37", "3T", "3L37"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			encore: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["6L25", "5L25", "4M", "4L25", "3T", "3L25"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6L49", "5L49", "4M", "4L43", "3M", "3L43"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L19", "5L19", "4L19", "3L19"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6L1", "5L55", "4L49", "3L49"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["6L31", "5L31", "4L31", "3L31"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	slaking: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "4S0", "3M"],
			afteryou: ["5T"],
			amnesia: ["6L25", "5L25", "4L25", "3L25"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L37", "5L37"],
			confide: ["6M"],
			counter: ["6L43", "5L43", "4L37", "3T", "3L37"],
			covet: ["6L31", "5T", "5L31", "4L31", "3L31"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			encore: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L19", "5L19", "4L19", "3L19"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6L49", "5L49", "4L43", "3L43"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "6L1", "5M", "5L55", "4M", "4L49"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M", "4S0"],
			gunkshot: ["5T", "4T"],
			hammerarm: ["6L1", "5L67", "4L61"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			punishment: ["6L1", "5L61", "4L55"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "4S0", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M", "4S0"],
			shockwave: ["4M", "3M"],
			slackoff: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	nincada: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			bugbite: ["6E", "5T", "5E", "4T", "4E"],
			bugbuzz: ["6E", "5E", "4E"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "3M", "3L45"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "5D", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3L25"],
			feintattack: ["6E", "5E", "4E", "3E"],
			finalgambit: ["6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L14", "5L14", "4L14", "3L14"],
			gigadrain: ["5T", "4M", "3M"],
			gust: ["6E", "5E", "4E", "3E"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			leechlife: ["6L5", "5L5", "5D", "4L5", "3L5"],
			metalclaw: ["6L38", "5L38", "4L38", "3L38"],
			mimic: ["3T"],
			mindreader: ["6L19", "5L19", "4L19", "3L19"],
			mudslap: ["6L31", "5L31", "4T", "4L31", "3T", "3L31"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "5D", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L9", "5L9", "4L9", "3L9"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			silverwind: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	ninjask: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L38", "5L38", "4L38", "3L38"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L45", "5L45", "4L45", "3L45"],
			bugbite: ["6L1", "5T", "5L1", "4T", "4L1"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L20", "5M", "5L20", "4M", "4L20", "3M", "3L20"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L20", "5L20", "4T", "4L20", "3T", "3L20"],
			furyswipes: ["6L14", "5L14", "4L14", "3L14"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leechlife: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mindreader: ["6L19", "5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L20", "5L20", "4L20", "3L20"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			slash: ["6L31", "5L31", "4L31", "3L31"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L25"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			xscissor: ["6M", "6L52", "5M", "5L52", "4M", "4L52"],
		},
	},
	shedinja: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["4R", "3R"],
			batonpass: ["4R", "3R"],
			bugbite: ["5T", "4T"],
			confide: ["6M"],
			confuseray: ["6L31", "5L31", "4L31", "3L31", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L14", "5L14", "4L14", "3L14"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grudge: ["6L43", "5L45", "4L45", "3L45", "3S0"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			healblock: ["6L50", "5L52", "4L52"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leechlife: ["6L5", "5L5", "4L5", "3L5"],
			mimic: ["3T"],
			mindreader: ["6L19", "5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			phantomforce: ["6L47"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L9", "5L9", "4L9", "3L9"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["4R", "3R"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "6L59", "5M", "5L59", "4M", "4L59", "3M", "3L38", "3S0"],
			shadowclaw: ["6M", "5M", "4M"],
			shadowsneak: ["6L38", "5L38", "4L38"],
			slash: ["4R", "3R"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["6L25", "5T", "5L25", "4T", "4L25", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["4R", "3R"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	whismur: {
		inherit: true,
		learnset: {
			astonish: ["6L11", "5L11", "4L11", "3L11"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			circlethrow: ["6E", "5E"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			disarmingvoice: ["6E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6E", "5T", "5E", "5D", "4E"],
			endure: ["4M", "3T"],
			extrasensory: ["6E", "5E", "4E", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L15", "5L15", "4L15", "3L15"],
			hypervoice: ["6L50", "5T", "5L51", "4L45", "3L45"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L45", "5M", "5L45", "4M", "4L41", "3M", "3L41"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L35", "5M", "5L35", "4M", "4L35", "3M", "3L35"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6L31", "5L31", "4L31", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6L45", "5T", "5L45", "4M", "4L41", "3T", "3L41"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			smokescreen: ["6E", "5E", "4E"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L25", "5L25", "4L25", "3L25"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L21", "5L21", "4L21", "3L21"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			synchronoise: ["6L41", "5L41"],
			takedown: ["6E", "5E", "4E", "3E"],
			teeterdance: ["3S0"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L5", "5T", "5L5", "5D", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "5D", "4T"],
		},
	},
	loudred: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L20", "5L20", "4L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L1", "5L1", "4L1", "3L1"],
			hypervoice: ["6L65", "5T", "5L65", "4L57", "3L57"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L57", "5M", "5L57", "4M", "4L51", "3M", "3L51"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6L37", "5L37", "4L37", "3L37"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6L57", "5T", "5L57", "4M", "4L51", "3T", "3L51"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L29", "5L29", "4L29", "3L29"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L23", "5L23", "4L23", "3L23"],
			swagger: ["6M", "5M", "4M", "3T"],
			synchronoise: ["6L51", "5L51"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	exploud: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L20", "5L20", "4L20"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			boomburst: ["6L1"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L40", "5L40", "4L40"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["6M", "6L79", "5M", "5L79", "4M", "4L71", "3M", "3L40", "3S1"],
			hypervoice: ["6L71", "5T", "5L71", "4L63", "3L63", "3S0"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L1", "5L1", "4L1"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "5M", "4M", "3M"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L55", "5M", "5L55", "4M", "4L55", "3M", "3L55", "3S0"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			screech: ["6L37", "5L37", "4L37", "3L37", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "6L63", "5T", "5L63", "4M", "4L55", "3T", "3L55", "3S0"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stomp: ["6L29", "5L29", "4L29", "3L29", "3S1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			supersonic: ["6L23", "5L23", "4L23", "3L23"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M", "3T"],
			synchronoise: ["6L55", "5L55"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			thunderpunch: ["5T", "4T", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	makuhita: {
		inherit: true,
		learnset: {
			armthrust: ["6L7", "5L7", "5D", "4L7", "3L10", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6L25", "5L25", "4L25", "3L37"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M", "3S0"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6E", "5E", "4E"],
			captivate: ["4M"],
			chipaway: ["6E", "5E"],
			closecombat: ["6L40", "5L40", "4L40"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			crosschop: ["6E", "5E", "4E", "3E"],
			detect: ["6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["6E", "5E", "4E", "3T", "3E"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6L37", "5L37", "4M", "4L37", "3T", "3L40"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L13", "5L13", "4L13", "3L19"],
			feint: ["6E", "5E", "4E"],
			feintattack: ["6E", "5E", "4E", "3E"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6E", "5E", "4M", "3M"],
			forcepalm: ["6L28", "5L28", "4L28"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["6L46", "5L46"],
			helpinghand: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "5D", "4T", "3T"],
			knockoff: ["6L19", "5T", "5L19", "4T", "4L19", "3L28"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6E", "5E", "4E", "3E"],
			reversal: ["6L43", "5L43", "4L43", "3L49"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M", "3S0"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L4", "5L4", "4L4", "3L4"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L31", "5L31", "4L31", "3T", "3L46"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			smellingsalts: ["6L22", "5L22", "4L22", "3L31"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["6L10", "5L10", "4L10", "3L13"],
			wakeupslap: ["6L34", "6E", "5L34", "5E", "4L34", "4E"],
			whirlpool: ["4M"],
			whirlwind: ["6L16", "5L16", "4L16", "3L22"],
			wideguard: ["6E", "5E"],
			workup: ["5M"],
		},
	},
	hariyama: {
		inherit: true,
		learnset: {
			armthrust: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bellydrum: ["6L27", "5L27", "4L27", "3L40"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["6L1", "5L1", "4M", "4L1"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			closecombat: ["6L52", "5L52", "4L52"],
			confide: ["6M"],
			counter: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6L47", "5L47", "4M", "4L47", "3T", "3L44"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L13", "5L13", "4L13", "3L19"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["6L32", "5L32", "4L32"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["6L62", "5L62"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			knockoff: ["6L19", "5T", "5L19", "4T", "4L19", "3L29"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6L57", "5L57", "4L57", "3L55"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6L37", "5L37", "4L37", "3T", "3L51"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			smellingsalts: ["6L22", "5L22", "4L22", "3L33"],
			snore: ["5T", "4T", "3T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["6L10", "5L10", "4L10", "3L13"],
			wakeupslap: ["6L42", "5L42", "4L42"],
			whirlpool: ["4M"],
			whirlwind: ["6L16", "5L16", "4L16", "3L22"],
			workup: ["5M"],
		},
	},
	nosepass: {
		inherit: true,
		learnset: {
			ancientpower: ["5D", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["6L8", "6E", "5T", "5L19", "5E", "4T", "4L19", "4E", "3L16"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			discharge: ["6L39", "5L55", "4L49"],
			doubleedge: ["6E", "5E", "4E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6L43", "5T", "5L79", "4T", "4L73"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			explosion: ["6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gravity: ["5T", "4T"],
			harden: ["6L4", "5L7", "4L7", "3L7"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			lockon: ["6L50", "5L73", "4L67", "3L46"],
			magiccoat: ["5T", "4T"],
			magnetrise: ["5T", "4T"],
			magnitude: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			powergem: ["6L32", "5L49", "4L49"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L22", "5M", "5L43", "4M", "4L43", "3M", "3L37"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L18", "5L18"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L29", "5M", "5L31", "4M", "4L31", "3T", "3L28", "3S0"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L11", "5L13", "4L13", "3L13"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6E", "5E", "4T", "4E", "3T", "3E"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L36", "5M", "5L37", "4M", "4L37", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L25", "5L25"],
			stealthrock: ["6E", "5T", "5E", "5D", "4M"],
			stoneedge: ["6M", "6L46", "5M", "5L61", "4M", "4L55"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "5D", "4L1", "3L1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M", "3S0"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "6L15", "5M", "5L25", "4M", "4L25", "3T", "3L22", "3S0"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			voltswitch: ["6M", "5M"],
			wideguard: ["6E"],
			zapcannon: ["6L50", "5L67", "4L61", "3L43"],
		},
	},
	probopass: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M"],
			block: ["6L1", "5T", "5L1", "4T", "4L1"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			discharge: ["6L39", "5L55", "4L49"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["6L43", "5T", "5L79", "4T", "4L73"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			irondefense: ["6L1", "5T", "5L1", "4T", "4L1"],
			ironhead: ["5T", "4T"],
			lockon: ["6L50", "5L73", "4L67"],
			magiccoat: ["5T", "4T"],
			magnetbomb: ["6L1", "5L1", "4L1"],
			magnetrise: ["6L1", "5T", "5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			powergem: ["6L32", "5L49", "4L49"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "6L22", "5M", "5L43", "4M", "4L43"],
			return: ["6M", "5M", "4M"],
			rockblast: ["6L18", "5L18"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L29", "5M", "5L31", "4M", "4L31"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L36", "5M", "5L37", "4M", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			spark: ["6L25", "5L25"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L46", "5M", "5L61", "4M", "4L55"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			taunt: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "6L15", "5M", "5L25", "4M", "4L25"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			zapcannon: ["6L50", "5L67", "4L61"],
		},
	},
	skitty: {
		inherit: true,
		learnset: {
			assist: ["6L22", "5L22", "4L18", "3L19"],
			attract: ["6M", "6L8", "5M", "5L8", "4M", "4L4", "3M", "3L7", "3S2"],
			batonpass: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["6L46", "6E", "5L46", "5E", "5D", "4M", "4L42"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L25", "5L25", "4L22", "3L25"],
			confide: ["6M"],
			copycat: ["6L18", "5L18", "4L11"],
			cosmicpower: ["6E"],
			covet: ["6L36", "5T", "5L36", "4L32", "3L31"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L42", "5L42", "4L39", "3T", "3L39"],
			doubleslap: ["6L15", "5L15", "4L15", "3L15"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			faketears: ["6E", "5E", "4E", "3E"],
			feintattack: ["6L29", "5L29", "4L25", "3L27"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6L4", "5L4", "5D", "4L4"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			headbutt: ["4T"],
			healbell: ["6L39", "5T", "5L39", "4T", "4L36", "3L37"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6E", "5T", "5E", "4T", "4E"],
			mimic: ["3T"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			payday: ["3S0"],
			playrough: ["6L49"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T", "3S1"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			simplebeam: ["6E", "5E"],
			sing: ["6L11", "5L11", "4L8", "3L13"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["6E", "5E", "4T", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			tailwhip: ["6L1", "5L1", "4L1", "3L3", "3S0", "3S1", "3S2"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			tickle: ["6E", "5E", "5D", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6E", "5T", "5E", "4E", "3E"],
			wakeupslap: ["6L32", "5L32", "4L29"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	delcatty: {
		inherit: true,
		learnset: {
			attract: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["3L1"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M", "3S0"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			swift: ["4T", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	sableye: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			astonish: ["6L11", "5L11", "4L11", "3L13"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "6S3", "5M", "4M", "3M"],
			captivate: ["6E", "5E", "4M"],
			confide: ["6M"],
			confuseray: ["6L46", "5L46", "4L46", "3L37"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			detect: ["6L22", "5L22", "4L22", "3L25"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6L18", "5L18", "4L18", "3L21"],
			feint: ["6E", "5E", "4E"],
			feintattack: ["6L32", "5L32", "4L32", "3L29", "3S1"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L4", "5L4", "5D", "4L4", "3L5", "3S0"],
			foulplay: ["6L50", "5T", "5L50", "5S2"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L15", "5L15", "4L15", "3L17"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T"],
			imprison: ["6E"],
			incinerate: ["6M", "5M"],
			knockoff: ["6L29", "5T", "5L29", "4T", "4L29", "3L33"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			meanlook: ["6L1", "6E", "5L60", "5E", "4L57", "3L45"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["6E", "5E"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L8", "5L8", "4L8", "3L9", "3S0"],
			octazooka: ["5S2"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			powergem: ["6L43", "5L43", "4L43"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["6L36", "5L36", "4L36"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6E", "6S3", "6S4", "5E", "4E", "3E", "3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "6L57", "6S3", "5M", "5L57", "4M", "4L53", "3M", "3L41", "3S1"],
			shadowclaw: ["6M", "6L39", "5M", "5L39", "4M", "4L39"],
			shadowsneak: ["6L25", "5L25", "4L25"],
			shockwave: ["6S4", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "5D", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6E", "5E", "5D", "4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "6S4", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			tickle: ["5S2"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "5S2", "4T"],
			waterpulse: ["4M", "3M"],
			willowisp: ["6M", "6S3", "6S4", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["6L1", "5T", "5L53", "4T", "4L50"],
		},
	},
	mawile: {
		inherit: true,
		learnset: {
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			astonish: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L31", "5L31", "4L31", "3L31"],
			bite: ["6L11", "5L11", "4L11", "3L11"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["6E", "5E", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			crunch: ["6L36", "5L36", "4L36", "3L36"],
			darkpulse: ["6M", "5T", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fairywind: ["6L1"],
			faketears: ["6L6", "5L6", "5D", "4L6", "3L6", "3S0"],
			falseswipe: ["6M", "5M", "4E", "3E", "3S1"],
			feintattack: ["6L26", "5L26", "4L26", "3L26"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6E", "6S2", "5E", "5D", "4E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1"],
			guardswap: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6E", "5E", "4E"],
			icepunch: ["5T", "5D", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6L41", "5T", "5L41", "4T", "4L41", "3L41", "3S1"],
			ironhead: ["6L1", "6S2", "6S3", "5T", "5L56", "4T", "4L56"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["6E", "5E"],
			mimic: ["3T"],
			mistyterrain: ["6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			playrough: ["6L1", "6S2", "6S3"],
			poisonfang: ["6E", "5E", "4E", "3E"],
			poweruppunch: ["6M"],
			protect: ["6M", "6S3", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4E", "3T", "3E"],
			punishment: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6E", "3T"],
			shadowball: ["6M", "5M", "4M"],
			sing: ["3S1"],
			slam: ["6E", "5E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snatch: ["5T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L50", "5L51", "4L51", "3L46"],
			stealthrock: ["5T"],
			stockpile: ["6L50", "5L51", "4L51", "3L46"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L46", "6E", "6S2", "6S3", "5L46", "5E", "4T", "4L46", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L50", "5L51", "4L51", "3L46"],
			sweetscent: ["6L16", "5L16", "4L16", "3L16"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			taunt: ["6M", "6L1", "5M", "4M", "3M"],
			thunderfang: ["6E", "5E", "4E"],
			thunderpunch: ["5T", "4T", "3T"],
			tickle: ["6E", "5E", "4E", "3E"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			visegrip: ["6L21", "5L21", "4L21", "3L21", "3S1"],
		},
	},
	aron: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L39", "5L43"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L46", "5L50", "4L43", "3T", "3L44"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonrush: ["6E", "5E", "4E"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["6L1", "5L4", "5D", "4L4", "3L4"],
			headbutt: ["6L8", "5L11", "4T", "4L11", "3L10"],
			headsmash: ["6E", "5E", "5D", "4E"],
			heavyslam: ["6L43", "5L46"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["6L25", "6E", "5T", "5L29", "5E", "4T", "4L29", "4E"],
			irontail: ["6L36", "5T", "5L39", "4M", "4L39", "3M", "3L29"],
			magnetrise: ["5T", "4T"],
			metalburst: ["6L50", "5L53", "4L46"],
			metalclaw: ["6L11", "5L15", "4L15", "3L13"],
			metalsound: ["6L32", "5L36", "4L36", "3L39"],
			mimic: ["3T"],
			mudslap: ["6L4", "5L8", "4T", "4L8", "3T", "3L7"],
			naturalgift: ["4M"],
			protect: ["6M", "6L29", "5M", "5L32", "4M", "4L32", "3M", "3L34"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6E"],
			roar: ["6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			stomp: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6E", "5T", "5E", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L22", "5L25", "4L25", "3L25"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	lairon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L45", "5L51"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L56", "5L62", "4L51", "3T", "3L53"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			heavyslam: ["6L51", "5L56"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["6L25", "5T", "5L29", "4T", "4L29"],
			irontail: ["6L40", "5T", "5L45", "4M", "4L45", "3M", "3L29"],
			magnetrise: ["5T", "4T"],
			metalburst: ["6L62", "5L67", "4L56"],
			metalclaw: ["6L11", "5L15", "4L15", "3L13"],
			metalsound: ["6L34", "5L40", "4L40", "3L45"],
			mimic: ["3T"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			protect: ["6M", "6L29", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L22", "5L25", "4L25", "3L25"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	aggron: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			autotomize: ["6L48", "5L57"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6L65", "5L74", "4L57", "3T", "3L63", "3S0"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6S2", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			heavyslam: ["6L57", "5L65"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["6L25", "6S2", "5T", "5L29", "4T", "4L29"],
			irontail: ["6L40", "5T", "5L48", "4M", "4L48", "3M", "3L29", "3S0", "3S1"],
			lowkick: ["5T", "4T"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["6L74", "5L82", "4L65"],
			metalclaw: ["6L11", "5L15", "4L15", "3L13"],
			metalsound: ["6L34", "5L40", "4L40", "3L50", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L29", "5M", "5L34", "4M", "4L34", "3M", "3L37", "3S0", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6S2", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L22", "5L25", "4L25", "3L25", "3S1"],
			taunt: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	meditite: {
		inherit: true,
		learnset: {
			acupressure: ["6L39", "5L39"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bide: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulletpunch: ["6E", "5E", "4E"],
			calmmind: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L8", "5L8", "4L8", "3L9", "3S0", "3S1"],
			counter: ["6L44", "3T"],
			detect: ["6L11", "5L11", "4L11", "3L12", "3S1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["6E", "5T", "5E", "5D", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["6E", "5E", "4E", "3T", "3E", "3S1"],
			endure: ["6L12", "5D", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E", "3E"],
			feint: ["6L22", "5L22", "4L22"],
			firepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["6L29", "5L29", "4L29"],
			foresight: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			guardswap: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["6L32", "5L32", "4L32", "3L32"],
			icepunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			meditate: ["6L4", "5L4", "5D", "4L4", "3L4", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["6L18", "5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			powerswap: ["6E", "5E", "4E"],
			powertrick: ["6L43", "5L43", "4L39"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychocut: ["6E", "5E", "4E"],
			psychup: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["6M", "5M"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L50", "5L50", "4L46", "3L44"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6L46", "5L46", "4L43", "3L41"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M", "3S1"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			vacuumwave: ["4T"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	medicham: {
		inherit: true,
		learnset: {
			acupressure: ["6L42", "5L42"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			counter: ["6L53", "3T"],
			detect: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["6L12", "4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L22", "5L22", "4L22"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["6L29", "5L29", "4L29"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["6L32", "5L32", "4L32", "3L32"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			meditate: ["6L1", "5L1", "4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["6L18", "5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			powertrick: ["6L49", "5L49", "4L42"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L62", "5L62", "4L55", "3L54"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			reversal: ["6L55", "5L55", "4L49", "3L46"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			vacuumwave: ["4T"],
			workup: ["5M"],
			zenheadbutt: ["6L1", "5T", "4T"],
		},
	},
	electrike: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L28", "5L28", "4L28", "3L33"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["6L44", "5L44", "4L44", "3L41"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			crunch: ["6E", "5E", "4E", "3E"],
			curse: ["6E", "5E", "4E", "3E"],
			discharge: ["6L41", "6E", "5L41", "5E", "4L41", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			eerieimpulse: ["6E"],
			electroball: ["6E", "5E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6E", "5E", "4E"],
			flameburst: ["6E", "5E"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			headbutt: ["6E", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L12", "5L12", "4L12", "3L12"],
			icefang: ["6E", "5E", "5D", "4E"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L9", "5L9", "4L9", "3L9"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L25", "5L25", "4L25", "3L25"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L17", "5L17", "4L17", "3L17"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L28"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6E", "5E", "4M", "3M"],
			signalbeam: ["5T", "5D", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L20", "5L20", "4L20", "3L20"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6E", "5E", "4T", "4E", "3T", "3E"],
			switcheroo: ["6E", "5E", "4E"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "6L52", "5M", "5L52", "4M", "4L49", "3M", "3L36"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderfang: ["6L33", "6E", "5L33", "5E", "4L33", "4E"],
			thunderwave: ["6M", "6L4", "5M", "5L4", "5D", "4M", "4L4", "3T", "3L4"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["6E", "5T", "5E", "4E", "3E"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L49", "5M", "5L49"],
		},
	},
	manectric: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L30", "5L30", "4L30", "3L39", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["6L54", "5L54", "4L54", "3L53"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			discharge: ["6L49", "5L49", "4L49"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			electricterrain: ["6L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L25", "5L25", "4L25", "3L25"],
			overheat: ["6M", "6S1", "5M", "4M"],
			protect: ["6M", "6S1", "5M", "4M", "3M"],
			quickattack: ["6L17", "5L17", "4L17", "3L17"],
			raindance: ["6M", "5M", "4M", "3M", "3S0"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "6L42", "5M", "5L42", "4M", "4L42", "3M", "3L31"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L20", "5L20", "4L20", "3L20"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "6L66", "5M", "5L66", "4M", "4L61", "3M", "3L45", "3S0"],
			thunderbolt: ["6M", "6S1", "5M", "4M", "3M"],
			thunderfang: ["6L37", "5L37", "4L37"],
			thunderwave: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T"],
			voltswitch: ["6M", "6S1", "5M"],
			wildcharge: ["6M", "6L61", "5M", "5L61"],
		},
	},
	plusle: {
		inherit: true,
		learnset: {
			agility: ["6L48", "5L48", "4L44", "3L47"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L44", "5L44", "4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["6L38", "5L38", "4L35", "3L31"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			copycat: ["6L24", "5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["6E", "5E", "5D", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L29", "5L29"],
			encore: ["6L17", "5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["6L1", "5L63"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6L35", "5L21", "4L21", "3L28"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["6L10", "5T", "5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["6L50", "5T", "5L51", "4T", "4L48"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L1", "5L56", "4L51"],
			naturalgift: ["4M"],
			nuzzle: ["6L1"],
			playnice: ["6L1"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L7", "5L7", "4L7", "3L10", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "5D", "4T"],
			sing: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L15", "5L15", "4L15", "3L19"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6E", "5E", "4E"],
			swift: ["6L31", "5L31", "4T", "4L29", "3T"],
			thunder: ["6M", "6L42", "5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "6L3", "5M", "5L3", "5D", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E"],
		},
	},
	minun: {
		inherit: true,
		learnset: {
			agility: ["6L48", "5L48", "4L44", "3L47"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L44", "5L44", "4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["6L38", "5L38", "4L35", "3L31"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L21", "5L21", "4L21", "3L28"],
			confide: ["6M"],
			copycat: ["6L24", "5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["6E", "5E", "5D", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L29", "5L29"],
			encore: ["6L17", "5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["6L1", "5L63"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6L35", "5L35", "4L31"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["6L10", "5T", "5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			irontail: ["5T", "4M", "3M"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6L1", "5L56", "4L51"],
			naturalgift: ["4M"],
			nuzzle: ["6L1"],
			playnice: ["6L1"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6L7", "5L7", "4L7", "3L10", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "5D", "4T"],
			sing: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spark: ["6L15", "5L15", "4L15", "3L19"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6E", "5E", "4E"],
			swift: ["6L31", "5L31", "4T", "4L29", "3T"],
			thunder: ["6M", "6L42", "5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "6L3", "5M", "5L3", "5D", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6L51", "5L51", "4L48"],
			uproar: ["5T", "4T"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E"],
		},
	},
	volbeat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L41", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L9", "5L9", "4L9", "3L5"],
			counter: ["3T"],
			dazzlinggleam: ["6M"],
			dizzypunch: ["6E", "5E"],
			doubleedge: ["6L45", "5L45", "4L45", "3T", "3L37"],
			doubleteam: ["6M", "6L5", "5M", "5L5", "4M", "4L5", "3M", "3L9"],
			dynamicpunch: ["3T"],
			encore: ["6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			helpinghand: ["6L33", "5T", "5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["6L13", "5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L29"],
			psychup: ["6M", "5M", "4M", "3T"],
			quickattack: ["6L17", "5L17", "4L17", "3L17"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["6E", "5E", "3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["6L25", "5T", "5L25", "4T", "4L25", "3L25"],
			silverwind: ["6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailglow: ["6L21", "5L21", "4L21", "3L21"],
			tailwind: ["5T", "5D", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "5D", "4E", "3E"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	illumise: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L41", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["6E", "5E", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L9", "5L9", "5D", "4L9", "3L9"],
			confide: ["6M"],
			confuseray: ["6E", "5E"],
			counter: ["3T"],
			covet: ["6L45", "5T", "5L45", "4L45", "3L37"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["6L25", "6E", "5L25", "5E", "4L25", "4E", "3L25"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E", "5D"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["6L29", "5L29", "4L29", "3L29"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigadrain: ["5T", "4M", "3M"],
			growth: ["6E", "5E", "4E", "3E"],
			helpinghand: ["6L33", "5T", "5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["6L13", "5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			playnice: ["6L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			quickattack: ["6L17", "5L17", "4L17", "3L17"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			silverwind: ["6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L5", "5L5", "4L5", "3L5"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "5D", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			wish: ["6L21", "5L21", "4L21", "3L21"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	budew: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6E", "5E", "4E"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			extrasensory: ["6E", "5E", "4E"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["6E", "5T", "5E", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6E", "5E"],
			growth: ["6L4", "5L4", "4L4"],
			hiddenpower: ["6M", "5M", "4M"],
			leafstorm: ["6E", "5E", "4E"],
			megadrain: ["6L13", "5L13", "4L13"],
			mindreader: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M"],
			pinmissile: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6E", "5T", "5E", "4T"],
			shadowball: ["6M", "5M", "4M"],
			sleeppowder: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			spikes: ["6E", "5E", "4E"],
			stunspore: ["6L10", "5L10", "4L10"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6E", "5T", "5E", "4T", "4E"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			watersport: ["6L7", "5L7", "4L7"],
			worryseed: ["6L16", "5T", "5L16", "4T", "4L16"],
		},
	},
	roselia: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			aromatherapy: ["6L43", "5L43", "4L43", "3L53"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["6E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6E", "5E", "4E", "3E"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6L25", "6E", "5T", "5L25", "5E", "4M", "4L25", "3M", "3L33"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L22", "6E", "5L22", "5E", "4L22", "3L29", "3S1"],
			growth: ["6L4", "5L4", "5D", "4L4", "3L5", "3S0"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ingrain: ["6L34", "5L34", "4L34", "3L41"],
			leafstorm: ["6E", "5E", "4E"],
			leechseed: ["6L16", "5L16", "4L16", "3L21", "3S1"],
			magicalleaf: ["6L19", "5L19", "4L19", "3L25", "3S1"],
			megadrain: ["6L13", "5L13", "4L13", "3L17"],
			mimic: ["3T"],
			mindreader: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M"],
			nightmare: ["3T"],
			petalblizzard: ["6L50"],
			petaldance: ["6L37", "5L40", "4L40", "3L49"],
			pinmissile: ["6E", "5E", "4E", "3E"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L7", "5L7", "4L7", "3L9", "3S0"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6E", "5T", "5E", "4T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sleeppowder: ["6E", "5E", "5D", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6E", "5E", "4E", "3E"],
			stunspore: ["6L10", "5L10", "4L10", "3L13"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["3S1"],
			sweetscent: ["6L31", "5L31", "4L31", "3L37"],
			swift: ["5D", "4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L46", "6E", "5T", "5L46", "5E", "4T", "4L46", "4E", "3L57", "3E"],
			toxic: ["6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L45"],
			toxicspikes: ["6L28", "5L28", "4L28"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	roserade: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grassyterrain: ["6L1"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			magicalleaf: ["6L1", "5L1", "4L1"],
			megadrain: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			sweetscent: ["6L1", "5L1", "4L1"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			venomdrench: ["6L1"],
			venoshock: ["6M", "5M"],
			weatherball: ["6L1", "5L1", "4L1"],
			worryseed: ["5T", "4T"],
		},
	},
	gulpin: {
		inherit: true,
		learnset: {
			acidarmor: ["6E", "5E", "5D", "4E", "3E"],
			acidspray: ["6L34", "5L34"],
			amnesia: ["6L17", "5L17", "4L17", "3L17"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L40"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E"],
			defensecurl: ["3T"],
			destinybond: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "4E", "3T", "3E"],
			dynamicpunch: ["3T"],
			encore: ["6L23", "5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L49", "5T", "5L49", "4T", "4L44"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			gunkshot: ["6L59", "6E", "5T", "5L59", "5E", "4T", "4L54"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mudslap: ["6E", "5E", "4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6E", "5T", "5E", "4T", "4E", "3E"],
			poisongas: ["6L9", "5L9", "5D", "4L9", "3L9"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L14", "5L14", "4L14", "3L14", "3S0"],
			sludgebomb: ["6M", "6L44", "5M", "5L44", "4M", "4L39", "3M", "3L39"],
			sludgewave: ["6M", "5M"],
			smog: ["6E", "5E", "4E", "3E"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L39", "5L39", "4L34", "3L34"],
			stockpile: ["6L39", "5L39", "4L34", "3L34"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L39", "5L39", "4L34", "3L34"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L28", "3S0"],
			venomdrench: ["6E"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
			wringout: ["6L54", "5L54", "4L49"],
			yawn: ["6L6", "5L6", "4L6", "3L6"],
		},
	},
	swalot: {
		inherit: true,
		learnset: {
			acidspray: ["6L38", "5L38"],
			amnesia: ["6L17", "5L17", "4L17", "3L17"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L46"],
			block: ["5T", "4T"],
			bodyslam: ["6L26", "5L26", "4L26", "3T", "3L26"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M"],
			encore: ["6L23", "5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L59", "5T", "5L59", "4T", "4L52"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["6L1", "5T", "5L73", "4T", "4L66"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5T", "4T"],
			poisongas: ["6L1", "5L1", "4L1", "3L1"],
			pound: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludge: ["6L1", "5L1", "4L1", "3L1"],
			sludgebomb: ["6M", "6L52", "5M", "5L52", "4M", "4L45", "3M", "3L48"],
			sludgewave: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L45", "5L45", "4L38", "3L40"],
			stockpile: ["6L45", "5L45", "4L38", "3L40"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L45", "5L45", "4L38", "3L40"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "6L30", "5M", "5L30", "4M", "4L30", "3M", "3L31"],
			venoshock: ["6M", "5M"],
			waterpulse: ["4M", "3M"],
			wringout: ["6L1", "5L66", "4L59"],
			yawn: ["6L1", "5L1", "4L1", "3L1"],
		},
	},
	carvanha: {
		inherit: true,
		learnset: {
			agility: ["6L36", "5L36", "4L36", "3L43"],
			ancientpower: ["6E", "5E", "4T", "4E"],
			aquajet: ["6L31", "5L31", "4L31"],
			assurance: ["6L26", "5L26", "4L26"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "6S1", "5L1", "5D", "4L1", "3L1", "3S0"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L28", "5L28", "4L28", "3L22"],
			darkpulse: ["6M", "5T", "5D", "4M"],
			destinybond: ["6E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L8", "5L8", "4L8", "3L13"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6E", "6S1", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L16", "5L16", "4L16"],
			icywind: ["5T", "4T", "3T"],
			leer: ["6L1", "6S1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L6", "5L6", "4L6", "3L7"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L11", "5L11", "4L11", "3L16", "3S0"],
			screech: ["6L18", "5L18", "4L18", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L21", "5M", "5L21", "4M", "4L21", "3T", "3L37"],
			swift: ["6E", "5E", "4T", "3T"],
			takedown: ["6L38", "5L38", "4L38", "3L31"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6E", "5E", "5D", "4E", "3E"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M", "3S0"],
			whirlpool: ["4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	sharpedo: {
		inherit: true,
		learnset: {
			agility: ["6L45", "5L45", "4L45", "3L53"],
			ancientpower: ["4T"],
			aquajet: ["6L34", "6S0", "5L34", "4L34"],
			assurance: ["6L26", "5L26", "4L26"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L28", "6S0", "6S1", "5L28", "4L28", "3L22"],
			darkpulse: ["6M", "5T", "4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L1", "5L1", "4L1"],
			focusenergy: ["6L1", "5L1", "4L1", "3L1"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L16", "6S0", "5L16", "4L16"],
			icywind: ["5T", "4T", "3T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6L1", "5L56", "4L56"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L11", "6S1", "5L11", "4L11", "3L16"],
			screech: ["6L18", "5L18", "4L18", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["6L50", "5L50", "4L50", "3L48"],
			slash: ["6L30", "6S1", "5L30", "4L30", "3L33"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L21", "5M", "5L21", "4M", "4L21", "3T", "3L43"],
			swift: ["4T", "3T"],
			taunt: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L38"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	wailmer: {
		inherit: true,
		learnset: {
			amnesia: ["6L37", "5L37", "4L37", "3L46"],
			aquaring: ["6E", "5E", "4E"],
			astonish: ["6L17", "5L17", "4L17", "3L23"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T"],
			bounce: ["6L44", "5T", "5L44", "5D", "4T", "4L44"],
			brine: ["6L31", "5L31", "4M", "4L31"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["6E"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["6E", "5E", "4E", "3T"],
			dive: ["6M", "6L41", "5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L4", "5L4", "4L4", "3L5"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["6L50", "5L50"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L47", "5L47", "4L47", "3L50"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			mimic: ["3T"],
			mist: ["6L24", "5L24", "4L24", "3L32"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L37"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L11", "5L11", "4T", "4L11", "3T", "3L14"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			soak: ["6E", "5E"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "4E", "3T", "3E"],
			thrash: ["6E", "5E", "4E", "3E"],
			tickle: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L7", "5L7", "5D", "4L7", "3L10"],
			waterpulse: ["6L21", "5L21", "4M", "4L21", "3M", "3L28"],
			waterspout: ["6L34", "5L34", "4L34", "3L41"],
			whirlpool: ["6L14", "5L14", "4M", "4L14", "3L19"],
			zenheadbutt: ["6E", "5T", "5E"],
		},
	},
	wailord: {
		inherit: true,
		learnset: {
			amnesia: ["6L37", "5L37", "4L37", "3L52", "3S0"],
			astonish: ["6L17", "5L17", "4L17", "3L23"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bounce: ["6L54", "5T", "5L54", "4T", "4L54"],
			brine: ["6L31", "5L31", "4M", "4L31"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["3T"],
			dive: ["6M", "6L46", "5M", "5L46", "4T", "4L46", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["6L70", "5L70"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L62", "5L62", "4L62", "3L59", "3S0"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			mimic: ["3T"],
			mist: ["6L24", "5L24", "4L24", "3L32", "3S1"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L37", "3S0", "3S1"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6L21", "5L21", "4M", "4L21", "3M", "3L28", "3S1"],
			waterspout: ["6L34", "5L34", "4L34", "3L44", "3S0", "3S1"],
			whirlpool: ["6L14", "5L14", "4M", "4L14", "3L19"],
			zenheadbutt: ["5T"],
		},
	},
	numel: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L19", "5L31", "4L25", "3L31"],
			ancientpower: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["6M"],
			curse: ["6L29", "5L29"],
			defensecurl: ["6E", "5E", "4E", "3T", "3E"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			doubleedge: ["6L47", "5L55", "4L51", "3T", "3L49"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L26", "5T", "5L41", "4T", "4L35"],
			earthquake: ["6M", "6L40", "5M", "5L45", "4M", "4L41", "3M", "3L35"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L5", "5L5", "5D", "4L5", "3L11", "3S0"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flameburst: ["6L15", "5L21"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L43", "5M", "5L51", "4M", "4L45", "3M", "3L41"],
			focusenergy: ["6L12", "5L15", "4L15", "3L25"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "6S1", "5L1", "4L1", "3L1"],
			growth: ["6E"],
			headbutt: ["4T"],
			heatwave: ["6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			howl: ["6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			ironhead: ["6E", "6S1", "5T", "5E"],
			lavaplume: ["6L22", "5L35", "4L31"],
			magnitude: ["6L8", "5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudbomb: ["6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6E", "5E", "4T", "4E", "3T", "3E"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E"],
			stealthrock: ["5T", "4M"],
			stockpile: ["6E", "5E", "4E"],
			stomp: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E"],
			tackle: ["6L1", "6S1", "5L1", "4L1", "3L1"],
			takedown: ["6L31", "5L25", "4L21", "3L29", "3S0"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			yawn: ["6L36", "6E", "5L36", "5E", "4E"],
		},
	},
	camerupt: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L19", "5L31", "4L25", "3L31"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6L29", "6S0", "5L29"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L26", "5T", "5L49", "4T", "4L39"],
			earthquake: ["6M", "6L46", "5M", "5L57", "4M", "4L49", "3M", "3L37"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["6L1", "5L67", "4L57", "3L45"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			fissure: ["6L1", "5L75", "4L67", "3L55"],
			flameburst: ["6L15", "5L21"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6L12", "5L15", "4L15", "3L25"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			lavaplume: ["6L22", "5L33", "4L31"],
			magnitude: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6L33", "6S0", "5M", "5L39", "4M", "4L33", "3T", "3L33"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L31", "6S0", "5L25", "4L21", "3L29"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			yawn: ["6L39", "6S0", "5L39"],
		},
	},
	torkoal: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			amnesia: ["6L49", "5L49", "4L49", "3L40"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6L33", "5L33", "4L33", "3T", "3L20"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			curse: ["6L12", "5L12", "4L12", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "4E"],
			ember: ["6L1", "5L1", "5D", "4L1", "3L1"],
			endure: ["6E", "5E", "4M", "4E", "3T", "3E"],
			eruption: ["6E", "5E", "4E", "3E"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firespin: ["6L17", "5L17", "4L17", "3L17"],
			fissure: ["6E", "5E", "5D", "4E"],
			flail: ["6L1", "5L52", "4L52", "3L43"],
			flameburst: ["6E", "5E"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L30"],
			flamewheel: ["6L23"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6L1", "5T", "5L55", "4T", "4L55", "3L46"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			inferno: ["6L1", "5L60"],
			irondefense: ["6L44", "5T", "5L44", "4T", "4L44", "3L33"],
			irontail: ["5T", "4M", "3M"],
			lavaplume: ["6L39", "5L39", "4L39"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "6L1", "5M", "5L36", "4M", "4L36", "3M", "3L27"],
			rapidspin: ["6L25", "5L23", "4L23"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["6L1", "5L65"],
			skullbash: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			smog: ["6L4", "5L4", "4L4", "3L4"],
			smokescreen: ["6L20", "5L20", "4L20", "3L14"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "5D", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6E"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			withdraw: ["6L7", "5L7", "4L7"],
			yawn: ["6E", "5E", "4E", "3E"],
		},
	},
	spoink: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6L50", "5T", "5L53", "4T", "4L48", "3L43"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L18", "5L18", "4L18", "3L25"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			endure: ["6E", "5E", "4M", "3T"],
			extrasensory: ["6E", "5E", "4E", "3E"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			luckychant: ["6E", "5E"],
			magiccoat: ["6L21", "5T", "5L21", "4T", "4L21", "3L28"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["6L10", "5L10", "4L10", "3L10"],
			payback: ["6M", "6L40", "5M", "5L41", "4M", "4L34"],
			powergem: ["6L33", "5L48", "4L46"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L14", "5L14", "4L14", "3L16"],
			psychic: ["6M", "6L44", "5M", "5L46", "4M", "4L41", "3M", "3L34"],
			psychup: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["6M", "6L38", "5M", "5L34"],
			psywave: ["6L7", "5L7", "5D", "4L7", "3L7"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "5D", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L37"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			simplebeam: ["6E"],
			skillswap: ["6E", "5T", "5E", "5D", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["6L29", "5T", "5L29", "4T", "4L29", "3T", "3L37"],
			splash: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "4T", "4E", "3E"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["3S0"],
			whirlwind: ["6E", "5E"],
			zenheadbutt: ["6L26", "6E", "5T", "5L26", "5E", "4T", "4L26", "4E"],
		},
	},
	grumpig: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6L60", "5T", "5L68", "4T", "4L60", "3L55"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L18", "5L18", "4L18", "3L25"],
			counter: ["3T"],
			covet: ["5T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["6L21", "5T", "5L21", "4T", "4L21", "3L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["6L1", "5L1", "4L1", "3L1"],
			payback: ["6M", "6L46", "5M", "5L47", "4M", "4L37"],
			powergem: ["6L35", "5L60", "4L55"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L1", "5L1", "4L1", "3L1"],
			psychic: ["6M", "6L52", "5M", "5L55", "4M", "4L47", "3M", "3L37"],
			psychup: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["6M", "6L42", "5M", "5L37"],
			psywave: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L43"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["6L29", "5T", "5L29", "4T", "4L29", "3T", "3L43"],
			splash: ["6L1", "5L1", "4L1", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			zenheadbutt: ["6L26", "5T", "5L26", "4T", "4L26"],
		},
	},
	spinda: {
		inherit: true,
		learnset: {
			assist: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			copycat: ["6L10", "5L10", "5D", "4L10"],
			counter: ["3T"],
			covet: ["5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E", "3E"],
			dizzypunch: ["6L28", "5L28", "4L28", "3L27"],
			doubleedge: ["6L46", "5L46", "4L46", "3T", "3L45"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			encore: ["6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "5D", "4E"],
			faketears: ["6E", "5E"],
			feintattack: ["6L14", "5L14", "4L14", "3L12"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6L50", "5L50", "4L50", "3L49"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			guardsplit: ["6E"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			hypnosis: ["6L23", "5L23", "4L23", "3L23"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["6E", "5T", "5E", "4T", "3T"],
			lastresort: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L19", "5L19", "4L19", "3L16"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychocut: ["6E", "5E", "4E"],
			psychoshift: ["6E"],
			psychup: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3T", "3L38"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6E", "5E"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["6E", "5T", "5E", "4T", "4E"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["3S0"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smellingsalts: ["6E", "5E", "4E", "3E"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L32", "5L32", "4T", "4L32"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5D"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			teeterdance: ["6L37", "5L37", "4L37", "3L34"],
			thief: ["6M", "5M", "4M", "3M"],
			thrash: ["6L50", "5L55", "4L55", "3L56"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "4E", "3E"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["6L5", "5T", "5L5", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	trapinch: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L17", "5L17"],
			bite: ["6L1", "5L1", "5D", "5S0", "4L1", "3L1"],
			bodyslam: ["3T"],
			bugbite: ["6E", "5T", "5E", "4T"],
			bulldoze: ["6M", "6L21", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L34", "5L33", "4L33", "3L33"],
			dig: ["6M", "6L29", "5M", "5L41", "4M", "4L41", "3M", "3L41"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["6L39", "6E", "5T", "5L65", "5E", "4T", "4L65"],
			earthquake: ["6M", "6L55", "5M", "5L73", "4M", "4L73", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feint: ["6L1", "5L81", "4L81"],
			feintattack: ["6L7", "5L17", "4L17", "3L17"],
			fissure: ["6L1", "5L89", "4L89"],
			flail: ["6E", "5E", "4E"],
			focusenergy: ["6E", "5E", "4E", "3E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6E", "5E", "4T", "4E"],
			gigadrain: ["5T", "5D", "4M", "3M"],
			gust: ["6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L49", "5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudshot: ["6E", "5E", "4E"],
			mudslap: ["6L13", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			quickattack: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "6L25", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6L4", "5L9", "4L9", "3L9"],
			sandstorm: ["6M", "6L44", "5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["6L10", "5L25", "4L25", "3L25"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6E", "5T", "5E", "5D"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6L1", "5T", "5L67"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
		},
	},
	vibrava: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L17", "5L17"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			bugbite: ["5T", "4T"],
			bulldoze: ["6M", "6L21", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["3L33"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L35", "5L35", "4L35", "3L35"],
			dragonpulse: ["5T", "4M"],
			earthpower: ["6L39", "5T", "5L39", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L1", "5L1", "4L1", "3L1"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["5T", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L49", "5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudslap: ["6L13", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "6L25", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["6M", "6L44", "5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L34", "5L41", "4L41", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T"],
			silverwind: ["4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			sonicboom: ["6L1", "5L1", "4L1"],
			steelwing: ["6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T"],
			supersonic: ["6L29", "5L33", "4L33"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
		},
	},
	flygon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bide: ["6L17", "5L17"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			bugbite: ["5T", "4T"],
			bulldoze: ["6M", "6L21", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["3L33", "3S0"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T", "4S1"],
			dragonbreath: ["6L35", "5L35", "4L35", "3L35", "3S0"],
			dragonclaw: ["6M", "6L55", "5M", "5L45", "4M", "4L45", "4S1", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "6L45", "5M", "5L65"],
			earthpower: ["6L39", "5T", "5L39", "4T"],
			earthquake: ["6M", "5M", "4M", "4S1", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L1", "5L1", "4L1", "3L1"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L49", "5M", "5L57", "4M", "4L57", "3M", "3L65"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["6L13", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "6L25", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["6M", "6L44", "5M", "5L49", "4M", "4L49", "3M", "3L53"],
			sandtomb: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			screech: ["6L34", "5L41", "4L41", "3L41", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["5T"],
			silverwind: ["4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			sonicboom: ["6L1", "5L1", "4L1"],
			steelwing: ["6M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T"],
			supersonic: ["6L29", "5L33", "4L33"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M", "4S1"],
		},
	},
	cacnea: {
		inherit: true,
		learnset: {
			absorb: ["6L5", "5L5", "5D", "4L5", "3L5", "3S0"],
			acid: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6E"],
			block: ["6E", "5T", "5E"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6L49", "5L49", "4L49", "3L41"],
			counter: ["6E", "5E", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			destinybond: ["6L57", "5L57", "4L57", "3L49"],
			disable: ["6E", "5E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["6E", "5E", "4E", "3T", "3E"],
			encore: ["3S0"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L29", "5L29", "4L29", "3L29"],
			fellstinger: ["6E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6E", "5E", "4E", "3E"],
			growth: ["6L9", "5L9", "4L9", "3L9"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			ingrain: ["6L25", "5L25", "4L25", "3L25"],
			leechseed: ["6L13", "5L13", "4L13", "3L13"],
			leer: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["6E", "5T", "5E", "4T", "4E"],
			magicalleaf: ["6E", "5E", "4E"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			needlearm: ["6L45", "5L45", "4L45", "3L37"],
			payback: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			pinmissile: ["6L21", "5L21", "4L21", "3L21"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			sandattack: ["6L17", "5L17", "4L17", "3L17"],
			sandstorm: ["6M", "6L53", "5M", "5L53", "4M", "4L53", "3M", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6E", "5T", "5E", "4T", "4E"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smellingsalts: ["6E", "5E", "4E"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6L33", "5L33", "4L33", "3L33"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L37", "5L37", "4T", "4L37"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			switcheroo: ["6E", "5E"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			teeterdance: ["6E", "5E", "5D", "4E", "3E"],
			thunderpunch: ["5T", "5D", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["6E", "5T", "5E", "4T"],
		},
	},
	cacturne: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["5T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonspore: ["6L59", "5L59", "4L59", "3L47"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			destinybond: ["6L1", "5L71", "4L71", "3L59"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L29", "5L29", "4L29", "3L29", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			ingrain: ["6L25", "5L25", "4L25", "3L25", "3S0"],
			leechseed: ["6L13", "5L13", "4L13", "3L13"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			needlearm: ["6L53", "5L53", "4L53", "3L41", "3S0"],
			payback: ["6M", "6L47", "5M", "5L47", "4M", "4L47"],
			pinmissile: ["6L21", "5L21", "4L21", "3L21"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L1", "5L1", "4L1", "3L1"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandattack: ["6L17", "5L17", "4L17", "3L17"],
			sandstorm: ["6M", "6L65", "5M", "5L65", "4M", "4L65", "3M", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			seismictoss: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6L35", "5L35", "4L35", "3L35", "3S0"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L41", "5L41", "4T", "4L41"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["5T", "4T"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	swablu: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6E", "5E", "4E", "3E"],
			aircutter: ["4T"],
			astonish: ["6L4", "5L5", "4L5", "3L8"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonguard: ["6L39", "5L40"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["6L42", "5T", "5L50", "4M", "4L45"],
			dragonrush: ["6E", "5E", "4E"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["3S0"],
			featherdance: ["6E", "5E", "5D", "4E"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L10", "5L13", "4L13", "3L18"],
			growl: ["6L1", "6S2", "5L1", "5S1", "4L1", "3L1", "3S0"],
			haze: ["6E", "5E", "4E", "3E"],
			healbell: ["5T", "4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["6E", "6S2", "5T", "5E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["6L34", "5L36", "4L36", "3L38"],
			mist: ["6L15", "5L23", "4L23", "3L28"],
			moonblast: ["6L50"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L21", "5L32", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			peck: ["6L1", "6S2", "5L1", "5D", "5S1", "4L1", "3L1", "3S0"],
			perishsong: ["6L48", "5L55", "4L50", "3L48"],
			pluck: ["5M", "4M"],
			powerswap: ["6E", "5E", "4E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6E", "5E", "4E", "3E"],
			rage: ["6E", "5E", "4E", "3E"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6L29", "5L45", "4L40", "3L41"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["6M", "6L18", "5M", "5L18"],
			safeguard: ["6M", "6L13", "5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["6L8", "5L9", "4L9", "3L11"],
			skyattack: ["3T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "6E", "5E", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			takedown: ["6L25", "5L28", "4L28", "3L31"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
		},
	},
	altaria: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M", "3S1"],
			aircutter: ["4T"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cottonguard: ["6L42", "5L46"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L35", "5L35", "5S2", "4L35", "3L35", "3S0", "3S1"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragondance: ["6L34", "5L39", "4L39", "3L40", "3S0"],
			dragonpulse: ["6L48", "5T", "5L62", "4M", "4L54"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["5S2"],
			fireblast: ["6M", "6S3", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furyattack: ["6L10", "5L13", "4L13", "3L18"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			healbell: ["5T", "4T", "3S1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["6S3", "5T"],
			icebeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mist: ["6L15", "5L23", "4L23", "3L28"],
			moonblast: ["6L60"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L21", "5L32", "5S2", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			peck: ["6L1", "5L1", "4L1", "3L1"],
			perishsong: ["6L57", "5L70", "4L62", "3L54"],
			pluck: ["6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["6M", "6S3", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6L29", "5L54", "4L46", "3L45", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "6L18", "5M", "5L18"],
			safeguard: ["6M", "6L13", "5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["6L1", "5L1", "4L1", "3L1"],
			skyattack: ["6L1", "5T", "5L77", "4T", "4L70", "3T", "3L59"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M", "3S1"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			takedown: ["6L25", "5L28", "5S2", "4L28", "3L31", "3S0"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5T", "4T"],
			wonderroom: ["5T"],
		},
	},
	zangoose: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M", "3S2"],
			captivate: ["4M"],
			closecombat: ["6L47", "5L53", "4L53"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E", "3T", "3E", "3S2"],
			crushclaw: ["6L22", "5L31", "4L31", "3L31", "3S2"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			detect: ["6L33", "5L40", "4L40", "3L46"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doublehit: ["6E", "5E", "5D", "4E"],
			doublekick: ["6E", "5E", "4E", "3E"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["6M", "6L19", "5M", "5L27", "4M", "4L27"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "6L29", "5M", "5L44", "4M", "4L44", "3L55"],
			feint: ["6E", "5E"],
			finalgambit: ["6E", "5E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flail: ["6E", "5E", "4E", "3E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L8", "5L14", "4T", "4L14", "3T", "3L13", "3S0"],
			furyswipes: ["6E", "5E", "4E"],
			gigadrain: ["5T", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L4", "3S0", "3S1"],
			lowkick: ["5T", "5D", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "4E"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			pursuit: ["6L12", "5L22", "4L22", "3L25"],
			quickattack: ["6L5", "5L5", "5D", "4L5", "3L7", "3S0", "3S1"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6E", "5E", "4E", "3E"],
			refresh: ["3S2"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			revenge: ["6L26", "5L26"],
			roar: ["6M", "5M", "4M", "4E", "3M", "3E"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["6L15", "5L18", "4L18", "3L19"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L43", "5M", "5L9", "4M", "4L9", "3T", "3L10", "3S0", "3S1"],
			taunt: ["6M", "6L40", "5M", "5L35", "4M", "4L35", "3M", "3L37"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			xscissor: ["6M", "6L36", "5M", "5L48", "4M", "4L48"],
		},
	},
	seviper: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "5D", "4T"],
			assurance: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			belch: ["6L46"],
			bind: ["5T"],
			bite: ["6L5", "5L10", "5D", "4L10", "3L10", "3S0", "3S2"],
			bodyslam: ["6E", "5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			coil: ["6L48", "5L64"],
			confide: ["6M"],
			crunch: ["6L45", "5L28", "4L28", "3L28", "3S1"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragontail: ["6M", "5M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			finalgambit: ["6E", "5E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["6L34", "5T", "5L34"],
			gigadrain: ["5T", "4M", "3M"],
			glare: ["6L23", "5L25", "4L25", "3L25", "3S1"],
			haze: ["6L38", "5L43", "4L43", "3L43"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			irontail: ["6E", "5T", "5E", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lick: ["6L9", "5L7", "4L7", "3L7", "3S0", "3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["6L31", "6E", "5L46", "5E", "4L46", "4E"],
			payback: ["6M", "5M", "4M"],
			poisonfang: ["6L27", "5L34", "4L34", "3L34"],
			poisonjab: ["6M", "6L42", "5M", "5L52", "4M", "4L52"],
			poisontail: ["6L12", "5L16", "4L16", "3L16", "3S0", "3S1"],
			protect: ["6M", "5M", "4M", "3M"],
			punishment: ["6E", "5E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E", "4E"],
			screech: ["6L16", "5L19", "4L19", "3L19", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spitup: ["6E", "5E", "4E", "3E"],
			stockpile: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L1", "5M", "5L37", "4M", "4L37", "3T", "3L37"],
			swallow: ["6E", "5E", "4E", "3E"],
			swift: ["4T", "3T"],
			switcheroo: ["6E", "5E", "4E"],
			taunt: ["6M", "5M", "4M", "3M"],
			thief: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			venomdrench: ["6L28"],
			venoshock: ["6M", "6L20", "5M", "5L55"],
			wrap: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S2"],
			wringout: ["6L50", "6E", "5L61", "5E", "4L55"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	lunatone: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			blizzard: ["6M", "5M", "4M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "5D", "4L1", "3L7", "3S0"],
			cosmicpower: ["6L29", "5L34", "4L34", "3L31"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthpower: ["5T", "5D", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "6L21", "5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L49", "5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L45", "5L53", "4L53", "3L43"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			healblock: ["6L37", "5L42", "4L42"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6L9", "5L12", "4L12", "3L19"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["6L1", "5T", "5L64"],
			mimic: ["3T"],
			moonblast: ["6L50"],
			moonlight: ["5D"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L33", "5M", "5L45", "4M", "4L45", "3M", "3L37", "3S1"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			psywave: ["6L17", "5L23", "4L23", "3L25"],
			raindance: ["6M", "5M", "4M", "3M", "3S1"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "6L13", "5M", "5L20", "4M", "4L20"],
			rockslide: ["6M", "6L25", "5M", "5L25", "4M", "3T"],
			rockthrow: ["6L1", "5L9", "4L9", "3L13"],
			rocktomb: ["6M", "5M", "4M", "3M", "3S1"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L41", "5M", "5L41", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trickroom: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	solrock: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "5D", "4L1", "3L7", "3S0"],
			cosmicpower: ["6L29", "5L34", "4L34", "3L31", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "6L21", "5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L49", "5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firespin: ["6L9", "5L12", "4L12", "3L19"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			healblock: ["6L37", "5L42", "4L42"],
			heatwave: ["5T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			morningsun: ["5D"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L33", "5M", "5L33", "4M", "3M", "3S1"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			psywave: ["6L17", "5L23", "4L23", "3L25"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "6L13", "5M", "5L20", "4M", "4L20"],
			rockslide: ["6M", "6L25", "5M", "5L45", "4M", "4L45", "3T", "3L37"],
			rockthrow: ["6L1", "5L9", "4L9", "3L13"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L45", "5M", "5L53", "4M", "4L53", "3M", "3L43"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L41", "5M", "5L41", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M", "3S1"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["6L1", "5T", "5L64"],
			zenheadbutt: ["5T", "5D", "4T"],
		},
	},
	barboach: {
		inherit: true,
		learnset: {
			amnesia: ["6L18", "5L18", "4L18", "3L21"],
			aquatail: ["6L35", "5T", "5L35", "4T", "4L35"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E"],
			earthpower: ["6E", "5T", "5E", "4T"],
			earthquake: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L31"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6L47", "5L47", "4L47", "3L41"],
			flail: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L43", "5L43", "4L43", "3L36"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6E", "5E", "4E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			magnitude: ["6L26", "5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["6L14", "5L14", "4L14"],
			muddywater: ["6E", "5E"],
			mudshot: ["6E", "5E"],
			mudslap: ["6L1", "5L1", "5D", "4T", "4L1", "3T", "3L1"],
			mudsport: ["6L6", "5L6", "4L6", "3L6"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L26"],
			return: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "5D", "4M", "3T"],
			snore: ["6L31", "5T", "5L31", "4T", "4L31", "3T", "3L26"],
			spark: ["6E", "5E", "5D", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			takedown: ["6E", "5E", "4E"],
			thrash: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "4L10", "3L11"],
			waterpulse: ["6L22", "5L22", "4M", "4L22", "3M"],
			watersport: ["6L6", "5L6", "4L6", "3L6"],
			whirlpool: ["6E", "5E", "4M", "4E", "3E"],
		},
	},
	whiscash: {
		inherit: true,
		learnset: {
			amnesia: ["6L18", "5L18", "4L18", "3L21"],
			aquatail: ["6L39", "5T", "5L39", "4T", "4L39", "4S0"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "4S0", "3M", "3L36"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6L57", "5L57", "4L57", "3L56"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L51", "5L51", "4L51", "3L46"],
			gigaimpact: ["6M", "5M", "4M", "4S0"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			magnitude: ["6L26", "5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["6L14", "5L14", "4L14"],
			mudslap: ["6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3M", "3L26"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["6L33", "5T", "5L33", "4T", "4L33", "3T", "3L26"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tickle: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "4L10", "3L11"],
			waterpulse: ["6L22", "5L22", "4M", "4L22", "3M"],
			watersport: ["6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			zenheadbutt: ["6L1", "5T", "5L1", "4T", "4L1", "4S0"],
		},
	},
	corphish: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6E", "5E", "4T", "4E", "3E"],
			aquajet: ["6E"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubble: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["6L20", "5L20", "4L20", "3L19"],
			captivate: ["4M"],
			chipaway: ["6E", "5E"],
			confide: ["6M"],
			counter: ["3T"],
			crabhammer: ["6L38", "5L38", "4L38", "3L34"],
			crunch: ["6L47", "5L47", "4L47", "3L43"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["6E", "5E", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E"],
			endeavor: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["6L53", "5L53", "4L53", "3L44"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L7", "5L7", "5D", "4L7", "3L7"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["6L26", "6E", "5T", "5L26", "5E", "4T", "4L26", "4E", "3L25"],
			leer: ["6L13", "5L13", "4L13", "3L13"],
			metalclaw: ["6E", "5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightslash: ["6L35", "5L35", "4L35"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "6L23", "5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6E", "5T", "5E", "4T", "4E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			switcheroo: ["6E"],
			swordsdance: ["6M", "6L44", "5M", "5L44", "4M", "4L44", "3T", "3L37"],
			taunt: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L31"],
			toxic: ["6M", "5M", "4M", "3M"],
			trumpcard: ["6E", "5E"],
			visegrip: ["6L10", "5L10", "4L10", "3L10"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["3S0"],
			whirlpool: ["4M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	crawdaunt: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bubble: ["6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["6L20", "5L20", "4L20", "3L19"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["3T"],
			crabhammer: ["6L44", "5L44", "4L44", "3L38", "3S0", "3S1"],
			crunch: ["6L57", "5L57", "4L57", "3L51"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endeavor: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			guillotine: ["6L1", "5L65", "4L65", "3L52", "3S0"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			knockoff: ["6L26", "5T", "5L26", "4T", "4L26", "3L25", "3S1"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			nightslash: ["6L39", "5L39", "4L39"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "6L23", "5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L30", "5L30", "4T", "4L30", "3T"],
			swordsdance: ["6M", "6L52", "5M", "5L52", "4M", "4L52", "3T", "3L43", "3S0", "3S1"],
			taunt: ["6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L33", "3S0", "3S1"],
			toxic: ["6M", "5M", "4M", "3M"],
			visegrip: ["6L1", "5L1", "4L1", "3L1"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	baltoy: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["6L21", "5L26", "4T", "4L25", "3L25"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			cosmicpower: ["6L31", "5L37", "4L45", "3L37"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillrun: ["5T"],
			earthpower: ["6L37", "5T", "5L51", "4T", "4L53"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L49", "5M", "5L60", "4M", "4L71", "3T", "3L45"],
			extrasensory: ["6L28", "5L43"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "5D", "4T"],
			guardsplit: ["6L34", "5L48"],
			gyroball: ["6M", "5M", "4M"],
			harden: ["6L1", "5L4", "4L3", "3L3"],
			headbutt: ["4T"],
			healblock: ["6L45", "5L54", "4L61"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["6L7", "5L11", "4T", "4L7", "3T", "3L7", "3S0"],
			naturalgift: ["4M"],
			powersplit: ["6L34", "5L48"],
			powertrick: ["6L17", "5L31", "4L31"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L13", "5L15", "4L11", "3L11", "3S0"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L4", "5L7", "5D", "4L5", "3L5"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocktomb: ["6M", "6L10", "5M", "5L18", "4M", "4L15", "3M", "3L15", "3S0"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "6L41", "5M", "5L34", "4M", "4L37", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L25", "5L21", "4L19", "3T", "3L19"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "5D", "4T"],
		},
	},
	claydol: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["6L21", "5L26", "4T", "4L25", "3L25"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			cosmicpower: ["6L31", "5L47", "4L51", "3L42"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			drillrun: ["5T"],
			earthpower: ["6L40", "5T", "5L59", "4T", "4L62"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L61", "5M", "5L72", "4M", "4L86", "3T", "3L55"],
			extrasensory: ["6L28", "5L39"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			guardsplit: ["6L34", "5L54"],
			gyroball: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healblock: ["6L54", "5L64", "4L73"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L36"],
			icebeam: ["6M", "5M", "4M", "3M"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mudslap: ["6L7", "5L11", "4T", "4L7", "3T", "3L7"],
			naturalgift: ["4M"],
			powersplit: ["6L34", "5L54"],
			powertrick: ["6L17", "5L31", "4L31"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L13", "5L15", "4L11", "3L11"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rapidspin: ["6L1", "5L1", "4L1", "3L1"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "6L10", "5M", "5L18", "4M", "4L15", "3M", "3L15"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "6L47", "5M", "5L34", "4M", "4L40", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["6L25", "5L21", "4L19", "3T", "3L19"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			teleport: ["6L1", "5L1", "4L1", "3L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	lileep: {
		inherit: true,
		learnset: {
			acid: ["6L8", "5L8", "5D", "5S0", "4L8", "3L15"],
			amnesia: ["6L29", "5L29", "4L29", "3L36"],
			ancientpower: ["6L43", "5L43", "4T", "4L43", "3L43"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			bind: ["5T"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L22", "5L22", "4L22", "3L29"],
			constrict: ["6L1", "5L1", "5S0", "4L1", "3L8"],
			curse: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["6E", "5E", "4M", "3T"],
			energyball: ["6M", "6L50", "5M", "5L50", "4M", "4L50"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L36", "5T", "5L36", "4T", "4L36"],
			gigadrain: ["6L26", "5T", "5D", "4M", "3M"],
			grassknot: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			ingrain: ["6L15", "5L15", "4L15", "3L22"],
			megadrain: ["6E", "5E"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			recover: ["6E", "5E", "5S0", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "5S0", "4M", "4E", "3T", "3E"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L57", "5L57", "4L57", "3L50"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			stockpile: ["6L57", "5L57", "4L57", "3L50"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L57", "5L57", "4L57", "3L50"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
			wringout: ["6L64", "6E", "5L64", "5E", "4L64", "4E"],
		},
	},
	cradily: {
		inherit: true,
		learnset: {
			acid: ["6L1", "5L1", "4L1", "3L1"],
			amnesia: ["6L29", "5L29", "4L29", "3L36"],
			ancientpower: ["6L36", "5L36", "4T", "4L36", "3L48"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6L22", "5L22", "4L22", "3L29"],
			constrict: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "6L56", "5M", "5L56", "4M", "4L56"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gastroacid: ["6L46", "5T", "5L46", "4T", "4L46"],
			gigadrain: ["6L26", "5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			infestation: ["6M"],
			ingrain: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spitup: ["6L1", "5L66", "4L66", "3L60"],
			stealthrock: ["5T", "4M"],
			stockpile: ["6L1", "5L66", "4L66", "3L60"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6L1", "5L66", "4L66", "3L60"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			worryseed: ["5T", "4T"],
			wringout: ["6L1", "5L76", "4L76"],
		},
	},
	anorith: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6L31", "5L31", "4T", "4L31", "3L37"],
			aquajet: ["6E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["6L25", "5T"],
			captivate: ["4M"],
			confide: ["6M"],
			crosspoison: ["6E", "5E", "5D", "5S0", "4E"],
			crushclaw: ["6L55", "5L55", "4L55"],
			curse: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L37", "5L37", "4T", "4L37", "3T", "3L43"],
			harden: ["6L1", "5L1", "5S0", "4L1", "3L7"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6E", "5T", "5E", "4T"],
			knockoff: ["6E", "5T", "5E", "4T", "4E", "3E"],
			metalclaw: ["6L19", "5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L7", "5L7", "5S0", "4L7", "3L13"],
			naturalgift: ["4M"],
			protect: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rapidspin: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L49", "5L49", "4L49", "3L55"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E", "4E"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "5D", "4L1", "3L1"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			slash: ["6L43", "5L43", "4L43", "3L49"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "5D", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "4E", "3T", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			watergun: ["6L13", "5L13", "5S0", "4L13", "3L19"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			xscissor: ["6M", "6L61", "5M", "5L61", "4M", "4L61"],
		},
	},
	armaldo: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6L31", "5L31", "4T", "4L31", "3L37"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bugbite: ["5T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crushclaw: ["6L1", "5L67", "4L67"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["6L37", "5L37", "4T", "4L37", "3T", "3L46"],
			gigaimpact: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			irondefense: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			metalclaw: ["6L19", "5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockblast: ["6L55", "5L55", "4L55", "3L64"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			slash: ["6L46", "5L46", "4L46", "3L55"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			xscissor: ["6M", "6L73", "5M", "5L73", "4M", "4L73"],
		},
	},
	feebas: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			brine: ["6E", "5E"],
			captivate: ["6E", "5E", "5D", "4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonbreath: ["6E", "5E", "4E", "3E"],
			dragonpulse: ["6E", "5T", "5E"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L30", "5L30", "4L30", "3L30"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			haze: ["6E", "5E", "4E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypnosis: ["6E", "5E", "4E", "3E"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["6E", "5T", "5E"],
			lightscreen: ["6M", "5M", "4E", "3E"],
			mimic: ["3T"],
			mirrorcoat: ["6E", "5E", "5D", "4E", "4S0", "3E"],
			mist: ["6E", "5E", "4E"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			splash: ["6L1", "5L1", "5D", "4L1", "4S0", "3L1"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L15", "5L15", "4L15", "3L15"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	milotic: {
		inherit: true,
		learnset: {
			aquaring: ["6L49", "5L49", "4L49"],
			aquatail: ["6L29", "5T", "5L29", "4T", "4L29"],
			attract: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3M", "3L45"],
			avalanche: ["4M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["6L25", "5L25", "4M", "4L25"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L37", "5L37", "5S3", "4L37", "4S1", "4S2", "3L40"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "5S3", "5S4", "4M", "4S1", "3M"],
			icywind: ["5T", "4T", "4S2", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["5S3"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "4S1", "4S2", "3M", "3L35", "3S0"],
			recover: ["6L21", "5L21", "5S3", "5S4", "4L21", "4S1", "4S2", "3L30", "3S0"],
			refresh: ["6L9", "5L9", "4L9", "3L15"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L45", "5M", "5L45", "4M", "4L45", "3M", "3L50"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "5S4", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "5S4", "4M", "3M"],
			twister: ["6L17", "5L17", "4T", "4L17", "3L25", "3S0"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6L13", "5L13", "4M", "4L13", "3M", "3L20", "3S0"],
			watersport: ["6L5", "5L5", "4L5", "3L10"],
			whirlpool: ["4M"],
			wrap: ["6L1", "5L1", "4L1", "3L5"],
		},
	},
	castform: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L40", "5M", "5L50", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			cosmicpower: ["6E"],
			defensecurl: ["3T"],
			disable: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			ember: ["6L10", "5L10", "5D", "4L10", "3L10"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L40", "5M", "5L50", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E", "3E"],
			guardswap: ["6E"],
			hail: ["6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			headbutt: ["6L15", "5L20"],
			hex: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L40", "5L50"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["5T", "4T"],
			luckychant: ["6E", "5E", "4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["6E", "5E", "5D", "4T", "4E"],
			powdersnow: ["6L10", "5L10", "4L10", "3L10"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "4E", "3T", "3E"],
			raindance: ["6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			reflecttype: ["6E"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			watergun: ["6L10", "5L10", "4L10", "3L10"],
			waterpulse: ["5D", "4M", "3M"],
			weatherball: ["6L30", "5L40", "4L30", "3L30"],
			workup: ["5M"],
		},
	},
	kecleon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			afteryou: ["5T"],
			ancientpower: ["6L1", "5L55", "4T", "4L55", "3L49"],
			aquatail: ["5T", "4T"],
			astonish: ["6L1", "5L1", "4L1", "3L1"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["6L4", "5T", "5L4", "4L4", "3L4"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			camouflage: ["6E"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["6E", "5E", "4E", "3E"],
			dizzypunch: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fakeout: ["6E", "5E", "4E"],
			feint: ["6L14", "5L14", "4L14"],
			feintattack: ["6L7", "5L7", "5D", "4L7", "3L7"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["6E", "5T", "5E"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["6L10", "5L10", "4L10", "3L12"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lick: ["6L1", "5L1", "4L1", "3L1"],
			lowkick: ["5T", "4T"],
			magiccoat: ["6E", "5T", "5E", "4T", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psybeam: ["6L18", "5L18", "4L15", "3L17"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6E", "5E", "4E"],
			recycle: ["5T", "4M"],
			reflecttype: ["5D"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1", "3L1"],
			screech: ["6L32", "5L32", "4L32", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "6L49", "5M", "5L49", "4M", "4L49"],
			shadowsneak: ["6L22", "5L22", "4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["6E", "5T", "5E", "5D", "4M", "3M"],
			slash: ["6L27", "5L27", "4L25", "3L31"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["6E", "5T", "5E", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3T", "3L40"],
			suckerpunch: ["6L43", "5L43", "4T", "4L43"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["6L1", "5L58"],
			tailwhip: ["6L1", "5L1", "4L1", "3L1"],
			thief: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6E", "5T", "5E", "4T", "4E", "3E"],
			trickroom: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			wonderroom: ["5T"],
			workup: ["5M"],
		},
	},
	shuppet: {
		inherit: true,
		learnset: {
			astonish: ["6E", "5E", "4E", "3E"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			curse: ["6L19", "5L13", "4L13", "3L20"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			destinybond: ["6E", "5E", "5D", "4E", "3E"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			embargo: ["6M", "6L38", "5M", "5L43", "4M", "4L38"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L22", "5L28", "4L28", "3L37", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["6E", "5E", "4E", "3E"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			grudge: ["6L46", "5L50", "4L46", "3L56"],
			gunkshot: ["6E", "5E"],
			headbutt: ["4T"],
			hex: ["6L26", "5L31"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			imprison: ["6E", "5E", "4E", "3E"],
			knockoff: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L7", "5L8", "5D", "4L8", "3L13"],
			ominouswind: ["6E", "5E", "4T"],
			painsplit: ["5T", "5D", "4T"],
			payback: ["6M", "5M", "4M", "4E"],
			phantomforce: ["6E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			screech: ["6L4", "5L5", "4L5", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "6L30", "5M", "5L35", "4M", "4L31", "3M", "3L44", "3S0"],
			shadowsneak: ["6L16", "6E", "5L20", "5E", "4L20", "4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["6L42", "5T", "5L46", "4M", "4L43", "3M", "3L49"],
			snore: ["3T"],
			spite: ["6L10", "5T", "5L16", "4T", "4L16", "3L25", "3S0"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L34", "5L38", "4T", "4L35"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6L50", "5T", "5L55", "4T", "4L50"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "6L13", "5M", "5L23", "4M", "4L23", "3L32", "3S0"],
		},
	},
	banette: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cottonguard: ["5S1"],
			curse: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			darkpulse: ["6M", "5T", "4M"],
			dazzlinggleam: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			embargo: ["6M", "6L40", "5M", "5L51", "4M", "4L42"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6L22", "5L28", "5S1", "4L28", "3L39", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grudge: ["6L52", "5L66", "4L58", "3L64"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hex: ["6L26", "5L31", "5S1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			knockoff: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "6L30", "5M", "5L35", "5S1", "4M", "4L31", "3M", "3L48", "3S0"],
			shadowclaw: ["6M", "5M", "4M"],
			shadowsneak: ["6L16", "5L20", "4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["6L46", "5T", "5L58", "4M", "4L51", "3M", "3L55"],
			snore: ["3T"],
			spite: ["6L10", "5T", "5L16", "4T", "4L16", "3L25"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L34", "5L42", "4T", "4L35"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["6L58", "5T", "5L75", "4T", "4L66"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "6L13", "5M", "5L23", "4M", "4L23", "3L32"],
		},
	},
	duskull: {
		inherit: true,
		learnset: {
			astonish: ["6L14", "5L14", "4L14", "3L16", "3S1"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L17", "5L17", "4L17", "3L23", "3S1"],
			curse: ["6L30", "5L30", "4L30", "3L34", "3S0"],
			darkpulse: ["6M", "6E", "5T", "5E", "4M"],
			destinybond: ["6E", "5E", "4E", "3E"],
			disable: ["6L6", "5L6", "5D", "4L6", "3L5"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			feintattack: ["6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			foresight: ["6L9", "5L9", "4L9", "3L12"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L49", "5L49", "4L46", "3L49"],
			gravity: ["5T", "4T"],
			grudge: ["6E", "5E", "4E", "3E"],
			haze: ["6E"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hex: ["6L38", "5L38"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			imprison: ["6E", "5E", "4E", "3E"],
			infestation: ["6M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L41", "5L41", "4L38", "3L45", "3S0"],
			memento: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["6E", "5E", "4T", "4E"],
			painsplit: ["6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			payback: ["6M", "6L46", "5M", "5L46", "4M", "4L41"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6L25", "5L25", "4L25", "3L27", "3S0"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M", "3S1"],
			shadowsneak: ["6L22", "5L22", "4L22"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "5D", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3L38", "3S0"],
			wonderroom: ["5T"],
		},
	},
	dusclops: {
		inherit: true,
		learnset: {
			astonish: ["6L14", "5L14", "4L14", "3L16"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["6L1", "5T", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L17", "5L17", "4L17", "3L23"],
			counter: ["3T"],
			curse: ["6L30", "5L30", "4L30", "3L34"],
			darkpulse: ["6M", "5T", "4M"],
			disable: ["6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["6L9", "5L9", "4L9", "3L12"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L61", "5L61", "4L61", "3L58"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["6L42", "5L42"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			meanlook: ["6L49", "5L49", "4L43", "3L51"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L58", "5M", "5L58", "4M", "4L51"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			pursuit: ["6L25", "5L25", "4L25", "3L27"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowpunch: ["6L37", "5L37", "4L37", "3L37"],
			shadowsneak: ["6L22", "5L22", "4L22"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["6L1", "5T", "5L1", "4T", "4L1", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "6L33", "5M", "5L33", "4M", "4L33", "3L41"],
			wonderroom: ["5T"],
		},
	},
	dusknoir: {
		inherit: true,
		learnset: {
			astonish: ["6L14", "5L14", "4L14"],
			attract: ["6M", "5M", "4M"],
			bind: ["6L1", "5T", "5L1", "4L1"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L17", "5L17", "4L17"],
			curse: ["6L30", "5L30", "4L30"],
			darkpulse: ["6M", "5T", "4M"],
			disable: ["6L1", "5L1", "4L1"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["6L9", "5L9", "4L9"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L61", "5L61", "4L61"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["6L42", "5L42"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			leer: ["6L1", "5L1", "4L1"],
			meanlook: ["6L49", "5L49", "4L43"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightshade: ["6L1", "5L1", "4L1"],
			ominouswind: ["4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L58", "5M", "5L58", "4M", "4L51"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			pursuit: ["6L25", "5L25", "4L25"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowpunch: ["6L37", "5L37", "4L37"],
			shadowsneak: ["6L22", "5L22", "4L22"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunderpunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			willowisp: ["6M", "6L33", "5M", "5L33", "4M", "4L33"],
		},
	},
	tropius: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["6L50", "5L51", "4L47", "4S0"],
			attract: ["6M", "5M", "4M", "3M"],
			bestow: ["6L1", "5L57"],
			bodyslam: ["6L37", "5L37", "4L37", "3T", "3L37"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragondance: ["6E", "5E", "4E"],
			dragonpulse: ["5T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5T", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L7", "5L7", "4L7", "3L7"],
			gust: ["6L1", "5L1", "5D", "4L1", "3L1"],
			headbutt: ["6E", "5E", "4T", "4E", "3E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			leafblade: ["6E", "5E", "4E"],
			leafstorm: ["6L1", "6E", "5L71", "5E", "4L61", "4E"],
			leaftornado: ["6L47", "5L47"],
			leechseed: ["6E", "5E", "5D", "4E", "3E"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			magicalleaf: ["6L31", "5L31", "4L31", "3L31"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["6L1", "6E", "5L67", "5E", "4M", "4L57"],
			naturepower: ["6M", "6E", "5E", "4E", "3E"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			razorleaf: ["6L11", "5L11", "4L11", "3L11"],
			razorwind: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["5T"],
			silverwind: ["5D", "4M"],
			slam: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L61", "5M", "5L61", "4M", "4L51", "4S0", "3M", "3L41"],
			steelwing: ["6M", "4M", "3M"],
			stomp: ["6L17", "5L17", "4L17", "3L17"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "4S0", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetscent: ["6L21", "5L21", "4L21", "3L21"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			synthesis: ["6L41", "6E", "5T", "5L41", "5E", "4T", "4L41", "4E", "4S0", "3L47"],
			tailwind: ["5T", "4T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["6L27", "5L27", "4L27", "3L27"],
			worryseed: ["5T", "4T"],
		},
	},
	chingling: {
		inherit: true,
		learnset: {
			astonish: ["6L9", "5L9", "4L9"],
			attract: ["6M", "5M", "4M"],
			bind: ["5T"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L14", "5L14", "4L14"],
			cosmicpower: ["6E"],
			curse: ["6E", "5E", "4E"],
			dazzlinggleam: ["6M"],
			disable: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M", "4E"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			entrainment: ["6L25", "5L25"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6E", "5E", "4E"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			growl: ["6L6", "5L6", "4L6"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			hypnosis: ["6E", "5E", "4E"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L22", "5T", "5L22", "4T", "4L22"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recover: ["6E", "5E", "4E"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["6E", "5T", "5E", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["6L17", "5T", "5L17", "4T", "4L17"],
			wish: ["6E", "5E", "4E"],
			wrap: ["6L1", "5L1", "4L1"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	chimecho: {
		inherit: true,
		learnset: {
			astonish: ["6L9", "5L9", "4L9", "3L9", "3S0"],
			attract: ["6M", "5M", "4M", "3M"],
			bind: ["5T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L14", "5L14", "4L14", "3L14"],
			cosmicpower: ["6E"],
			curse: ["6E", "5E", "4E", "3E"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			disable: ["6E", "5E", "4E", "3E"],
			doubleedge: ["6L33", "5L33", "4L33", "3T", "3L33"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dreameater: ["6M", "5M", "4M", "4E", "3T", "3E"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			extrasensory: ["6L46", "5L46", "4L46"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6E", "5E", "4E"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			growl: ["6L6", "5L6", "4L6", "3L6", "3S0"],
			healbell: ["6L38", "5T", "5L38", "4T", "4L38", "3L38"],
			healingwish: ["6L1", "5L57", "4L49"],
			healpulse: ["6L49", "5L49"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T", "5D"],
			hypnosis: ["6E", "5E", "5D", "4E", "3E"],
			icywind: ["5T", "4T", "3T"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "5M", "4M", "3M", "3L46"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			psywave: ["6L30", "5L30", "4L30", "3L30"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6E"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3M", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			synchronoise: ["6L1", "5L54"],
			takedown: ["6L22", "5L22", "4L22", "3L17"],
			taunt: ["6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["6L17", "5T", "5L17", "4T", "4L17", "3L22"],
			wish: ["6E", "5E", "4E"],
			wrap: ["6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			yawn: ["6L25", "5L25", "4L25", "3L25"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	absol: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			assurance: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6E", "5E", "4E", "3E"],
			bite: ["6L20", "5L28", "4L28", "3L21", "3S2"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5T", "4M"],
			detect: ["6L1", "5L49", "4L49"],
			doubleedge: ["6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["6M", "6L25", "5M", "5L33", "4M", "4L33", "3M", "3L31", "3S3"],
			dreameater: ["6M", "5M", "4M", "3T"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			falseswipe: ["6M", "5M", "4M"],
			feint: ["6L1", "5L1", "5D", "4L1"],
			feintattack: ["6E", "5E", "4E", "3E"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			futuresight: ["6L36", "5L41", "4L41", "3L41", "3S3"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hex: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			knockoff: ["5T", "4T"],
			leer: ["6L4", "5L4", "4L4", "3L5", "3S0", "3S1"],
			magiccoat: ["6E", "5T", "5E", "4T", "4E", "3E"],
			meanlook: ["6E", "5E", "4E"],
			mefirst: ["6L1", "6E", "5L57", "5E", "4L57", "4E"],
			megahorn: ["6E", "5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["6L41", "5L52", "4L52"],
			payback: ["6M", "5M", "4M"],
			perishsong: ["6L1", "6E", "5L65", "5E", "4L65", "3L46", "3S3"],
			playrough: ["6E"],
			protect: ["6M", "5M", "4M", "3M"],
			psychocut: ["6L47", "5L60", "4L60"],
			psychup: ["6M", "5M", "4M", "3T"],
			punishment: ["6E", "5E", "4E"],
			pursuit: ["6L12", "5L20", "4L20"],
			quickattack: ["6L9", "5L12", "4L12", "3L13"],
			raindance: ["6M", "5M", "4M", "3M"],
			razorwind: ["6L1", "5L17", "4L17", "3L17", "3S2"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scratch: ["6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["6L28", "5L36", "4L36", "3L36", "3S3"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T", "3S1", "3S2"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["6L50", "6E", "5L44", "5E", "4T", "4L44", "4E"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["5T", "5D", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "6L33", "5M", "5L25", "4M", "4L25", "3T", "3L26", "3S2"],
			taunt: ["6M", "6L1", "5M", "5L9", "4M", "4L9", "3M", "3L9"],
			thief: ["6M", "5M", "4M", "3M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["6M", "5M", "4M"],
			wish: ["3S0"],
			xscissor: ["6M", "5M", "4M"],
			zenheadbutt: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	snorunt: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["6E", "5E", "4M"],
			bide: ["6E", "5E", "4E"],
			bite: ["6L10", "5L10", "4L10", "3L10", "3S0"],
			blizzard: ["6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L43"],
			block: ["6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L31", "5L31", "4L31", "3L28"],
			disable: ["6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L4", "5M", "5L4", "4M", "4L4", "3M", "3L7"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			faketears: ["6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L37"],
			headbutt: ["6L19", "5L19", "4T", "4L19", "3L19"],
			hex: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M", "3L34"],
			icefang: ["6L28", "5L28", "4L28"],
			iceshard: ["6L37", "5L37", "4L37"],
			icywind: ["6L13", "5T", "5L13", "4T", "4L13", "3T", "3L16", "3S0"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powdersnow: ["6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["6E", "5E", "4T", "4E"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sing: ["3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spikes: ["6E", "5E", "4E", "3E"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			swagger: ["6M", "5M", "4M", "3T"],
			switcheroo: ["6E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["5D", "4M", "3M", "3S0"],
			weatherball: ["6E", "5E", "5D", "4E"],
		},
	},
	glalie: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			blizzard: ["6M", "6L51", "5M", "5L51", "4M", "4L51", "3M", "3L53"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L31", "5L31", "4L31", "3L28"],
			darkpulse: ["6M", "5T", "4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			hail: ["6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L42"],
			headbutt: ["6L19", "5L19", "4T", "4L19", "3L19"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L34"],
			icefang: ["6L28", "5L28", "4L28"],
			icywind: ["6L13", "5T", "5L13", "4T", "4L13", "3T", "3L16"],
			ironhead: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			sheercold: ["6L1", "5L59", "4L59", "3L61"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M", "3T"],
			taunt: ["6M", "5M", "4M", "3M"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	froslass: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L51", "5M", "5L51", "4M", "4L51"],
			block: ["5T", "4T"],
			captivate: ["6L31", "5L31", "4M", "4L31"],
			confide: ["6M"],
			confuseray: ["6L19", "5L19", "4L19"],
			destinybond: ["6L1", "5L59", "4L59"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			dreameater: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "6L40", "5M", "5L40", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			iceshard: ["6L37", "5L37", "4L37"],
			icywind: ["6L13", "5T", "5L13", "4T", "4L13"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["6L22", "5L22", "4T", "4L22"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			powdersnow: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			wakeupslap: ["6L28", "5L28", "4L28"],
			waterpulse: ["4M"],
		},
	},
	spheal: {
		inherit: true,
		learnset: {
			aquaring: ["6E", "5E", "4E"],
			aquatail: ["5T", "5D", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L25", "5L25", "4L25", "3L25", "3S0"],
			bellydrum: ["6E"],
			blizzard: ["6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			bodyslam: ["6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["6L17", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["6M"],
			curse: ["6E", "5E", "4E", "3E"],
			defensecurl: ["6L1", "5L1", "4L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L7", "5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fissure: ["6E", "5E", "5D", "4E", "3E"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			iceball: ["6L13", "5L13", "4L13", "3L13"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T", "3S0"],
			naturalgift: ["4M"],
			powdersnow: ["6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6E", "5E", "4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L49", "5L49", "4L49", "3L49"],
			signalbeam: ["6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["6L37", "5T", "5L37", "4T", "4L37", "3T", "3L37"],
			spitup: ["6E", "5E", "4E", "3E"],
			stockpile: ["6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swallow: ["6E", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			watersport: ["6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["6E", "5E", "4E", "3E"],
		},
	},
	sealeo: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L25", "5L25", "4L25", "3L25"],
			blizzard: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L47"],
			bodyslam: ["6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["6L17", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			defensecurl: ["6L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			iceball: ["6L13", "5L13", "4L13", "3L13"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L5", "4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L55", "5L55", "4L55", "3L55"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["6L39", "5T", "5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	walrein: {
		inherit: true,
		learnset: {
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			aurorabeam: ["6L25", "5L25", "4L25", "3L25"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L52", "5M", "5L52", "4M", "4L52", "3M", "3L50"],
			block: ["5T", "4T"],
			bodyslam: ["6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["6L19", "5S0", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L1", "5L1", "4L1"],
			defensecurl: ["6L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1", "3L1"],
			hail: ["6M", "6L31", "5M", "5L31", "5S0", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			iceball: ["6L13", "5L13", "4L13", "3L13"],
			icebeam: ["6M", "5M", "5S0", "4M", "3M"],
			icefang: ["6L44", "5L44", "4L44"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["6L1", "5L1", "4L1", "3L1"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["6L7", "4T", "3T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L65", "5L65", "5S0", "4L65", "3L61"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["6L39", "5T", "5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "6L32", "5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	clamperl: {
		inherit: true,
		learnset: {
			aquaring: ["6E", "5E", "5D", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			barrier: ["6E", "5E", "4E", "3E"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["6E", "5E", "4E", "3T", "3E"],
			brine: ["6E", "5E", "4M"],
			captivate: ["5D", "4M"],
			clamp: ["6L1", "5L1", "4L1", "3L1"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			mimic: ["3T"],
			muddywater: ["6E", "5E", "4E"],
			mudsport: ["6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["6E", "5E", "4E", "3E"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["6L50", "5L51"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6E", "5E", "4M", "3M"],
			whirlpool: ["6L1", "5L1", "5D", "4M", "4L1", "3L1"],
		},
	},
	huntail: {
		inherit: true,
		learnset: {
			aquatail: ["6L46", "5T", "5L46", "4T", "4L46"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L33", "5L33", "4L33", "3L43"],
			bind: ["5T"],
			bite: ["6L6", "5L6", "4L6", "3L8"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brine: ["6L28", "5L28", "4M", "4L28"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L42", "5L42", "4L42", "3L36"],
			dive: ["6M", "6L37", "5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L50", "5L51", "4L51", "3L50"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icefang: ["6L24", "5L24", "4L24"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L19", "5L19", "4L19", "3L29"],
			screech: ["6L10", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["5T", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["6L23", "4T"],
			superfang: ["5T", "4T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L15", "5L15", "4M", "4L15", "3M", "3L22"],
			whirlpool: ["6L1", "5L1", "4M", "4L1", "3L1"],
		},
	},
	gorebyss: {
		inherit: true,
		learnset: {
			agility: ["6L10", "5L10", "4L10", "3L15"],
			amnesia: ["6L19", "5L19", "4L19", "3L29"],
			aquaring: ["6L24", "5L24", "4L24"],
			aquatail: ["6L46", "5T", "5L46", "4T", "4L46"],
			attract: ["6M", "5M", "4M", "3M"],
			batonpass: ["6L33", "5L33", "4L33", "3L43"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			captivate: ["6L28", "5L28", "4M", "4L28"],
			confide: ["6M"],
			confusion: ["6L6", "5L6", "4L6", "3L8"],
			dive: ["6M", "6L37", "5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L50", "5L51", "4L51", "3L50"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			infestation: ["6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L42", "5M", "5L42", "4M", "4L42", "3M", "3L36"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L15", "5L15", "4M", "4L15", "3M", "3L22"],
			whirlpool: ["6L1", "5L1", "4M", "4L1", "3L1"],
		},
	},
	relicanth: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E", "4E", "3E"],
			ancientpower: ["6L1", "5L43", "4T", "4L43", "3L43"],
			aquatail: ["6E", "5T", "5E", "4T", "4E"],
			attract: ["6M", "5M", "4M", "3M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5T", "4T"],
			brine: ["6E", "5E", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			dive: ["6M", "6L57", "5M", "5L57", "4T", "4L57", "3M"],
			doubleedge: ["6L50", "5L50", "4L50", "3T", "3L57"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthpower: ["5T", "5D", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			harden: ["6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			headsmash: ["6L1", "5L78", "4L78"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L1", "5L71", "4L71", "3L64"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			magnitude: ["6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			muddywater: ["6E", "5E", "4E"],
			mudshot: ["6E", "5E"],
			mudslap: ["6E", "5E", "4T", "4E", "3T"],
			mudsport: ["6L1", "5L36", "4L36", "3L36"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L64", "5M", "5L64", "4M", "4L64", "3M", "3L50"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["6E", "5E", "4E", "3E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			smackdown: ["6M", "5M"],
			snore: ["6E", "5T", "5E", "4T", "4E", "3T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L29", "5L29", "4L29", "3L29"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L8", "5L8", "5D", "4L8", "3L8"],
			waterpulse: ["4M", "3M"],
			watersport: ["6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["6L22", "5L22", "4L22", "3L22"],
			zenheadbutt: ["6E", "5T", "5E"],
		},
	},
	luvdisc: {
		inherit: true,
		learnset: {
			agility: ["6L9", "5L9", "4L9", "3L16"],
			aquajet: ["6E", "5E", "4E"],
			aquaring: ["6L46", "6E", "5L46", "5E", "4L37", "4E"],
			attract: ["6M", "6L27", "5M", "5L27", "4M", "4L22", "3M", "3L28"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bounce: ["5T", "4T"],
			brine: ["6E", "5E", "4M"],
			captivate: ["6L50", "6E", "5L51", "5E", "4M", "4L40", "4E"],
			charm: ["6L4", "5L4", "5D", "4L4", "3L4"],
			confide: ["6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			entrainment: ["6E"],
			facade: ["6M", "5M", "4M", "3M"],
			flail: ["6L31", "5L31", "4L46", "3L40"],
			frustration: ["6M", "5M", "4M", "3M"],
			hail: ["6M", "5M", "4M", "3M"],
			healpulse: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L40", "5L40"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "5D", "4T", "3T"],
			luckychant: ["6L17", "5L17", "4L17"],
			mimic: ["3T"],
			mudsport: ["6E", "5E", "5D", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L55", "5M", "5L55", "4M", "4L51", "3M", "3L48"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			splash: ["6E", "5E", "4E", "3E"],
			substitute: ["6M", "5M", "4M", "3T"],
			supersonic: ["6E", "5E", "4E", "3E"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			sweetkiss: ["6L37", "5L37", "4L27", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["6L1", "5L1", "4L1", "3L1"],
			takedown: ["6L14", "5L14", "4L14", "3L24"],
			toxic: ["6M", "5M", "4M", "3M"],
			waterfall: ["6M", "5M", "4M", "3M"],
			watergun: ["6L7", "5L7", "4L7", "3L12"],
			waterpulse: ["6L22", "5L22", "4M", "4L31", "3M"],
			watersport: ["6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	bagon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L5", "5L5", "5D", "4L5", "3L5", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L46", "5L46", "4L46", "3L41"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["6E", "5E"],
			doubleedge: ["6L55", "5L55", "4L55", "3T", "3L53"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L31", "5L31", "4L31", "3L33"],
			dragonclaw: ["6M", "6L50", "5M", "5L50", "4M", "4L50", "3M", "3L49"],
			dragondance: ["6E", "5E", "5D", "4E", "3E"],
			dragonpulse: ["6E", "5T", "5E", "4M"],
			dragonrage: ["6E", "5E", "4E", "3E"],
			dragonrush: ["6E", "5E", "4E"],
			ember: ["6L25", "5L25", "4L25", "3L25"],
			endure: ["6E", "5E", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			firefang: ["6E", "5E", "4E"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L20", "5L20", "4L20", "3L21"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["6L16", "5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6E", "5E", "4E", "3E"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["3S1"],
			leer: ["6L10", "5L10", "4L10", "3L9"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "5D", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			rage: ["6L1", "6S3", "5L1", "5S2", "4L1", "3L1", "3S0", "3S1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			scaryface: ["6L40", "5L40", "4L40", "3L37"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M", "4E"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			thrash: ["6E", "6S3", "5E", "4E", "3E"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6E", "5E", "4T", "4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["6L35", "5T", "5L35", "4T", "4L35"],
		},
	},
	shelgon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L50", "5L50", "4L50", "3L56"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["6L61", "5L61", "4L61", "3T", "3L78"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L32", "5L32", "4L32", "3L38"],
			dragonclaw: ["6M", "6L55", "5M", "5L55", "4M", "4L55", "3M", "3L69"],
			dragonpulse: ["5T", "4M"],
			ember: ["6L25", "5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			focusenergy: ["6L20", "5L20", "4L20", "3L21"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "6L30", "5M", "5L30", "4M", "4L30", "3M", "3L30"],
			rage: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			scaryface: ["6L43", "5L43", "4L43", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	salamence: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "5S3", "4M", "3M", "3S1"],
			aircutter: ["4T"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M", "3M"],
			bite: ["6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L53", "5L53", "4L53", "3L61"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["6L1", "5L70", "4L70", "3T", "3L93"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L32", "5L32", "4L32", "3L38", "3S0"],
			dragonclaw: ["6M", "6L61", "5M", "5L61", "5S3", "4M", "4L61", "4S2", "3M", "3L79", "3S1"],
			dragondance: ["5S3", "3S1"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "6L80", "5M", "5L80"],
			earthquake: ["6M", "5M", "4M", "3M"],
			ember: ["6L25", "5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "4S2", "3M"],
			firefang: ["6L1", "5L1", "4L1"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "6L50", "5M", "5L50", "4M", "4L50", "3M", "3L50", "3S0"],
			focusenergy: ["6L20", "5L20", "4L20", "3L21"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["6L1", "5L1", "4T", "4L1", "3L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["4S2"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			hypervoice: ["5T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M", "3M"],
			leer: ["6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5T", "5S3", "4T"],
			protect: ["6M", "6L30", "5M", "5L30", "4M", "4L30", "3M", "3L30", "3S0"],
			rage: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L43", "5L43", "4L43", "3L47", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			steelwing: ["6M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			thunderfang: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	beldum: {
		inherit: true,
		learnset: {
			headbutt: ["4T"],
			irondefense: ["6S0", "5T", "4T"],
			ironhead: ["6S0", "5T", "5D", "4T"],
			takedown: ["6L1", "5L1", "5D", "4L1", "3L1"],
			zenheadbutt: ["6S0", "5T", "5D", "4T"],
		},
	},
	metang: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L38", "5L44", "4L44", "3L56"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6L32", "5L32", "4L32"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L20", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L50", "5M", "5L56", "4M", "4L56", "3M", "3L62"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L47", "5T", "5L40", "4T", "4L40", "3L44"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magnetrise: ["6L1", "5T", "5L1", "4T", "4L1"],
			metalclaw: ["6L1", "5L1", "4L1", "3L20", "3S0"],
			meteormash: ["6L44", "5L48", "4L48", "3L50"],
			mimic: ["3T"],
			miracleeye: ["6L26", "5L26"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L41", "5M", "5L36", "4M", "4L36", "3M", "3L38"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			pursuit: ["6L23", "5L28", "4L28", "3L32"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L35", "5L24", "4L24", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			zenheadbutt: ["6L29", "5T", "5L52", "4T", "4L52"],
		},
	},
	metagross: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L38", "5L44", "5S4", "4L44", "3L66"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6L32", "5L32", "5S1", "5S2", "4L32", "4S0"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "3L1"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5S4", "5S5", "3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "5S1", "5S3", "5S6", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "5M", "4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			hammerarm: ["6L45", "5L45", "5S1", "5S2", "5S4", "5S5", "4L45", "4S0"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L62", "5M", "5L71", "5S6", "4M", "4L71", "3M", "3L77"],
			icepunch: ["5T", "5S2", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L53", "5T", "5L40", "5S4", "4T", "4L40", "3L44"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magnetrise: ["6L1", "5T", "5L1", "4T", "4L1"],
			metalclaw: ["6L1", "5L1", "4L1", "3L1"],
			meteormash: ["6L44", "5L53", "5S1", "5S3", "5S5", "5S6", "4L53", "4S0", "3L55"],
			mimic: ["3T"],
			miracleeye: ["6L26", "5L26"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "5S3", "4M", "3M"],
			psychic: ["6M", "6L41", "5M", "5L36", "5S5", "5S6", "4M", "4L36", "3M", "3L38"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			pursuit: ["6L23", "5L28", "4L28", "3L32"],
			raindance: ["6M", "5M", "4M", "3M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L35", "5L24", "4L24", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			sludgebomb: ["6M", "5M", "4M", "3M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderpunch: ["5T", "4T", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			zenheadbutt: ["6L29", "5T", "5L62", "5S2", "5S3", "4T", "4L62", "4S0"],
		},
	},
	regirock: {
		inherit: true,
		learnset: {
			ancientpower: ["6L33", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6S4", "5M"],
			chargebeam: ["6M", "6L49", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			drainpunch: ["5T", "4M"],
			dynamicpunch: ["3T"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L1", "6S5", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hammerarm: ["6L1", "6S5", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L89", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["6S5", "5T", "4T", "3T"],
			irondefense: ["6L41", "6S4", "5T", "5L41", "5S3", "4L41", "3L41"],
			ironhead: ["5T", "4T"],
			lockon: ["6L1", "5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["6L9", "5L9", "4L9", "4S2", "3L9", "3S0"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L1", "5L1", "4L1", "4S2"],
			stoneedge: ["6M", "6L73", "6S5", "5M", "5L73", "4M", "4L73"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			zapcannon: ["6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	regice: {
		inherit: true,
		learnset: {
			amnesia: ["6L41", "6S4", "6S5", "5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["6L33", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "6S4", "5M"],
			chargebeam: ["6M", "6L49", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hail: ["6M", "6S5", "5M", "4M", "3M"],
			hammerarm: ["6L1", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L89", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icebeam: ["6M", "6L73", "6S5", "5M", "5L73", "4M", "4L73", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["6L9", "5T", "5L9", "4T", "4L9", "4S2", "3T", "3L9", "3S0"],
			ironhead: ["5T", "4T"],
			lockon: ["6L1", "5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stomp: ["6L1", "5L1", "4L1", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			superpower: ["6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "6S5", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			zapcannon: ["6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	registeel: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			amnesia: ["6L41", "6S4", "5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["6L33", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			chargebeam: ["6M", "6L49", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["6M"],
			counter: ["3T"],
			curse: ["6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "6L73", "5M", "5L73", "4M", "4L73"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["6S5", "5T", "4T"],
			hammerarm: ["6L1", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L89", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["5T", "4T", "3T"],
			irondefense: ["6L41", "6S4", "6S5", "5T", "5L41", "4T", "4L41", "3L41"],
			ironhead: ["6L1", "6S5", "5T", "5L73", "4T", "4L73"],
			lockon: ["6L1", "5L57", "5S3", "4L57", "3L57"],
			magnetrise: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["6L9", "5L9", "4L9", "4S2", "3L9", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6S5", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6L1", "5L1", "4L1", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			zapcannon: ["6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L1", "5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L20", "6S6", "5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["6L1", "5T", "5L80", "4M", "4L70"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			guardsplit: ["6L1", "5L75"],
			healingwish: ["6L1", "5L85", "4L60"],
			healpulse: ["6L1", "6S6", "5L65", "5S5"],
			helpinghand: ["6L10", "5T", "5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mimic: ["3T"],
			mistball: ["6L35", "6S6", "5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L60", "5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["6L50", "6S6", "5L50", "5S5", "4L50"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			psywave: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L45", "5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["6M", "5M", "4M", "3M"],
			reflecttype: ["6L1", "5L70"],
			refresh: ["6L30", "5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["6L25", "5L25", "4L25", "4S3", "4S4", "3L25", "3S0"],
			whirlpool: ["4M"],
			wish: ["6L5", "5L5", "4L5", "3L5"],
			zenheadbutt: ["6L40", "5T", "5L40", "4T", "4L40", "4S4"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			attract: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6L20", "6S6", "5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragondance: ["6L1", "5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			dragonpulse: ["6L1", "6S7", "5T", "5L80", "4M", "4L70"],
			dreameater: ["6M", "5M", "4M", "3T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			healblock: ["6L5", "5L5", "4L5"],
			healpulse: ["6L1", "6S6", "6S7", "5L65", "5S5"],
			helpinghand: ["6L10", "5T", "5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lusterpurge: ["6L35", "6S6", "6S7", "5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			magiccoat: ["5T", "4T"],
			memento: ["6L1", "5L85", "4L60", "3L5"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			powersplit: ["6L1", "5L75"],
			protect: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "4S3", "4S4", "3M", "3L25", "3S0"],
			psychic: ["6M", "6L60", "6S7", "5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["6L50", "6S6", "5L50", "5S5", "4L50"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			psywave: ["6L1", "5L1", "4L1", "3L1"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L45", "5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["6L30", "5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			steelwing: ["6M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["6L1", "5M", "5L70"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["6L40", "5T", "5L40", "4T", "4L40", "4S4"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["6L45", "5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			aquaring: ["6L30", "6S5", "5L30", "4L30", "4S2"],
			aquatail: ["6L65", "5T", "5L65", "4T", "4L65"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M", "3M"],
			block: ["5T", "4T"],
			bodyslam: ["6L15", "6S5", "5L15", "4L15", "3T", "3L20", "3S0"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L60", "5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			confide: ["6M"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["6L80", "5L80", "4L65", "3T", "3L65", "3S1"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			earthquake: ["6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["6M", "5M", "4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hydropump: ["6L90", "5L90", "4L45", "3L45", "3S0", "3S1"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icebeam: ["6M", "6L35", "6S5", "6S6", "5M", "5L35", "5S3", "5S4", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			icywind: ["5T", "4T", "3T"],
			ironhead: ["5T", "4T"],
			mimic: ["3T"],
			muddywater: ["6L20", "5L20", "4L20"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "4L50", "3M", "3L50", "3S1"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			scald: ["6M", "5M"],
			scaryface: ["6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["6L75", "6S6", "5L75", "5S4", "4L60", "3L60", "3S1"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["6M", "6S6", "5M", "5S3", "5S4", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["6L1", "5L1", "4M", "4L1", "3M", "3L1"],
			waterspout: ["6L50", "6S6", "5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			whirlpool: ["4M"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["6L45", "5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			block: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "6L60", "5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dragonclaw: ["6M", "5M", "4M", "3M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["6L65", "5T", "5L65", "5S4", "4T", "4L65"],
			earthquake: ["6M", "6L35", "6S5", "5M", "5L35", "5S3", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["6L50", "5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "6L90", "5M", "5L90", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			firepunch: ["6S6", "5T", "4T", "3T"],
			fissure: ["6L75", "5L75", "4L60", "3L60", "3S1"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			hammerarm: ["6L20", "6S6", "5L20", "5S4", "4L20"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			lavaplume: ["6L15", "6S5", "5L15", "4L15"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudshot: ["6L1", "5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			rest: ["6M", "6L30", "6S5", "5M", "5L30", "4M", "4L30", "4S2", "3M", "3L50", "3S1"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "6S6", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L20", "3L20", "3S0"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "6L80", "6S6", "5M", "5L80", "5S3", "5S4", "4M", "4L65", "3M", "3L65", "3S1"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M", "3T"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			uproar: ["5T", "4T"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			airslash: ["6L35", "5L35", "4L35", "4S1"],
			ancientpower: ["6L45", "5L45", "5S2", "4T", "4L15", "4S1", "3L15"],
			aquatail: ["5T", "4T"],
			avalanche: ["4M"],
			bind: ["5T"],
			blizzard: ["6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			bulkup: ["6M", "5M", "4M", "3M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L15", "5L15", "4L15", "3L35"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["6T", "6S7", "5T", "4T"],
			dragonclaw: ["6M", "6S6", "5M", "4M", "4L20", "3M", "3L20"],
			dragondance: ["6L60", "6S4", "6S6", "5L60", "5S2", "4L30", "3L30"],
			dragonpulse: ["6L90", "6S4", "6S5", "5T", "5L90", "5S2", "5S3", "4M", "4L75"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M", "3M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			extremespeed: ["6L75", "6S4", "6S5", "6S6", "5L75", "5S3", "4L60", "3L60", "3S0"],
			facade: ["6M", "5M", "4M", "3M"],
			fireblast: ["6M", "5M", "4M", "3M"],
			flamethrower: ["6M", "5M", "4M", "3M"],
			fling: ["6M", "5M", "4M"],
			fly: ["6M", "6L65", "6S7", "5M", "5L65", "4M", "4L45", "3M", "3L45", "3S0"],
			focusblast: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["6M", "5M", "4M"],
			gyroball: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L80", "5M", "5L80", "5S3", "4M", "4L65", "3M", "3L75"],
			hypervoice: ["6L20", "5T", "5L20", "4L20"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icywind: ["5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6L50", "5T", "5L50", "5S2", "4T", "4L50", "4S1", "3L65", "3S0"],
			overheat: ["6M", "5M", "4M", "3M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychup: ["6M", "5M", "4M", "3T"],
			raindance: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "6L30", "5M", "5L30", "4M", "4L30", "4S1", "3M", "3L50", "3S0"],
			return: ["6M", "5M", "4M", "3M"],
			roar: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			scaryface: ["6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M", "3M"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			surf: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["6M", "5M", "4M"],
			tailwind: ["5T", "4T"],
			thunder: ["6M", "6S5", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			twister: ["6L1", "6S5", "5L1", "4T", "4L1", "3L1"],
			uproar: ["5T", "4T"],
			vcreate: ["5S3"],
			waterfall: ["6M", "5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	jirachi: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			bodyslam: ["3T"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "6S10", "6S12", "6S13", "5L1", "4L1", "4S3", "4S4", "3L1", "3S0", "3S1"],
			cosmicpower: ["6L60", "6S11", "5L60", "5S7", "4L60", "3L45"],
			dazzlinggleam: ["6M"],
			defensecurl: ["3T"],
			doomdesire: ["6L70", "5L70", "4L70", "3L50"],
			doubleedge: ["6L40", "5L40", "4L40", "3T", "3L35"],
			doubleteam: ["6M", "5M", "4M", "3M"],
			dracometeor: ["5S6", "4S4"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			followme: ["5S6"],
			frustration: ["6M", "5M", "4M", "3M"],
			futuresight: ["6L55", "5L55", "4L55", "3L40"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6L45", "5T", "5L45", "4T", "4L45"],
			headbutt: ["4T"],
			healingwish: ["6L50", "6S9", "5L50", "5S5", "5S7", "5S8", "4L50"],
			helpinghand: ["6L15", "6S10", "5T", "5L15", "4T", "4L15", "3L15", "3S2"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			lastresort: ["6L65", "5T", "5L65", "4T", "4L65"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			meteormash: ["5S5", "5S6", "5S7"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonblast: ["6S9"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L20", "5M", "5L20", "5S5", "4M", "4L20", "3M", "3L20", "3S2"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M", "3M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			refresh: ["6L25", "5L25", "4L25", "3L25", "3S2"],
			rest: ["6M", "6L5", "6S13", "5M", "5L5", "4M", "4L5", "4S3", "4S4", "3M", "3L5", "3S0", "3S1", "3S2"],
			return: ["6M", "6S10", "5M", "5S8", "4M", "3M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			sandstorm: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snore: ["5T", "4T", "3T"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L10", "6S9", "6S12", "5L10", "5S5", "5S8", "4T", "4L10", "3T", "3L10"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			wish: ["6L1", "6S9", "6S10", "6S11", "6S12", "6S13", "5L1", "5S6", "5S7", "5S8", "4L1", "4S3", "4S4", "3L1", "3S0", "3S1"],
			zenheadbutt: ["6L35", "5T", "5L35", "4T", "4L35"],
		},
	},
	deoxys: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M", "3M"],
			agility: ["6L73", "5L73", "4L73", "3L35"],
			allyswitch: ["5M"],
			amnesia: ["6L73", "5L73", "4L73", "3L35"],
			avalanche: ["4M"],
			bind: ["5T"],
			bodyslam: ["3T"],
			brickbreak: ["6M", "5M", "4M", "3M"],
			calmmind: ["6M", "5M", "4M", "3M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cosmicpower: ["6L73", "6S10", "5L73", "4L73", "3L35", "3S3"],
			counter: ["6L97", "5L97", "4L97", "4S6", "3T", "3L50"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["6M", "5S9"],
			detect: ["4S6"],
			doubleedge: ["3T"],
			doubleteam: ["6M", "6L17", "5M", "5L17", "4M", "4L17", "4S5", "3M", "3L10"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["6M", "5M", "4M"],
			extremespeed: ["6L97", "5L97", "4L97", "4S4", "4S5", "3L50"],
			facade: ["6M", "5M", "4M", "3M"],
			firepunch: ["5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["6M", "5M", "4M", "3M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M", "3M"],
			hyperbeam: ["6M", "6L97", "6S10", "5M", "5L97", "4M", "4L97", "4S7", "3M", "3L50", "3S3"],
			icebeam: ["6M", "5M", "4M", "3M"],
			icepunch: ["5T", "4T", "3T"],
			icywind: ["5T", "4T", "3T"],
			irondefense: ["6L73", "5T", "5L73", "4T", "4L73", "4S4", "3L35"],
			knockoff: ["6L25", "5T", "5L25", "4T", "4L25", "3L15", "3S1", "3S2"],
			leer: ["6L1", "5L1", "4L1", "4S8", "3L1"],
			lightscreen: ["6M", "5M", "4M", "3M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["4S7"],
			mimic: ["3T"],
			mirrorcoat: ["6L97", "5L97", "4L97", "4S6", "3L50"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5S9"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["6L9", "5L9", "4L9", "4S8", "3L5"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M", "3M"],
			psychic: ["6M", "6L41", "5M", "5L41", "4M", "4L41", "3M", "3L25", "3S0", "3S1", "3S2"],
			psychoboost: ["6L89", "6S10", "5L89", "5S9", "4L89", "4S4", "4S5", "4S6", "4S7", "4S8", "3L45", "3S3"],
			psychoshift: ["6L57", "5L57", "4L57"],
			psychup: ["6M", "5M", "4M", "3T"],
			psyshock: ["6M", "5M"],
			pursuit: ["6L33", "5L33", "4L33", "3L20", "3S0", "3S2"],
			raindance: ["6M", "5M", "4M", "3M"],
			recover: ["6L81", "6S10", "5L81", "5S9", "4L81", "3L40", "3S3"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M", "3M"],
			rest: ["6M", "5M", "4M", "3M"],
			return: ["6M", "5M", "4M", "3M"],
			rockslide: ["6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["6M", "5M", "4M", "3M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["6M", "5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M", "3M"],
			sleeptalk: ["6M", "5T", "4M", "3T"],
			snatch: ["6L49", "5T", "5L49", "4M", "4L49", "3M", "3L30", "3S1"],
			snore: ["5T", "4T", "3T"],
			solarbeam: ["6M", "5M", "4M", "3M"],
			spikes: ["6L33", "5L33", "4L33", "3L20", "3S1"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["6M", "5M", "4M", "3T"],
			sunnyday: ["6M", "5M", "4M", "3M"],
			superpower: ["6L49", "5L49", "4T", "4L49", "4S7", "3S0"],
			swagger: ["6M", "5M", "4M", "3T"],
			swift: ["6L49", "5L49", "4T", "4L49", "4S5", "3T", "3L30", "3S2"],
			taunt: ["6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L15", "3S0"],
			telekinesis: ["5M"],
			teleport: ["6L17", "5L17", "4L17", "3L10"],
			thunder: ["6M", "5M", "4M", "3M"],
			thunderbolt: ["6M", "5M", "4M", "3M"],
			thunderpunch: ["5T", "4T", "3T"],
			thunderwave: ["6M", "5M", "4M", "3T"],
			torment: ["6M", "5M", "4M", "3M"],
			toxic: ["6M", "5M", "4M", "3M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			waterpulse: ["4M", "3M"],
			wonderroom: ["5T"],
			wrap: ["6L1", "5L1", "4L1", "4S8", "3L1"],
			zapcannon: ["6L81", "5L81", "4L81", "4S4", "3L40"],
			zenheadbutt: ["6L65", "5T", "5L65", "4T", "4L65"],
		},
	},
	turtwig: {
		inherit: true,
		learnset: {
			absorb: ["6L9", "5L9", "5S0", "5S1", "4L9"],
			amnesia: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			bite: ["6L21", "5L21", "4L21"],
			bodyslam: ["6E", "5E", "4E"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L37", "5L37", "4L37"],
			curse: ["6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["6E", "5T", "5E", "4T"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["6L41", "5T", "5L41", "4M", "4L41"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			grassyterrain: ["6E"],
			growth: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			irontail: ["5T", "4M"],
			leafstorm: ["6L45", "5L45", "4L45"],
			leechseed: ["6L29", "5L29", "4L29"],
			lightscreen: ["6M", "5M", "4M"],
			megadrain: ["6L25", "5L25", "4L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M"],
			razorleaf: ["6L13", "5L13", "4L13"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandtomb: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			spitup: ["6E", "5E", "4E"],
			stealthrock: ["5T", "4M"],
			stockpile: ["6E", "5E", "5S1", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["6E", "5T", "5E", "4T", "4E"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6E", "5E", "4E"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6L33", "5T", "5L33", "4T", "4L33"],
			tackle: ["6L1", "5L1", "5S0", "5S1", "4L1"],
			thrash: ["6E", "5E", "4E"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M"],
			wideguard: ["6E", "5E"],
			withdraw: ["6L5", "5L5", "5S0", "5S1", "4L5"],
			worryseed: ["6E", "5T", "5E", "4T", "4E"],
		},
	},
	grotle: {
		inherit: true,
		learnset: {
			absorb: ["6L9", "5L9", "4L9"],
			attract: ["6M", "5M", "4M"],
			bite: ["6L22", "5L22", "4L22"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L42", "5L42", "4L42"],
			curse: ["6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["6L47", "5T", "5L47", "4M", "4L47"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			irontail: ["5T", "4M"],
			leafstorm: ["6L52", "5L52", "4L52"],
			leechseed: ["6L32", "5L32", "4L32"],
			lightscreen: ["6M", "5M", "4M"],
			megadrain: ["6L27", "5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M"],
			razorleaf: ["6L13", "5L13", "4L13"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6L37", "5T", "5L37", "4T", "4L37"],
			tackle: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M"],
			withdraw: ["6L1", "5L1", "4L1"],
			worryseed: ["5T", "4T"],
		},
	},
	torterra: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			bite: ["6L22", "5L22", "4L22"],
			block: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L45", "5L45", "4L45"],
			curse: ["6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L32", "5M", "5L32", "5S0", "4M", "4L32"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frenzyplant: ["6T", "5T", "4T"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["6L51", "5T", "5L51", "4M", "4L51"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasspledge: ["6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			leafstorm: ["6L57", "5L57", "4L57"],
			leechseed: ["6L33", "5L33", "4L33"],
			lightscreen: ["6M", "5M", "4M"],
			megadrain: ["6L27", "5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			outrage: ["5T", "5S0", "4T"],
			protect: ["6M", "5M", "4M"],
			razorleaf: ["6L1", "5L1", "4L1"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "5S0", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6L39", "5T", "5L39", "4T", "4L39"],
			tackle: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M"],
			withdraw: ["6L1", "5L1", "4L1"],
			woodhammer: ["6L1", "5L1", "5S0", "4L1"],
			worryseed: ["5T", "4T"],
		},
	},
	chimchar: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L39", "5M", "5L39"],
			aerialace: ["6M", "5M", "4M"],
			assist: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			blazekick: ["6E", "5E", "4E"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doublekick: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			ember: ["6L7", "5L7", "5S1", "5S3", "4L7"],
			encore: ["6E", "5E", "4E"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "6L31", "5M", "5L31", "4M", "4L31"],
			fakeout: ["6E", "5E", "5S3", "4E"],
			fireblast: ["6M", "5M", "4M"],
			firepledge: ["6T", "5T"],
			firepunch: ["6E", "5T", "5E", "4T", "4E"],
			firespin: ["6L33", "5L33", "4L33"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L47", "5M", "5L47", "4M", "4L41", "4S0", "4S2"],
			flamewheel: ["6L17", "5L17", "4L17"],
			fling: ["6M", "5M", "4M"],
			focusenergy: ["6E", "5E", "4E"],
			focuspunch: ["6E", "5E", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyswipes: ["6L15", "5L15", "4L15"],
			grassknot: ["6M", "5M", "4M", "4S0", "4S2"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["6E", "5T", "5E", "4T", "4E"],
			helpinghand: ["6E", "5T", "5E", "4T", "4E", "4S0", "4S2"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "5S1", "5S3", "4L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["6L23", "5L23", "4L23"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			quickguard: ["6E", "5E"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "5S1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slackoff: ["6L41", "5L41", "4L39"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			submission: ["6E", "5E"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L9", "5M", "5L9", "5S1", "5S3", "4M", "4L9"],
			thunderpunch: ["6E", "5T", "5E", "4T", "4E", "4S0", "4S2"],
			torment: ["6M", "6L25", "5M", "5L25", "4M", "4L25"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	monferno: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L46", "5M", "5L46"],
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			captivate: ["4M"],
			closecombat: ["6L36", "5L36", "4L36"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dualchop: ["5T"],
			ember: ["6L1", "5L1", "4L1"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L26", "5L26", "4L26"],
			fireblast: ["6M", "5M", "4M"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T", "4T"],
			firespin: ["6L39", "5L39", "4L39"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M"],
			flamewheel: ["6L19", "5L19", "4L19"],
			flareblitz: ["6L56", "5L56", "4L49"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furyswipes: ["6L16", "5L16", "4L16"],
			grassknot: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slackoff: ["6L49", "5L49", "4L46"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L9", "5M", "5L9", "4M", "4L9"],
			thunderpunch: ["5T", "4T"],
			torment: ["6M", "6L29", "5M", "5L29", "4M", "4L29"],
			toxic: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	infernape: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L52", "5M", "5L52"],
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			blastburn: ["6T", "5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "6L58", "5M", "5L58", "4M", "4L53"],
			captivate: ["4M"],
			closecombat: ["6L36", "6S1", "5L36", "5S0", "4L41"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			ember: ["6L1", "5L1", "4L1"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L26", "5L26", "4L29"],
			fireblast: ["6M", "6S1", "5M", "5S0", "4M"],
			firepledge: ["6T", "5T"],
			firepunch: ["6S1", "5T", "4T"],
			firespin: ["6L42", "5L42", "4L45"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M"],
			flamewheel: ["6L19", "5L19", "4L21"],
			flareblitz: ["6L1", "5L68", "4L57"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["6S1", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyswipes: ["6L16", "5L16", "4L17"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "5S0", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			punishment: ["6L29", "5L29", "4L33"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thunderpunch: ["5T", "4T"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "5S0", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	piplup: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			agility: ["6E", "5E", "4E"],
			aquaring: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			bide: ["6L22", "6E", "5L22", "5E", "4L18"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["6L29", "5L29", "4M", "4L29"],
			bubble: ["6L8", "5L8", "5S0", "5S3", "4L8"],
			bubblebeam: ["6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			drillpeck: ["6L39", "5L39", "4L39"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			featherdance: ["6E", "5E", "5S1", "5S2", "5S3", "4E"],
			flail: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6L25", "5L25", "4L25"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L4", "6S4", "5L4", "5S0", "5S3", "4L4"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hydropump: ["6L43", "6E", "5L43", "5E", "5S1", "4L43", "4E"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["6E", "5T", "5E", "4T"],
			mist: ["6L36", "5L36", "4L36"],
			mudslap: ["6E", "5E", "4T", "4E"],
			mudsport: ["6E", "5E", "4E"],
			naturalgift: ["4M"],
			peck: ["6L15", "5L15", "5S1", "5S2", "4L15"],
			pluck: ["5M", "4M"],
			pound: ["6L1", "6S4", "5L1", "5S0", "5S3", "4L1"],
			protect: ["6M", "5M", "4M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "6S4", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M", "5S2"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["5T", "4T"],
			sing: ["5S2"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["6E", "5T", "5E", "4T", "4E"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			supersonic: ["6E", "5E", "4E"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M"],
			watersport: ["6L11", "5L11", "5S1", "4L11"],
			whirlpool: ["6L32", "5L32", "4M", "4L32"],
			yawn: ["6E", "5E", "4E"],
		},
	},
	prinplup: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			bide: ["6L24", "5L24", "4L19"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["6L33", "5L33", "4M", "4L33"],
			bubble: ["6L8", "5L8", "4L8"],
			bubblebeam: ["6L19", "5L19", "4L19"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			drillpeck: ["6L46", "5L46", "4L46"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6L28", "5L28", "4L28"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L50", "5L51", "4L51"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			metalclaw: ["6L16", "5L16", "4L16"],
			mist: ["6L42", "5L42", "4L42"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["6L15", "5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M"],
			watersport: ["6L11", "5L11", "4L11"],
			whirlpool: ["6L37", "5L37", "4M", "4L37"],
		},
	},
	empoleon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aquajet: ["6L36", "5L36", "5S0", "4L36"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["6L33", "5L33", "4M", "4L33"],
			bubble: ["6L1", "5L1", "4L1"],
			bubblebeam: ["6L19", "5L19", "4L19"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			drillpeck: ["6L52", "5L52", "4L52"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6L28", "5L28", "4L28"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "5S0", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["6T", "5T", "4T"],
			hydropump: ["6L59", "5L59", "5S0", "4L59"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "5S0", "4M"],
			icywind: ["5T", "4T"],
			irondefense: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			metalclaw: ["6L16", "5L16", "4L16"],
			mist: ["6L46", "5L46", "4L46"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["6L15", "5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			steelwing: ["6M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "6L24", "5M", "5L24", "4M", "4L19"],
			swordsdance: ["6M", "6L11", "5M", "5L11", "4M", "4L11"],
			tackle: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["4M"],
			whirlpool: ["6L39", "5L39", "4M", "4L39"],
		},
	},
	starly: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L25", "5M", "5L25", "4M", "4L25"],
			agility: ["6L33", "5L33", "4L33"],
			aircutter: ["4T"],
			astonish: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			bravebird: ["6L37", "5L37", "4L37"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			detect: ["6E", "5E"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L17", "5T", "5L17", "4T", "4L17"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			featherdance: ["6E", "5E", "4E"],
			finalgambit: ["6L41", "5L41"],
			fly: ["6M", "5M", "4M"],
			foresight: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6E", "5E", "4E"],
			growl: ["6L1", "5L1", "4L1", "4S0"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			mirrormove: ["6E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6E", "5E", "4E"],
			quickattack: ["6L5", "5L5", "4L5"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6E", "5E"],
			roost: ["6M", "6E", "5T", "5E", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			steelwing: ["6M", "6E", "5E", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1", "4S0"],
			tailwind: ["5T", "4T"],
			takedown: ["6L29", "5L29", "4L29"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6E", "5E"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L21", "5L21", "4L21"],
			wingattack: ["6L9", "5L9", "4L9"],
			workup: ["5M"],
		},
	},
	staravia: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L28", "5M", "5L28", "4M", "4L28"],
			agility: ["6L38", "5L38", "4L38"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M"],
			bravebird: ["6L43", "5L43", "4L43"],
			captivate: ["4M"],
			confide: ["6M"],
			defog: ["4M"],
			doubleteam: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L18", "5T", "5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			featherdance: ["5D"],
			finalgambit: ["6L48", "5L48"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			steelwing: ["6M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			tailwind: ["5T", "5D", "4T"],
			takedown: ["6L33", "5L33", "4L33"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L23", "5L23", "4L23"],
			wingattack: ["6L9", "5L9", "5D", "4L9"],
			workup: ["5M"],
		},
	},
	staraptor: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L28", "5M", "5L28", "4M", "4L28"],
			agility: ["6L41", "5L41", "4L41"],
			aircutter: ["4T"],
			attract: ["6M", "5M", "4M"],
			bravebird: ["6L49", "5L49", "4L49"],
			captivate: ["4M"],
			closecombat: ["6L34", "5L34", "4L34"],
			confide: ["6M"],
			defog: ["4M"],
			doubleteam: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L18", "5T", "5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			finalgambit: ["6L57", "5L57"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			skyattack: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			steelwing: ["6M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			tailwind: ["5T", "4T"],
			takedown: ["6L33", "5L33", "4L33"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			whirlwind: ["6L23", "5L23", "4L23"],
			wingattack: ["6L1", "5L1", "4L1"],
			workup: ["5M"],
		},
	},
	bidoof: {
		inherit: true,
		learnset: {
			amnesia: ["6L29", "5L29", "4L29"],
			aquatail: ["6E", "5T", "5E", "5D", "4T", "4E"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			curse: ["6L45", "5L45", "4L45"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6L9", "6E", "5L9", "5E", "4L9", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["6E", "5E", "4M"],
			facade: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6E", "5E", "4E"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L5", "5L5", "4L5"],
			headbutt: ["6L17", "5L17", "4T", "4L17"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperfang: ["6L21", "5L21", "4L21"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			irontail: ["5T", "4M"],
			lastresort: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["6E", "5E", "4E"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["6E", "5E"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["6L13", "6E", "5L13", "5E", "4T", "4L13", "4E"],
			round: ["6M", "5M"],
			secretpower: ["6M", "5D", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			skullbash: ["6E", "5E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["6L37", "5T", "5L37", "4T", "4L37"],
			superpower: ["6L41", "5T", "5L41", "4T", "4L41"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "5D", "4L1", "4S0"],
			takedown: ["6L33", "5L33", "4L33"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			watersport: ["6E", "5E", "4E"],
			workup: ["5M"],
			yawn: ["6L25", "5L25", "4L25"],
		},
	},
	bibarel: {
		inherit: true,
		learnset: {
			amnesia: ["6L33", "5L33", "4L33"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			covet: ["5T"],
			curse: ["6L53", "5L53", "4L53"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6L9", "5L9", "4L9"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			headbutt: ["6L18", "5L18", "4T", "4L18"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hyperfang: ["6L23", "5L23", "4L23"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			irontail: ["5T", "4M"],
			lastresort: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["6L13", "5L13", "4T", "4L13"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["6L43", "5T", "5L43", "4T", "4L43"],
			superpower: ["6L48", "5T", "5L48", "4T", "4L48"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L38", "5L38", "4L38"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			watergun: ["6L15", "5L15", "4L15"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			yawn: ["6L28", "5L28", "4L28"],
		},
	},
	kricketot: {
		inherit: true,
		learnset: {
			bide: ["6L1", "5L1", "4L1"],
			bugbite: ["6L16", "5T", "5L16", "4T", "4L16"],
			endeavor: ["5T", "5D", "4T"],
			growl: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			snore: ["5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "6L6", "5L6", "5D"],
			uproar: ["5T", "5D", "4T"],
		},
	},
	kricketune: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			bide: ["6L1", "5L1", "4L1"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["5T", "4T"],
			bugbuzz: ["6L46", "5L46", "4L34"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "5M", "4M"],
			fellstinger: ["6L36"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["6L22", "5L22", "4L22"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["6L10", "5L10", "4T", "4L10"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			healbell: ["5T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			infestation: ["6M"],
			knockoff: ["5T", "4T"],
			leechlife: ["6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L42", "5L42", "4L42"],
			perishsong: ["6L50", "5L50", "4L38"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			screech: ["6L34", "5L34", "4L30"],
			secretpower: ["6M", "4M"],
			silverwind: ["4M"],
			sing: ["6L18", "5L18", "4L18"],
			slash: ["6L26", "5L26", "4L26"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stickyweb: ["6L44"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L38", "5M", "5L38", "4M", "4L38"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			xscissor: ["6M", "6L30", "5M", "5L30", "4M", "4L26"],
		},
	},
	shinx: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			babydolleyes: ["6L11"],
			bite: ["6L17", "5L17", "4L13"],
			captivate: ["4M"],
			charge: ["6L9", "5L9", "5D", "4L9"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			crunch: ["6L33", "5L33", "4L29"],
			discharge: ["6L41", "5L41", "4L41"],
			doublekick: ["6E", "5E"],
			doubleteam: ["6M", "5M", "4M"],
			eerieimpulse: ["6E"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			faketears: ["6E"],
			firefang: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["6E", "5E"],
			hiddenpower: ["6M", "5M", "4M"],
			howl: ["6E", "5E", "4E"],
			icefang: ["6E", "5E", "4E"],
			irontail: ["5T", "4M"],
			leer: ["6L5", "5L5", "4L5"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "5D", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6E", "5E", "5D", "4E"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "6L21", "5M", "5L21", "4M", "4L21"],
			round: ["6M", "5M"],
			scaryface: ["6L37", "5L37", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["6E", "5E", "4M"],
			signalbeam: ["6E", "5T", "5E", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T"],
			spark: ["6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			swagger: ["6M", "6L25", "5M", "5L25", "4M", "4L25"],
			swift: ["6E", "5E", "4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6E", "5E", "4E"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderfang: ["6L29", "6E", "5L29", "5E", "4L29", "4E"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L45", "5M", "5L45"],
		},
	},
	luxio: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bite: ["6L18", "5L18", "4L13"],
			captivate: ["4M"],
			charge: ["6L9", "5L9", "4L9"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			crunch: ["6L38", "5L38", "4L33"],
			discharge: ["6L48", "5L48", "4L48"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "6L23", "5M", "5L23", "4M", "4L23"],
			round: ["6M", "5M"],
			scaryface: ["6L43", "5L43", "4L43"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T"],
			spark: ["6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			swagger: ["6M", "6L28", "5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderfang: ["6L33", "5L33", "4L33"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L53", "5M", "5L53"],
		},
	},
	luxray: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bite: ["6L18", "5L18", "4L13"],
			captivate: ["4M"],
			charge: ["6L1", "5L1", "4L1"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			crunch: ["6L42", "5L42", "4L35"],
			discharge: ["6L56", "5L56", "4L56"],
			doubleteam: ["6M", "5M", "4M"],
			electricterrain: ["6L1"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "6L23", "5M", "5L23", "4M", "4L23"],
			round: ["6M", "5M"],
			scaryface: ["6L49", "5L49", "4L49"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T"],
			spark: ["6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "6L28", "5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderfang: ["6L35", "5L35", "4L35"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L63", "5M", "5L63"],
		},
	},
	cranidos: {
		inherit: true,
		learnset: {
			ancientpower: ["6L33", "5L33", "4T", "4L28"],
			assurance: ["6L24", "5L24", "4L24"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L28", "5L28"],
			confide: ["6M"],
			crunch: ["6E", "5E", "5S0", "4E"],
			curse: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			dragonpulse: ["5T", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "5D", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusenergy: ["6L6", "5L6", "4L6"],
			frustration: ["6M", "5M", "4M"],
			hammerarm: ["6E", "5E", "4E"],
			headbutt: ["6L1", "5L1", "5D", "5S0", "4T", "4L1"],
			headsmash: ["6L46", "5L46", "4L43"],
			hiddenpower: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6E", "5T", "5E", "5D", "4T"],
			irontail: ["6E", "5T", "5E", "4M"],
			leer: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L10", "5L10", "5S0", "4L10"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L19", "5L19", "4L19"],
			screech: ["6L42", "5L42", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			slam: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stomp: ["6E", "5E", "4E"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			takedown: ["6L15", "5L15", "5S0", "4L15"],
			thief: ["6M", "5M", "4M"],
			thrash: ["6E", "5E", "4E"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			whirlwind: ["6E", "5E", "4E"],
			zenheadbutt: ["6L37", "5T", "5L37", "4T", "4L33"],
		},
	},
	rampardos: {
		inherit: true,
		learnset: {
			ancientpower: ["6L36", "5L36", "4T", "4L28"],
			assurance: ["6L24", "5L24", "4L24"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			chipaway: ["6L28", "5L28"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endeavor: ["6L30", "5T", "5L30", "4T", "4L30"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focusenergy: ["6L6", "5L6", "4L6"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["6L1", "5L1", "4T", "4L1"],
			headsmash: ["6L58", "5L58", "4L52"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L10", "5L10", "4L10"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L19", "5L19", "4L19"],
			screech: ["6L51", "5L51", "4L43"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			takedown: ["6L15", "5L15", "4L15"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			whirlpool: ["4M"],
			zenheadbutt: ["6L43", "5T", "5L43", "4T", "4L36"],
		},
	},
	shieldon: {
		inherit: true,
		learnset: {
			ancientpower: ["6L28", "5L28", "4T", "4L28"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			bodyslam: ["6E", "5E", "5S0", "4E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D", "4E"],
			curse: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["6L33", "5L33", "4M", "4L33"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			fissure: ["6E", "5E", "5D", "4E"],
			flamethrower: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			focusenergy: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M"],
			guardsplit: ["6E"],
			headbutt: ["6E", "5E", "4T", "4E"],
			heavyslam: ["6L46", "5L46"],
			hiddenpower: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6L19", "5T", "5L19", "4T", "4L19"],
			ironhead: ["6L42", "5T", "5L42", "4T", "4L43"],
			irontail: ["5T", "4M"],
			magnetrise: ["5T", "4T"],
			metalburst: ["6L37", "5L37", "4L37"],
			metalsound: ["6L10", "5L10", "5S0", "4L10"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "6L1", "5M", "5L1", "5D", "5S0", "4M", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockblast: ["6E", "5E", "4E"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6E", "5E", "4E"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			stealthrock: ["6E", "5T", "5E", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "6L24", "5M", "5L24", "4M", "4L24"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L15", "5L15", "5S0", "4L15"],
			taunt: ["6M", "6L6", "5M", "5L6", "4M", "4L6"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			wideguard: ["6E", "5E"],
		},
	},
	bastiodon: {
		inherit: true,
		learnset: {
			ancientpower: ["6L28", "5L28", "4T", "4L28"],
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			block: ["6L30", "5T", "5L30", "4T", "4L30"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["6L36", "5L36", "4M", "4L36"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["6L58", "5L58"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6L19", "5T", "5L19", "4T", "4L19"],
			ironhead: ["6L51", "5T", "5L51", "4T", "4L52"],
			irontail: ["5T", "4M"],
			magiccoat: ["5T", "4T"],
			magnetrise: ["5T", "4T"],
			metalburst: ["6L43", "5L43", "4L43"],
			metalsound: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "6L24", "5M", "5L24", "4M", "4L24"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L15", "5L15", "4L15"],
			taunt: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
		},
	},
	burmy: {
		inherit: true,
		learnset: {
			bugbite: ["6L15", "5T", "5L15", "5D", "4T", "4L15"],
			electroweb: ["5T"],
			hiddenpower: ["6M", "6L20", "5L20", "4L20"],
			protect: ["6M", "6L1", "5L1", "5D", "4L1"],
			snore: ["5T", "5D", "4T"],
			stringshot: ["4T"],
			tackle: ["6L10", "5L10", "4L10"],
		},
	},
	wormadam: {
		inherit: true,
		learnset: {
			attract: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			bulletseed: ["4M"],
			captivate: ["6L35", "5L35", "4M", "4L35"],
			confide: ["6M"],
			confusion: ["6L23", "5L23", "4L23"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			electroweb: ["5T"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flail: ["6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L29", "5L29", "4L29"],
			hiddenpower: ["6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			leafstorm: ["6L47", "5L47", "4L47"],
			naturalgift: ["4M"],
			protect: ["6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["6L32", "5L32", "4L32"],
			psychic: ["6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6L26", "5L26", "4L26"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T", "4T"],
		},
	},
	wormadamsandy: {
		inherit: true,
		learnset: {
			attract: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			bulldoze: ["6M", "5M"],
			captivate: ["6L35", "5L35", "4M", "4L35"],
			confide: ["6M"],
			confusion: ["6L23", "5L23", "4L23"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			electroweb: ["5T"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fissure: ["6L47", "5L47", "4L47"],
			flail: ["6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			harden: ["6L29", "5L29", "4L29"],
			hiddenpower: ["6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["6L32", "5L32", "4L32"],
			psychic: ["6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockblast: ["6L26", "5L26", "4L26"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
		},
	},
	wormadamtrash: {
		inherit: true,
		learnset: {
			attract: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			captivate: ["6L35", "5L35", "4M", "4L35"],
			confide: ["6M"],
			confusion: ["6L23", "5L23", "4L23"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			electroweb: ["5T"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flail: ["6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			gyroball: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			irondefense: ["5T", "4T"],
			ironhead: ["6L47", "5T", "5L47", "4T", "4L47"],
			magnetrise: ["5T", "4T"],
			metalsound: ["6L29", "5L29", "4L29"],
			mirrorshot: ["6L26", "5L26", "4L26"],
			naturalgift: ["4M"],
			protect: ["6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["6L32", "5L32", "4L32"],
			psychic: ["6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			venoshock: ["6M", "5M"],
		},
	},
	mothim: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["6L41", "5L41", "4L41"],
			attract: ["6M", "5M", "4M"],
			bugbite: ["6L15", "5T", "5L15", "4T", "4L15"],
			bugbuzz: ["6L47", "5L47", "4L47"],
			camouflage: ["6L35", "5L35", "4L35"],
			captivate: ["4M"],
			confide: ["6M"],
			confusion: ["6L23", "5L23", "4L23"],
			defog: ["4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			electroweb: ["5T"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L26", "5L26", "4L26"],
			hiddenpower: ["6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonpowder: ["6L29", "5L29", "4L29"],
			protect: ["6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["6L32", "5L32", "4L32"],
			psychic: ["6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["6M", "5M", "4M"],
			quiverdance: ["6L50", "5L50"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["6L38", "5L38", "4M", "4L38"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
		},
	},
	combee: {
		inherit: true,
		learnset: {
			aircutter: ["5D", "4T"],
			bugbite: ["6L13", "5T", "5L13", "4T", "4L13"],
			bugbuzz: ["6L29", "5L29"],
			endeavor: ["5T", "4T"],
			gust: ["6L1", "5L1", "5D", "4L1"],
			mudslap: ["4T"],
			ominouswind: ["4T"],
			snore: ["5T", "4T"],
			stringshot: ["4T"],
			sweetscent: ["6L1", "5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["5T", "5D", "4T"],
		},
	},
	vespiquen: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["6L37", "5L37"],
			attackorder: ["6L45", "5L37", "4L37"],
			attract: ["6M", "5M", "4M"],
			bugbite: ["5T", "4T"],
			captivate: ["6L41", "5L33", "4M", "4L33"],
			confide: ["6M"],
			confuseray: ["6L1", "5L7", "4L7"],
			cut: ["6M", "5M", "4M"],
			defendorder: ["6L17", "5L13", "4L13"],
			defog: ["4M"],
			destinybond: ["6L1", "5L43", "4L43"],
			doubleteam: ["6M", "5M", "4M"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fellstinger: ["6L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["6L5", "5L9", "4T", "4L9"],
			furyswipes: ["6L13", "5L19", "4L19"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L1", "5L1", "4L1"],
			healorder: ["6L29", "5L25", "4L25"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonsting: ["6L1", "5L3", "4L3"],
			powergem: ["6L25", "5L21", "4L21"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L9", "5L15", "4L15"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roost: ["6M", "5T", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			slash: ["6L21", "5L31", "4L31"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "6L49", "5M", "5L39", "4M", "4L39"],
			sweetscent: ["6L1", "5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "6L33", "5M", "5L27", "4M", "4L27"],
			uturn: ["6M", "5M", "4M"],
			venoshock: ["6M", "5M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	pachirisu: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bestow: ["6E", "5E"],
			bide: ["6L1", "5L1", "4L1"],
			bite: ["6E", "5E", "4E"],
			captivate: ["4M"],
			charge: ["6E", "5E"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L9", "5L9", "4L9"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E", "5D", "4E"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			discharge: ["6L41", "5L41", "4L29"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			electroball: ["6L25", "5L25"],
			endure: ["6L17", "5L17", "4M", "4L17"],
			facade: ["6M", "5M", "4M"],
			faketears: ["6E", "5E", "4E"],
			flail: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			flatter: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			followme: ["6E", "6S0", "5E"],
			frustration: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperfang: ["6L49", "5L49"],
			iondeluge: ["6E"],
			irontail: ["6E", "5T", "5E", "4M"],
			lastresort: ["6L45", "5T", "5L45", "4T", "4L37"],
			lightscreen: ["6M", "5M", "4M"],
			magnetrise: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nuzzle: ["6L19", "6S0"],
			protect: ["6M", "6S0", "5M", "4M"],
			quickattack: ["6L5", "5L5", "5D", "4L5"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["6E", "5E", "4T", "4E"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shockwave: ["5D", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			spark: ["6L13", "5L13", "4L13"],
			substitute: ["6M", "5M", "4M"],
			superfang: ["6L37", "6S0", "5T", "5L37", "4T", "4L33"],
			swagger: ["6M", "5M", "4M"],
			sweetkiss: ["6L29", "5L29", "4L25"],
			swift: ["6L21", "5L21", "4T", "4L21"],
			tailwhip: ["6E", "5E"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "6L33", "5M", "5L33", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			voltswitch: ["6M", "5M"],
		},
	},
	buizel: {
		inherit: true,
		learnset: {
			agility: ["6L41", "5L28", "4L28"],
			aquajet: ["6L24", "5L21", "4L21"],
			aquaring: ["6E", "5E"],
			aquatail: ["6L38", "6E", "5T", "5L55", "5E"],
			attract: ["6M", "5M", "4M"],
			batonpass: ["6E", "5E", "4E"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["6L27", "5L27"],
			doubleslap: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["6E", "5E", "4E"],
			furyswipes: ["6E", "5E", "4E"],
			growl: ["6L4", "5L1", "4L1"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["6E", "5E", "4T", "4E"],
			hiddenpower: ["6M", "5M", "4M"],
			hydropump: ["6L45", "5L45"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			irontail: ["5T", "4M"],
			mefirst: ["6E", "5E"],
			mudslap: ["6E", "5E", "4T", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["6E", "5E", "4E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L18", "5L10", "4L10"],
			quickattack: ["6L11", "5L3", "4L3"],
			raindance: ["6M", "5M", "4M"],
			razorwind: ["6L35", "5L45", "4L45"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			slash: ["6E", "5E", "5D", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			soak: ["6E"],
			sonicboom: ["6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L21", "5L15", "4T", "4L15"],
			switcheroo: ["6E", "5E"],
			tailslap: ["6E", "5E"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			watergun: ["6L15", "5L6", "5D", "4L6"],
			waterpulse: ["5D", "4M"],
			watersport: ["6L7", "5L1", "5D", "4L1"],
			whirlpool: ["6L31", "5L36", "4M", "4L36"],
		},
	},
	floatzel: {
		inherit: true,
		learnset: {
			agility: ["6L51", "5L29", "4L29"],
			aquajet: ["6L24", "5L21", "4L21"],
			aquatail: ["6L46", "5T", "5L62", "4T"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L1", "5L26", "4L26"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["6L29", "5L29"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hydropump: ["6L57", "5L57"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icefang: ["6L1", "5L1", "4L1"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			irontail: ["5T", "4M"],
			lowkick: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L18", "5L10", "4L10"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			razorwind: ["6L41", "5L50", "4L50"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			sonicboom: ["6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L21", "5L15", "4T", "4L15"],
			taunt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			watergun: ["6L15", "5L6", "4L6"],
			waterpulse: ["4M"],
			watersport: ["6L1", "5L1", "4L1"],
			whirlpool: ["6L35", "5L39", "4M", "4L39"],
		},
	},
	cherubi: {
		inherit: true,
		learnset: {
			aromatherapy: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			bulletseed: ["5D", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6E", "5E"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flowershield: ["6E"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6E", "5E", "4E"],
			growth: ["6L7", "5L7", "4L7"],
			healingwish: ["6E", "5E"],
			healpulse: ["6E", "5E", "5D"],
			helpinghand: ["6L13", "5T", "5L13", "4T", "4L13"],
			hiddenpower: ["6M", "5M", "4M"],
			leechseed: ["6L10", "5L10", "5D", "4L10"],
			luckychant: ["6L40", "5L40", "4L40"],
			magicalleaf: ["6L19", "5L19", "4L19"],
			morningsun: ["6L1", "5L1"],
			naturalgift: ["6E", "5E", "4M"],
			naturepower: ["6M", "6E", "5E", "4E"],
			petalblizzard: ["6L47"],
			protect: ["6M", "5M", "4M"],
			razorleaf: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["6E", "5E", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6E", "5T", "5E", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "6L37", "5M", "5L37", "4M", "4L37"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			swagger: ["6M", "5M", "4M"],
			sweetscent: ["6E", "5E", "4E"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L31", "5L31", "4L31"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M"],
			weatherball: ["6E", "5E", "4E"],
			worryseed: ["6L28", "5T", "5L28", "4T", "4L28"],
		},
	},
	cherrim: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			growth: ["6L1", "5L1", "4L1"],
			helpinghand: ["6L13", "5T", "5L13", "4T", "4L13"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			leechseed: ["6L10", "5L10", "4L10"],
			luckychant: ["6L48", "5L48", "4L48"],
			magicalleaf: ["6L19", "5L19", "4L19"],
			morningsun: ["6L1", "5L1"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["6L25", "5L25", "4L25"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "6L43", "5M", "5L43", "4M", "4L43"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L35", "5L35", "4L35"],
			toxic: ["6M", "5M", "4M"],
			worryseed: ["6L30", "5T", "5L30", "4T", "4L30"],
		},
	},
	shellos: {
		inherit: true,
		learnset: {
			acidarmor: ["6E"],
			amnesia: ["6E", "5E", "4E"],
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			bodyslam: ["6L29", "5L29", "4L29"],
			brine: ["6E", "5E", "4M"],
			captivate: ["4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			curse: ["6E", "5E", "4E"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fissure: ["6E", "5E", "4E"],
			frustration: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M"],
			harden: ["6L4", "5L4", "4L4"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "6L16", "5M", "5L16", "4M", "4L16"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			memento: ["6E", "5E", "4E"],
			mirrorcoat: ["6E", "5E", "4E"],
			mist: ["6E", "5E"],
			mudbomb: ["6L11", "5L11", "4L11"],
			muddywater: ["6L37", "5L37", "4L37"],
			mudslap: ["6L1", "5L1", "5D", "4T", "4L1"],
			mudsport: ["6L2", "5L2", "4L2"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			recover: ["6L46", "5L46", "4L46"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "5D", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludge: ["6E", "5E", "4E"],
			snore: ["5T", "4T"],
			spitup: ["6E", "5E", "4E"],
			stockpile: ["6E", "5E", "4E"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M"],
			trumpcard: ["6E", "5E", "4E"],
			waterpulse: ["6L7", "5L7", "4M", "4L7"],
			whirlpool: ["4M"],
			yawn: ["6E", "5E", "5D", "4E"],
		},
	},
	gastrodon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			block: ["5T", "4T"],
			bodyslam: ["6L29", "5L29", "4L29"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M"],
			harden: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "6L16", "5M", "5L16", "4M", "4L16"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			infestation: ["6M"],
			mudbomb: ["6L11", "5L11", "4L11"],
			muddywater: ["6L41", "5L41", "4L41"],
			mudslap: ["6L1", "5L1", "4T", "4L1"],
			mudsport: ["6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "6L22", "5M", "5L22", "4M", "4L22"],
			recover: ["6L54", "5L54", "4L54"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M", "4M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpulse: ["6L1", "5L1", "4M", "4L1"],
			whirlpool: ["4M"],
		},
	},
	gastrodoneast: {
		inherit: true,
		learnset: {},
	},
	drifloon: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aircutter: ["4T"],
			amnesia: ["6L40", "5L40"],
			astonish: ["6L4", "5L6", "4L6"],
			attract: ["6M", "5M", "4M"],
			batonpass: ["6L44", "5L38", "4L33"],
			bind: ["5T"],
			bodyslam: ["6E", "5E", "4E"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			defog: ["6E", "5E", "4M"],
			destinybond: ["6E", "5E", "4E"],
			disable: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "6L50", "5M", "5L46", "4M", "4L43"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["6L13", "5L14", "4L14"],
			frustration: ["6M", "5M", "4M"],
			gust: ["6L8", "5L11", "4L11"],
			gyroball: ["6M", "5M", "4M"],
			haze: ["6E", "5E", "4E"],
			hex: ["6L27", "5L22"],
			hiddenpower: ["6M", "5M", "4M"],
			hypnosis: ["6E", "5E", "5D", "4E"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			magiccoat: ["5T", "4T"],
			memento: ["6E", "5E", "4E"],
			minimize: ["6L1", "5L1", "5D", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["6L20", "5L33", "4T", "4L30"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L16", "5M", "5L17", "4M", "4L17"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "6L36", "5M", "5L43", "4M", "4L38"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["5T", "5D", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			spitup: ["6L32", "5L30", "4L27"],
			stockpile: ["6L25", "5L27", "4L22"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6L32", "5L30", "4L27"],
			swift: ["4T"],
			tailwind: ["6E", "5T", "4T"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			weatherball: ["6E", "5E", "4E"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	drifblim: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aircutter: ["4T"],
			amnesia: ["6L46", "5L46"],
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			batonpass: ["6L52", "5L44", "4L37"],
			bind: ["5T"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			constrict: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "6L60", "5M", "5L56", "4M", "4L51"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M"],
			focusenergy: ["6L13", "5L14", "4L14"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L1", "5L1", "4L1"],
			gyroball: ["6M", "5M", "4M"],
			hex: ["6L27", "5L22"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			magiccoat: ["5T", "4T"],
			minimize: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["6L20", "5L37", "4T", "4L32"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "6L16", "5M", "5L17", "4M", "4L17"],
			phantomforce: ["6L1"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "6L40", "5M", "5L51", "4M", "4L44"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			spitup: ["6L34", "5L32", "4L27"],
			stockpile: ["6L25", "5L27", "4L22"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6L34", "5L32", "4L27"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	buneary: {
		inherit: true,
		learnset: {
			afteryou: ["6L43", "5T", "5L43"],
			agility: ["6L33", "5L33", "4L33"],
			attract: ["6M", "5M", "4M", "4E"],
			babydolleyes: ["6L10"],
			batonpass: ["6L26", "5L26", "4L26"],
			bounce: ["6L56", "5T", "5L56", "4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L46", "5L46", "4L43"],
			circlethrow: ["6E", "5E"],
			confide: ["6M"],
			copycat: ["6E", "5E"],
			cosmicpower: ["6E"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6L1", "5L1", "4L1"],
			dig: ["6M", "5M", "4M"],
			dizzypunch: ["6L36", "5L36", "4L36"],
			doublehit: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "5D", "4M"],
			encore: ["6E", "5E", "4E"],
			endeavor: ["5T", "4T"],
			endure: ["6L6", "5L6", "4M", "4L6"],
			entrainment: ["6L50", "5L53"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["6E", "5E", "5D", "4E"],
			faketears: ["6E", "5E", "4E"],
			firepunch: ["6E", "5T", "5E", "4E"],
			flail: ["6E", "5E", "4E"],
			fling: ["6M", "5M", "4M"],
			focuspunch: ["6E", "5E", "4M"],
			foresight: ["6L1", "5L1", "5D", "4L1"],
			frustration: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healingwish: ["6L63", "5L63", "4L53"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["6E", "5T", "5E", "4E"],
			irontail: ["5T", "4M"],
			jumpkick: ["6L23", "5L23", "4L23"],
			lastresort: ["5T", "4T"],
			lowkick: ["6E", "5T", "5E", "4T", "4E"],
			magiccoat: ["5T", "4T"],
			mudslap: ["4T"],
			mudsport: ["6E"],
			naturalgift: ["4M"],
			pound: ["6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L16", "5L16", "4L16"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			skyuppercut: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			splash: ["6L1", "5L1", "4L1"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			sweetkiss: ["6E", "5E", "4E"],
			swift: ["4T"],
			switcheroo: ["6E", "5E", "4E"],
			teeterdance: ["6E"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["6E", "5T", "5E", "4E"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	lopunny: {
		inherit: true,
		learnset: {
			afteryou: ["6L43", "5T", "5L43"],
			agility: ["6L33", "5L33", "4L33"],
			attract: ["6M", "5M", "4M"],
			batonpass: ["6L26", "5L26", "4L26"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["6L1", "5T", "5L56", "4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L46", "5L46", "4L43"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["6L1", "5L1", "4L1"],
			dig: ["6M", "5M", "4M"],
			dizzypunch: ["6L36", "5L36", "4L36"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M"],
			endeavor: ["5T", "4T"],
			endure: ["6L6", "5L6", "4M", "4L6"],
			entrainment: ["6L53", "5L53"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			healingwish: ["6L1", "5L63", "4L53"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			irontail: ["5T", "4M"],
			jumpkick: ["6L23", "5L23", "4L23"],
			lastresort: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["6L1", "5T", "5L1", "4T", "4L1"],
			mirrorcoat: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L16", "5L16", "4L16"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rocksmash: ["6M", "5M", "4M"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			splash: ["6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	glameow: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			assist: ["6L29", "5L29", "4L29"],
			assurance: ["6E", "5E", "5D", "4E"],
			attract: ["6M", "6L44", "5M", "5L44", "4M", "4L45"],
			bite: ["6E", "5E", "4E"],
			captivate: ["6L32", "5L32", "4M", "4L32"],
			charm: ["6L25", "5L25", "4L25"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["6L1", "5L1", "5D", "4L1"],
			faketears: ["6E", "5E", "4E"],
			feintattack: ["6L17", "5L17", "4L17"],
			flail: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L20", "5L20", "4L20"],
			growl: ["6L8", "5L8", "4L8"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "6L48", "5M", "5L48"],
			hypervoice: ["5T"],
			hypnosis: ["6L13", "5L13", "4L13"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6E", "5T", "5E", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			playrough: ["6L50"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			quickattack: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E", "4E"],
			scratch: ["6L5", "5L5", "4L5"],
			secretpower: ["6M", "5D", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			slash: ["6L37", "5L37", "4L37"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["6E", "5T", "5E", "4M"],
			snore: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L41", "5L41", "4T", "4L41"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tailwhip: ["6E", "5E", "4E"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "4M"],
			wakeupslap: ["6E", "5E"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	purugly: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			assist: ["6L29", "5L29", "4L29"],
			attract: ["6M", "6L52", "5M", "5L52", "4M", "4L53"],
			bodyslam: ["6L45", "5L45", "4L45"],
			bulldoze: ["6M", "5M"],
			captivate: ["6L32", "5L32", "4M", "4L32"],
			charm: ["6L25", "5L25", "4L25"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["6L1", "5L1", "4L1"],
			feintattack: ["6L17", "5L17", "4L17"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L20", "5L20", "4L20"],
			gigaimpact: ["6M", "5M", "4M"],
			growl: ["6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "6L60", "5M", "5L60"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			hypnosis: ["6L13", "5L13", "4L13"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			slash: ["6L37", "5L37", "4L37"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "6L38", "5M", "5L38", "4M", "4L38"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	stunky: {
		inherit: true,
		learnset: {
			acidspray: ["6L32", "5L32"],
			astonish: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			belch: ["6L46"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6E", "5E", "4E"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "6L49", "5M", "5L49", "4M", "4L44"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L18", "5L18", "4L18"],
			fireblast: ["6M", "5M", "4M"],
			flameburst: ["6E", "5E"],
			flamethrower: ["6M", "5M", "4M"],
			focusenergy: ["6L1", "5L1", "4L1"],
			foulplay: ["6E", "5T", "5E", "5D"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L10", "5L10", "4L10"],
			haze: ["6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E", "4M"],
			leer: ["6E", "5E", "4E"],
			memento: ["6L43", "5L43", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L37", "5L37", "4L31"],
			payback: ["6M", "5M", "4M"],
			playrough: ["6E"],
			poisongas: ["6L4", "5L4", "4L4"],
			protect: ["6M", "5M", "4M"],
			punishment: ["6E", "5E", "4E"],
			pursuit: ["6E", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E", "4E"],
			scratch: ["6L1", "5L1", "4L1"],
			screech: ["6L7", "5L7", "5D", "4L7"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L22", "5L22", "4L22"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			smog: ["6E", "5E", "4E"],
			smokescreen: ["6L14", "5L14", "4L14"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["5D", "4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "6L27", "5M", "5L27", "4M", "4L20"],
			venoshock: ["6M", "5M"],
		},
	},
	skuntank: {
		inherit: true,
		learnset: {
			acidspray: ["6L32", "5L32"],
			attract: ["6M", "5M", "4M"],
			belch: ["6L56"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "6L61", "5M", "5L61", "4M", "4L52"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L18", "5L18", "4L18"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "6L34", "5M", "5L34", "4M", "4L34"],
			focusenergy: ["6L1", "5L1", "4L1"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["6L10", "5L10", "4L10"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			memento: ["6L51", "5L51", "4L41"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L41", "5L41", "4L31"],
			payback: ["6M", "5M", "4M"],
			poisongas: ["6L1", "5L1", "4L1"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1", "4L1"],
			screech: ["6L7", "5L7", "4L7"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L22", "5L22", "4L22"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			smokescreen: ["6L14", "5L14", "4L14"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "6L27", "5M", "5L27", "4M", "4L20"],
			venoshock: ["6M", "5M"],
		},
	},
	bronzor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L11", "5L11", "4L14"],
			confusion: ["6L1", "5L1", "4L1"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			extrasensory: ["6L39", "5L19", "4L19"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L21", "5L21", "4L41"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L29", "5L29", "4L37"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "5D", "4T"],
			gyroball: ["6M", "6L35", "5M", "5L35", "4M", "4L35"],
			healblock: ["6L45", "5L45", "4L52"],
			heavyslam: ["6L49", "5L49"],
			hiddenpower: ["6M", "5M", "4M"],
			hypnosis: ["6L5", "5L5", "5D", "4L7"],
			imprison: ["6L9", "5L9", "4L12"],
			irondefense: ["6L19", "5T", "5L19", "4L26"],
			lightscreen: ["6M", "5M", "4M"],
			metalsound: ["6L31", "5L31"],
			naturalgift: ["4M"],
			payback: ["6M", "6L41", "5M", "5L49", "4M", "4L49"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			psywave: ["6L15", "5L15"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L25", "5M", "5L25", "4M", "4L30"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "5D", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
		},
	},
	bronzong: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			block: ["6L33", "5T", "5L33", "4T", "4L33"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L11", "5L11", "4L14"],
			confusion: ["6L1", "5L1", "4L1"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["6M", "5M", "4M"],
			extrasensory: ["6L42", "5L19", "4L19"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L21", "5L21", "4L50"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L29", "5L29", "4L43"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			gyroball: ["6M", "6L36", "5M", "5L36", "4M", "4L38"],
			healblock: ["6L52", "5L52", "4L67"],
			heavyslam: ["6L58", "5L58"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypnosis: ["6L1", "5L1", "4L1"],
			imprison: ["6L1", "5L1", "4L1"],
			irondefense: ["6L19", "5T", "5L19", "4L26"],
			ironhead: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			metalsound: ["6L31", "5L31"],
			naturalgift: ["4M"],
			payback: ["6M", "6L46", "5M", "5L46", "4M", "4L61"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			psywave: ["6L15", "5L15"],
			raindance: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L25", "5M", "5L25", "4M", "4L30"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	chatot: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			agility: ["6E", "5E", "4E"],
			aircutter: ["6E", "5E", "4T"],
			attract: ["6M", "5M", "4M"],
			boomburst: ["6E"],
			captivate: ["4M"],
			chatter: ["6L1", "5L21", "4L21", "4S0"],
			confide: ["6M", "6L1"],
			defog: ["6E", "5E", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "6L37", "5M", "5L37"],
			encore: ["6E", "5E", "4E"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			featherdance: ["6L50", "5L53", "4L41"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furyattack: ["6L17", "5L17", "4L17", "4S0"],
			growl: ["6L5", "5L5", "4L5"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hypervoice: ["6L1", "5T", "5L57", "4L45"],
			mimic: ["6L33", "5L33", "4L29"],
			mirrormove: ["6L9", "5L9", "5D", "4L9", "4S0"],
			mudslap: ["4T"],
			nastyplot: ["6E", "5E", "5D", "4E"],
			naturalgift: ["4M"],
			nightshade: ["6E", "5E", "4E"],
			ominouswind: ["4T"],
			peck: ["6L1", "5L1", "4L1"],
			pluck: ["5M", "4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roleplay: ["5T", "5D", "4T"],
			roost: ["6M", "6L41", "5T", "5L41", "4M", "4L33"],
			round: ["6M", "6L29", "5M", "5L29"],
			secretpower: ["6M", "4M"],
			sing: ["6L13", "5L13", "4L13"],
			skyattack: ["5T", "4T"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M"],
			snore: ["5T", "4T"],
			steelwing: ["6M", "6E", "5E", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			supersonic: ["6E", "5E", "4E"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			synchronoise: ["6L49", "5L49"],
			tailwind: ["5T", "4T"],
			taunt: ["6M", "6L1", "5M", "5L25", "4M", "4L25", "4S0"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6L45", "5T", "5L45", "4T", "4L37"],
			uturn: ["6M", "5M", "4M"],
			workup: ["5M"],
		},
	},
	spiritomb: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["6E", "5E", "4M"],
			confide: ["6M"],
			confuseray: ["6L1", "5L1", "4L1"],
			curse: ["6L1", "5L1", "4L1"],
			darkpulse: ["6M", "6L49", "5T", "5L49", "5S0", "4M", "4L49"],
			destinybond: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "6L19", "5M", "5L19", "4M", "4L19"],
			embargo: ["6M", "5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L7", "5L7", "4L7"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6E", "5T"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grudge: ["6E", "5E", "4E"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypnosis: ["6L13", "5L13", "4L13"],
			icywind: ["5T", "5D", "4T"],
			imprison: ["6E", "5E", "4E"],
			infestation: ["6M"],
			memento: ["6L43", "5L43", "4L43"],
			nastyplot: ["6L37", "5L37", "4L37"],
			naturalgift: ["4M"],
			nightmare: ["6E", "5E"],
			ominouswind: ["6L25", "5L25", "4T", "4L25"],
			painsplit: ["6E", "5T", "5E", "5D", "4T", "4E"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "5S0", "4M"],
			psychup: ["6M", "5M", "4M"],
			pursuit: ["6L1", "5L1", "4L1"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowsneak: ["6L1", "6E", "5L1", "5E", "4L1", "4E"],
			shockwave: ["4M"],
			silverwind: ["5S0", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smokescreen: ["6E", "5E", "4E"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["6L1", "5T", "5L1", "5D", "4T", "4L1"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L31", "5L31", "4T", "4L31"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			uproar: ["5T", "4T"],
			waterpulse: ["4M"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
		},
	},
	gible: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			bodyslam: ["6E", "5E", "4E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "6L31", "5M", "5L31", "4M", "4L31"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonbreath: ["6E", "5E", "4E"],
			dragonclaw: ["6M", "6L27", "5M", "5L27", "4M", "4L27"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L7", "5L7", "5D", "4L7"],
			dragonrush: ["6L37", "5L37", "4L37"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["5D", "4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6E", "5T", "5E", "4T", "4E"],
			irontail: ["6E", "5T", "5E"],
			metalclaw: ["6E", "5E", "4E"],
			mudshot: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6E", "5T", "5E", "5D", "4T", "4E"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["6E", "5E", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L3", "5L3", "4L3"],
			sandstorm: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			sandtomb: ["6L19", "6E", "5L19", "5E", "4L19", "4E"],
			scaryface: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L25", "5L25", "4L25"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L15", "5L15", "4L15"],
			thrash: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M"],
			twister: ["6E", "5E", "4T", "4E"],
		},
	},
	gabite: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			attract: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "6L40", "5M", "5L40", "4M", "4L40"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonclaw: ["6M", "6L33", "5M", "5L33", "4M", "4L33"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L7", "5L7", "4L7"],
			dragonrush: ["6L49", "5L49", "4L49"],
			dualchop: ["6L24", "5T", "5L24"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			sandstorm: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			sandtomb: ["6L19", "5L19", "4L19"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L28", "5L28", "4L28"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
		},
	},
	garchomp: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			brickbreak: ["6M", "6S4", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L48", "6S2", "6S3", "5L48", "5S1", "4L48"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "6L40", "6S2", "6S3", "5M", "5L40", "5S1", "4M", "4L40"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "6S2", "5T", "4T"],
			dragonclaw: ["6M", "6L33", "6S2", "6S3", "5M", "5L33", "5S1", "4M", "4L33"],
			dragonpulse: ["5T", "4M"],
			dragonrage: ["6L1", "5L1", "4L1"],
			dragonrush: ["6L55", "6S4", "5L55", "4L55"],
			dragontail: ["6M", "5M"],
			dualchop: ["6L24", "5T", "5L24"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6S4", "5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firefang: ["6L1", "5L1", "4L1"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "6S4", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "5S0", "5S1", "4T"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			sandstorm: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			sandtomb: ["6L19", "5L19", "4L19"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			slash: ["6L28", "6S3", "5L28", "4L28"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "5S0", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "5S0", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L15", "5L15", "4L15"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			whirlpool: ["4M"],
		},
	},
	riolu: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			attract: ["6M", "5M", "4M"],
			aurasphere: ["4S0"],
			bite: ["6E", "5E", "4E"],
			blazekick: ["6E", "5E", "4E"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6E", "5E", "5D", "4E", "4S0"],
			captivate: ["4M"],
			circlethrow: ["6E", "5E"],
			confide: ["6M"],
			copycat: ["6L19", "5L29", "4L29"],
			counter: ["6L6", "5L6", "4L6"],
			crosschop: ["6E", "5E", "4E"],
			crunch: ["6E", "5E", "4E"],
			detect: ["6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M", "4S0"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["6L1", "5L1", "5D", "4M", "4L1"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L11", "5L15", "4L15"],
			finalgambit: ["6L50", "5L55"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["5D", "4M"],
			followme: ["6E", "5E", "4E"],
			forcepalm: ["6L15", "5L11", "4L11"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			highjumpkick: ["6E", "5E", "4E"],
			icepunch: ["5T", "4T"],
			irondefense: ["6E", "5T", "5E", "4T", "4E"],
			irontail: ["5T", "4M"],
			lowkick: ["6E", "5T", "5E", "4T", "4E"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T", "4T"],
			mindreader: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			nastyplot: ["6L47", "5L47"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			quickattack: ["6L1", "5L1", "4L1"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			reversal: ["6L29", "5L19", "4L19"],
			roar: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			screech: ["6L24", "5L24", "4L24"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M", "4S0"],
			skyuppercut: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			vacuumwave: ["6E", "5E", "4T", "4E"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	lucario: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			aurasphere: ["6L1", "6S4", "5L51", "4L37", "4S0"],
			blazekick: ["4S1"],
			bonerush: ["6L29", "5L19", "4L19", "4S1"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["5S2", "5S3"],
			calmmind: ["6M", "6L47", "5M", "5L47", "4M"],
			captivate: ["4M"],
			closecombat: ["6L1", "6S4", "5L55", "5S3", "4L42"],
			confide: ["6M"],
			counter: ["6L6", "5L6", "5S2", "4L6"],
			darkpulse: ["6M", "5T", "5L1", "4M", "4L1", "4S0"],
			detect: ["6L1", "5L1", "5S2", "4L1"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dragonpulse: ["6L1", "5T", "5L60", "4M", "4L47", "4S0"],
			drainpunch: ["5T", "4M"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			extremespeed: ["6L1", "5L65", "4L51"],
			facade: ["6M", "5M", "4M"],
			feint: ["6L11", "5L15", "4L15"],
			flashcannon: ["6M", "6S4", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			forcepalm: ["5L11", "4L11", "4S1"],
			foresight: ["6L1", "5L1", "4L1"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["6L51", "5L42"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			irondefense: ["5T", "4T"],
			irontail: ["5T", "4M"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T", "4T"],
			mefirst: ["6L37", "5L29", "4L29"],
			metalclaw: ["6L1", "5L1", "5S2", "4L1"],
			metalsound: ["6L24", "5L24", "4L24"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M", "6L15"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			quickattack: ["6L1", "6S4", "5L1", "4L1"],
			quickguard: ["6L33", "5L33"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "5S3", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stoneedge: ["6M", "5M", "5S3", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M", "4S1"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "6L19", "5M", "5L37", "4M", "4L33"],
			thunderpunch: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			waterpulse: ["4M", "4S0"],
			workup: ["5M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	hippopotas: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bite: ["6L7", "5L7", "5D", "4L7"],
			bodyslam: ["6E", "5E", "4E"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L31", "5L31", "4L31"],
			curse: ["6E", "5E", "4E"],
			dig: ["6M", "6L19", "5M", "5L19", "4M", "4L19"],
			doubleedge: ["6L44", "5L44", "4L44"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L37", "5M", "5L37", "4M", "4L37"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fissure: ["6L50", "5L50", "4L50"],
			frustration: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			irontail: ["5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6E", "5E", "4E"],
			roar: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			sandstorm: ["6M", "5M", "4M"],
			sandtomb: ["6L25", "6E", "5L25", "5E", "4L25", "4E"],
			secretpower: ["6M", "4M"],
			slackoff: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "6E", "5T", "5E", "4M"],
			snore: ["5T", "4T"],
			spitup: ["6E", "5E", "4E"],
			stealthrock: ["5T", "4M"],
			stockpile: ["6E", "5E", "5D", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "5D", "4T"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6E", "5E", "4E"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L19", "5L19", "4L19"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			whirlwind: ["6E", "5E"],
			yawn: ["6L13", "5L13", "4L13"],
		},
	},
	hippowdon: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bite: ["6L1", "5L1", "4L1"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L31", "5L31", "4L31"],
			dig: ["6M", "6L19", "5M", "5L19", "4M", "4L19"],
			doubleedge: ["6L50", "5L50", "4L50"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "6L40", "5M", "5L40", "4M", "4L40"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			firefang: ["6L1", "5L1", "4L1"],
			fissure: ["6L60", "5L60", "4L60"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icefang: ["6L1", "5L1", "4L1"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1", "4L1"],
			sandstorm: ["6M", "5M", "4M"],
			sandtomb: ["6L25", "5L25", "4L25"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T"],
			swagger: ["6M", "5M", "4M"],
			tackle: ["6L1", "5L1", "4L1"],
			takedown: ["6L19", "5L19", "4L19"],
			thunderfang: ["6L1", "5L1", "4L1"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			yawn: ["6L1", "5L1", "4L1"],
		},
	},
	skorupi: {
		inherit: true,
		learnset: {
			acupressure: ["6L13", "5L17", "4L17"],
			aerialace: ["6M", "5M", "4M"],
			agility: ["6E", "5E", "5D", "4E"],
			aquatail: ["5T", "5D", "4T"],
			attract: ["6M", "5M", "4M"],
			bite: ["6L1", "5L1", "5D", "4L1"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["6L20", "5T", "5L34", "4T", "4L34"],
			captivate: ["4M"],
			confide: ["6M"],
			confuseray: ["6E", "5E", "4E"],
			crosspoison: ["6L49", "5L61", "4L50"],
			crunch: ["6L45", "5L56", "4L45"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "5M", "4M"],
			feintattack: ["6E", "5E", "4E"],
			fellstinger: ["6L47"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "6L30", "5M", "5L45"],
			infestation: ["6M"],
			irontail: ["6E", "5T", "5E", "4M"],
			knockoff: ["6L5", "5T", "5L6", "4T", "4L6"],
			leer: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L38", "6E", "5L38", "5E", "4E"],
			payback: ["6M", "5M", "4M"],
			pinmissile: ["6L9", "5L12", "4L12"],
			poisonfang: ["6L23", "5L39", "4L39"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1"],
			poisontail: ["6E", "5E"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L16", "6E", "5L16", "5E", "4E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E", "4E"],
			scaryface: ["6L41", "5L23", "4L23"],
			screech: ["6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			slash: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			toxicspikes: ["6L34", "5L28", "4L28"],
			twineedle: ["6E", "5E"],
			venoshock: ["6M", "6L27", "5M", "5L50"],
			whirlwind: ["6E", "5E", "4E"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	drapion: {
		inherit: true,
		learnset: {
			acupressure: ["6L13", "5L17", "4L17"],
			aerialace: ["6M", "5M", "4M"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "5M", "4M"],
			bite: ["6L1", "5L1", "4L1"],
			brickbreak: ["6M", "5M", "4M"],
			bugbite: ["6L20", "5T", "5L34", "4T", "4L34"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crosspoison: ["6L57", "5L73", "4L58"],
			crunch: ["6L49", "5L65", "4L49"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			falseswipe: ["6M", "5M", "4M"],
			fellstinger: ["6L53"],
			firefang: ["6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "6L30", "5M", "5L48"],
			hyperbeam: ["6M", "5M", "4M"],
			icefang: ["6L1", "5L1", "4L1"],
			infestation: ["6M"],
			irontail: ["5T", "4M"],
			knockoff: ["6L1", "5T", "5L1", "4T", "4L1"],
			leer: ["6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["6L38", "5L38"],
			payback: ["6M", "5M", "4M"],
			pinmissile: ["6L9", "5L12", "4L1"],
			poisonfang: ["6L23", "5L39", "4L39"],
			poisonjab: ["6M", "5M", "4M"],
			poisonsting: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L16", "5L16"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L43", "5L23", "4L23"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunderfang: ["6L1", "5L1", "4L1"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			toxicspikes: ["6L34", "5L28", "4L28"],
			venoshock: ["6M", "6L27", "5M", "5L56"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	croagunk: {
		inherit: true,
		learnset: {
			acupressure: ["6E", "5E"],
			astonish: ["6L1", "5L1", "5S0", "4L1"],
			attract: ["6M", "5M", "4M"],
			belch: ["6L47"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			bulletpunch: ["6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["6M"],
			counter: ["6E", "5E", "4E"],
			crosschop: ["6E", "5E", "4E"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["6E", "5T", "5E", "5D"],
			dualchop: ["5T"],
			dynamicpunch: ["6E", "5E", "4E"],
			earthquake: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fakeout: ["6E", "5E", "4E"],
			feint: ["6E", "5E", "4E"],
			feintattack: ["6L17", "5L17", "4L17"],
			flatter: ["6L50", "5L50", "4L45"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gunkshot: ["5T", "5D", "4T"],
			headbutt: ["6E", "5E", "4T", "4E"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			meditate: ["6E", "5E", "4E"],
			mefirst: ["6E", "5E", "4E"],
			mudbomb: ["6L29", "5L29", "4L29"],
			mudslap: ["6L3", "5L3", "5S0", "5S1", "4T", "4L3"],
			nastyplot: ["6L38", "5L38", "4L36"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L43", "5M", "5L43", "5S1", "4M", "4L38"],
			poisonsting: ["6L8", "5L8", "5D", "5S0", "5S1", "4L8"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L15", "5L15", "4L15"],
			quickguard: ["6E"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6L22", "5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "6L45", "5M", "5L45", "4M", "4L43"],
			sludgewave: ["6M", "5M"],
			smellingsalts: ["6E", "5E", "4E"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L31", "5L31", "4T", "4L31"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "6L24", "5M", "5L24", "4M", "4L24"],
			taunt: ["6M", "6L10", "5M", "5L10", "5S0", "5S1", "4M", "4L10"],
			thief: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			vacuumwave: ["6E", "5E", "4T", "4E"],
			venoshock: ["6M", "6L36", "5M", "5L36"],
			wakeupslap: ["6E", "5E", "4E"],
			workup: ["5M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	toxicroak: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1", "4L1"],
			attract: ["6M", "5M", "4M"],
			belch: ["6L58"],
			bounce: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T"],
			dualchop: ["5T"],
			earthquake: ["6M", "5M", "4M"],
			embargo: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L17", "5L17", "4L17"],
			flatter: ["6L62", "5L62", "4L54"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			gunkshot: ["5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lowkick: ["5T", "4T"],
			lowsweep: ["6M", "5M"],
			mudbomb: ["6L29", "5L29", "4L29"],
			mudslap: ["6L1", "5L1", "4T", "4L1"],
			nastyplot: ["6L41", "5L41", "4L36"],
			naturalgift: ["4M"],
			payback: ["6M", "5M", "4M"],
			poisonjab: ["6M", "6L49", "5M", "5L49", "4M", "4L41"],
			poisonsting: ["6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			pursuit: ["6L15", "5L15", "4L15"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6L22", "5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "6L54", "5M", "5L54", "4M", "4L49"],
			sludgewave: ["6M", "5M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["6L31", "5L31", "4T", "4L31"],
			sunnyday: ["6M", "5M", "4M"],
			superfang: ["5T", "4T"],
			swagger: ["6M", "6L24", "5M", "5L24", "4M", "4L24"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "6L10", "5M", "5L10", "4M", "4L10"],
			thief: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["6M", "6L36", "5M", "5L36"],
			workup: ["5M"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	carnivine: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			bind: ["6L1", "5T", "5L1", "4L1"],
			bite: ["6L7", "5L7", "5D", "4L7"],
			bugbite: ["5T", "4T"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L41", "5L41", "4L37"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L27", "5L27", "4L27"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gastroacid: ["5T", "5D", "4T"],
			gigadrain: ["6E", "5T", "5E", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6E", "5E"],
			growth: ["6L1", "5L1", "4L1"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			infestation: ["6M"],
			ingrain: ["6L21", "5L21", "4L21"],
			knockoff: ["5T", "4T"],
			leaftornado: ["6L31", "5L31"],
			leechseed: ["6E", "5E", "4E"],
			magicalleaf: ["6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			payback: ["6M", "5M", "4M"],
			powerwhip: ["6L50", "5L51", "4L47"],
			protect: ["6M", "5M", "4M"],
			ragepowder: ["6E", "5E", "5D"],
			razorleaf: ["6E", "5E", "4E"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			slam: ["6E", "5E", "4E"],
			sleeppowder: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			spitup: ["6L37", "5L37", "4L31"],
			stockpile: ["6L37", "5L37", "4L31"],
			stunspore: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swallow: ["6L37", "5L37", "4L31"],
			sweetscent: ["6L17", "5L17", "4L17"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6E", "5T", "5E", "4T", "4E"],
			thief: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			vinewhip: ["6L11", "5L11", "4L11"],
			worryseed: ["6E", "5T", "5E", "4T", "4E"],
			wringout: ["6L47", "5L47", "4L41"],
		},
	},
	finneon: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "4E"],
			aircutter: ["4T"],
			aquaring: ["6L33", "5L33", "4L33"],
			aquatail: ["6E", "5T", "5E", "4T", "4E"],
			attract: ["6M", "6L10", "5M", "5L10", "5D", "4M", "4L10"],
			aurorabeam: ["6E", "5E"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["6L45", "5T", "5L45", "4T", "4L45"],
			brine: ["6E", "5E", "4M"],
			captivate: ["6L26", "5L26", "4M", "4L26"],
			charm: ["6E", "5E", "4E"],
			confide: ["6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flail: ["6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gust: ["6L17", "5L17", "4L17"],
			hail: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pound: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			psybeam: ["6E", "5E", "4E"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L29", "5M", "5L29", "4M", "4L29"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6E", "5T", "5E"],
			silverwind: ["6L49", "5L49", "4M", "4L49"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			soak: ["6L54", "5L54"],
			splash: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			sweetkiss: ["6E", "5E", "5D", "4E"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			tickle: ["6E", "5E", "4E"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "6L42", "5M", "5L42", "4M", "4L42"],
			waterfall: ["6M", "5M", "4M"],
			watergun: ["6L6", "5L6", "4L6"],
			waterpulse: ["6L22", "5L22", "5D", "4M", "4L22"],
			whirlpool: ["6L38", "5L38", "4M", "4L38"],
		},
	},
	lumineon: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			aquaring: ["6L35", "5L35", "4L35"],
			aquatail: ["5T", "4T"],
			attract: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["6L53", "5T", "5L53", "4T", "4L53"],
			brine: ["4M"],
			captivate: ["6L26", "5L26", "4M", "4L26"],
			confide: ["6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			gust: ["6L1", "5L17", "4L17"],
			hail: ["6M", "5M", "4M"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["6M", "5M", "4M"],
			pound: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L29", "5M", "5L29", "4M", "4L29"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["5T"],
			silverwind: ["6L59", "5L59", "4M", "4L59"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			soak: ["6L1", "5L66"],
			substitute: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["6M", "6L48", "5M", "5L48", "4M", "4L48"],
			waterfall: ["6M", "5M", "4M"],
			watergun: ["6L1", "5L1", "4L1"],
			waterpulse: ["6L22", "5L22", "4M", "4L22"],
			whirlpool: ["6L42", "5L42", "4M", "4L42"],
		},
	},
	snover: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			avalanche: ["6E", "5E", "5D", "4M"],
			blizzard: ["6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bulletseed: ["6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleedge: ["6E", "5E", "4E"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "5D", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L13", "5L13", "4L13"],
			growth: ["6E", "5E", "4E"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			iceshard: ["6L26", "5L26", "4L26"],
			icywind: ["6L9", "5T", "5L9", "4T", "4L9"],
			ingrain: ["6L31", "5L31", "4L31"],
			irontail: ["5T", "4M"],
			leechseed: ["6E", "5E", "4E"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			magicalleaf: ["6E", "5E", "4E"],
			mist: ["6L21", "6E", "5L21", "5E", "4L21", "4E"],
			mudslap: ["4T"],
			naturalgift: ["6E", "5E", "4M"],
			powdersnow: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6L5", "5L5", "5D", "4L5"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6E", "5T", "5E", "4T", "4E"],
			shadowball: ["6M", "5M", "4M"],
			sheercold: ["6L46", "5L46", "4L46"],
			skullbash: ["6E", "5E", "4E"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stomp: ["6E", "5E", "4E"],
			substitute: ["6M", "5M", "4M"],
			swagger: ["6M", "6L17", "5M", "5L17", "4M", "4L17"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			woodhammer: ["6L36", "5L36", "4L36"],
			worryseed: ["5T", "4T"],
		},
	},
	abomasnow: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["6M", "6L47", "5M", "5L47", "4M", "4L47"],
			block: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["6L13", "5L13", "4L13"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			iceshard: ["6L26", "5L26", "4L26"],
			icywind: ["6L1", "5T", "5L1", "4T", "4L1"],
			ingrain: ["6L31", "5L31", "4L31"],
			irontail: ["5T", "4M"],
			leer: ["6L1", "5L1", "4L1"],
			lightscreen: ["6M", "5M", "4M"],
			mist: ["6L21", "5L21", "4L21"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			powdersnow: ["6L1", "5L1", "4L1"],
			protect: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			razorleaf: ["6L1", "5L1", "4L1"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			shadowball: ["6M", "5M", "4M"],
			sheercold: ["6L58", "5L58", "4L58"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			swagger: ["6M", "6L17", "5M", "5L17", "4M", "4L17"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["5T", "4T"],
			toxic: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			woodhammer: ["6L36", "5L36", "4L36"],
			worryseed: ["5T", "4T"],
		},
	},
	rotom: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "6S1", "5L1", "5S0", "4L1"],
			charge: ["6L1", "5L57", "4L43"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confuseray: ["6L1", "5L1", "4L1"],
			darkpulse: ["6M", "5T", "4M"],
			discharge: ["6L1", "5L64", "4L50"],
			doubleteam: ["6M", "6L15", "5M", "5L15", "4M", "4L15"],
			dreameater: ["6M", "5M", "4M"],
			electroball: ["6L43", "5L43"],
			electroweb: ["5T"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			hex: ["6L50", "5L50"],
			hiddenpower: ["6M", "5M", "4M"],
			lightscreen: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["6L29", "5L29", "4T", "4L29"],
			painsplit: ["5T", "4T"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["6L22", "6S1", "5L22", "5D", "4M", "4L22"],
			signalbeam: ["5T", "5D", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			substitute: ["6M", "6L36", "5M", "5L36", "4M", "4L36"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thundershock: ["6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			thunderwave: ["6M", "6L1", "6S1", "5M", "5L1", "5D", "4M", "4L1"],
			toxic: ["6M", "5M", "4M"],
			trick: ["6L1", "6S1", "5T", "5L1", "5S0", "4T", "4L1"],
			uproar: ["6L8", "5T", "5L8", "5S0", "4T", "4L8"],
			voltswitch: ["6M", "5M"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	rotomheat: {
		inherit: true,
		learnset: {
			overheat: ["6R", "5R", "4R"],
		},
	},
	rotomwash: {
		inherit: true,
		learnset: {
			hydropump: ["6R", "5R", "4R"],
		},
	},
	rotomfrost: {
		inherit: true,
		learnset: {
			blizzard: ["6R", "5R", "4R"],
		},
	},
	rotomfan: {
		inherit: true,
		learnset: {
			airslash: ["6R", "5R", "4R"],
		},
	},
	rotommow: {
		inherit: true,
		learnset: {
			leafstorm: ["6R", "5R", "4R"],
		},
	},
	uxie: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			amnesia: ["6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "4S0"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["6L16", "5L16", "4M", "4L16"],
			energyball: ["6M", "5M", "4M"],
			extrasensory: ["6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flail: ["6L1", "5L61", "5S2", "4L61"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			imprison: ["6L6", "5L6", "4L6"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			memento: ["6L1", "5L76", "4L76"],
			mudslap: ["4T"],
			naturalgift: ["6L1", "5L66", "4M", "4L66"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L21", "5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			wonderroom: ["5T"],
			yawn: ["6L31", "6S3", "5L31", "4L31", "4S0", "4S1"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	mesprit: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			blizzard: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			charm: ["6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "4S0"],
			copycat: ["6L1", "5L61", "5S2", "4L61"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			extrasensory: ["6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["6L1", "5L76", "4L76"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			imprison: ["6L6", "5L6", "4L6"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			luckychant: ["6L31", "6S3", "5L31", "4L31", "4S0", "4S1"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mudslap: ["4T"],
			naturalgift: ["6L1", "5L66", "4M", "4L66"],
			poweruppunch: ["6M"],
			protect: ["6M", "6L16", "5M", "5L16", "4M", "4L16"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L21", "5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	azelf: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1", "4S0"],
			dazzlinggleam: ["6M"],
			detect: ["6L16", "5L16", "4L16"],
			doubleteam: ["6M", "5M", "4M"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			explosion: ["6M", "6L76", "5M", "5L76", "4M", "4L76"],
			extrasensory: ["6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firepunch: ["5T", "4T"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			futuresight: ["6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["5T", "4T"],
			imprison: ["6L6", "5L6", "4L6"],
			incinerate: ["6M", "5M"],
			irontail: ["5T", "4M"],
			knockoff: ["5T", "4T"],
			lastresort: ["6L1", "5T", "5L61", "5S2", "4T", "4L61"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mudslap: ["4T"],
			nastyplot: ["6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			naturalgift: ["6L1", "5L66", "4M", "4L66"],
			payback: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["6M", "5M", "4M"],
			roleplay: ["5T", "4T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["6L21", "5L21", "4T", "4L21", "4S1"],
			taunt: ["6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["5T", "4T"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			uproar: ["6L31", "6S3", "5T", "5L31", "4T", "4L31", "4S0", "4S1"],
			uturn: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			wonderroom: ["5T"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	dialga: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			ancientpower: ["6L10", "5L10", "4T", "4L10", "4S0"],
			aurasphere: ["6L37", "6S5", "5L37", "5S4", "4L37"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "5T", "5S4", "4T"],
			dragonbreath: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["5T", "5S4", "4M"],
			dragontail: ["6M", "5M"],
			earthpower: ["6L33", "5T", "5L33", "4T", "4L33", "4S1"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "6L50", "6S5", "6S6", "5M", "5L50", "4M", "4L42"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			irontail: ["6L42", "6S5", "5T", "5L42", "4M"],
			magnetrise: ["5T", "4T"],
			metalburst: ["6L24", "6S6", "5L24", "4L24"],
			metalclaw: ["6L6", "5L6", "4L6", "4S0"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "6S6", "5M", "4M"],
			powergem: ["6L19", "5L19", "4L19"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			roaroftime: ["6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			slash: ["6L15", "5L15", "4L15", "4S1"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
		},
	},
	palkia: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			ancientpower: ["6L10", "5L10", "4T", "4L10", "4S0"],
			aquatail: ["6L24", "5T", "5L24", "4T", "4L24"],
			aurasphere: ["6L37", "6S5", "6S6", "5L37", "5S4", "4L37"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "5T", "5S4", "4T"],
			dragonbreath: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["6M", "6L28", "5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["5T", "4M"],
			dragontail: ["6M", "5M"],
			earthpower: ["6L33", "6S5", "6S6", "5T", "5L33", "4T", "4L33", "4S1"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6L50", "6S5", "6S6", "5L50", "5S4", "4L42"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5T", "4T"],
			powergem: ["6L19", "5L19", "4L19"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			scaryface: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			slash: ["6L15", "5L15", "4L15", "4S1"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			spacialrend: ["6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			waterpulse: ["6L6", "5L6", "4M", "4L6", "4S0"],
			whirlpool: ["4M"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["6L1", "5L1", "4T", "4L1", "4S2"],
			attract: ["6M", "5M", "4M"],
			bugbite: ["5T", "4T"],
			bulldoze: ["6M", "5M"],
			captivate: ["4M"],
			confide: ["6M"],
			crunch: ["6L33", "6S4", "5L33", "4L33", "4S1"],
			darkpulse: ["6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["6M", "5M", "4M"],
			dragonpulse: ["5T", "4M"],
			earthpower: ["6L1", "5T", "5L73", "4T", "4L73", "4S2"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			eruption: ["4S2"],
			explosion: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			firefang: ["6L17", "5L17", "4L17"],
			firespin: ["6L1", "5L57", "5S3", "4L57", "4S0"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6L1", "5T", "5L81", "4T", "4L81"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["6L1", "5T", "5L65", "5S3", "4T", "4L65", "4S0"],
			lavaplume: ["6L49", "6S4", "5L49", "5S3", "4L49", "4S0", "4S1"],
			leer: ["6L9", "5L9", "4L9"],
			magmastorm: ["6L1", "5L96", "4L96", "4S2"],
			metalsound: ["6L25", "6S4", "5L25", "4L25", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			overheat: ["6M", "5M", "4M"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			scaryface: ["6L41", "6S4", "5L41", "5S3", "4L41", "4S0", "4S1"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "6L88", "5M", "5L88", "4M", "4L88"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	regigigas: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			ancientpower: ["4T"],
			avalanche: ["4M"],
			block: ["5T", "4T"],
			brickbreak: ["6M", "5M", "4M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			confuseray: ["6L1", "5L1", "4L1", "4S0", "4S1"],
			crushgrip: ["6L1", "5L75", "4L75", "4S2"],
			dizzypunch: ["6L1", "5L1", "4L1", "4S1"],
			doubleteam: ["6M", "5M", "4M"],
			drainpunch: ["5T", "4M"],
			earthpower: ["5T", "4T"],
			earthquake: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			firepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["6L1", "6S4", "5L1", "4L1", "4S1"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "6L100", "5M", "5L100", "4M", "4L100"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			heavyslam: ["6L1", "5L90"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icepunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			icywind: ["5T", "4T", "4S2"],
			ironhead: ["5T", "4T", "4S2"],
			knockoff: ["6L1", "5T", "5L1", "4L1", "4S1"],
			megapunch: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["6M"],
			payback: ["6M", "6L65", "5M", "5L65", "5S3"],
			poweruppunch: ["6M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			revenge: ["6L25", "6S4", "5L25", "5S3", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["6M", "5M", "4M"],
			rockslide: ["6M", "5M", "4M", "4S2"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			smackdown: ["6M", "5M"],
			snore: ["5T", "4T"],
			stomp: ["4L1", "4S0"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			superpower: ["5T", "4T", "4L25", "4S0"],
			swagger: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderpunch: ["6L1", "5T", "5L1", "4T", "4L1"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			wideguard: ["6L40", "6S4", "5L40", "5S3"],
			zenheadbutt: ["6L50", "6S4", "5T", "5L50", "5S3", "4T", "4L50", "4S0"],
		},
	},
	giratina: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			aircutter: ["4T"],
			ancientpower: ["6L10", "5L10", "4T", "4L10", "4S1"],
			aquatail: ["5T", "4T"],
			aurasphere: ["6L37", "6S5", "6S6", "5L37", "5S4", "4L37"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			destinybond: ["6L24", "5L24", "4L24"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "6S6", "5T", "4T"],
			dragonbreath: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["6M", "6L28", "5M", "5L28", "5S4", "4M", "4L28", "4S1"],
			dragonpulse: ["5T", "5S4", "4M"],
			dragontail: ["6M", "5M"],
			dreameater: ["6M", "5M", "4M"],
			earthpower: ["6L33", "5T", "5L33", "4T", "4L33", "4S0"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S0"],
			hex: ["6L50", "6S5", "5L50"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypervoice: ["5T"],
			icywind: ["5T", "4T"],
			ironhead: ["6S6", "5T", "4T"],
			irontail: ["5T", "4M"],
			magiccoat: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["6L6", "5L6", "4T", "4L6", "4S1"],
			outrage: ["5T", "4T"],
			painsplit: ["5T", "4T"],
			payback: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			scaryface: ["6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "6L42", "6S5", "5M", "5L42", "4M", "4L42"],
			shadowforce: ["6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			shadowsneak: ["6L19", "5L19", "4L19"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			slash: ["6L15", "5L15", "4L15", "4S0"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			spite: ["5T", "4T"],
			steelwing: ["6M", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			twister: ["4T"],
			willowisp: ["6M", "5M", "4M"],
		},
	},
	cresselia: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M", "4M"],
			aurorabeam: ["6L29", "6S3", "5L29", "4L29", "4S0"],
			calmmind: ["6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1", "4L1"],
			doubleteam: ["6M", "6L1", "5M", "5L1", "4M", "4L1"],
			dreameater: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "5S2", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["6L38", "6S3", "5L38", "5S1", "4L38", "4S0"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "5S2", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "5S2", "4M"],
			icywind: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			lunardance: ["6L1", "5L84", "4L84"],
			magiccoat: ["5T", "4T"],
			magicroom: ["5T"],
			mist: ["6L20", "6S3", "5L20", "4L20", "4S0"],
			moonblast: ["6L99"],
			moonlight: ["6L1", "5L57", "5S1", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "6L93", "5M", "5L93", "4M", "4L93"],
			psychocut: ["6L1", "5L66", "5S1", "4L66"],
			psychoshift: ["6L1", "5L75", "4L75"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M", "5S2"],
			raindance: ["6M", "5M", "4M"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L11", "5M", "5L11", "4M", "4L11"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			slash: ["6L47", "6S3", "5L47", "5S1", "4L47", "4S0"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	phione: {
		inherit: true,
		learnset: {
			acidarmor: ["6L31", "5L31", "4L31"],
			ancientpower: ["4T"],
			aquaring: ["6L54", "5L54", "4L54"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bubble: ["6L1", "5L1", "4L1"],
			bubblebeam: ["6L24", "5L24", "4L24"],
			charm: ["6L9", "5L9", "4L9"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "6L61", "5M", "5L61", "4T", "4L61"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M", "4S0"],
			hail: ["6M", "5M", "4M"],
			healbell: ["5T", "4T"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "6L69", "5M", "5L69", "4M", "4L69", "4S0"],
			rest: ["6M", "5M", "4M", "4S0"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["5T", "4T"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			supersonic: ["6L16", "5L16", "4L16"],
			surf: ["6M", "5M", "4M", "4S0"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpulse: ["6L46", "5L46", "4M", "4L46"],
			watersport: ["6L1", "5L1", "4L1"],
			whirlpool: ["6L39", "5L39", "4M", "4L39"],
		},
	},
	manaphy: {
		inherit: true,
		learnset: {
			acidarmor: ["6L31", "5L31", "4L31", "4S2"],
			ancientpower: ["4T"],
			aquaring: ["6L54", "5L54", "4L54", "4S3"],
			blizzard: ["6M", "5M", "4M"],
			bounce: ["5T", "4T"],
			brine: ["4M"],
			bubble: ["6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1"],
			bubblebeam: ["6L24", "5L24", "4L24"],
			calmmind: ["6M", "5M", "4M"],
			charm: ["6L9", "5L9", "4L9"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "6L61", "5M", "5L61", "4T", "4L61"],
			doubleteam: ["6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			hail: ["6M", "5M", "4M"],
			healbell: ["5T", "4T"],
			heartswap: ["6L76", "6S4", "5L76", "4L76", "4S2", "4S3"],
			helpinghand: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			raindance: ["6M", "6L69", "5M", "5L69", "4M", "4L69"],
			reflect: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			scald: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M"],
			signalbeam: ["5T", "4T"],
			skillswap: ["5T", "4M"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			substitute: ["6M", "5M", "4M"],
			supersonic: ["6L16", "5L16", "4L16"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			tailglow: ["6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1"],
			toxic: ["6M", "5M", "4M"],
			uproar: ["5T", "4T"],
			uturn: ["6M", "5M", "4M"],
			waterfall: ["6M", "5M", "4M"],
			waterpulse: ["6L46", "5L46", "4M", "4L46", "4S2", "4S3"],
			watersport: ["6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1", "4S3"],
			whirlpool: ["6L39", "5L39", "4M", "4L39", "4S2"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "6L93", "6S5", "5T", "5L93", "4M", "4L93", "4S2"],
			darkvoid: ["6L66", "6S5", "6S6", "5L66", "5S4", "4L66", "4S2"],
			disable: ["6L1", "5L1", "4L1"],
			doubleteam: ["6M", "6L47", "5M", "5L47", "4M", "4L47", "4S2", "4S3"],
			drainpunch: ["5T", "4M"],
			dreameater: ["6M", "6L84", "6S5", "5M", "5L84", "4M", "4L84"],
			embargo: ["6M", "5M", "4M", "4L75"],
			endure: ["4M"],
			facade: ["6M", "5M", "4M"],
			feintattack: ["6L29", "6S6", "5L29", "5S4", "4L29", "4S3"],
			flash: ["6M", "5M", "4M"],
			fling: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			focuspunch: ["4M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			haze: ["6L57", "5L57", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			hypnosis: ["6L20", "5L20", "4L20", "4S0", "4S1", "4S3"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T", "4T"],
			lastresort: ["5T", "4T"],
			mudslap: ["4T"],
			nastyplot: ["6L75", "5L75", "4L75"],
			naturalgift: ["4M"],
			nightmare: ["6L38", "6S6", "5L38", "5S4", "4L38", "4S0", "4S1", "4S3"],
			nightshade: ["4L1"],
			ominouswind: ["6L1", "6S6", "5L1", "5S4", "4T", "4L1"],
			payback: ["6M", "5M", "4M"],
			phantomforce: ["6S5"],
			poisonjab: ["6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			pursuit: ["4L29", "4S0"],
			quickattack: ["6L11", "5L11", "4L11", "4S0"],
			raindance: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roaroftime: ["4S1"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["6M", "5M", "4M", "4S2"],
			shadowclaw: ["6M", "5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snarl: ["6M", "5M"],
			snatch: ["5T", "4M"],
			snore: ["5T", "4T"],
			spacialrend: ["4S1"],
			spite: ["5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			taunt: ["6M", "5M", "4M"],
			thief: ["6M", "5M", "4M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			torment: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			willowisp: ["6M", "5M", "4M"],
			wonderroom: ["5T"],
			xscissor: ["6M", "5M", "4M"],
		},
	},
	shaymin: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L64", "6S4", "5L64", "4L64", "4S0"],
			bulletseed: ["4M"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			defensecurl: ["4L1"],
			doubleteam: ["6M", "5M", "4M"],
			earthpower: ["5T", "4T"],
			endeavor: ["5T", "4T"],
			endure: ["4M"],
			energyball: ["6M", "6L73", "6S4", "5M", "5L73", "4M", "4L73", "4S0"],
			facade: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			grasswhistle: ["4L82"],
			growth: ["6L1", "6S3", "5L1", "4L1", "4S1"],
			headbutt: ["4T"],
			healingwish: ["6L91", "5L91", "4L91"],
			hiddenpower: ["6M", "5M", "4M"],
			hyperbeam: ["6M", "5M", "4M"],
			lastresort: ["5T", "4T"],
			leechseed: ["6L19", "5L19", "5S2", "4L19", "4S1"],
			luckychant: ["4L91"],
			magicalleaf: ["6L10", "6S3", "5L10", "4L10", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["6L46", "5L46", "4M", "4L46"],
			naturepower: ["6M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			rest: ["6M", "5M", "4M"],
			return: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["5T", "4T"],
			seedflare: ["6L100", "6S3", "6S4", "5L100", "5S2", "4L100", "4S0"],
			sleeptalk: ["6M", "5T", "4M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			substitute: ["6M", "6S4", "5M", "4M", "4S0"],
			sunnyday: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			sweetkiss: ["6L82", "5L82", "4L82"],
			sweetscent: ["6L37", "5L37", "5S2", "4L37"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			synthesis: ["6L28", "5T", "5L28", "5S2", "4T", "4L28", "4S1"],
			toxic: ["6M", "5M", "4M"],
			worryseed: ["6L55", "5T", "5L55", "4T", "4L55"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	arceus: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M", "4M"],
			ancientpower: ["4T"],
			aquatail: ["5T", "4T"],
			avalanche: ["4M"],
			blizzard: ["6M", "5M", "4M"],
			brickbreak: ["6M", "5M", "4M"],
			brine: ["4M"],
			bulldoze: ["6M", "5M"],
			bulletseed: ["4M"],
			calmmind: ["6M", "5M", "4M"],
			chargebeam: ["6M", "5M", "4M"],
			confide: ["6M"],
			cosmicpower: ["6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["6M", "5T", "4M"],
			defog: ["4M"],
			dive: ["6M", "4T"],
			doubleteam: ["6M", "5M", "4M"],
			dracometeor: ["6T", "5T", "4T"],
			dragonclaw: ["6M", "5M", "4M"],
			dragonpulse: ["5T", "4M"],
			dreameater: ["6M", "5M", "4M"],
			earthpower: ["6L20", "6S2", "5T", "5L20", "4T", "4L20"],
			earthquake: ["6M", "5M", "4M"],
			echoedvoice: ["6M", "5M"],
			endure: ["4M"],
			energyball: ["6M", "5M", "4M"],
			extremespeed: ["6L40", "5L40", "4L40"],
			facade: ["6M", "5M", "4M"],
			fireblast: ["6M", "5M", "4M"],
			flamethrower: ["6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["6M", "5M", "4M"],
			fly: ["6M", "5M", "4M"],
			focusblast: ["6M", "5M", "4M"],
			frustration: ["6M", "5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["6L60", "5L60", "4L60"],
			gigadrain: ["5T", "4M"],
			gigaimpact: ["6M", "5M", "4M"],
			grassknot: ["6M", "5M", "4M"],
			gravity: ["6L10", "5T", "5L10", "4T", "4L10"],
			hail: ["6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5T", "4T"],
			hiddenpower: ["6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L80", "6S3", "5M", "5L80", "5S1", "4M", "4L80"],
			hypervoice: ["6L30", "5T", "5L30", "4L30"],
			icebeam: ["6M", "5M", "4M"],
			icywind: ["5T", "4T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T", "4T"],
			ironhead: ["5T", "4T"],
			irontail: ["5T", "4M"],
			judgment: ["6L100", "6S2", "6S3", "5L100", "5S1", "4L100", "4S0"],
			lastresort: ["5T", "4T"],
			lightscreen: ["6M", "5M", "4M"],
			magiccoat: ["5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["6L1", "5L1", "4M", "4L1"],
			ominouswind: ["4T"],
			outrage: ["5T", "4T"],
			overheat: ["6M", "5M", "4M"],
			payback: ["6M", "5M", "4M"],
			perishsong: ["6L90", "6S3", "5L90", "5S1", "4L90"],
			poisonjab: ["6M", "5M", "4M"],
			protect: ["6M", "5M", "4M"],
			psychic: ["6M", "5M", "4M"],
			psychup: ["6M", "5M", "4M"],
			psyshock: ["6M", "5M"],
			punishment: ["6L1", "5L1", "4L1"],
			quash: ["6M", "5M"],
			raindance: ["6M", "5M", "4M"],
			recover: ["6L70", "6S3", "5L70", "5S1", "4L70"],
			recycle: ["5T", "4M"],
			reflect: ["6M", "5M", "4M"],
			refresh: ["6L50", "5L50", "4L50"],
			rest: ["6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M", "4M"],
			roar: ["6M", "5M", "4M"],
			roaroftime: ["4S0"],
			rockclimb: ["4M"],
			rockslide: ["6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["6M", "5M", "4M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M", "4M"],
			sandstorm: ["6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seismictoss: ["6L1", "5L1", "4L1"],
			shadowball: ["6M", "5M", "4M"],
			shadowclaw: ["6M", "5M", "4M"],
			shadowforce: ["4S0"],
			shockwave: ["4M"],
			signalbeam: ["5T", "4T"],
			silverwind: ["4M"],
			sleeptalk: ["6M", "5T", "4M"],
			sludgebomb: ["6M", "5M", "4M"],
			snarl: ["6M", "5M"],
			snore: ["5T", "4T"],
			solarbeam: ["6M", "5M", "4M"],
			spacialrend: ["4S0"],
			stealthrock: ["5T", "4M"],
			stoneedge: ["6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["6M", "5M", "4M"],
			sunnyday: ["6M", "5M", "4M"],
			surf: ["6M", "5M", "4M"],
			swagger: ["6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["6M", "5M", "4M"],
			tailwind: ["5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M", "4M"],
			thunderbolt: ["6M", "5M", "4M"],
			thunderwave: ["6M", "5M", "4M"],
			toxic: ["6M", "5M", "4M"],
			trick: ["5T", "4T"],
			trickroom: ["6M", "5M", "4M"],
			twister: ["4T"],
			waterfall: ["6M", "5M", "4M"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			willowisp: ["6M", "5M", "4M"],
			workup: ["5M"],
			xscissor: ["6M", "5M", "4M"],
			zenheadbutt: ["5T", "4T"],
		},
	},
	victini: {
		inherit: true,
		learnset: {
			blueflare: ["5S2"],
			boltstrike: ["5S2"],
			bounce: ["5T"],
			brickbreak: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			confusion: ["6L1", "6S3", "6S4", "5L1", "5S0"],
			dazzlinggleam: ["6M"],
			doubleedge: ["6L65", "5L65"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endure: ["6L9", "6S4", "5L9", "5S0"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			finalgambit: ["6L81", "5L81"],
			fireblast: ["6M", "5M"],
			firepunch: ["5T"],
			flameburst: ["6L41", "5L41"],
			flamecharge: ["6M", "6L25", "5M", "5L25"],
			flamethrower: ["6M", "5M"],
			flareblitz: ["6L73", "5L73"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L1", "5L1"],
			frustration: ["6M", "5M"],
			fusionbolt: ["5S1"],
			fusionflare: ["5S1"],
			gigaimpact: ["6M", "5M"],
			glaciate: ["5S2"],
			grassknot: ["6M", "5M"],
			headbutt: ["6L17", "5L17"],
			heatwave: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "6L1", "6S4", "5M", "5L1", "5S0"],
			inferno: ["6L57", "5L57"],
			lastresort: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			overheat: ["6M", "6L97", "5M", "5L97"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			quickattack: ["6L1", "6S3", "6S4", "6S5", "5L1", "5S0"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			reversal: ["6L33", "5L33"],
			rocksmash: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			searingshot: ["6L1", "6S3", "5L1", "5S1"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			storedpower: ["6L89", "5L89"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "6S5", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			vcreate: ["6S3", "6S5", "5S1", "5S2"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["6L49", "5T", "5L49"],
		},
	},
	snivy: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			aromatherapy: ["5S0"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			calmmind: ["6M", "5M"],
			captivate: ["6E", "5E"],
			coil: ["6L31", "5L31"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			energyball: ["6M", "5M", "5S0"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["6L40", "5T", "5L40"],
			gigadrain: ["6L34", "5T", "5L34"],
			glare: ["6E", "5E"],
			grassknot: ["6M", "5M"],
			grasspledge: ["6T", "5T"],
			grassyterrain: ["6E"],
			growth: ["6L13", "5L13", "5S0"],
			hiddenpower: ["6M", "5M"],
			irontail: ["6E", "5T", "5E"],
			knockoff: ["5T"],
			leafblade: ["6L28", "5L28"],
			leafstorm: ["6L43", "5L43"],
			leaftornado: ["6L16", "5L16"],
			leechseed: ["6L19", "5L19"],
			leer: ["6L4", "5L4"],
			lightscreen: ["6M", "5M"],
			magicalleaf: ["6E", "5E"],
			meanlook: ["6E", "5E"],
			megadrain: ["6L22", "5L22"],
			mirrorcoat: ["6E", "5E"],
			naturalgift: ["6E", "5E"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			slam: ["6L25", "5L25"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			sweetscent: ["6E", "5E"],
			swordsdance: ["6M", "5M"],
			synthesis: ["5T", "5S0"],
			tackle: ["6L1", "5L1"],
			taunt: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			twister: ["6E", "5E"],
			vinewhip: ["6L7", "5L7"],
			worryseed: ["5T"],
			wrap: ["6L10", "5L10"],
			wringout: ["6L37", "5L37"],
		},
	},
	servine: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			calmmind: ["6M", "5M"],
			coil: ["6L36", "5L36"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["6L48", "5T", "5L48"],
			gigadrain: ["6L40", "5T", "5L40"],
			grassknot: ["6M", "5M"],
			grasspledge: ["6T", "5T"],
			growth: ["6L13", "5L13"],
			hiddenpower: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leafblade: ["6L32", "5L32"],
			leafstorm: ["6L52", "5L52"],
			leaftornado: ["6L16", "5L16"],
			leechseed: ["6L20", "5L20"],
			leer: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			megadrain: ["6L24", "5L24"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			slam: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			taunt: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			vinewhip: ["6L1", "5L1"],
			worryseed: ["5T"],
			wrap: ["6L1", "5L1"],
			wringout: ["6L44", "5L44"],
		},
	},
	serperior: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			calmmind: ["6M", "5M"],
			coil: ["6L38", "5L38"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dragonpulse: ["5T"],
			dragontail: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frenzyplant: ["6T", "5T"],
			frustration: ["6M", "5M"],
			gastroacid: ["6L56", "5T", "5L56"],
			gigadrain: ["6L44", "6S1", "5T", "5L44", "5S0"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			grasspledge: ["6T", "5T"],
			growth: ["6L13", "5L13"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leafblade: ["6L32", "5L32"],
			leafstorm: ["6L62", "6S1", "5L62", "5S0"],
			leaftornado: ["6L16", "5L16"],
			leechseed: ["6L20", "5L20", "5S0"],
			leer: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			megadrain: ["6L24", "5L24"],
			naturepower: ["6M"],
			outrage: ["5T"],
			protect: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			slam: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M", "5S0"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			taunt: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			vinewhip: ["6L1", "5L1"],
			worryseed: ["5T"],
			wrap: ["6L1", "5L1"],
			wringout: ["6L50", "6S1", "5L50"],
		},
	},
	tepig: {
		inherit: true,
		learnset: {
			assurance: ["6L31", "5L31"],
			attract: ["6M", "5M"],
			bodyslam: ["6E", "5E"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			curse: ["6E", "5E"],
			defensecurl: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L7", "5L7"],
			endeavor: ["6E", "5T", "5E"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firepledge: ["6T", "5T"],
			flamecharge: ["6M", "6L15", "5M", "5L15"],
			flamethrower: ["6M", "6L33", "5M", "5L33"],
			flareblitz: ["6L43", "5L43"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			headsmash: ["6L37", "5L37"],
			heatcrash: ["6L27", "5L27"],
			heatwave: ["5T"],
			heavyslam: ["6E", "5E"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			magnitude: ["6E", "5E"],
			odorsleuth: ["6L9", "5L9"],
			overheat: ["6M", "5M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L39", "5M", "5L39"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L21", "5L21"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			smog: ["6L19", "5L19"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6E"],
			sunnyday: ["6M", "5M"],
			superpower: ["6E", "5T", "5E"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L3", "5L3"],
			takedown: ["6L25", "5L25"],
			taunt: ["6M", "5M"],
			thrash: ["6E", "5E"],
			toxic: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			yawn: ["6E", "5E"],
		},
	},
	pignite: {
		inherit: true,
		learnset: {
			armthrust: ["6L17", "5L17"],
			assurance: ["6L36", "5L36"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			defensecurl: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T"],
			flamecharge: ["6M", "6L15", "5M", "5L15"],
			flamethrower: ["6M", "6L39", "5M", "5L39"],
			flareblitz: ["6L52", "5L52"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			headsmash: ["6L44", "5L44"],
			heatcrash: ["6L31", "5L31"],
			heatwave: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			odorsleuth: ["6L1", "5L1"],
			overheat: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L47", "5M", "5L47"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L23", "5L23"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smog: ["6L20", "5L20"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L1", "5L1"],
			takedown: ["6L28", "5L28"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	emboar: {
		inherit: true,
		learnset: {
			armthrust: ["6L17", "5L17"],
			assurance: ["6L38", "5L38"],
			attract: ["6M", "5M"],
			blastburn: ["6T", "5T"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			defensecurl: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firepledge: ["6T", "5T"],
			firepunch: ["5T"],
			flamecharge: ["6M", "6L15", "5M", "5L15"],
			flamethrower: ["6M", "6L43", "5M", "5L43"],
			flareblitz: ["6L62", "6S1", "5L62", "5S0"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hammerarm: ["6L1", "5L1", "5S0"],
			headsmash: ["6L50", "6S1", "5L50", "5S0"],
			heatcrash: ["6L31", "5L31"],
			heatwave: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T"],
			irontail: ["5T"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			odorsleuth: ["6L1", "5L1"],
			overheat: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L55", "5M", "5L55"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L23", "5L23"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			smog: ["6L20", "5L20"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L1", "5L1"],
			takedown: ["6L28", "6S1", "5L28"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			wildcharge: ["6M", "5M", "5S0"],
			willowisp: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	oshawott: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			airslash: ["6E", "5E"],
			aquajet: ["6L29", "5L29"],
			aquatail: ["6L35", "5T", "5L35"],
			assurance: ["6E", "5E"],
			attract: ["6M", "5M"],
			blizzard: ["6M", "5M"],
			brine: ["6E", "5E"],
			confide: ["6M"],
			copycat: ["6E", "5E"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			detect: ["6E", "5E"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			encore: ["6L31", "5L31"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusenergy: ["6L13", "5L13"],
			frustration: ["6M", "5M"],
			furycutter: ["6L19", "5L19"],
			grassknot: ["6M", "5M"],
			hail: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L43", "5L43"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			irontail: ["5T"],
			nightslash: ["6E", "5E"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			razorshell: ["6L17", "5L17"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L37", "5M", "5L37"],
			return: ["6M", "5M"],
			revenge: ["6L25", "5L25"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			screech: ["6E", "5E"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L41", "5M", "5L41"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L5", "5L5"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trumpcard: ["6E", "5E"],
			waterfall: ["6M", "5M"],
			watergun: ["6L7", "5L7"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6L23", "5L23"],
			watersport: ["6L11", "5L11"],
			xscissor: ["6M", "5M"],
		},
	},
	dewott: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquajet: ["6L33", "5L33"],
			aquatail: ["6L41", "5T", "5L41"],
			attract: ["6M", "5M"],
			blizzard: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			encore: ["6L36", "5L36"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusenergy: ["6L13", "5L13"],
			frustration: ["6M", "5M"],
			furycutter: ["6L20", "5L20"],
			grassknot: ["6M", "5M"],
			hail: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L52", "5L52"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			irontail: ["5T"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			razorshell: ["6L17", "5L17"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L44", "5M", "5L44"],
			return: ["6M", "5M"],
			revenge: ["6L28", "5L28"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L49", "5M", "5L49"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L1", "5L1"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			watergun: ["6L1", "5L1"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6L25", "5L25"],
			watersport: ["6L1", "5L1"],
			xscissor: ["6M", "5M"],
		},
	},
	samurott: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquajet: ["6L33", "5L33"],
			aquatail: ["6L45", "5T", "5L45"],
			attract: ["6M", "5M"],
			blizzard: ["6M", "5M"],
			block: ["5T"],
			confide: ["6M", "6S1"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dragontail: ["6M", "5M"],
			encore: ["6L38", "5L38"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusenergy: ["6L13", "5L13"],
			frustration: ["6M", "5M"],
			furycutter: ["6L20", "5L20"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hail: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hydrocannon: ["6T", "5T"],
			hydropump: ["6L62", "6S1", "5L62", "5S0"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M", "5S0"],
			icywind: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			megahorn: ["6L1", "5L1", "5S0"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			razorshell: ["6L17", "6S1", "5L17"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L50", "5M", "5L50"],
			return: ["6M", "5M"],
			revenge: ["6L28", "5L28"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			slash: ["6L36", "5L36"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T", "5S0"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L57", "5M", "5L57"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L1", "5L1"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			watergun: ["6L1", "5L1"],
			waterpledge: ["6T", "5T"],
			waterpulse: ["6L25", "5L25"],
			watersport: ["6L1", "5L1"],
			xscissor: ["6M", "5M"],
		},
	},
	patrat: {
		inherit: true,
		learnset: {
			afteryou: ["6L23", "5T", "5L23"],
			aquatail: ["5T"],
			assurance: ["6E", "5E"],
			attract: ["6M", "5M"],
			batonpass: ["6L33", "5L33"],
			bide: ["6L8", "5L8"],
			bite: ["6L6", "5L6"],
			confide: ["6M"],
			covet: ["5T"],
			crunch: ["6L16", "5L16"],
			cut: ["6M", "5M"],
			detect: ["6L11", "5L11"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			flail: ["6E", "5E"],
			fling: ["6M", "5M"],
			foresight: ["6E", "5E"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperfang: ["6L28", "5L28"],
			hypnosis: ["6L18", "5L18"],
			irontail: ["6E", "5T", "5E"],
			lastresort: ["5T"],
			leer: ["6L3", "5L3"],
			lowkick: ["5T"],
			meanlook: ["6L31", "5L31"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6E", "5E"],
			round: ["6M", "5M"],
			sandattack: ["6L13", "5L13"],
			screech: ["6E", "5E"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			slam: ["6L36", "5L36"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superfang: ["6L21", "5T", "5L21"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			thunderbolt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["6L26", "5M", "5L26"],
			zenheadbutt: ["5T"],
		},
	},
	watchog: {
		inherit: true,
		learnset: {
			afteryou: ["6L25", "5T", "5L25"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			batonpass: ["6L39", "5L39"],
			bide: ["6L8", "5L8"],
			bite: ["6L1", "5L1"],
			confide: ["6M"],
			confuseray: ["6L20", "5L20"],
			covet: ["5T"],
			crunch: ["6L16", "5L16"],
			cut: ["6M", "5M"],
			detect: ["6L11", "5L11"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hyperfang: ["6L32", "5L32"],
			hypnosis: ["6L18", "5L18"],
			icepunch: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			lastresort: ["5T"],
			leer: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			lowkick: ["6L1", "5T", "5L1"],
			meanlook: ["6L36", "5L36"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "6L29", "5M", "5L29"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			sandattack: ["6L13", "5L13"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			slam: ["6L43", "5L43"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superfang: ["6L22", "5T", "5L22"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T"],
		},
	},
	lillipup: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			afteryou: ["6E"],
			attract: ["6M", "5M"],
			babydolleyes: ["6L10"],
			bite: ["6L8", "5L8"],
			charm: ["6E", "5E"],
			confide: ["6M"],
			covet: ["5T"],
			crunch: ["6L22", "5L22"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			firefang: ["6E", "5E"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L40", "5M", "5L40"],
			helpinghand: ["6L12", "5T", "5L12"],
			hiddenpower: ["6M", "5M"],
			howl: ["6E", "5E"],
			hypervoice: ["5T"],
			icefang: ["6E", "5E"],
			lastresort: ["6L36", "5T", "5L36"],
			leer: ["6L1", "5L1"],
			lick: ["6E", "5E"],
			mudslap: ["6E", "5E"],
			odorsleuth: ["6L5", "5L5"],
			playrough: ["6L45"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L29", "5M", "5L29"],
			return: ["6M", "5M"],
			reversal: ["6L33", "5L33"],
			roar: ["6M", "6L26", "5M", "5L26"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			takedown: ["6L15", "5L15"],
			thunderbolt: ["6M", "5M"],
			thunderfang: ["6E", "5E"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			wildcharge: ["6M", "5M"],
			workup: ["6L19", "5M", "5L19"],
			yawn: ["6E", "5E"],
		},
	},
	herdier: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			confide: ["6M"],
			covet: ["5T"],
			crunch: ["6L24", "5L24"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L47", "5M", "5L47"],
			helpinghand: ["6L12", "5T", "5L12"],
			hiddenpower: ["6M", "5M"],
			hypervoice: ["5T"],
			lastresort: ["6L42", "5T", "5L42"],
			leer: ["6L1", "5L1"],
			odorsleuth: ["6L1", "5L1"],
			payback: ["6M", "5M"],
			playrough: ["6L52"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L33", "5M", "5L33"],
			return: ["6M", "5M"],
			reversal: ["6L38", "5L38"],
			roar: ["6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			takedown: ["6L15", "5L15"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			wildcharge: ["6M", "5M"],
			workup: ["6L20", "5M", "5L20"],
		},
	},
	stoutland: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			confide: ["6M"],
			covet: ["5T"],
			crunch: ["6L24", "5L24"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			firefang: ["6L1", "5L1"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L59", "5M", "5L59"],
			helpinghand: ["6L12", "5T", "5L12"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["5T"],
			icefang: ["6L1", "5L1"],
			ironhead: ["5T"],
			lastresort: ["6L51", "5T", "5L51"],
			leer: ["6L1", "5L1"],
			odorsleuth: ["6L1", "5L1"],
			payback: ["6M", "5M"],
			playrough: ["6L63"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L36", "5M", "5L36"],
			return: ["6M", "5M"],
			reversal: ["6L42", "5L42"],
			roar: ["6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			takedown: ["6L15", "5L15"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderfang: ["6L1", "5L1"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			wildcharge: ["6M", "5M"],
			workup: ["6L20", "5M", "5L20"],
		},
	},
	purrloin: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			assist: ["6L6", "5L6"],
			assurance: ["6L28", "5L28"],
			attract: ["6M", "5M"],
			captivate: ["6L33", "5L33"],
			charm: ["6E", "5E"],
			confide: ["6M"],
			copycat: ["6E"],
			covet: ["6E", "5T", "5E"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M"],
			encore: ["6E", "5E"],
			facade: ["6M", "5M"],
			fakeout: ["6L21", "5L21"],
			faketears: ["6E", "5E"],
			feintattack: ["6E", "5E"],
			foulplay: ["6E", "5T", "5E"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L12", "5L12"],
			grassknot: ["6M", "5M"],
			growl: ["6L3", "5L3"],
			gunkshot: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L24", "5M", "5L24"],
			hypervoice: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			nastyplot: ["6L42", "5L42"],
			nightslash: ["6L37", "5L37"],
			payback: ["6M", "5M"],
			payday: ["6E", "5E"],
			playrough: ["6L49"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			pursuit: ["6L15", "5L15"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sandattack: ["6L10", "5L10"],
			scratch: ["6L1", "5L1"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L30", "5L30"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["6L39", "5T", "5L39"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6L46", "5L46"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "6L19", "5M", "5L19"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			uturn: ["6M", "5M"],
			yawn: ["6E", "5E"],
		},
	},
	liepard: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			assist: ["6L1", "5L1"],
			assurance: ["6L31", "5L31"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M"],
			encore: ["5S0"],
			facade: ["6M", "5M"],
			fakeout: ["6L22", "5L22", "5S0"],
			foulplay: ["5T", "5S0"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L12", "5L12"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			gunkshot: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L26", "5M", "5L26"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			nastyplot: ["6L50", "5L50"],
			nightslash: ["6L43", "5L43"],
			payback: ["6M", "5M"],
			playrough: ["6L58"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			pursuit: ["6L15", "5L15"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			scratch: ["6L1", "5L1"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L34", "5L34"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["6L47", "5T", "5L47"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6L55", "5L55"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M", "5S0"],
			taunt: ["6M", "6L38", "5M", "5L38"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "6L19", "5M", "5L19"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			uturn: ["6M", "5M"],
		},
	},
	pansage: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L31", "5M", "5L31"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			bite: ["6L19", "5L19", "5S0"],
			bulletseed: ["6E", "5E", "5S0"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			crunch: ["6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M", "5S0", "5S2"],
			disarmingvoice: ["6E"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "6L28", "5M", "5L28"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L13", "5L13"],
			gigadrain: ["5T"],
			grassknot: ["6M", "6L34", "5M", "5L34"],
			grasswhistle: ["6E", "5E"],
			gunkshot: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leafstorm: ["6E", "5E", "5S1"],
			leechseed: ["6L16", "5L16"],
			leer: ["6L4", "5L4", "5S1"],
			lick: ["6L7", "5L7", "5S1"],
			lowkick: ["6E", "5T", "5E"],
			lowsweep: ["6M", "5M"],
			magicalleaf: ["6E", "5E"],
			nastyplot: ["6E", "5E"],
			naturalgift: ["6L40", "5L40"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			playnice: ["6L1"],
			protect: ["6M", "5M"],
			recycle: ["6L37", "5T", "5L37"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M", "5S2"],
			roleplay: ["6E", "5T", "5E"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1"],
			seedbomb: ["6L22", "5T", "5L22", "5S2"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M", "5S0", "5S2"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synthesis: ["5T"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			tickle: ["6E", "5E"],
			torment: ["6M", "6L25", "5M", "5L25"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			vinewhip: ["6L10", "5L10", "5S1"],
			workup: ["5M"],
			worryseed: ["5T"],
		},
	},
	simisage: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L1", "5L1"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lick: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			seedbomb: ["6L1", "5T", "5L1"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			synthesis: ["5T"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			workup: ["5M"],
			worryseed: ["5T"],
		},
	},
	pansear: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L31", "5M", "5L31"],
			amnesia: ["6L25", "5L25"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			bite: ["6L19", "5L19"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			crunch: ["6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			disarmingvoice: ["6E"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "6L34", "5M", "5L34"],
			firepunch: ["6E", "5T", "5E"],
			firespin: ["6E", "5E"],
			flameburst: ["6L22", "5L22"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			fling: ["6M", "6L28", "5M", "5L28"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L13", "5L13"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			heatwave: ["6E", "5T", "5E", "5S0"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "6L10", "5M", "5L10", "5S0"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L4", "5L4", "5S0"],
			lick: ["6L7", "5L7", "5S0"],
			lowkick: ["6E", "5T", "5E"],
			lowsweep: ["6M", "5M"],
			nastyplot: ["6E", "5E"],
			naturalgift: ["6L40", "5L40"],
			overheat: ["6M", "5M"],
			payback: ["6M", "5M"],
			playnice: ["6L1"],
			protect: ["6M", "5M"],
			recycle: ["6L37", "5T", "5L37"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["6E", "5T", "5E"],
			round: ["6M", "5M"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			tickle: ["6E", "5E"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			willowisp: ["6M", "5M"],
			workup: ["5M"],
			yawn: ["6L16", "5L16"],
		},
	},
	simisear: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firepunch: ["5T"],
			flameburst: ["6L1", "5L1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L1", "5L1"],
			gigaimpact: ["6M", "6S0", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			heatwave: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6S0", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lick: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			overheat: ["6M", "5M"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M", "6S0"],
			protect: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			willowisp: ["6M", "5M"],
			workup: ["6S0", "5M"],
		},
	},
	panpour: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L31", "5M", "5L31"],
			aquaring: ["6E", "5E"],
			aquatail: ["6E", "5T", "5E"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			bite: ["6L19", "5L19"],
			blizzard: ["6M", "5M"],
			brine: ["6L34", "5L34"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			crunch: ["6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			disarmingvoice: ["6E"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fling: ["6M", "6L28", "5M", "5L28"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L13", "5L13"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			hail: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["6E", "5E", "5S0"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			icywind: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L4", "5L4", "5S0"],
			lick: ["6L7", "5L7", "5S0"],
			lowkick: ["6E", "5T", "5E"],
			lowsweep: ["6M", "5M"],
			mudsport: ["6E", "5E"],
			nastyplot: ["6E", "5E"],
			naturalgift: ["6L40", "5L40"],
			payback: ["6M", "5M"],
			playnice: ["6L1"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recycle: ["6L37", "5T", "5L37"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["6E", "5T", "5E"],
			round: ["6M", "5M"],
			scald: ["6M", "6L22", "5M", "5L22"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "6L25", "5M", "5L25"],
			thief: ["6M", "5M"],
			tickle: ["6E", "5E"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			waterfall: ["6M", "5M"],
			watergun: ["6L10", "5L10", "5S0"],
			watersport: ["6L16", "5L16"],
			workup: ["5M"],
		},
	},
	simipour: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			blizzard: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L1", "5L1"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			hail: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			icywind: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lick: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			scald: ["6M", "6L1", "5M", "5L1"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			waterfall: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	munna: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M"],
			barrier: ["6E", "5E"],
			batonpass: ["6E", "5E"],
			calmmind: ["6M", "6L35", "5M", "5L35"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6E", "5E"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "6L41", "5M", "5L41"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			healbell: ["5T"],
			healingwish: ["6E"],
			helpinghand: ["6E", "5T", "5E"],
			hiddenpower: ["6M", "5M"],
			hypnosis: ["6L19", "5L19"],
			imprison: ["6L13", "5L13"],
			lightscreen: ["6M", "5M"],
			luckychant: ["6L5", "5L5"],
			magiccoat: ["6E", "5T", "5E"],
			moonlight: ["6L17", "5L17"],
			nightmare: ["6L29", "5L29"],
			painsplit: ["5T"],
			protect: ["6M", "5M"],
			psybeam: ["6L11", "5L11"],
			psychic: ["6M", "6L37", "5M", "5L37"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			psywave: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "6E", "5E"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snore: ["5T"],
			sonicboom: ["6E", "5E"],
			storedpower: ["6L47", "5L47"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6E", "5E"],
			synchronoise: ["6L25", "5L25"],
			telekinesis: ["6L43", "5M", "5L43"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			wonderroom: ["5T"],
			worryseed: ["5T"],
			yawn: ["6L7", "5L7"],
			zenheadbutt: ["6L23", "5T", "5L23"],
		},
	},
	musharna: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			defensecurl: ["6L1", "5L1", "5S0"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			healbell: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypnosis: ["6L1", "5L1", "5S0"],
			lightscreen: ["6M", "5M"],
			luckychant: ["6L1", "5L1", "5S0"],
			magiccoat: ["5T"],
			painsplit: ["5T"],
			protect: ["6M", "5M"],
			psybeam: ["6L1", "5L1", "5S0"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			wonderroom: ["5T"],
			worryseed: ["5T"],
			zenheadbutt: ["5T"],
		},
	},
	pidove: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aircutter: ["6L15", "5L15", "5S0"],
			airslash: ["6L29", "5L29"],
			attract: ["6M", "5M"],
			bestow: ["6E", "5E"],
			confide: ["6M"],
			detect: ["6L22", "5L22"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "6L43", "5M", "5L43"],
			featherdance: ["6L36", "5L36"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			growl: ["6L4", "5L4"],
			gust: ["6L1", "5L1", "5D", "5S0"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			hypnosis: ["6E", "5E", "5D"],
			leer: ["6L8", "5L8"],
			luckychant: ["6E", "5E"],
			morningsun: ["6E", "5E", "5D"],
			nightslash: ["6E"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			quickattack: ["6L11", "5L11", "5S0"],
			raindance: ["6M", "5M"],
			razorwind: ["6L32", "5L32"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6L18", "5T", "5L18"],
			round: ["6M", "5M"],
			skyattack: ["6L50", "5T", "5L50"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M", "6E", "5E"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "6L39", "5M", "5L39"],
			tailwind: ["6L46", "5T", "5L46"],
			taunt: ["6M", "6L25", "5M", "5L25"],
			toxic: ["6M", "5M"],
			uproar: ["6E", "5T", "5E"],
			uturn: ["6M", "5M"],
			wish: ["6E", "5E"],
			workup: ["5M"],
		},
	},
	tranquill: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aircutter: ["6L15", "5L15"],
			airslash: ["6L32", "5L32"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			detect: ["6L23", "5L23"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "6L50", "5M", "5L50"],
			featherdance: ["6L41", "5L41"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			gust: ["6L1", "5L1"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			leer: ["6L1", "5L1"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			razorwind: ["6L36", "5L36"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6L18", "5T", "5L18"],
			round: ["6M", "5M"],
			skyattack: ["6L59", "5T", "5L59"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "6L45", "5M", "5L45"],
			tailwind: ["6L54", "5T", "5L54"],
			taunt: ["6M", "6L27", "5M", "5L27"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	unfezant: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aircutter: ["6L15", "5L15"],
			airslash: ["6L33", "5L33"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			detect: ["6L23", "5L23"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "6L55", "5M", "5L55"],
			featherdance: ["6L44", "5L44"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			gust: ["6L1", "5L1"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			leer: ["6L1", "5L1"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			razorwind: ["6L38", "5L38"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6L18", "5T", "5L18"],
			round: ["6M", "5M"],
			skyattack: ["6L66", "5T", "5L66"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "6L49", "5M", "5L49"],
			tailwind: ["6L60", "5T", "5L60"],
			taunt: ["6M", "6L27", "5M", "5L27"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	blitzle: {
		inherit: true,
		learnset: {
			agility: ["6L36", "5L36"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			charge: ["6L8", "5L8"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			discharge: ["6L32", "5L32"],
			doubleedge: ["6E", "5E"],
			doublekick: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			flamecharge: ["6M", "6L18", "5M", "5L18"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			mefirst: ["6E", "5E"],
			protect: ["6M", "5M"],
			pursuit: ["6L22", "5L22"],
			quickattack: ["6L1", "5L1"],
			rage: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E"],
			screech: ["6E", "5E"],
			shockwave: ["6L11", "6E", "5L11", "5E"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["6E"],
			snore: ["5T"],
			spark: ["6L25", "5L25"],
			stomp: ["6L29", "5L29"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwhip: ["6L4", "5L4"],
			takedown: ["6E", "5E"],
			thrash: ["6L43", "5L43"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "6L15", "5M", "5L15"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L39", "5M", "5L39"],
		},
	},
	zebstrika: {
		inherit: true,
		learnset: {
			agility: ["6L42", "5L42"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			charge: ["6L1", "5L1"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			discharge: ["6L36", "5L36"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			flamecharge: ["6M", "6L18", "5M", "5L18"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			iondeluge: ["6L1"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			overheat: ["6M", "5M"],
			protect: ["6M", "5M"],
			pursuit: ["6L22", "5L22"],
			quickattack: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			shockwave: ["6L11", "5L11"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spark: ["6L25", "5L25"],
			stomp: ["6L31", "5L31"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwhip: ["6L1", "5L1"],
			thrash: ["6L53", "5L53"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "6L1", "5M", "5L1"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L47", "5M", "5L47"],
		},
	},
	roggenrola: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			autotomize: ["6E", "5E"],
			block: ["5T"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			explosion: ["6M", "6L40", "5M", "5L40"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gravity: ["6E", "5T", "5E"],
			harden: ["6L4", "5L4"],
			headbutt: ["6L10", "5L10"],
			heavyslam: ["6E", "5E"],
			hiddenpower: ["6M", "5M"],
			irondefense: ["6L20", "5T", "5L20"],
			lockon: ["6E", "5E"],
			magnitude: ["6E", "5E"],
			mudslap: ["6L17", "5L17"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L14", "5L14"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L27", "5M", "5L27"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "6E", "5M", "5E"],
			round: ["6M", "5M"],
			sandattack: ["6L7", "5L7"],
			sandstorm: ["6M", "6L33", "5M", "5L33"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L23", "5M", "5L23"],
			snore: ["5T"],
			stealthrock: ["6L30", "5T", "5L30"],
			stoneedge: ["6M", "6L36", "5M", "5L36"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			takedown: ["6E", "5E"],
			toxic: ["6M", "5M"],
			wideguard: ["6E"],
		},
	},
	boldore: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			block: ["5T"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			curse: ["5D"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			explosion: ["6M", "6L55", "5M", "5L55"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gravity: ["5T"],
			harden: ["6L1", "5L1"],
			headbutt: ["6L1", "5L1"],
			heavyslam: ["5D"],
			hiddenpower: ["6M", "5M"],
			irondefense: ["6L20", "5T", "5L20"],
			mudslap: ["6L17", "5L17"],
			naturepower: ["6M"],
			powergem: ["6L25", "5L25"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L14", "5L14"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L30", "5M", "5L30"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "6L42", "5M", "5L42"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L23", "5M", "5L23", "5D"],
			snore: ["5T"],
			stealthrock: ["6L36", "5T", "5L36"],
			stoneedge: ["6M", "6L48", "5M", "5L48"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
		},
	},
	gigalith: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			block: ["5T"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			explosion: ["6M", "6L55", "5M", "5L55"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			gravity: ["5T"],
			harden: ["6L1", "5L1"],
			headbutt: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["6L20", "5T", "5L20"],
			ironhead: ["5T"],
			mudslap: ["6L17", "5L17"],
			naturepower: ["6M"],
			powergem: ["6L25", "5L25"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L14", "5L14"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L30", "5M", "5L30"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "6L42", "5M", "5L42"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L23", "5M", "5L23"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stealthrock: ["6L36", "5T", "5L36"],
			stoneedge: ["6M", "6L48", "5M", "5L48"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
		},
	},
	woobat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			afteryou: ["5T"],
			aircutter: ["6L21", "5L21"],
			airslash: ["6L32", "5L32"],
			amnesia: ["6L29", "5L29"],
			assurance: ["6L12", "5L12"],
			attract: ["6M", "6L25", "5M", "5L25"],
			calmmind: ["6M", "6L29", "5M", "5L29"],
			captivate: ["6E"],
			chargebeam: ["6M", "5M"],
			charm: ["6E", "5E"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endeavor: ["6L47", "5T", "5L47"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			faketears: ["6E", "5E"],
			flash: ["6M", "5M"],
			flatter: ["6E", "5E"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L36", "5L36"],
			gigadrain: ["5T"],
			gust: ["6L8", "5L8"],
			gyroball: ["6M", "5M"],
			heartstamp: ["6L15", "5L15"],
			heatwave: ["5T"],
			helpinghand: ["6E", "5T", "5E"],
			hiddenpower: ["6M", "5M"],
			imprison: ["6L19", "5L19"],
			knockoff: ["6E", "5T", "5E"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			odorsleuth: ["6L4", "5L4"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "6L41", "5M", "5L41"],
			psychoshift: ["6E"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6E", "5T", "5E"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			storedpower: ["6E", "5E"],
			substitute: ["6M", "5M"],
			superfang: ["5T"],
			supersonic: ["6E", "5E"],
			swagger: ["6M", "5M"],
			synchronoise: ["6E", "5E"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			venomdrench: ["6E"],
			zenheadbutt: ["5T"],
		},
	},
	swoobat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			afteryou: ["5T"],
			aircutter: ["6L21", "5L21"],
			airslash: ["6L32", "5L32"],
			amnesia: ["6L29", "5L29"],
			assurance: ["6L1", "5L1"],
			attract: ["6M", "6L25", "5M", "5L25"],
			calmmind: ["6M", "6L29", "5M", "5L29"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endeavor: ["6L47", "5T", "5L47"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L36", "5L36"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			gust: ["6L1", "5L1"],
			gyroball: ["6M", "5M"],
			heartstamp: ["6L15", "5L15"],
			heatwave: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			imprison: ["6L19", "5L19"],
			knockoff: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			odorsleuth: ["6L1", "5L1"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "6L41", "5M", "5L41"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			skyattack: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			superfang: ["5T"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	drilbur: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crushclaw: ["6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["6M", "6L19", "5M", "5L19"],
			doubleteam: ["6M", "5M"],
			drillrun: ["6L43", "5T", "5L43"],
			earthpower: ["6E", "5T", "5E"],
			earthquake: ["6M", "6L33", "5M", "5L33"],
			facade: ["6M", "5M"],
			fissure: ["6L47", "5L47"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L12", "5L12"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L22", "5M", "5L22"],
			irondefense: ["6E", "5T", "5E"],
			metalclaw: ["6L15", "5L15"],
			metalsound: ["6E", "5E", "5D"],
			mudslap: ["6L8", "5L8"],
			mudsport: ["6L1", "5L1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rapidspin: ["6L5", "6E", "5L5", "5E", "5D"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6E", "5E", "5D"],
			rockslide: ["6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L40", "5M", "5L40"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			skullbash: ["6E", "5E"],
			slash: ["6L26", "5L26"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			submission: ["6E", "5E"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L36", "5M", "5L36"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	excadrill: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			dig: ["6M", "6L19", "5M", "5L19"],
			doubleteam: ["6M", "5M"],
			drillrun: ["6L55", "5T", "5L55"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L36", "5M", "5L36"],
			facade: ["6M", "5M"],
			fissure: ["6L62", "5L62"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L12", "5L12"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L22", "5M", "5L22"],
			horndrill: ["6L31", "5L31"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["5T"],
			magnetrise: ["5T"],
			metalclaw: ["6L15", "5L15"],
			mudslap: ["6L1", "5L1"],
			mudsport: ["6L1", "5L1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rapidspin: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rototiller: ["6L1"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L49", "5M", "5L49"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L26", "5L26"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L42", "5M", "5L42"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	audino: {
		inherit: true,
		learnset: {
			afteryou: ["6L40", "5T", "5L40"],
			amnesia: ["6E", "5E"],
			attract: ["6M", "6L15", "5M", "5L15"],
			bestow: ["6E", "5E"],
			blizzard: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M"],
			doubleedge: ["6L50", "5L50"],
			doubleslap: ["6L10", "5L10", "5S0"],
			doubleteam: ["6M", "5M"],
			drainingkiss: ["6E"],
			drainpunch: ["5T"],
			dreameater: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6E", "5E", "5D"],
			entrainment: ["6L25", "5L25"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firepunch: ["5T"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			growl: ["6L1", "5L1"],
			healbell: ["6E", "5T", "5E"],
			healingwish: ["6E", "5E"],
			healpulse: ["6L35", "6S3", "5L35", "5S0", "5S1", "5S2"],
			helpinghand: ["6L1", "5T", "5L1", "5D", "5S0", "5S1", "5S2"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["5T"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			icywind: ["5T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			lastresort: ["6L1", "5T", "5L55"],
			lightscreen: ["6M", "5M"],
			lowkick: ["5T"],
			luckychant: ["6E", "5E"],
			magiccoat: ["5T"],
			painsplit: ["5T"],
			playnice: ["6L1"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			present: ["5S1", "5S2"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			refresh: ["6L5", "5L5", "5S0", "5S1", "5S2"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "6L20", "5L20"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			simplebeam: ["6L45", "6S3", "5L45"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snatch: ["5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			sweetkiss: ["6E", "5E"],
			takedown: ["6L30", "5L30"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "6S3", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trickroom: ["6M", "6S3", "5M"],
			uproar: ["5T"],
			wildcharge: ["6M", "5M"],
			wish: ["6E", "5E"],
			workup: ["5M"],
			yawn: ["6E", "5E", "5D"],
			zenheadbutt: ["5T"],
		},
	},
	timburr: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bide: ["6L8", "5L8"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "6L28", "5M", "5L28"],
			chipaway: ["6L24", "5L24"],
			cometpunch: ["6E", "5E"],
			confide: ["6M"],
			counter: ["6E", "5E"],
			detect: ["6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["6E", "5T", "5E"],
			dynamicpunch: ["6L34", "5L34"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L4", "5L4"],
			focuspunch: ["6L46", "5L46"],
			forcepalm: ["6E", "5E"],
			foresight: ["6E", "5E"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hammerarm: ["6L40", "5L40"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			icepunch: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["6L12", "5T", "5L12"],
			lowsweep: ["6M", "5M"],
			machpunch: ["6E", "5E"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			reversal: ["6E", "5E"],
			rockslide: ["6M", "6L31", "5M", "5L31"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L16", "5L16"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L37", "5L37"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			smellingsalts: ["6E", "5E"],
			snore: ["5T"],
			stoneedge: ["6M", "6L43", "5M", "5L43"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L49", "5T", "5L49"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			wakeupslap: ["6L20", "5L20"],
			wideguard: ["6E", "5E"],
			workup: ["5M"],
		},
	},
	gurdurr: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bide: ["6L1", "5L1"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "6L29", "5M", "5L29"],
			chipaway: ["6L24", "5L24"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T", "5D"],
			dynamicpunch: ["6L37", "5L37"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L1", "5L1"],
			focuspunch: ["6L53", "5L53"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hammerarm: ["6L45", "5L45"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			icepunch: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["6L12", "5T", "5L12", "5D"],
			lowsweep: ["6M", "5M"],
			machpunch: ["5D"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "6L33", "5M", "5L33"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L16", "5L16"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L41", "5L41"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			stoneedge: ["6M", "6L49", "5M", "5L49"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L57", "5T", "5L57"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			wakeupslap: ["6L20", "5L20"],
			workup: ["5M"],
		},
	},
	conkeldurr: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bide: ["6L1", "5L1"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "6L29", "5M", "5L29"],
			bulldoze: ["6M", "5M"],
			chipaway: ["6L24", "5L24"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			dynamicpunch: ["6L37", "5L37"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L1", "5L1"],
			focuspunch: ["6L53", "5L53"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hammerarm: ["6L45", "5L45"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			icepunch: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["6L12", "5T", "5L12"],
			lowsweep: ["6M", "5M"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "6L33", "5M", "5L33"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L16", "5L16"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L41", "5L41"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			stoneedge: ["6M", "6L49", "5M", "5L49"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L57", "5T", "5L57"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			wakeupslap: ["6L20", "5L20"],
			workup: ["5M"],
		},
	},
	tympole: {
		inherit: true,
		learnset: {
			afteryou: ["6E"],
			aquaring: ["6L20", "5L20"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			bubble: ["6L1", "5L1"],
			bubblebeam: ["6L12", "5L12"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["6E", "5T", "5E", "5D"],
			echoedvoice: ["6M", "6L38", "5M", "5L38"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			flail: ["6L34", "5L34"],
			frustration: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L42", "5L42"],
			hypervoice: ["6L45", "5T", "5L45"],
			icywind: ["5T"],
			infestation: ["6M"],
			mist: ["6E", "5E"],
			mudbomb: ["6E", "5E"],
			muddywater: ["6L27", "5L27"],
			mudshot: ["6L16", "5L16"],
			mudsport: ["6E", "5E"],
			protect: ["6M", "5M"],
			raindance: ["6M", "6L31", "5M", "5L31"],
			refresh: ["6E", "5E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "6L9", "5M", "5L9", "5D"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["6E", "5T", "5E"],
			substitute: ["6M", "5M"],
			supersonic: ["6L5", "5L5"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["6L23", "5T", "5L23"],
			waterpulse: ["6E", "5E", "5D"],
		},
	},
	palpitoad: {
		inherit: true,
		learnset: {
			aquaring: ["6L20", "5L20"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			bubble: ["6L1", "5L1"],
			bubblebeam: ["6L12", "5L12"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "6L42", "5M", "5L42"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			flail: ["6L37", "5L37"],
			frustration: ["6M", "5M"],
			gastroacid: ["5T"],
			growl: ["6L1", "5L1"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L47", "5L47"],
			hypervoice: ["6L51", "5T", "5L51"],
			icywind: ["5T"],
			infestation: ["6M"],
			muddywater: ["6L28", "5L28"],
			mudshot: ["6L16", "5L16"],
			protect: ["6M", "5M"],
			raindance: ["6M", "6L33", "5M", "5L33"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "6L1", "5M", "5L1"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			substitute: ["6M", "5M"],
			supersonic: ["6L1", "5L1"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["6L23", "5T", "5L23"],
		},
	},
	seismitoad: {
		inherit: true,
		learnset: {
			acid: ["6L36", "5L36"],
			aquaring: ["6L20", "5L20"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			brickbreak: ["6M", "5M"],
			bubble: ["6L1", "5L1"],
			bubblebeam: ["6L12", "5L12"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["6L44", "5T", "5L44"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			echoedvoice: ["6M", "6L49", "5M", "5L49"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			flail: ["6L39", "5L39"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L53", "5L53"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L59", "5T", "5L59"],
			icepunch: ["5T"],
			icywind: ["5T"],
			infestation: ["6M"],
			knockoff: ["5T"],
			lowkick: ["5T"],
			muddywater: ["6L28", "5L28"],
			mudshot: ["6L16", "5L16"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "6L33", "5M", "5L33"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "6L1", "5M", "5L1"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			supersonic: ["6L1", "5L1"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["6L23", "5T", "5L23"],
			venoshock: ["6M", "5M"],
		},
	},
	throh: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bide: ["6L5", "5L5"],
			bind: ["6L1", "5T", "5L1", "5D"],
			block: ["5T"],
			bodyslam: ["6L29", "5L29"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "6L33", "5M", "5L33"],
			bulldoze: ["6M", "5M"],
			circlethrow: ["6L37", "5L37"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			endure: ["6L41", "5L41"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L9", "5L9"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			icepunch: ["5T", "5D"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L21", "5L21"],
			reversal: ["6L50", "5L53"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			seismictoss: ["6L13", "5L13"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			stormthrow: ["6L25", "5L25"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L48", "5T", "5L49", "5D"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			vitalthrow: ["6L17", "5L17"],
			wideguard: ["6L45", "5L45"],
			workup: ["5M"],
		},
	},
	sawk: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bide: ["6L5", "5L5"],
			block: ["5T"],
			brickbreak: ["6M", "6L29", "5M", "5L29"],
			bulkup: ["6M", "6L33", "5M", "5L33"],
			bulldoze: ["6M", "5M"],
			closecombat: ["6L48", "5L49"],
			confide: ["6M"],
			counter: ["6L21", "5L21"],
			dig: ["6M", "5M"],
			doublekick: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			dualchop: ["5T", "5D"],
			earthquake: ["6M", "5M"],
			endure: ["6L41", "5L41"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focusenergy: ["6L9", "5L9"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			icepunch: ["5T"],
			karatechop: ["6L25", "5L25"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "6L17", "5M", "5L17"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			quickguard: ["6L45", "5L45"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L37", "5M", "5L37"],
			return: ["6M", "5M"],
			reversal: ["6L50", "5L53"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "6L1", "5M", "5L1", "5D"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderpunch: ["5T", "5D"],
			toxic: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	sewaddle: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E"],
			airslash: ["6E", "5E"],
			attract: ["6M", "5M"],
			batonpass: ["6E", "5E"],
			bugbite: ["6L8", "5T", "5L8"],
			bugbuzz: ["6L36", "5L36"],
			calmmind: ["6M", "5M"],
			camouflage: ["6E", "5E"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			electroweb: ["5T"],
			endure: ["6L29", "5L29"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flail: ["6L43", "5L43"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			grassknot: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			irondefense: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			mefirst: ["6E", "5E"],
			mindreader: ["6E", "5E"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			razorleaf: ["6L15", "5L15"],
			razorwind: ["6E", "5E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			screech: ["6E", "5E"],
			seedbomb: ["5T"],
			signalbeam: ["5T"],
			silverwind: ["6E", "5E"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stickyweb: ["6L31"],
			stringshot: ["6L1", "5L1"],
			strugglebug: ["6M", "6L22", "5M", "5L22"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	swadloon: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bugbite: ["6L1", "5T", "5L1"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			electroweb: ["5T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			grassknot: ["6M", "5M"],
			grasswhistle: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			irondefense: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			protect: ["6M", "6L20", "5M", "5L20"],
			razorleaf: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stringshot: ["6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	leavanny: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			bugbite: ["6L1", "5T", "5L1"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			electroweb: ["5T"],
			energyball: ["6M", "5M"],
			entrainment: ["6L43", "5L43"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L1", "5M", "5L1"],
			fellstinger: ["6L34"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			healbell: ["5T"],
			helpinghand: ["6L32", "5T", "5L32"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			leafblade: ["6L36", "5L36"],
			leafstorm: ["6L50", "5L50"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			razorleaf: ["6L1", "5L1"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			slash: ["6L29", "5L29"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			steelwing: ["6M"],
			stringshot: ["6L1", "5L1"],
			strugglebug: ["6M", "6L22", "5M", "5L22"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L46", "5M", "5L46"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
			worryseed: ["5T"],
			xscissor: ["6M", "6L39", "5M", "5L39"],
		},
	},
	venipede: {
		inherit: true,
		learnset: {
			agility: ["6L29", "5L29"],
			attract: ["6M", "5M"],
			bugbite: ["6L22", "5T", "5L22"],
			confide: ["6M"],
			defensecurl: ["6L1", "5L1"],
			doubleedge: ["6L43", "5L43"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T"],
			payback: ["6M", "5M"],
			pinmissile: ["6E", "5E"],
			poisonjab: ["6M", "5M"],
			poisonsting: ["6L5", "5L5"],
			poisontail: ["6L19", "5L19"],
			protect: ["6M", "6L15", "5M", "5L15"],
			pursuit: ["6L12", "5L12"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6L40", "6E", "5L40", "5E"],
			rocksmash: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			screech: ["6L8", "5L8"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spikes: ["6E", "5E"],
			steamroller: ["6L33", "5L33"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			takedown: ["6E", "5E"],
			toxic: ["6M", "6L36", "5M", "5L36"],
			toxicspikes: ["6E", "5E"],
			twineedle: ["6E", "5E"],
			venoshock: ["6M", "6L26", "5M", "5L26"],
		},
	},
	whirlipede: {
		inherit: true,
		learnset: {
			agility: ["6L32", "5L32"],
			attract: ["6M", "5M"],
			bugbite: ["6L23", "5T", "5L23"],
			confide: ["6M"],
			defensecurl: ["6L1", "5L1"],
			doubleedge: ["6L50", "5L50"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["6L22", "5T", "5L22"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poisonsting: ["6L1", "5L1"],
			poisontail: ["6L19", "5L19"],
			protect: ["6M", "6L15", "5M", "5L15"],
			pursuit: ["6L12", "5L12"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6L46", "5L46"],
			rocksmash: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			steamroller: ["6L37", "5L37"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "6L41", "5M", "5L41"],
			venomdrench: ["6L43"],
			venoshock: ["6M", "6L28", "5M", "5L28"],
		},
	},
	scolipede: {
		inherit: true,
		learnset: {
			agility: ["6L33", "5L33"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			batonpass: ["6L30", "5L30"],
			bugbite: ["6L23", "5T", "5L23"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			defensecurl: ["6L1", "5L1"],
			dig: ["6M", "5M"],
			doubleedge: ["6L55", "5L55"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T"],
			irontail: ["5T"],
			megahorn: ["6L1", "5L1"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poisonsting: ["6L1", "5L1"],
			poisontail: ["6L19", "5L19", "5D"],
			protect: ["6M", "6L15", "5M", "5L15"],
			pursuit: ["6L12", "5L12"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6L50", "5L50"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			steamroller: ["6L39", "5L39"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T", "5D"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			toxic: ["6M", "6L44", "5M", "5L44"],
			toxicspikes: ["5D"],
			venomdrench: ["6L47"],
			venoshock: ["6M", "6L28", "5M", "5L28"],
			xscissor: ["6M", "5M"],
		},
	},
	cottonee: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			beatup: ["6E", "5E"],
			captivate: ["6E"],
			charm: ["6L28", "5L28"],
			confide: ["6M"],
			cottonguard: ["6L37", "5L37"],
			cottonspore: ["6L17", "5L17"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			encore: ["6E", "5E", "5D"],
			endeavor: ["6L44", "5T", "5L44"],
			energyball: ["6M", "6L35", "5M", "5L35"],
			facade: ["6M", "5M"],
			fairywind: ["6L1"],
			faketears: ["6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["6L26", "5T", "5L26"],
			grassknot: ["6M", "5M"],
			grasswhistle: ["6E", "5E"],
			growth: ["6L4", "5L4"],
			helpinghand: ["6L31", "5T", "5L31"],
			hiddenpower: ["6M", "5M"],
			knockoff: ["5T"],
			leechseed: ["6L8", "5L8", "5D"],
			megadrain: ["6L13", "5L13"],
			memento: ["6E", "5E"],
			naturalgift: ["6E", "5E"],
			naturepower: ["6M"],
			poisonpowder: ["6L22", "5L22"],
			protect: ["6M", "5M"],
			razorleaf: ["6L19", "5L19"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "6L46", "5M", "5L46"],
			stunspore: ["6L10", "5L10"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "6L40", "5M", "5L40"],
			swagger: ["6M", "5M"],
			switcheroo: ["6E", "5E"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M"],
			worryseed: ["6E", "5T", "5E", "5D"],
		},
	},
	whimsicott: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			beatup: ["5S0"],
			confide: ["6M"],
			cottonspore: ["6L1", "5L1"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T", "5S0"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growth: ["6L1", "5L1"],
			gust: ["6L10", "5L10"],
			helpinghand: ["5T", "5S0"],
			hiddenpower: ["6M", "5M"],
			hurricane: ["6L46", "5L46"],
			hyperbeam: ["6M", "5M"],
			knockoff: ["5T"],
			leechseed: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			megadrain: ["6L1", "5L1"],
			moonblast: ["6L50"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M", "5S0"],
			tailwind: ["6L28", "5T", "5L28"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trickroom: ["6M", "5M"],
			uturn: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	petilil: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			afteryou: ["6L44", "5T", "5L44"],
			aromatherapy: ["6L28", "5L28"],
			attract: ["6M", "5M"],
			bide: ["6E", "5E"],
			charm: ["6E", "5E", "5D"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			endure: ["6E", "5E"],
			energyball: ["6M", "6L35", "5M", "5L35"],
			entrainment: ["6L37", "5L37"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["6L26", "5T", "5L26"],
			grassknot: ["6M", "5M"],
			grasswhistle: ["6E", "5E"],
			growth: ["6L4", "5L4"],
			healbell: ["5T"],
			healingwish: ["6E", "5E"],
			helpinghand: ["6L31", "5T", "5L31"],
			hiddenpower: ["6M", "5M"],
			ingrain: ["6E", "5E"],
			leafstorm: ["6L46", "5L46"],
			leechseed: ["6L8", "5L8"],
			magicalleaf: ["6L19", "5L19"],
			megadrain: ["6L13", "5L13"],
			naturalgift: ["6E", "5E"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeppowder: ["6L10", "5L10", "5D"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stunspore: ["6L22", "5L22"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "6L40", "5M", "5L40"],
			swagger: ["6M", "5M"],
			sweetscent: ["6E", "5E", "5D"],
			synthesis: ["6L17", "5T", "5L17"],
			toxic: ["6M", "5M"],
			worryseed: ["6E", "5T", "5E"],
		},
	},
	lilligant: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growth: ["6L1", "5L1"],
			healbell: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			leechseed: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			megadrain: ["6L1", "5L1"],
			naturepower: ["6M"],
			petalblizzard: ["6L50"],
			petaldance: ["6L46", "5L46"],
			protect: ["6M", "5M"],
			quiverdance: ["6L28", "5L28"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			synthesis: ["6L1", "5T", "5L1"],
			teeterdance: ["6L10", "5L10"],
			toxic: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	basculin: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E", "5D"],
			aquajet: ["6L13", "5L13"],
			aquatail: ["6L28", "5T", "5L28"],
			attract: ["6M", "5M"],
			bite: ["6L10", "5L10"],
			bounce: ["5T"],
			brine: ["6E", "5E"],
			bubblebeam: ["6E", "5E"],
			chipaway: ["6L16", "5L16"],
			confide: ["6M"],
			crunch: ["6L24", "5L24"],
			cut: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleedge: ["6L36", "5L36"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			finalgambit: ["6L50", "5L51"],
			flail: ["6L1", "5L46"],
			frustration: ["6M", "5M"],
			hail: ["6M", "5M"],
			headbutt: ["6L7", "5L7", "5D"],
			hiddenpower: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			muddywater: ["6E", "5E"],
			mudshot: ["6E", "5E"],
			protect: ["6M", "5M"],
			rage: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6E", "5E"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			scaryface: ["6L41", "5L41"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			soak: ["6L32", "5L32"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6E", "5E"],
			tackle: ["6L1", "5L1"],
			tailwhip: ["6L1"],
			takedown: ["6L20", "5L20"],
			taunt: ["6M", "5M"],
			thrash: ["6L1", "5L56"],
			toxic: ["6M", "5M"],
			uproar: ["6L4", "5T", "5L4"],
			waterfall: ["6M", "5M"],
			watergun: ["6L1", "5L1"],
			whirlpool: ["6E", "5E"],
			zenheadbutt: ["5T", "5D"],
		},
	},
	sandile: {
		inherit: true,
		learnset: {
			aquatail: ["5T"],
			assurance: ["6L16", "5L16"],
			attract: ["6M", "5M"],
			beatup: ["6E", "5E"],
			bite: ["6L4", "5L4"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			counter: ["6E", "5E"],
			crunch: ["6L28", "5L28"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "6L31", "5M", "5L31"],
			doubleedge: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L43", "5M", "5L43"],
			embargo: ["6M", "6L22", "5M", "5L22"],
			facade: ["6M", "5M"],
			firefang: ["6E", "5E"],
			focusenergy: ["6E", "5E"],
			foulplay: ["6L37", "5T", "5L37"],
			frustration: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			leer: ["6L1", "5L1"],
			meanlook: ["6E", "5E"],
			mefirst: ["6E"],
			mudslap: ["6L19", "5L19"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			rage: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockclimb: ["6E", "5E"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L7", "5L7"],
			sandstorm: ["6M", "6L40", "5M", "5L40"],
			sandtomb: ["6L13", "5L13"],
			scaryface: ["6L34", "5L34"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "6L25", "5M", "5L25"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thrash: ["6L46", "5L46"],
			thunderfang: ["6E", "5E"],
			torment: ["6M", "6L10", "5M", "5L10"],
			toxic: ["6M", "5M"],
			uproar: ["6E", "5T", "5E"],
		},
	},
	krokorok: {
		inherit: true,
		learnset: {
			aquatail: ["5T"],
			assurance: ["6L16", "5L16"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L28", "5L28"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "6L32", "5M", "5L32"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L48", "5M", "5L48"],
			embargo: ["6M", "6L22", "5M", "5L22"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			foulplay: ["6L40", "5T", "5L40"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			mudslap: ["6L19", "5L19"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			rage: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "6L44", "5M", "5L44"],
			sandtomb: ["6L13", "5L13"],
			scaryface: ["6L36", "5L36"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "6L25", "5M", "5L25"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thrash: ["6L52", "5L52"],
			torment: ["6M", "6L10", "5M", "5L10"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
		},
	},
	krookodile: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			assurance: ["6L16", "5L16"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			counter: ["5D"],
			crunch: ["6L28", "5L28", "5D"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "6L32", "5M", "5L32"],
			doubleteam: ["6M", "5M"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["5T"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L54", "5M", "5L54"],
			embargo: ["6M", "6L22", "5M", "5L22"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			foulplay: ["6L42", "5T", "5L42"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			meanlook: ["5D"],
			mudslap: ["6L19", "5L19"],
			outrage: ["6L1", "5T", "5L60"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			rage: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "6L48", "5M", "5L48"],
			sandtomb: ["6L13", "5L13"],
			scaryface: ["6L36", "5L36"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "6L25", "5M", "5L25"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "6L10", "5M", "5L10"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
		},
	},
	darumaka: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bellydrum: ["6L30", "5L30"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			encore: ["6E", "5E"],
			endeavor: ["5T"],
			endure: ["6E", "5E"],
			facade: ["6M", "6L19", "5M", "5L19"],
			fireblast: ["6M", "5M"],
			firefang: ["6L11", "5L11"],
			firepunch: ["6L22", "5T", "5L22"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flamewheel: ["6E", "5E"],
			flareblitz: ["6L33", "5L33"],
			fling: ["6M", "5M"],
			focusenergy: ["6E", "5E"],
			focuspunch: ["6E", "5E"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hammerarm: ["6E", "5E"],
			headbutt: ["6L14", "5L14"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			incinerate: ["6M", "6L6", "5M", "5L6"],
			overheat: ["6M", "6L42", "5M", "5L42"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			rage: ["6L9", "5L9"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L3", "5L3"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snatch: ["6E"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L39", "5T", "5L39"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			takedown: ["6E", "5E"],
			taunt: ["6M", "6L35", "5M", "5L35"],
			thief: ["6M", "5M"],
			thrash: ["6L27", "5L27"],
			toxic: ["6M", "5M"],
			uproar: ["6L17", "5T", "5L17"],
			uturn: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			workup: ["6L25", "5M", "5L25"],
			yawn: ["6E", "5E"],
			zenheadbutt: ["5T"],
		},
	},
	darmanitan: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			bellydrum: ["6L30", "6S1", "5L30", "5S0"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "6L19", "5M", "5L19"],
			fireblast: ["6M", "5M"],
			firefang: ["6L11", "5L11"],
			firepunch: ["6L22", "5T", "5L22"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flareblitz: ["6L33", "6S1", "5L33", "5S0"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gyroball: ["6M", "5M"],
			hammerarm: ["6L35", "6S1", "5L35", "5S0"],
			headbutt: ["6L14", "5L14"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "6L1", "5M", "5L1"],
			overheat: ["6M", "6L54", "5M", "5L54"],
			payback: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			rage: ["6L1", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L47", "5T", "5L47"],
			swagger: ["6M", "6L17", "5M", "5L17"],
			tackle: ["6L1", "5L1"],
			taunt: ["6M", "6L39", "5M", "5L39"],
			thief: ["6M", "5M"],
			thrash: ["6L27", "6S1", "5L27", "5S0"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			workup: ["6L25", "5M", "5L25"],
			zenheadbutt: ["5T"],
		},
	},
	maractus: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			acupressure: ["6L29", "5L29"],
			aerialace: ["6M", "5M"],
			afteryou: ["6L1", "5T", "5L57"],
			attract: ["6M", "5M"],
			bounce: ["6E", "5T", "5E"],
			bulletseed: ["6E", "5E"],
			confide: ["6M"],
			cottonguard: ["6L1", "5L55"],
			cottonspore: ["6L18", "5L18"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["6L26", "5T", "5L26"],
			grassknot: ["6M", "5M"],
			grasswhistle: ["6E", "5E"],
			grassyterrain: ["6E"],
			growth: ["6L6", "5L6"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hypervoice: ["5T"],
			ingrain: ["6L33", "5L33"],
			knockoff: ["5T"],
			leechseed: ["6E", "5E", "5D"],
			megadrain: ["6L13", "5L13"],
			naturepower: ["6M"],
			needlearm: ["6L22", "5L22"],
			peck: ["6L1", "5L1"],
			petalblizzard: ["6L48"],
			petaldance: ["6L38", "5L38"],
			pinmissile: ["6L10", "5L10", "5D"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["6E", "5T", "5E"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "6L50", "5M", "5L50"],
			spikes: ["6E", "5E", "5D"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6L42", "5L42"],
			sunnyday: ["6M", "6L45", "5M", "5L45"],
			swagger: ["6M", "5M"],
			sweetscent: ["6L3", "5L3"],
			synthesis: ["6L15", "5T", "5L15"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			woodhammer: ["6E", "5E"],
			worryseed: ["6E", "5T", "5E"],
		},
	},
	dwebble: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			block: ["6E", "5T", "5E"],
			bugbite: ["6L23", "5T", "5L23"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			counter: ["6E", "5E"],
			curse: ["6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			feintattack: ["6L13", "5L13"],
			flail: ["6L41", "5L41"],
			frustration: ["6M", "5M"],
			furycutter: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6E", "5T", "5E"],
			knockoff: ["5T"],
			naturepower: ["6M"],
			nightslash: ["6E", "5E"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L5", "5L5"],
			rockpolish: ["6M", "6L19", "5M", "5L19"],
			rockslide: ["6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rockwrecker: ["6L43", "5L43"],
			rototiller: ["6E"],
			round: ["6M", "5M"],
			sandattack: ["6L11", "5L11"],
			sandstorm: ["6M", "5M"],
			sandtomb: ["6E", "5E"],
			shadowclaw: ["6M", "5M"],
			shellsmash: ["6L37", "5L37"],
			slash: ["6L31", "5L31"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L17", "5M", "5L17"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spikes: ["6E", "5E"],
			stealthrock: ["6L24", "5T", "5L24"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			toxic: ["6M", "5M"],
			wideguard: ["6E"],
			withdraw: ["6L7", "5L7"],
			xscissor: ["6M", "6L35", "5M", "5L35"],
		},
	},
	crustle: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			block: ["5T"],
			bugbite: ["6L23", "5T", "5L23"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			counter: ["5D"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6L13", "5L13"],
			flail: ["6L50", "5L50"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			naturepower: ["6M"],
			nightslash: ["5D"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L1", "5L1"],
			rockpolish: ["6M", "6L19", "5M", "5L19"],
			rockslide: ["6M", "6L29", "5M", "5L29", "5D"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rockwrecker: ["6L55", "5L55"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			shellsmash: ["6L1", "5L1"],
			slash: ["6L31", "5L31"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L17", "5M", "5L17"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stealthrock: ["6L24", "5T", "5L24"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			toxic: ["6M", "5M"],
			withdraw: ["6L1", "5L1"],
			xscissor: ["6M", "6L38", "5M", "5L38"],
		},
	},
	scraggy: {
		inherit: true,
		learnset: {
			amnesia: ["6E", "5E"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "6L20", "5M", "5L20"],
			bulkup: ["6M", "5M"],
			chipaway: ["6L27", "5L27"],
			confide: ["6M"],
			counter: ["6E", "5E"],
			crunch: ["6L38", "5L38"],
			darkpulse: ["6M", "5T"],
			detect: ["6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dragonclaw: ["6M", "5M"],
			dragondance: ["6E", "5E"],
			dragonpulse: ["5T"],
			dragontail: ["6M", "5M"],
			drainpunch: ["6E", "5T", "5E", "5D"],
			dualchop: ["5T"],
			facade: ["6M", "6L42", "5M", "5L42"],
			fakeout: ["6E", "5E", "5D"],
			feintattack: ["6L9", "6E", "5L9", "5E"],
			firepunch: ["6E", "5T", "5E"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focuspunch: ["6L48", "5L49"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			headbutt: ["6L12", "5L12", "5S0"],
			headsmash: ["6L50", "5L53"],
			hiddenpower: ["6M", "5M"],
			highjumpkick: ["6L31", "5L31", "5S0"],
			icepunch: ["6E", "5T", "5E"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1", "5S0"],
			lowkick: ["6L1", "5T", "5L1", "5D", "5S0"],
			lowsweep: ["6M", "5M"],
			payback: ["6M", "6L23", "5M", "5L23"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			quickguard: ["6E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockclimb: ["6L45", "5L45"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L5", "5L5"],
			scaryface: ["6L34", "5L34"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superfang: ["5T"],
			swagger: ["6M", "6L16", "5M", "5L16"],
			taunt: ["6M", "5M"],
			thunderpunch: ["6E", "5T", "5E"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["6E", "5T", "5E"],
		},
	},
	scrafty: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			brickbreak: ["6M", "6L20", "5M", "5L20"],
			bulkup: ["6M", "5M"],
			chipaway: ["6L27", "5L27"],
			confide: ["6M"],
			crunch: ["6L38", "5L38"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["5T"],
			dragontail: ["6M", "5M"],
			drainpunch: ["5T", "5S0"],
			dualchop: ["5T"],
			facade: ["6M", "6L45", "5M", "5L45"],
			feintattack: ["6L1", "5L1"],
			firepunch: ["5T", "5S0"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focuspunch: ["6L58", "5L58"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			headbutt: ["6L12", "5L12"],
			headsmash: ["6L65", "5L65"],
			hiddenpower: ["6M", "5M"],
			highjumpkick: ["6L31", "5L31"],
			hyperbeam: ["6M", "5M"],
			icepunch: ["5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["6L1", "5T", "5L1"],
			lowsweep: ["6M", "5M"],
			outrage: ["5T"],
			payback: ["6M", "6L23", "5M", "5L23", "5S0"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockclimb: ["6L51", "5L51"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			scaryface: ["6L34", "5L34"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M", "5S0"],
			sunnyday: ["6M", "5M"],
			superfang: ["5T"],
			swagger: ["6M", "6L16", "5M", "5L16"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderpunch: ["5T"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T"],
		},
	},
	sigilyph: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aircutter: ["6L21", "5L21"],
			airslash: ["6L41", "5L41"],
			ancientpower: ["6E", "5E"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			cosmicpower: ["6L48", "5L48"],
			darkpulse: ["6M", "5T"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6E"],
			gravity: ["6L38", "5T", "5L38"],
			gust: ["6L1", "5L1"],
			heatwave: ["5T", "5D"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypnosis: ["6L4", "5L4", "5D"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			lightscreen: ["6M", "6L24", "5M", "5L24"],
			magiccoat: ["5T"],
			magicroom: ["5T"],
			miracleeye: ["6L1", "5L1"],
			mirrormove: ["6L34", "5L34"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			psybeam: ["6L18", "5L18"],
			psychic: ["6M", "6L44", "5M", "5L44"],
			psychoshift: ["6E", "5E"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			psywave: ["6L8", "5L8"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "6L28", "5M", "5L28"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6E", "5T", "5E"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["6E", "5T", "5E"],
			skyattack: ["6L50", "5T", "5L51"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			steelwing: ["6M", "6E", "5E"],
			storedpower: ["6E", "5E", "5D"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synchronoise: ["6L31", "5L31"],
			tailwind: ["6L11", "5T", "5L11"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			whirlwind: ["6L14", "5L14"],
			zenheadbutt: ["5T"],
		},
	},
	yamask: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			allyswitch: ["6E"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			block: ["5T"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6L29", "5L29"],
			darkpulse: ["6M", "5T"],
			destinybond: ["6L49", "5L49"],
			disable: ["6L5", "6E", "5L5", "5E"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endure: ["6E", "5E"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			faketears: ["6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			grudge: ["6L41", "5L41"],
			guardsplit: ["6L33", "5L33"],
			haze: ["6L9", "5L9"],
			healblock: ["6E", "5E"],
			hex: ["6L17", "5L17"],
			hiddenpower: ["6M", "5M"],
			imprison: ["6E", "5E"],
			infestation: ["6M"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			magiccoat: ["5T"],
			meanlook: ["6L45", "5L45"],
			memento: ["6E", "5E"],
			nastyplot: ["6E", "5E"],
			nightmare: ["6E", "5E"],
			nightshade: ["6L13", "5L13"],
			ominouswind: ["6L25", "5L25"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			powersplit: ["6L33", "5L33"],
			protect: ["6M", "6L1", "5M", "5L1"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "6L37", "5M", "5L37"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			toxicspikes: ["6E"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			willowisp: ["6M", "6L21", "5M", "5L21"],
			wonderroom: ["5T"],
		},
	},
	cofagrigus: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			block: ["5T"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6L29", "5L29"],
			darkpulse: ["6M", "5T"],
			destinybond: ["6L57", "5L57"],
			disable: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			grudge: ["6L45", "5L45"],
			guardsplit: ["6L33", "5L33"],
			haze: ["6L1", "5L1"],
			hex: ["6L17", "5L17"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			magiccoat: ["5T"],
			meanlook: ["6L51", "5L51"],
			nightshade: ["6L13", "5L13"],
			ominouswind: ["6L25", "5L25"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			powersplit: ["6L33", "5L33"],
			protect: ["6M", "6L1", "5M", "5L1"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			scaryface: ["6L34", "5L34"],
			shadowball: ["6M", "6L39", "5M", "5L39"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			willowisp: ["6M", "6L21", "5M", "5L21"],
			wonderroom: ["5T"],
		},
	},
	tirtouga: {
		inherit: true,
		learnset: {
			ancientpower: ["6L18", "5L18"],
			aquajet: ["6L15", "5L15", "5S0"],
			aquatail: ["6L41", "5T", "5L41"],
			attract: ["6M", "5M"],
			bide: ["6L1", "6E", "5L1", "5E"],
			bite: ["6L8", "5L8", "5S0"],
			blizzard: ["6M", "5M"],
			block: ["5T"],
			bodyslam: ["6E", "5E", "5S0"],
			brine: ["6L28", "5L28"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L21", "5L21"],
			curse: ["6L35", "5L35"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			flail: ["6E", "5E", "5D"],
			frustration: ["6M", "5M"],
			guardswap: ["6E"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L50", "5L51"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			irondefense: ["6E", "5T", "5E", "5D"],
			irontail: ["5T"],
			knockoff: ["6E", "5E"],
			protect: ["6M", "6L11", "5M", "5L11", "5S0"],
			raindance: ["6M", "6L48", "5M", "5L48"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L45", "5M", "5L45"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6E", "5E"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L5", "5L5", "5D"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scald: ["6M", "5M"],
			shellsmash: ["6L38", "5L38"],
			slam: ["6E", "5E"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L31", "5M", "5L31"],
			snore: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			watergun: ["6L1", "5L1"],
			waterpulse: ["6E", "5E"],
			whirlpool: ["6E", "5E"],
			wideguard: ["6L25", "5L25"],
			withdraw: ["6L1", "5L1"],
		},
	},
	carracosta: {
		inherit: true,
		learnset: {
			ancientpower: ["6L18", "5L18"],
			aquajet: ["6L15", "5L15"],
			aquatail: ["6L45", "5T", "5L45"],
			attract: ["6M", "5M"],
			bide: ["6L1", "5L1"],
			bite: ["6L8", "5L8"],
			blizzard: ["6M", "5M"],
			block: ["5T"],
			brine: ["6L28", "5L28"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L21", "5L21"],
			curse: ["6L35", "5L35"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L61", "5L61"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			irondefense: ["5T"],
			ironhead: ["5T"],
			irontail: ["5T"],
			lowkick: ["5T"],
			protect: ["6M", "6L11", "5M", "5L11"],
			raindance: ["6M", "6L56", "5M", "5L56"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L51", "5M", "5L51"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scald: ["6M", "5M"],
			shellsmash: ["6L40", "5L40"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L31", "5M", "5L31"],
			snore: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			watergun: ["6L1", "5L1"],
			wideguard: ["6L25", "5L25"],
			withdraw: ["6L1", "5L1"],
		},
	},
	archen: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L28", "5M", "5L28"],
			aerialace: ["6M", "5M"],
			agility: ["6L21", "5L21"],
			allyswitch: ["6E"],
			ancientpower: ["6L18", "5L18"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bite: ["6E", "5E"],
			bounce: ["5T"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L35", "5L35"],
			cut: ["6M", "5M"],
			defog: ["6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "6L8", "5M", "5L8", "5S0"],
			dragonbreath: ["6L31", "5L31"],
			dragonclaw: ["6M", "6L48", "5M", "5L48"],
			dragonpulse: ["6E", "5T", "5E"],
			earthpower: ["6E", "5T", "5E"],
			earthquake: ["6M", "5M"],
			endeavor: ["6L38", "5T", "5L38"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			headsmash: ["6E", "5E", "5S0"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["5T"],
			irontail: ["5T"],
			knockoff: ["6E", "5E"],
			leer: ["6L1", "5L1"],
			pluck: ["6L15", "5M", "5L15"],
			protect: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			quickguard: ["6L25", "5L25"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L45", "5M", "5L45"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L5", "5L5"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scaryface: ["6L11", "5L11", "5S0"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			steelwing: ["6M", "6E", "5E"],
			stoneedge: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			switcheroo: ["6E"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			thrash: ["6L50", "5L51"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "6L41", "5M", "5L41"],
			wingattack: ["6L1", "5L1", "5S0"],
		},
	},
	archeops: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L28", "5M", "5L28"],
			aerialace: ["6M", "5M"],
			agility: ["6L21", "5L21"],
			ancientpower: ["6L18", "5L18"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L35", "5L35"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "6L8", "5M", "5L8"],
			dragonbreath: ["6L31", "5L31"],
			dragonclaw: ["6M", "6L56", "5M", "5L56"],
			dragonpulse: ["5T"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			endeavor: ["6L40", "5T", "5L40"],
			facade: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["5T"],
			irontail: ["5T"],
			leer: ["6L1", "5L1"],
			outrage: ["5T"],
			pluck: ["6L15", "5M", "5L15"],
			protect: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			quickguard: ["6L25", "5L25"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L51", "5M", "5L51"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L1", "5L1"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scaryface: ["6L11", "5L11"],
			shadowclaw: ["6M", "5M"],
			skyattack: ["5T"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			thrash: ["6L61", "5L61"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "6L45", "5M", "5L45"],
			wingattack: ["6L1", "5L1"],
		},
	},
	trubbish: {
		inherit: true,
		learnset: {
			acidspray: ["6L12", "5L12"],
			amnesia: ["6L40", "5L40"],
			attract: ["6M", "5M"],
			belch: ["6L42"],
			clearsmog: ["6L34", "5L34"],
			confide: ["6M"],
			curse: ["6E", "5E"],
			darkpulse: ["6M", "5T"],
			doubleslap: ["6L14", "5L14"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			explosion: ["6M", "6L47", "5M", "5L47"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gunkshot: ["6L45", "5T", "5L45"],
			haze: ["6E", "5E"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			mudsport: ["6E", "5E"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			poisongas: ["6L1", "5L1"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recycle: ["6L3", "5T", "5L3"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6E", "5E"],
			rollout: ["6E", "5E"],
			round: ["6M", "5M"],
			sandattack: ["6E", "5E"],
			seedbomb: ["5T"],
			selfdestruct: ["6E", "5E"],
			sleeptalk: ["6M", "5T"],
			sludge: ["6L18", "5L18"],
			sludgebomb: ["6M", "6L29", "5M", "5L29"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			spikes: ["6E", "5E"],
			spite: ["5T"],
			stockpile: ["6L23", "5L23"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swallow: ["6L23", "5L23"],
			takedown: ["6L25", "5L25"],
			thief: ["6M", "5M"],
			toxic: ["6M", "6L36", "5M", "5L36"],
			toxicspikes: ["6L7", "5L7"],
			venoshock: ["6M", "5M"],
		},
	},
	garbodor: {
		inherit: true,
		learnset: {
			acidspray: ["6L12", "5L12"],
			amnesia: ["6L46", "5L46"],
			attract: ["6M", "5M"],
			belch: ["6L49"],
			bodyslam: ["6L25", "5L25"],
			clearsmog: ["6L34", "5L34"],
			confide: ["6M"],
			darkpulse: ["6M", "5T"],
			doubleslap: ["6L14", "5L14"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			explosion: ["6M", "6L59", "5M", "5L59"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			gunkshot: ["6L54", "5T", "5L54"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			painsplit: ["5T"],
			payback: ["6M", "5M"],
			poisongas: ["6L1", "5L1"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recycle: ["6L1", "5T", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			round: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			sludge: ["6L18", "5L18"],
			sludgebomb: ["6M", "6L29", "5M", "5L29"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spite: ["5T"],
			stockpile: ["6L23", "5L23"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swallow: ["6L23", "5L23"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			toxic: ["6M", "6L39", "5M", "5L39"],
			toxicspikes: ["6L1", "5L1"],
			venoshock: ["6M", "5M"],
		},
	},
	zorua: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			agility: ["6L37", "5L37"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			calmmind: ["6M", "5M"],
			captivate: ["6E", "5E"],
			confide: ["6M"],
			copycat: ["6E"],
			counter: ["6E", "5E"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "6E", "5T", "5E"],
			detect: ["6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "6L41", "5M", "5L41"],
			extrasensory: ["6E", "5E"],
			facade: ["6M", "5M"],
			faketears: ["6L9", "5L9"],
			feintattack: ["6L17", "5L17"],
			fling: ["6M", "5M"],
			foulplay: ["6L29", "5T", "5L29"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L13", "5L13"],
			grassknot: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["5T"],
			imprison: ["6L53", "5L53"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			memento: ["6E", "5E"],
			nastyplot: ["6L49", "5L49"],
			nightdaze: ["6L57", "5L57"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			punishment: ["6L45", "5L45"],
			pursuit: ["6L5", "5L5"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L21", "5L21"],
			scratch: ["6L1", "5L1"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["6E", "5T", "5E"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6E", "5E"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			taunt: ["6M", "6L25", "5M", "5L25"],
			thief: ["6M", "5M"],
			torment: ["6M", "6L33", "5M", "5L33"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
		},
	},
	zoroark: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			agility: ["6L39", "5L39", "5S0"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "6S1", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "6L44", "5M", "5L44", "5S0"],
			facade: ["6M", "5M"],
			feintattack: ["6L17", "5L17"],
			flamethrower: ["6M", "6S1", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			foulplay: ["6L29", "5T", "5L29"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L13", "6S2", "5L13"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L1", "5M", "5L1"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["5T"],
			imprison: ["6L1", "5L59"],
			incinerate: ["6M", "5M"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			nastyplot: ["6L54", "6S2", "5L54"],
			nightdaze: ["6L1", "5L64"],
			nightslash: ["6L30", "5L30"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			punishment: ["6L49", "6S2", "5L49", "5S0"],
			pursuit: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L21", "6S2", "5L21"],
			scratch: ["6L1", "5L1"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M", "5S0"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			taunt: ["6M", "6L25", "5M", "5L25"],
			thief: ["6M", "5M"],
			torment: ["6M", "6L34", "5M", "5L34"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			uproar: ["5T"],
			uturn: ["6M", "6L1", "5M", "5L1"],
		},
	},
	minccino: {
		inherit: true,
		learnset: {
			afteryou: ["6L49", "5T", "5L49"],
			aquatail: ["6E", "5T", "5E"],
			attract: ["6M", "5M"],
			babydolleyes: ["6L3"],
			calmmind: ["6M", "5M"],
			captivate: ["6L39", "5L39"],
			charm: ["6L27", "5L27"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M"],
			doubleslap: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "6L33", "5M", "5L33"],
			encore: ["6L15", "5L15"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			faketears: ["6E", "5E"],
			flail: ["6E", "5E"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growl: ["5L3"],
			gunkshot: ["5T"],
			helpinghand: ["6L7", "5T", "5L7"],
			hiddenpower: ["6M", "5M"],
			hypervoice: ["6L43", "5T", "5L43"],
			irontail: ["6E", "5T", "5E"],
			knockoff: ["6E", "5T", "5E"],
			lastresort: ["6L45", "5T", "5L45"],
			mudslap: ["6E", "5E"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sing: ["6L21", "5L21"],
			slam: ["6L37", "5L37"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6L19", "5L19"],
			tailslap: ["6L25", "5L25"],
			tailwhip: ["6E", "5E"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			tickle: ["6L9", "5L9"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			wakeupslap: ["6L31", "5L31"],
			workup: ["5M"],
		},
	},
	cinccino: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bulletseed: ["6L1", "5L1"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gunkshot: ["5T"],
			helpinghand: ["6L1", "5T", "5L1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["5T"],
			irontail: ["5T"],
			knockoff: ["5T"],
			lastresort: ["5T"],
			lightscreen: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockblast: ["6L1", "5L1"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sing: ["6L1", "5L1"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailslap: ["6L1", "5L1"],
			thief: ["6M", "5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			tickle: ["6L1", "5L1"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			workup: ["5M"],
		},
	},
	gothita: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			captivate: ["6E", "5E"],
			chargebeam: ["6M", "5M"],
			charm: ["6L46", "5L46"],
			confide: ["6M"],
			confusion: ["6L3", "5L3"],
			covet: ["5T"],
			darkpulse: ["6M", "6E", "5E"],
			doubleslap: ["6L14", "5L14"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "6L19", "5M", "5L19"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			faketears: ["6L10", "5L10"],
			feintattack: ["6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["6L28", "5L28"],
			fling: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			healbell: ["5T"],
			healblock: ["6L33", "5L33"],
			healpulse: ["6E"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			magicroom: ["6L48", "5T", "5L48"],
			meanlook: ["6E", "5E"],
			miracleeye: ["6E", "5E"],
			mirrorcoat: ["6E", "5E"],
			payback: ["6M", "5M"],
			playnice: ["6L8"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "5M"],
			psybeam: ["6L16", "5L16"],
			psychic: ["6M", "6L37", "5M", "5L37"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["6L40", "5M", "5L40"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			tickle: ["6L7", "5L7"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["6E", "5T", "5E"],
			zenheadbutt: ["5T"],
		},
	},
	gothorita: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			charm: ["6L50", "5L50"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			covet: ["5T"],
			doubleslap: ["6L14", "5L14"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "6L19", "5M", "5L19"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			faketears: ["6L10", "5L1"],
			feintattack: ["6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["6L28", "5L28", "5S0", "5S1"],
			fling: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31", "5S0", "5S1"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			healbell: ["5T"],
			healblock: ["6L34", "5L34"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			imprison: ["5S1"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			magicroom: ["6L53", "5T", "5L53"],
			mirrorcoat: ["5S0"],
			payback: ["6M", "5M"],
			playnice: ["6L1"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "5M"],
			psybeam: ["6L16", "5L16"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25", "5S0", "5S1"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["6L43", "5M", "5L43"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			tickle: ["6L1", "5L1"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			zenheadbutt: ["5T"],
		},
	},
	gothitelle: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			charm: ["6L54", "5L54"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			covet: ["5T"],
			doubleslap: ["6L14", "5L14"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "6L19", "5M", "5L19"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			faketears: ["6L10", "5L1"],
			feintattack: ["6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["6L28", "5L28"],
			fling: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			healbell: ["5T"],
			healblock: ["6L34", "5L34"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			lightscreen: ["6M", "5M"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T"],
			magicroom: ["6L59", "5T", "5L59"],
			payback: ["6M", "5M"],
			playnice: ["6L1"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psybeam: ["6L16", "5L16"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["6L45", "5M", "5L45"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			tickle: ["6L1", "5L1"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			zenheadbutt: ["5T"],
		},
	},
	solosis: {
		inherit: true,
		learnset: {
			acidarmor: ["6E", "5E"],
			afteryou: ["5T"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			charm: ["6L19", "5L19"],
			confide: ["6M"],
			confuseray: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endeavor: ["6L28", "5T", "5L28"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			healblock: ["6L46", "5L46"],
			helpinghand: ["6E"],
			hiddenpower: ["6M", "6L14", "5M", "5L14"],
			imprison: ["6E", "5E"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L16", "5M", "5L16"],
			magiccoat: ["5T"],
			nightshade: ["6E", "5E"],
			painsplit: ["6L33", "5T", "5L33"],
			protect: ["6M", "5M"],
			psychic: ["6M", "6L37", "5M", "5L37"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25"],
			psywave: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			recover: ["6L24", "5L24"],
			reflect: ["6M", "6L3", "5M", "5L3"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			rollout: ["6L7", "5L7"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			secretpower: ["6M", "6E", "5E"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["6L40", "5T", "5L40"],
			sleeptalk: ["6M", "5T"],
			snatch: ["6L10", "5T", "5L10"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["6E", "5T", "5E"],
			trickroom: ["6M", "5M"],
			wonderroom: ["6L48", "5T", "5L48"],
			zenheadbutt: ["5T"],
		},
	},
	duosion: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			charm: ["6L19", "5L19"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endeavor: ["6L28", "5T", "5L28"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			healblock: ["6L50", "5L50"],
			hiddenpower: ["6M", "6L14", "5M", "5L14"],
			imprison: ["5D"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L16", "5M", "5L16"],
			magiccoat: ["5T"],
			painsplit: ["6L34", "5T", "5L34"],
			protect: ["6M", "5M"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25"],
			psywave: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			recover: ["6L24", "5L24", "5D"],
			reflect: ["6M", "6L1", "5M", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["6L43", "5T", "5L43"],
			sleeptalk: ["6M", "5T"],
			snatch: ["6L1", "5T", "5L1"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T", "5D"],
			trickroom: ["6M", "5M"],
			wonderroom: ["6L53", "5T", "5L53"],
			zenheadbutt: ["5T"],
		},
	},
	reuniclus: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			charm: ["6L19", "5L19"],
			confide: ["6M"],
			dizzypunch: ["6L41", "5L41"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			endeavor: ["6L28", "5T", "5L28"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			futuresight: ["6L31", "5L31"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			healblock: ["6L54", "5L54"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "6L14", "5M", "5L14"],
			hyperbeam: ["6M", "5M"],
			icepunch: ["5T"],
			infestation: ["6M"],
			knockoff: ["5T"],
			lightscreen: ["6M", "6L16", "5M", "5L16"],
			magiccoat: ["5T"],
			painsplit: ["6L34", "5T", "5L34"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "6L25", "5M", "5L25"],
			psywave: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			recover: ["6L24", "5L24"],
			reflect: ["6M", "6L1", "5M", "5L1"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			skillswap: ["6L45", "5T", "5L45"],
			sleeptalk: ["6M", "5T"],
			snatch: ["6L1", "5T", "5L1"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			wonderroom: ["6L59", "5T", "5L59"],
			zenheadbutt: ["5T"],
		},
	},
	ducklett: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L15", "5M", "5L15"],
			aircutter: ["6E", "5E"],
			airslash: ["6L27", "5L27"],
			aquaring: ["6L24", "5L24"],
			attract: ["6M", "5M"],
			bravebird: ["6L41", "5L41"],
			brine: ["6E", "5E", "5D"],
			bubblebeam: ["6L19", "5L19"],
			confide: ["6M"],
			defog: ["6L6", "5L6", "5D"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			featherdance: ["6L21", "5L21"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gust: ["6E", "5E"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hurricane: ["6L46", "5L46"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			luckychant: ["6E", "5E"],
			mefirst: ["6E", "5E", "5D"],
			mirrormove: ["6E", "5E"],
			mudsport: ["6E"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "6L34", "5M", "5L34"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6L30", "5T", "5L30"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M", "6E", "5E"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["6L37", "5T", "5L37"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			watergun: ["6L1", "5L1"],
			waterpulse: ["6L13", "5L13"],
			watersport: ["6L3", "5L3"],
			wingattack: ["6L9", "5L9"],
		},
	},
	swanna: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L15", "5M", "5L15"],
			airslash: ["6L27", "5L27"],
			aquaring: ["6L24", "5L24"],
			attract: ["6M", "5M"],
			bravebird: ["6L47", "5L47"],
			bubblebeam: ["6L19", "5L19"],
			confide: ["6M"],
			defog: ["6L1", "5L1"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			featherdance: ["6L21", "5L21"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hurricane: ["6L55", "5L55"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "6L34", "5M", "5L34"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6L30", "5T", "5L30"],
			round: ["6M", "5M"],
			scald: ["6M", "5M"],
			skyattack: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["6L40", "5T", "5L40"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			watergun: ["6L1", "5L1"],
			waterpulse: ["6L13", "5L13"],
			watersport: ["6L1", "5L1"],
			wingattack: ["6L1", "5L1"],
		},
	},
	vanillite: {
		inherit: true,
		learnset: {
			acidarmor: ["6L31", "5L31"],
			astonish: ["6L7", "5L7"],
			attract: ["6M", "5M"],
			autotomize: ["6E", "5E"],
			avalanche: ["6L19", "5L19"],
			blizzard: ["6M", "6L49", "5M", "5L49"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			hail: ["6M", "6L40", "5M", "5L40"],
			harden: ["6L4", "5L4"],
			hiddenpower: ["6M", "5M"],
			icebeam: ["6M", "6L35", "5M", "5L35"],
			iceshard: ["6E", "5E"],
			iciclespear: ["6L1", "5L1"],
			icywind: ["6L13", "5T", "5L13"],
			imprison: ["6E", "5E"],
			irondefense: ["6E", "5T", "5E"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			magnetrise: ["6E", "5T", "5E"],
			mirrorcoat: ["6L44", "5L44"],
			mirrorshot: ["6L26", "5L26"],
			mist: ["6L16", "5L16"],
			naturalgift: ["6E", "5E"],
			powdersnow: ["6E", "5E"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sheercold: ["6L53", "5L53"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "6L22", "5M", "5L22"],
			toxic: ["6M", "5M"],
			uproar: ["6L10", "5T", "5L10"],
			waterpulse: ["6E", "5E"],
		},
	},
	vanillish: {
		inherit: true,
		learnset: {
			acidarmor: ["6L31", "5L31"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			avalanche: ["6L19", "5L19"],
			blizzard: ["6M", "6L53", "5M", "5L53"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			hail: ["6M", "6L42", "5M", "5L42"],
			harden: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			icebeam: ["6M", "6L36", "5M", "5L36"],
			iceshard: ["5D"],
			iciclespear: ["6L1", "5L1"],
			icywind: ["6L13", "5T", "5L13"],
			imprison: ["5D"],
			irondefense: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			magnetrise: ["5T"],
			mirrorcoat: ["6L47", "5L47"],
			mirrorshot: ["6L26", "5L26", "5D"],
			mist: ["6L16", "5L16"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sheercold: ["6L58", "5L58"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "6L22", "5M", "5L22"],
			toxic: ["6M", "5M"],
			uproar: ["6L1", "5T", "5L1"],
		},
	},
	vanilluxe: {
		inherit: true,
		learnset: {
			acidarmor: ["6L31", "5L31"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			avalanche: ["6L19", "5L19"],
			blizzard: ["6M", "6L59", "5M", "5L59"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			freezedry: ["6L1"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "6L42", "5M", "5L42"],
			harden: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "6L36", "5M", "5L36"],
			iciclespear: ["6L1", "5L1"],
			icywind: ["6L13", "5T", "5L13"],
			irondefense: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			magnetrise: ["5T"],
			mirrorcoat: ["6L50", "5L50"],
			mirrorshot: ["6L26", "5L26"],
			mist: ["6L16", "5L16"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sheercold: ["6L1", "5L67"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "6L22", "5M", "5L22"],
			toxic: ["6M", "5M"],
			uproar: ["6L1", "5T", "5L1"],
			weatherball: ["6L1", "5L1"],
		},
	},
	deerling: {
		inherit: true,
		learnset: {
			agility: ["6E", "5E"],
			aromatherapy: ["6L28", "5L28", "5S0"],
			attract: ["6M", "5M"],
			batonpass: ["6E", "5E"],
			bounce: ["5T"],
			camouflage: ["6L1", "5L1"],
			charm: ["6L36", "5L36"],
			confide: ["6M"],
			doubleedge: ["6L46", "5L46"],
			doublekick: ["6L10", "5L10"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			energyball: ["6M", "6L32", "5M", "5L32"],
			facade: ["6M", "5M"],
			faketears: ["6E", "5E"],
			feintattack: ["6L16", "5L16", "5S0"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			grassknot: ["6M", "5M"],
			grasswhistle: ["6E", "5E"],
			growl: ["6L4", "5L4"],
			hiddenpower: ["6M", "5M"],
			jumpkick: ["6L24", "5L24", "5S0"],
			lastresort: ["5T"],
			leechseed: ["6L13", "5L13"],
			lightscreen: ["6M", "5M"],
			naturalgift: ["6E", "5E"],
			naturepower: ["6M", "6L41", "5L41"],
			odorsleuth: ["6E", "5E"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			sandattack: ["6L7", "5L7"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snore: ["5T"],
			solarbeam: ["6M", "6L51", "5M", "5L51"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synthesis: ["6E", "5T", "5E"],
			tackle: ["6L1", "5L1"],
			takedown: ["6L20", "5L20", "5S0"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			worryseed: ["6E", "5T", "5E"],
		},
	},
	sawsbuck: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L28", "5L28"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			camouflage: ["6L1", "5L1"],
			charm: ["6L36", "5L36"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleedge: ["6L52", "5L52"],
			doublekick: ["6L10", "5L10"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			energyball: ["6M", "6L32", "5M", "5L32"],
			facade: ["6M", "5M"],
			feintattack: ["6L16", "5L16"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			hornleech: ["6L37", "5L37"],
			hyperbeam: ["6M", "5M"],
			jumpkick: ["6L24", "5L24"],
			lastresort: ["5T"],
			leechseed: ["6L13", "5L13"],
			lightscreen: ["6M", "5M"],
			megahorn: ["6L1", "5L1"],
			naturepower: ["6M", "6L44", "5L44"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			seedbomb: ["5T"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "6L60", "5M", "5L60"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			synthesis: ["5T"],
			tackle: ["6L1", "5L1"],
			takedown: ["6L20", "5L20"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			worryseed: ["5T"],
		},
	},
	emolga: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L30", "5M", "5L30"],
			aerialace: ["6M", "5M"],
			agility: ["6L46", "5L46"],
			airslash: ["6E", "5E", "5D"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			batonpass: ["6E", "5E"],
			charge: ["6L10", "5L10"],
			chargebeam: ["6M", "5M"],
			charm: ["6E", "5E", "5D"],
			confide: ["6M"],
			covet: ["6E", "5T", "5E"],
			cut: ["6M", "5M"],
			discharge: ["6L50", "5L50"],
			doubleteam: ["6M", "6L19", "5M", "5L19"],
			electroball: ["6L26", "5L26"],
			encore: ["6L38", "5L38"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			iondeluge: ["6E"],
			irontail: ["6E", "5T", "5E"],
			knockoff: ["5T"],
			lastresort: ["5T"],
			lightscreen: ["6M", "6L34", "5M", "5L34"],
			nuzzle: ["6L15"],
			protect: ["6M", "5M"],
			pursuit: ["6L16", "5L16"],
			quickattack: ["6L4", "5L4", "5D"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "6E", "5T", "5E"],
			round: ["6M", "5M"],
			shockwave: ["6L22", "6E", "5L22", "5E"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spark: ["6L13", "5L13"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwhip: ["6L7", "5L7"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thundershock: ["6L1", "5L1"],
			thunderwave: ["6M", "5M"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			voltswitch: ["6M", "6L42", "5M", "5L42"],
			wildcharge: ["6M", "5M"],
		},
	},
	karrablast: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			bugbite: ["6E", "5T", "5E", "5D"],
			bugbuzz: ["6L28", "5L28", "5S0"],
			confide: ["6M"],
			counter: ["6E", "5E"],
			cut: ["6M", "5M"],
			doubleedge: ["6L56", "5L56"],
			doubleteam: ["6M", "5M"],
			drillrun: ["6E"],
			endure: ["6L8", "5L8", "5D"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L25", "5M", "5L25", "5S0"],
			feintattack: ["6E", "5E"],
			flail: ["6L49", "5L49", "5S1"],
			frustration: ["6M", "5M"],
			furyattack: ["6L16", "5L16", "5S0"],
			furycutter: ["6L13", "5L13"],
			gigadrain: ["5T"],
			headbutt: ["6L20", "5L20", "5S0"],
			hiddenpower: ["6M", "5M"],
			hornattack: ["6E", "5E"],
			infestation: ["6M"],
			irondefense: ["5T"],
			knockoff: ["6E", "5T", "5E"],
			leer: ["6L4", "5L4"],
			megahorn: ["6E", "5E", "5D", "5S1"],
			peck: ["6L1", "5L1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L40", "5L40"],
			screech: ["6E", "5E"],
			slash: ["6L32", "5L32"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L52", "5M", "5L52"],
			takedown: ["6L37", "5L37", "5S1"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "6L44", "5M", "5L44", "5S1"],
		},
	},
	escavalier: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			bugbite: ["5T"],
			bugbuzz: ["6L28", "5L28"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleedge: ["6L1"],
			doubleteam: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L25", "5M", "5L25"],
			fellstinger: ["6L1"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyattack: ["6L16", "5L16"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "6L56", "5M", "5L56"],
			headbutt: ["6L20", "5L20"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["6L40", "5T", "5L40"],
			ironhead: ["6L37", "5T", "5L37"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			peck: ["6L1", "5L1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			quickguard: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			reversal: ["6L49", "5L49"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			slash: ["6L32", "5L32"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L52", "5M", "5L52"],
			toxic: ["6M", "5M"],
			twineedle: ["6L1", "5L1"],
			xscissor: ["6M", "6L44", "5M", "5L44"],
		},
	},
	foongus: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			afteryou: ["5T"],
			astonish: ["6L8", "5L8"],
			attract: ["6M", "5M"],
			bide: ["6L12", "5L12"],
			bodyslam: ["6E", "5E"],
			clearsmog: ["6L39", "5L39"],
			confide: ["6M"],
			defensecurl: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			endure: ["6E", "5E"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6L20", "5L20"],
			flash: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			gastroacid: ["6E", "5T", "5E"],
			gigadrain: ["6L28", "5T", "5L28"],
			grassknot: ["6M", "5M"],
			growth: ["6L6", "6E", "5L6", "5E"],
			hiddenpower: ["6M", "5M"],
			ingrain: ["6L18", "5L18"],
			megadrain: ["6L15", "5L15"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			poisonpowder: ["6E", "5E"],
			protect: ["6M", "5M"],
			ragepowder: ["6L45", "5L45"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rollout: ["6E", "5E"],
			round: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "6L43", "5M", "5L43"],
			spore: ["6L50", "5L50"],
			stunspore: ["6E", "5E"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			sweetscent: ["6L24", "5L24"],
			synthesis: ["6L35", "5T", "5L35"],
			toxic: ["6M", "6L32", "5M", "5L32"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	amoonguss: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			afteryou: ["5T"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			bide: ["6L1", "5L1"],
			clearsmog: ["6L43", "5L43"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6L20", "5L20"],
			flash: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			gastroacid: ["5T"],
			gigadrain: ["6L28", "5T", "5L28"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growth: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			ingrain: ["6L18", "5L18"],
			megadrain: ["6L15", "5L15"],
			naturepower: ["6M"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			ragepowder: ["6L54", "5L54"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			solarbeam: ["6M", "6L49", "5M", "5L49"],
			spore: ["6L62", "5L62"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			sweetscent: ["6L24", "5L24"],
			synthesis: ["6L35", "5T", "5L35"],
			toxic: ["6M", "6L32", "5M", "5L32"],
			venoshock: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	frillish: {
		inherit: true,
		learnset: {
			absorb: ["6L5", "5L5"],
			acidarmor: ["6E", "5E"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			blizzard: ["6M", "5M"],
			brine: ["6L32", "5L32"],
			bubble: ["6L1", "5L1"],
			bubblebeam: ["6L13", "5L13"],
			confide: ["6M"],
			confuseray: ["6E", "5E"],
			constrict: ["6E", "5E"],
			darkpulse: ["6M", "5T"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			hail: ["6M", "5M"],
			hex: ["6L43", "5L43"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L49", "5L49"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			magiccoat: ["5T"],
			mist: ["6E", "5E"],
			nightshade: ["6L9", "5L9"],
			ominouswind: ["6L27", "5L27"],
			painsplit: ["6E", "5T", "5E"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "6L37", "5M", "5L37"],
			recover: ["6L17", "6E", "5L17", "5E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			scald: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			waterpulse: ["6L22", "5L22"],
			watersport: ["6L1", "5L1"],
			waterspout: ["6L61", "5L61"],
			willowisp: ["6M", "5M"],
			wringout: ["6L55", "5L55"],
		},
	},
	jellicent: {
		inherit: true,
		learnset: {
			absorb: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			blizzard: ["6M", "5M"],
			brine: ["6L32", "5L32", "5S0"],
			bubble: ["6L1", "5L1"],
			bubblebeam: ["6L13", "5L13"],
			confide: ["6M"],
			darkpulse: ["6M", "5T"],
			dazzlinggleam: ["6M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "5M"],
			hex: ["6L45", "5L45"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L53", "5L53"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			magiccoat: ["5T"],
			nightshade: ["6L1", "5L1"],
			ominouswind: ["6L27", "5L27", "5S0"],
			painsplit: ["5T"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "6L37", "5M", "5L37", "5S0"],
			recover: ["6L17", "5L17"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			scald: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			waterfall: ["6M", "5M"],
			waterpulse: ["6L22", "5L22", "5S0"],
			watersport: ["6L1", "5L1"],
			waterspout: ["6L1", "5L69"],
			willowisp: ["6M", "5M"],
			wringout: ["6L1", "5L61"],
		},
	},
	alomomola: {
		inherit: true,
		learnset: {
			aquajet: ["6L9", "5L9"],
			aquaring: ["6L5", "5L5", "5D"],
			attract: ["6M", "5M"],
			blizzard: ["6M", "5M"],
			bounce: ["5T"],
			brine: ["6L41", "5L41"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			dive: ["6M", "5M"],
			doubleslap: ["6L13", "5L13"],
			doubleteam: ["6M", "5M"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			frustration: ["6M", "5M"],
			hail: ["6M", "5M"],
			healingwish: ["6L1", "5L57"],
			healpulse: ["6L17", "5L17"],
			helpinghand: ["6L49", "5T", "5L49"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L1", "5L61"],
			icebeam: ["6M", "5M"],
			icywind: ["5T"],
			knockoff: ["5T"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			mirrorcoat: ["6E", "5E", "5D"],
			mist: ["6E", "5E"],
			painsplit: ["6E", "5T", "5E", "5D"],
			pound: ["6L1", "5L1"],
			protect: ["6M", "6L21", "5M", "5L21"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			refresh: ["6E", "5E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "6L45", "5M", "5L45"],
			scald: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			soak: ["6L33", "5L33"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M"],
			wakeupslap: ["6L29", "5L29"],
			waterfall: ["6M", "5M"],
			waterpulse: ["6L25", "5L25"],
			watersport: ["6L1", "5L1"],
			wideguard: ["6L1", "5L53"],
			wish: ["6L37", "5L37"],
		},
	},
	joltik: {
		inherit: true,
		learnset: {
			agility: ["6L37", "5L37"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			bugbite: ["6L18", "5T", "5L18"],
			bugbuzz: ["6L48", "5L48"],
			camouflage: ["6E"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			crosspoison: ["6E", "5E"],
			cut: ["6M", "5M"],
			disable: ["6E", "5E"],
			discharge: ["6L45", "5L45"],
			doubleteam: ["6M", "5M"],
			electroball: ["6L29", "5L29"],
			electroweb: ["6L15", "5T", "5L15"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furycutter: ["6L12", "5L12"],
			gastroacid: ["6L23", "5T", "5L23"],
			gigadrain: ["5T"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			leechlife: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			pinmissile: ["6E", "5E"],
			poisonjab: ["6M", "5M"],
			poisonsting: ["6E", "5E"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6E", "5E"],
			round: ["6M", "5M"],
			screech: ["6L7", "5L7"],
			signalbeam: ["6L34", "5T", "5L34"],
			slash: ["6L26", "5L26"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spiderweb: ["6L1", "5L1"],
			stringshot: ["6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6L40", "5L40"],
			swagger: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "6L4", "5M", "5L4"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	galvantula: {
		inherit: true,
		learnset: {
			agility: ["6L40", "5L40"],
			attract: ["6M", "5M"],
			bounce: ["5T"],
			bugbite: ["6L18", "5T", "5L18"],
			bugbuzz: ["6L60", "5L60"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			disable: ["5D"],
			discharge: ["6L54", "5L54"],
			doubleteam: ["6M", "5M"],
			electroball: ["6L29", "5L29", "5D"],
			electroweb: ["6L15", "5T", "5L15"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furycutter: ["6L12", "5L12"],
			gastroacid: ["6L23", "5T", "5L23"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			leechlife: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			pursuit: ["5D"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			screech: ["6L7", "5L7"],
			signalbeam: ["6L34", "5T", "5L34"],
			slash: ["6L26", "5L26"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spiderweb: ["6L1", "5L1"],
			stickyweb: ["6L1"],
			stringshot: ["6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6L46", "5L46"],
			swagger: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "6L1", "5M", "5L1"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	ferroseed: {
		inherit: true,
		learnset: {
			acidspray: ["6E"],
			bulletseed: ["6E", "5E"],
			confide: ["6M"],
			curse: ["6L9", "5L9"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "6L55", "5M", "5L55"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "6L52", "5M", "5L52"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gravity: ["6E", "5T", "5E"],
			gyroball: ["6M", "6L21", "5M", "5L21"],
			harden: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			ingrain: ["6L35", "5L35"],
			irondefense: ["6L26", "5T", "5L26"],
			ironhead: ["6L43", "5T", "5L43"],
			leechseed: ["6E", "5E"],
			magnetrise: ["5T"],
			metalclaw: ["6L14", "5L14"],
			mirrorshot: ["6L30", "5L30"],
			naturepower: ["6M"],
			payback: ["6M", "6L47", "5M", "5L47"],
			pinmissile: ["6L18", "5L18"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6E", "5E"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rollout: ["6L6", "5L6"],
			round: ["6M", "5M"],
			seedbomb: ["6E", "5T", "5E"],
			selfdestruct: ["6L38", "5L38"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spikes: ["6E", "5E"],
			stealthrock: ["6E", "5T", "5E"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			worryseed: ["6E", "5T", "5E"],
		},
	},
	ferrothorn: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6L1", "5L1"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "6L67", "5M", "5L67"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "6L61", "5M", "5L61"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			gyroball: ["6M", "6L21", "5M", "5L21"],
			harden: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			ingrain: ["6L35", "5L35"],
			irondefense: ["6L26", "5T", "5L26"],
			ironhead: ["6L46", "5T", "5L46"],
			knockoff: ["5T"],
			magnetrise: ["5T"],
			metalclaw: ["6L14", "5L14"],
			mirrorshot: ["6L30", "5L30"],
			naturepower: ["6M"],
			payback: ["6M", "6L53", "5M", "5L53"],
			pinmissile: ["6L18", "5L18"],
			poisonjab: ["6M", "5M"],
			powerwhip: ["6L40", "5L40"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6L1", "5L1"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rollout: ["6L1", "5L1"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			seedbomb: ["5T"],
			selfdestruct: ["6L38", "5L38"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "5M"],
			tackle: ["6L1", "5L1"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			worryseed: ["5T"],
		},
	},
	klink: {
		inherit: true,
		learnset: {
			autotomize: ["6L31", "5L31"],
			bind: ["6L21", "5T", "5L21"],
			charge: ["6L6", "5L6"],
			chargebeam: ["6M", "6L26", "5M", "5L26"],
			confide: ["6M"],
			discharge: ["6L42", "5L42"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			geargrind: ["6L16", "5L16"],
			gravity: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "6L57", "5M", "5L57"],
			irondefense: ["5T"],
			lockon: ["6L50", "5L51"],
			magiccoat: ["5T"],
			magnetrise: ["5T"],
			metalsound: ["6L45", "5L45"],
			mirrorshot: ["6L36", "5L36"],
			protect: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			screech: ["6L39", "5L39"],
			shiftgear: ["6L48", "5L48"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thundershock: ["6L11", "5L11"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			visegrip: ["6L1", "5L1"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L54", "5L54"],
		},
	},
	klang: {
		inherit: true,
		learnset: {
			autotomize: ["6L31", "5L31"],
			bind: ["6L21", "5T", "5L21"],
			charge: ["6L1", "5L1"],
			chargebeam: ["6M", "6L26", "5M", "5L26", "5D"],
			confide: ["6M"],
			discharge: ["6L44", "5L44"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			geargrind: ["6L1", "5L1"],
			gravity: ["5T", "5D"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "6L64", "5M", "5L64"],
			irondefense: ["5T"],
			lockon: ["6L56", "5L56"],
			magiccoat: ["5T"],
			magnetrise: ["5T", "5D"],
			metalsound: ["6L48", "5L48"],
			mirrorshot: ["6L36", "5L36"],
			protect: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			screech: ["6L40", "5L40"],
			shiftgear: ["6L52", "5L52"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thundershock: ["6L1", "5L1"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			visegrip: ["6L1", "5L1"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L60", "5L60"],
		},
	},
	klinklang: {
		inherit: true,
		learnset: {
			autotomize: ["6L31", "5L31"],
			bind: ["6L21", "5T", "5L21"],
			charge: ["6L1", "5L1"],
			chargebeam: ["6M", "6L25", "5M", "5L25"],
			confide: ["6M"],
			discharge: ["6L44", "5L44"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			geargrind: ["6L1", "5L1"],
			gigaimpact: ["6M", "5M"],
			gravity: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "6L72", "5M", "5L72"],
			irondefense: ["5T"],
			lockon: ["6L60", "5L60"],
			magiccoat: ["5T"],
			magneticflux: ["6L1"],
			magnetrise: ["5T"],
			metalsound: ["6L48", "5L48"],
			mirrorshot: ["6L36", "5L36"],
			protect: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			screech: ["6L40", "5L40"],
			shiftgear: ["6L54", "5L54"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thundershock: ["6L1", "5L1"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			visegrip: ["6L1", "5L1"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1", "5L66"],
		},
	},
	tynamo: {
		inherit: true,
		learnset: {
			chargebeam: ["6M", "6L1", "5L1"],
			magnetrise: ["5T"],
			spark: ["6L1", "5L1"],
			tackle: ["6L1", "5L1"],
			thunderwave: ["6M", "6L1", "5L1"],
		},
	},
	eelektrik: {
		inherit: true,
		learnset: {
			acid: ["6L19", "5L19"],
			acidspray: ["6L49", "5L49"],
			acrobatics: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bind: ["6L9", "5T", "5L9"],
			bounce: ["5T"],
			chargebeam: ["6M", "6L1", "5M", "5L1"],
			coil: ["6L54", "5L54"],
			confide: ["6M"],
			crunch: ["6L39", "5L39"],
			discharge: ["6L29", "5L29"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["6L64", "5T", "5L64"],
			gigadrain: ["5T"],
			headbutt: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spark: ["6L1", "5L1"],
			substitute: ["6M", "5M"],
			superfang: ["5T"],
			swagger: ["6M", "5M"],
			thrash: ["6L74", "5L74"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "6L44", "5M", "5L44"],
			thunderwave: ["6M", "6L1", "5M", "5L1"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "6L59", "5M", "5L59"],
			zapcannon: ["6L69", "5L69"],
		},
	},
	eelektross: {
		inherit: true,
		learnset: {
			acid: ["6L1", "5L1"],
			acrobatics: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bind: ["5T"],
			bounce: ["5T"],
			brickbreak: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			coil: ["6L1"],
			confide: ["6M"],
			crunch: ["6L1", "5L1"],
			crushclaw: ["6L1", "5L1"],
			cut: ["6M", "5M"],
			discharge: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dragonclaw: ["6M", "5M"],
			dragontail: ["6M", "5M"],
			drainpunch: ["5T"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["6L1", "5T"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			headbutt: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			iondeluge: ["6L1"],
			irontail: ["5T"],
			knockoff: ["5T"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superfang: ["5T"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			thrash: ["6L1"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zapcannon: ["6L1"],
		},
	},
	elgyem: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			allyswitch: ["6E", "5M"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			barrier: ["6E", "5E", "5D"],
			calmmind: ["6M", "6L43", "5M", "5L43"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			cosmicpower: ["6E"],
			darkpulse: ["6M", "5T"],
			disable: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gravity: ["5T"],
			growl: ["6L4", "5L4"],
			guardsplit: ["6L50", "5L50"],
			guardswap: ["6E", "5E"],
			headbutt: ["6L18", "5L18"],
			healblock: ["6L8", "5L8", "5D"],
			hiddenpower: ["6M", "6L22", "5M", "5L22"],
			imprison: ["6L25", "5L25"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			miracleeye: ["6L11", "5L11"],
			nastyplot: ["6E", "5E", "5D"],
			painsplit: ["5T"],
			powersplit: ["6L50", "5L50"],
			powerswap: ["6E", "5E"],
			protect: ["6M", "5M"],
			psybeam: ["6L15", "5L15"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "6L36", "5M", "5L36"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recover: ["6L46", "5L46"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			simplebeam: ["6L29", "5L29"],
			skillswap: ["6E", "5T", "5E"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synchronoise: ["6L53", "5L53"],
			telekinesis: ["5M"],
			teleport: ["6E", "5E"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			wonderroom: ["6L56", "5T", "5L56"],
			zenheadbutt: ["6L32", "5T", "5L32"],
		},
	},
	beheeyem: {
		inherit: true,
		learnset: {
			afteryou: ["5T"],
			allyswitch: ["5M"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "6L45", "5M", "5L45"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			confusion: ["6L1", "5L1"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			embargo: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			gravity: ["5T"],
			growl: ["6L1", "5L1"],
			guardsplit: ["6L56", "5L56"],
			headbutt: ["6L18", "5L18"],
			healblock: ["6L1", "5L1"],
			hiddenpower: ["6M", "6L22", "5M", "5L22"],
			hyperbeam: ["6M", "5M"],
			imprison: ["6L25", "5L25"],
			lightscreen: ["6M", "5M"],
			magiccoat: ["5T"],
			miracleeye: ["6L1", "5L1"],
			painsplit: ["5T"],
			powersplit: ["6L58", "5L58"],
			protect: ["6M", "5M"],
			psybeam: ["6L15", "5L15"],
			psychic: ["6M", "6L39", "5M", "5L39"],
			psychup: ["6M", "6L36", "5M", "5L36"],
			psyshock: ["6M", "5M"],
			raindance: ["6M", "5M"],
			recover: ["6L50", "5L50"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			signalbeam: ["5T"],
			simplebeam: ["6L29", "5L29"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			synchronoise: ["6L1", "5L63"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			wonderroom: ["6L1", "5T", "5L68"],
			zenheadbutt: ["6L32", "5T", "5L32"],
		},
	},
	litwick: {
		inherit: true,
		learnset: {
			acid: ["6E", "5E"],
			acidarmor: ["6E", "5E"],
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			captivate: ["6E", "5E"],
			clearsmog: ["6E", "5E"],
			confide: ["6M"],
			confuseray: ["6L10", "5L10"],
			curse: ["6L43", "5L43"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			endure: ["6E", "5E"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firespin: ["6L7", "5L7"],
			flameburst: ["6L20", "5L20"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			haze: ["6E", "5E"],
			heatwave: ["6E", "5T", "5E"],
			hex: ["6L28", "5L28"],
			hiddenpower: ["6M", "5M"],
			imprison: ["6L24", "5L24"],
			incinerate: ["6M", "5M"],
			inferno: ["6L38", "5L38"],
			memento: ["6L33", "5L33"],
			minimize: ["6L3", "5L3"],
			nightshade: ["6L13", "5L13"],
			overheat: ["6M", "6L61", "5M", "5L61"],
			painsplit: ["6L55", "5T", "5L55"],
			payback: ["6M", "5M"],
			powersplit: ["6E"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "6L49", "5M", "5L49"],
			sleeptalk: ["6M", "5T"],
			smog: ["6L5", "5L5"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			willowisp: ["6M", "6L16", "5M", "5L16"],
		},
	},
	lampent: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			confuseray: ["6L10", "5L10"],
			curse: ["6L45", "5L45"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			firespin: ["6L7", "5L7"],
			flameburst: ["6L20", "5L20"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			heatwave: ["5T"],
			hex: ["6L28", "5L28"],
			hiddenpower: ["6M", "5M"],
			imprison: ["6L24", "5L24"],
			incinerate: ["6M", "5M"],
			inferno: ["6L38", "5L38"],
			memento: ["6L33", "5L33"],
			minimize: ["6L1", "5L1"],
			nightshade: ["6L13", "5L13"],
			overheat: ["6M", "6L69", "5M", "5L69"],
			painsplit: ["6L61", "5T", "5L61"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			psychup: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "6L53", "5M", "5L53"],
			sleeptalk: ["6M", "5T"],
			smog: ["6L1", "5L1"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			willowisp: ["6M", "6L16", "5M", "5L16"],
		},
	},
	chandelure: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			confuseray: ["6L1", "5L1"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dreameater: ["6M", "5M"],
			embargo: ["6M", "5M"],
			energyball: ["6M", "5M", "5S0"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			flameburst: ["6L1", "5L1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			heatwave: ["5T", "5S0"],
			hex: ["6L1", "5L1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			overheat: ["6M", "5M"],
			painsplit: ["6L1", "5T"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M", "5S0"],
			psychup: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M", "5S0"],
			sleeptalk: ["6M", "5T"],
			smog: ["6L1", "5L1"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spite: ["5T"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			willowisp: ["6M", "5M"],
		},
	},
	axew: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			assurance: ["6L7", "5L7"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			counter: ["6E", "5E", "5D"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonclaw: ["6M", "6L28", "5M", "5L28", "5S1"],
			dragondance: ["6L32", "5L32"],
			dragonpulse: ["6L41", "6E", "5T", "5L41", "5E"],
			dragonrage: ["6L10", "5L10", "5D", "5S0", "5S1", "5S2"],
			dualchop: ["6L13", "5T", "5L13"],
			endeavor: ["6E", "5T", "5E"],
			endure: ["6E", "5E", "5S1"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L24", "5M", "5L24"],
			fling: ["6M", "5M"],
			focusenergy: ["6E", "5E"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L61", "5M", "5L61", "5S2"],
			guillotine: ["6L50", "5L51"],
			harden: ["6E", "5E"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6E", "5T", "5E"],
			leer: ["6L4", "5L4"],
			nightslash: ["6E", "5E", "5D"],
			outrage: ["6L56", "5T", "5L56", "5S2"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			razorwind: ["6E", "5E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M", "5S1"],
			reversal: ["6E", "5E"],
			roar: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L16", "5L16"],
			scratch: ["6L1", "5L1", "5S0", "5S2"],
			slash: ["6L20", "5L20"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L46", "5M", "5L46"],
			taunt: ["6M", "6L36", "5M", "5L36"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	fraxure: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			assurance: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonclaw: ["6M", "6L28", "5M", "5L28"],
			dragondance: ["6L32", "5L32"],
			dragonpulse: ["6L42", "5T", "5L42"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			dualchop: ["6L13", "5T", "5L13"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L24", "5M", "5L24"],
			fling: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L66", "5M", "5L66"],
			guillotine: ["6L54", "5L54"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			outrage: ["6L60", "5T", "5L60"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L16", "5L16"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L20", "5L20"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L48", "5M", "5L48"],
			taunt: ["6M", "6L36", "5M", "5L36"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	haxorus: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			assurance: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonclaw: ["6M", "6L28", "5M", "5L28"],
			dragondance: ["6L32", "5L32", "5S0"],
			dragonpulse: ["6L42", "5T", "5L42"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			dualchop: ["6L13", "5T", "5L13", "5S0"],
			earthquake: ["6M", "5M", "5S0"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "6L24", "5M", "5L24"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "6L74", "5M", "5L74"],
			grassknot: ["6M", "5M"],
			guillotine: ["6L58", "5L58"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			outrage: ["6L1", "5T", "5L66"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L16", "5L16"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L20", "5L20"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L50", "5M", "5L50"],
			taunt: ["6M", "6L36", "5M", "5L36"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M", "5S0"],
		},
	},
	cubchoo: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			assurance: ["6E", "5E"],
			attract: ["6M", "5M"],
			avalanche: ["6E", "5E"],
			bide: ["6L9", "5L9", "5S0"],
			blizzard: ["6M", "6L45", "5M", "5L45"],
			brine: ["6L21", "5L21"],
			charm: ["6L29", "5L29"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			encore: ["6E", "5E"],
			endure: ["6L25", "5L25"],
			facade: ["6M", "5M"],
			flail: ["6L36", "5L36"],
			fling: ["6M", "5M"],
			focuspunch: ["6E", "5E"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L17", "5L17"],
			grassknot: ["6M", "5M"],
			growl: ["6L1", "5L5", "5S0"],
			hail: ["6M", "6L49", "5M", "5L49"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icepunch: ["6E", "5T", "5E"],
			icywind: ["6L13", "5T", "5L13", "5S0"],
			lowkick: ["5T"],
			nightslash: ["6E", "5E"],
			playnice: ["6L15"],
			playrough: ["6E"],
			powdersnow: ["6L5", "5L1", "5S0"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "6L41", "5M", "5L41"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			sheercold: ["6L57", "5L57"],
			slash: ["6L33", "5L33"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			thrash: ["6L53", "5L53"],
			toxic: ["6M", "5M"],
			yawn: ["6E", "5E"],
		},
	},
	beartic: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquajet: ["6L1", "5L1"],
			attract: ["6M", "5M"],
			bide: ["6L1", "5L1"],
			blizzard: ["6M", "6L45", "5M", "5L45"],
			brickbreak: ["6M", "5M"],
			brine: ["6L21", "5L21"],
			bulkup: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			endure: ["6L25", "5L25"],
			facade: ["6M", "5M"],
			flail: ["6L36", "5L36"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L17", "5L17"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			growl: ["6L1", "5L1"],
			hail: ["6M", "6L53", "5M", "5L53"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			iciclecrash: ["6L37", "5L37"],
			icywind: ["6L1", "5T", "5L1"],
			lowkick: ["5T"],
			playnice: ["6L9"],
			powdersnow: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "6L41", "5M", "5L41"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			sheercold: ["6L1", "5L66"],
			slash: ["6L33", "5L33"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["6L1", "5T", "5L1"],
			surf: ["6M", "5M"],
			swagger: ["6M", "6L29", "5M", "5L29"],
			swordsdance: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thrash: ["6L1", "5L59"],
			toxic: ["6M", "5M"],
		},
	},
	cryogonal: {
		inherit: true,
		learnset: {
			acidarmor: ["6L29", "5L29"],
			acrobatics: ["6M", "5M"],
			attract: ["6M", "5M"],
			aurorabeam: ["6L25", "5L25"],
			bind: ["6L1", "5T", "5L1"],
			blizzard: ["6M", "5M"],
			confide: ["6M"],
			confuseray: ["6L45", "5L45"],
			doubleteam: ["6M", "5M"],
			explosion: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			freezedry: ["6L50"],
			frostbreath: ["6M", "5M"],
			frustration: ["6M", "5M"],
			hail: ["6M", "5M"],
			haze: ["6L1", "5L21"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			icebeam: ["6M", "6L33", "5M", "5L33"],
			iceshard: ["6L1", "5L5"],
			icywind: ["6L17", "5T", "5L17"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			lightscreen: ["6M", "6L37", "5M", "5L37"],
			magiccoat: ["5T"],
			mist: ["6L1", "5L21"],
			nightslash: ["6L1", "5L57"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rapidspin: ["6L13", "5L13"],
			recover: ["6L49", "5L49"],
			reflect: ["6M", "6L37", "5M", "5L37"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sharpen: ["6L9", "5L9"],
			sheercold: ["6L1", "5L61"],
			signalbeam: ["5T"],
			slash: ["6L41", "5L41"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "6L53", "5M", "5L53"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
		},
	},
	shelmet: {
		inherit: true,
		learnset: {
			acid: ["6L4", "5L4", "5D"],
			acidarmor: ["6L32", "5L32"],
			attract: ["6M", "5M"],
			batonpass: ["6E", "5E", "5D"],
			bide: ["6L8", "5L8"],
			bodyslam: ["6L40", "5L40", "5S1"],
			bugbite: ["5T"],
			bugbuzz: ["6L44", "5L44", "5S1"],
			confide: ["6M"],
			curse: ["6L13", "5L13"],
			doubleedge: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			encore: ["6E", "5E", "5D", "5S1"],
			endure: ["6E", "5E"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			feint: ["6E", "5E"],
			finalgambit: ["6L56", "5L56"],
			frustration: ["6M", "5M"],
			gastroacid: ["5T"],
			gigadrain: ["6L37", "5T", "5L37", "5S1"],
			guardsplit: ["6E", "5E"],
			guardswap: ["6L50", "5L52"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			leechlife: ["6L1", "5L1"],
			megadrain: ["6L20", "5L20", "5S0"],
			mindreader: ["6E", "5E"],
			mudslap: ["6E", "5E"],
			protect: ["6M", "6L28", "5M", "5L28", "5S0"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			recover: ["6L49", "5L49"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			spikes: ["6E", "5E"],
			strugglebug: ["6M", "6L16", "5M", "5L16", "5S0"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			venoshock: ["6M", "5M"],
			yawn: ["6L25", "5L25", "5S0"],
		},
	},
	accelgor: {
		inherit: true,
		learnset: {
			acidspray: ["6L1", "5L1"],
			agility: ["6L32", "5L32"],
			attract: ["6M", "5M"],
			bugbite: ["5T"],
			bugbuzz: ["6L44", "5L44"],
			confide: ["6M"],
			doubleteam: ["6M", "6L1", "5M", "5L1"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			finalgambit: ["6L1", "5L56"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gastroacid: ["5T"],
			gigadrain: ["6L37", "5T", "5L37"],
			gigaimpact: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			infestation: ["6M"],
			knockoff: ["5T"],
			leechlife: ["6L1", "5L1"],
			mefirst: ["6L28", "5L28"],
			megadrain: ["6L20", "5L20"],
			powerswap: ["6L1", "5L52"],
			protect: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			raindance: ["6M", "5M"],
			recover: ["6L49", "5L49"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			snore: ["5T"],
			strugglebug: ["6M", "6L16", "5M", "5L16"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6L25", "5L25"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "6L40", "5M", "5L40"],
			venoshock: ["6M", "5M"],
		},
	},
	stunfisk: {
		inherit: true,
		learnset: {
			aquatail: ["5T"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			bide: ["6L5", "5L5"],
			bounce: ["6L35", "5T", "5L35"],
			bulldoze: ["6M", "5M"],
			camouflage: ["6L17", "5L17"],
			confide: ["6M"],
			curse: ["6E", "5E", "5D"],
			dig: ["6M", "5M"],
			discharge: ["6L25", "5L25"],
			doubleteam: ["6M", "5M"],
			earthpower: ["6E", "5T", "5E"],
			earthquake: ["6M", "5M"],
			eerieimpulse: ["6E"],
			electroweb: ["5T"],
			endeavor: ["5T"],
			endure: ["6L30", "5L30"],
			facade: ["6M", "5M"],
			fissure: ["6L1", "5L61"],
			flail: ["6L1", "5L55"],
			flash: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			infestation: ["6M"],
			magnetrise: ["5T"],
			mefirst: ["6E"],
			mudbomb: ["6L21", "5L21"],
			muddywater: ["6L40", "5L40"],
			mudshot: ["6L13", "5L13"],
			mudslap: ["6L1", "5L1", "5D"],
			mudsport: ["6L1", "5L1"],
			painsplit: ["6E", "5T", "5E"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflecttype: ["6E"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L50", "5L50"],
			rockslide: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scald: ["6M", "5M"],
			shockwave: ["6E", "5E"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			snore: ["5T"],
			spark: ["6E", "5E"],
			spite: ["6E", "5T", "5E"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			substitute: ["6M", "5M"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tackle: ["6L1"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "6L45", "5M", "5L45"],
			thundershock: ["6L9", "5L9"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			watergun: ["6L1"],
			yawn: ["6E", "5E", "5D"],
		},
	},
	mienfoo: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			allyswitch: ["6E"],
			attract: ["6M", "5M"],
			aurasphere: ["6L61", "5L61"],
			batonpass: ["6E", "5E"],
			bounce: ["6L49", "5T", "5L49"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			calmmind: ["6M", "6L25", "5M", "5L25"],
			confide: ["6M"],
			detect: ["6L9", "5L9"],
			dig: ["6M", "5M"],
			doubleslap: ["6L17", "5L17"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["6L33", "5T", "5L33"],
			dualchop: ["5T"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			fakeout: ["6L13", "5L13"],
			feint: ["6E", "5E"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			forcepalm: ["6L29", "5L29"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			highjumpkick: ["6L50", "5L53"],
			jumpkick: ["6L37", "5L37"],
			knockoff: ["6E", "5T", "5E"],
			lowkick: ["6E", "5T", "5E"],
			lowsweep: ["6M", "5M"],
			meditate: ["6L5", "5L5"],
			mefirst: ["6E", "5E"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickguard: ["6L45", "5L45"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			reversal: ["6L57", "5L57"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smellingsalts: ["6E", "5E"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6L21", "5L21"],
			swordsdance: ["6M", "5M"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "6L41", "5M", "5L41"],
			vitalthrow: ["6E", "5E"],
			workup: ["5M"],
		},
	},
	mienshao: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			attract: ["6M", "5M"],
			aurasphere: ["6L1", "5L70"],
			bounce: ["6L49", "5T", "5L49"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			calmmind: ["6M", "6L25", "5M", "5L25"],
			confide: ["6M"],
			detect: ["6L1", "5L1"],
			dig: ["6M", "5M"],
			doubleslap: ["6L17", "5L17"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["6L33", "5T", "5L33"],
			dualchop: ["5T"],
			facade: ["6M", "5M"],
			fakeout: ["6L1", "5L1"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			forcepalm: ["6L29", "5L29"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			highjumpkick: ["6L56", "5L56"],
			hyperbeam: ["6M", "5M"],
			jumpkick: ["6L37", "5L37"],
			knockoff: ["5T"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			meditate: ["6L1", "5L1"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			reversal: ["6L1", "5L63"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swift: ["6L21", "5L21"],
			swordsdance: ["6M", "5M"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "6L41", "5M", "5L41"],
			wideguard: ["6L45", "5L45"],
			workup: ["5M"],
		},
	},
	druddigon: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bite: ["6L9", "5L9", "5D"],
			bulldoze: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			chipaway: ["6L31", "5L31"],
			confide: ["6M"],
			crunch: ["6L25", "5L25"],
			crushclaw: ["6E", "5E"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonclaw: ["6M", "6L27", "5M", "5L27"],
			dragonpulse: ["5T"],
			dragonrage: ["6L18", "5L18"],
			dragontail: ["6M", "6L45", "5M", "5L45"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6E", "5E"],
			firefang: ["6E", "5E", "5D"],
			firepunch: ["5T"],
			flamethrower: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			glare: ["6E", "5E"],
			gunkshot: ["5T"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L5", "5M", "5L5"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["5T"],
			irontail: ["6E", "5T", "5E"],
			leer: ["6L1", "5L1", "5S0"],
			metalclaw: ["6E", "5E"],
			nightslash: ["6L40", "5L40"],
			outrage: ["6L62", "5T", "5L62"],
			payback: ["6M", "5M"],
			poisontail: ["6E", "5E"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L35", "5L35"],
			roar: ["6M", "5M"],
			rockclimb: ["6L49", "5L49"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L13", "5L13"],
			scratch: ["6L1", "5L1", "5S0"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L21", "5L21"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snarl: ["6M", "5M"],
			snatch: ["6E", "5T", "5E"],
			snore: ["5T"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6E", "5E", "5D"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L55", "5T", "5L55"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thunderfang: ["6E", "5E"],
			thunderpunch: ["5T"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
		},
	},
	golett: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6L40", "5L40"],
			defensecurl: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			dynamicpunch: ["6L30", "5L30"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L45", "5M", "5L45"],
			facade: ["6M", "5M"],
			firepunch: ["5T", "5D"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focuspunch: ["6L55", "5L55"],
			frustration: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			gyroball: ["6M", "5M"],
			hammerarm: ["6L50", "5L50"],
			hiddenpower: ["6M", "5M"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			icywind: ["5T"],
			irondefense: ["6L17", "5T", "5L17"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T"],
			magnitude: ["6L25", "5L25"],
			megapunch: ["6L21", "5L21"],
			mudslap: ["6L5", "5L5"],
			nightshade: ["6L35", "5L35"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L9", "5L9", "5D"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowpunch: ["6L13", "5L13"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stealthrock: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderpunch: ["5T", "5D"],
			toxic: ["6M", "5M"],
		},
	},
	golurk: {
		inherit: true,
		learnset: {
			astonish: ["6L1", "5L1"],
			block: ["5T"],
			brickbreak: ["6M", "5M"],
			bulldoze: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			curse: ["6L40", "5L40"],
			defensecurl: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			dynamicpunch: ["6L30", "5L30"],
			earthpower: ["5T"],
			earthquake: ["6M", "6L50", "5M", "5L50"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			focuspunch: ["6L1", "5L70"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			gyroball: ["6M", "5M", "5S0"],
			hammerarm: ["6L60", "5L60", "5S0"],
			heavyslam: ["6L43", "5L43"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M", "5S0"],
			icebeam: ["6M", "5M"],
			icepunch: ["5T"],
			icywind: ["5T"],
			irondefense: ["6L17", "5T", "5L17"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T"],
			magnitude: ["6L25", "5L25"],
			megapunch: ["6L21", "5L21"],
			mudslap: ["6L1", "5L1"],
			nightshade: ["6L35", "5L35"],
			phantomforce: ["6L1"],
			pound: ["6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			rollout: ["6L9", "5L9"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowpunch: ["6L13", "5L13", "5S0"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			telekinesis: ["5M"],
			thief: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			toxic: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	pawniard: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			assurance: ["6L33", "5L33"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dualchop: ["5T"],
			embargo: ["6M", "6L41", "5M", "5L41"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			feintattack: ["6L17", "5L17"],
			fling: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			furycutter: ["6L9", "5L9", "5D"],
			grassknot: ["6M", "5M"],
			guillotine: ["6L62", "5L62"],
			headbutt: ["6E", "5E"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6L46", "5T", "5L46"],
			ironhead: ["6L54", "5T", "5L54"],
			knockoff: ["5T"],
			leer: ["6L6", "5L6"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T"],
			meanlook: ["6E", "5E"],
			metalclaw: ["6L25", "5L25"],
			metalsound: ["6L38", "5L38"],
			nightslash: ["6L49", "5L49"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psychocut: ["6E", "5E", "5D"],
			pursuit: ["6E", "5E"],
			quickguard: ["6E"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6E", "5E"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scaryface: ["6L22", "5L22"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L30", "5L30"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stealthrock: ["6E", "5T", "5E"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6E", "5E", "5D"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L57", "5M", "5L57"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "6L14", "5M", "5L14"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	bisharp: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			assurance: ["6L33", "5L33"],
			attract: ["6M", "5M"],
			brickbreak: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dualchop: ["5T"],
			embargo: ["6M", "6L41", "5M", "5L41"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			feintattack: ["6L17", "5L17"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			furycutter: ["6L1", "5L1"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			guillotine: ["6L1", "5L71"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["6L46", "5T", "5L46"],
			ironhead: ["6L1", "5T", "5L57"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			magnetrise: ["5T"],
			metalburst: ["6L1", "5L1"],
			metalclaw: ["6L25", "5L25"],
			metalsound: ["6L38", "5L38"],
			nightslash: ["6L49", "5L49"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			scaryface: ["6L22", "5L22"],
			scratch: ["6L1", "5L1"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L30", "5L30"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			spite: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L63", "5M", "5L63"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "6L1", "5M", "5L1"],
			toxic: ["6M", "5M"],
			xscissor: ["6M", "5M"],
		},
	},
	bouffalant: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			amnesia: ["6E", "5E"],
			attract: ["6M", "5M"],
			belch: ["6E"],
			bulldoze: ["6M", "5M"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthquake: ["6M", "6S0", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "6S0", "5M"],
			focusenergy: ["6L36", "5L36"],
			frustration: ["6M", "5M"],
			furyattack: ["6L11", "5L11"],
			gigaimpact: ["6M", "6L61", "5M", "5L61"],
			headbutt: ["6E", "5E"],
			headcharge: ["6L31", "6S0", "5L31"],
			hiddenpower: ["6M", "5M"],
			hornattack: ["6L16", "5L16"],
			ironhead: ["6E", "5T", "5E"],
			leer: ["6L1", "5L1"],
			megahorn: ["6L41", "5L41"],
			mudshot: ["6E", "5E"],
			mudslap: ["6E", "5E"],
			outrage: ["5T"],
			payback: ["6M", "5M"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			pursuit: ["6L1", "5L1"],
			rage: ["6L6", "5L6"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L26", "5L26"],
			reversal: ["6L46", "5L46"],
			rockclimb: ["6E", "5E"],
			rockslide: ["6M", "6S0", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L21", "5L21"],
			skullbash: ["6E", "5E"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stomp: ["6E", "5E"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L56", "5M", "5L56"],
			taunt: ["6M", "5M"],
			thrash: ["6L50", "5L51"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			wildcharge: ["6M", "5M"],
			workup: ["5M"],
			zenheadbutt: ["5T"],
		},
	},
	rufflet: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L23", "5M", "5L23"],
			airslash: ["6L41", "5L41"],
			attract: ["6M", "5M"],
			bravebird: ["6L59", "5L59"],
			bulkup: ["6M", "5M"],
			confide: ["6M"],
			crushclaw: ["6L46", "5L46"],
			cut: ["6M", "5M"],
			defog: ["6L32", "5L32"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyattack: ["6L5", "5L5"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L14", "5M", "5L14"],
			leer: ["6L1", "5L1"],
			peck: ["6L1", "5L1"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			scaryface: ["6L19", "5L19"],
			shadowclaw: ["6M", "5M"],
			skydrop: ["6M", "6L50", "5M", "5L50"],
			slash: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			tailwind: ["6L37", "5T", "5L37"],
			thrash: ["6L64", "5L64"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			whirlwind: ["6L55", "5L55"],
			wingattack: ["6L10", "5L10"],
			workup: ["5M"],
		},
	},
	braviary: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L23", "5M", "5L23", "5S0"],
			airslash: ["6L41", "5L41"],
			attract: ["6M", "5M"],
			bravebird: ["6L1", "5L63"],
			bulkup: ["6M", "5M"],
			confide: ["6M"],
			crushclaw: ["6L46", "5L46"],
			cut: ["6M", "5M"],
			defog: ["6L32", "5L32"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyattack: ["6L1", "5L1"],
			gigaimpact: ["6M", "5M"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L14", "5M", "5L14", "5S0"],
			hyperbeam: ["6M", "5M"],
			leer: ["6L1", "5L1"],
			peck: ["6L1", "5L1"],
			pluck: ["5M"],
			protect: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			scaryface: ["6L19", "5L19", "5S0"],
			shadowclaw: ["6M", "5M"],
			skyattack: ["5T"],
			skydrop: ["6M", "6L50", "5M", "5L50"],
			slash: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["6L1", "5T", "5L51"],
			swagger: ["6M", "5M"],
			tailwind: ["6L37", "5T", "5L37"],
			thrash: ["6L1", "5L70"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			whirlwind: ["6L1", "5L57"],
			wingattack: ["6L1", "5L1", "5S0"],
			workup: ["5M"],
		},
	},
	vullaby: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			airslash: ["6L41", "5L41"],
			attract: ["6M", "5M"],
			block: ["5T"],
			bravebird: ["6L59", "5L59"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "6L46", "5T", "5L46"],
			defog: ["6L32", "5L32"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "6L50", "5M", "5L50"],
			facade: ["6M", "5M"],
			faketears: ["6E", "5E"],
			feintattack: ["6L23", "5L23"],
			flatter: ["6L19", "5L19"],
			fly: ["6M", "5M"],
			foulplay: ["6E", "5T"],
			frustration: ["6M", "5M"],
			furyattack: ["6L5", "5L5"],
			gust: ["6L1", "5L1"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["6E", "5T", "5E"],
			leer: ["6L1", "5L1"],
			meanlook: ["6E", "5E"],
			mirrormove: ["6L64", "5L64"],
			nastyplot: ["6L14", "5L14"],
			payback: ["6M", "5M"],
			pluck: ["6L10", "5M", "5L10"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			punishment: ["6L28", "5L28"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "6E", "5T", "5E"],
			round: ["6M", "5M"],
			scaryface: ["6E", "5E"],
			shadowball: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			steelwing: ["6M", "6E", "5E"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["6L37", "5T", "5L37"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			whirlwind: ["6L55", "5L55"],
		},
	},
	mandibuzz: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			airslash: ["6L41", "5L41"],
			attract: ["6M", "5M"],
			block: ["5T"],
			bonerush: ["6L1", "5L51"],
			bravebird: ["6L1", "5L63"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			darkpulse: ["6M", "6L46", "5T", "5L46"],
			defog: ["6L32", "5L32"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "6L50", "5M", "5L50"],
			facade: ["6M", "5M"],
			feintattack: ["6L23", "5L23", "5S0"],
			flatter: ["6L19", "5L19", "5S0"],
			fly: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			furyattack: ["6L1", "5L1"],
			gigaimpact: ["6M", "5M"],
			gust: ["6L1", "5L1"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["5T"],
			leer: ["6L1", "5L1"],
			mirrormove: ["6L1", "5L70"],
			nastyplot: ["6L14", "5L14", "5S0"],
			payback: ["6M", "5M"],
			pluck: ["6L1", "5M", "5L1", "5S0"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			punishment: ["6L28", "5L28"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			skyattack: ["5T"],
			sleeptalk: ["6M", "5T"],
			snarl: ["6M", "5M"],
			snatch: ["5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["6L37", "5T", "5L37"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			whirlwind: ["6L1", "5L57"],
		},
	},
	heatmor: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			amnesia: ["6L44", "5L46"],
			attract: ["6M", "5M"],
			belch: ["6E"],
			bind: ["6L11", "5T", "5L11"],
			bodyslam: ["6E", "5E"],
			bugbite: ["6L36", "5T", "5L36"],
			confide: ["6M"],
			curse: ["6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			feintattack: ["6E", "5E"],
			fireblast: ["6M", "5M"],
			firepunch: ["5T"],
			firespin: ["6L16", "5L16"],
			flameburst: ["6L31", "5L31"],
			flamethrower: ["6M", "6L47", "5M", "5L51"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furyswipes: ["6L21", "5L21"],
			gastroacid: ["5T"],
			gigadrain: ["5T", "5D"],
			gigaimpact: ["6M", "5M"],
			heatwave: ["6E", "5T", "5E", "5D"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "6L1", "5M"],
			incinerate: ["6M", "6L1", "5M", "5L1", "5D"],
			inferno: ["6L1", "5L61"],
			knockoff: ["5T"],
			lick: ["6L1", "5L1"],
			lowkick: ["5T"],
			nightslash: ["6E", "5E"],
			odorsleuth: ["6L6", "5L6"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			pursuit: ["6E", "5E"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L41", "5L41"],
			sleeptalk: ["6M", "6E", "5T", "5E"],
			snatch: ["6L26", "5T", "5L26"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			spitup: ["6L50", "5L56"],
			stockpile: ["6L50", "5L56"],
			substitute: ["6M", "5M"],
			suckerpunch: ["6E", "5E"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swallow: ["6L50", "5L56"],
			tackle: ["6L1"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderpunch: ["5T"],
			tickle: ["6E", "5E"],
			toxic: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			wrap: ["6E", "5E"],
		},
	},
	durant: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			agility: ["6L16", "5L16"],
			attract: ["6M", "5M"],
			batonpass: ["6E", "5E"],
			bite: ["6L11", "5L11"],
			bugbite: ["6L26", "5T", "5L26"],
			confide: ["6M"],
			crunch: ["6L31", "5L31"],
			cut: ["6M", "5M"],
			dig: ["6M", "6L41", "5M", "5L41"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			endure: ["6E", "5E", "5D"],
			energyball: ["6M", "5M"],
			entrainment: ["6L46", "5L46"],
			facade: ["6M", "5M"],
			feintattack: ["6E", "5E"],
			flashcannon: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furycutter: ["6L6", "5L6", "5D"],
			gigaimpact: ["6M", "5M"],
			guillotine: ["6L1", "5L61"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6L1", "5T", "5L56"],
			ironhead: ["6L36", "5T", "5L36"],
			metalclaw: ["6L21", "5L21"],
			metalsound: ["6L1", "5L66"],
			protect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rockclimb: ["6E", "5E"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sandattack: ["6L1", "5L1"],
			sandstorm: ["6M", "5M"],
			screech: ["6E", "5E"],
			shadowclaw: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			thunderfang: ["6E", "5E", "5D"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			visegrip: ["6L1", "5L1"],
			xscissor: ["6M", "6L51", "5M", "5L51"],
		},
	},
	deino: {
		inherit: true,
		learnset: {
			aquatail: ["5T"],
			assurance: ["6E", "5E"],
			astonish: ["6E", "5E"],
			attract: ["6M", "5M"],
			bite: ["6L9", "5L9"],
			bodyslam: ["6L48", "5L48"],
			confide: ["6M"],
			crunch: ["6L25", "5L25"],
			darkpulse: ["6M", "6E", "5T", "5E"],
			doublehit: ["6E", "5E"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonbreath: ["6L17", "5L17"],
			dragonpulse: ["6L32", "5T", "5L32"],
			dragonrage: ["6L1", "5L1", "5S0"],
			dragonrush: ["6L42", "5L42"],
			dragontail: ["6M", "5M"],
			earthpower: ["6E", "5T", "5E"],
			facade: ["6M", "5M"],
			firefang: ["6E", "5E"],
			focusenergy: ["6L4", "5L4"],
			frustration: ["6M", "5M"],
			headbutt: ["6L12", "5L12"],
			headsmash: ["6E", "5E"],
			hiddenpower: ["6M", "5M"],
			hypervoice: ["6L58", "5T", "5L58"],
			icefang: ["6E", "5E"],
			incinerate: ["6M", "5M"],
			outrage: ["6L62", "5T", "5L62"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L20", "5M", "5L20"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L50", "5L52"],
			screech: ["6E", "5E"],
			slam: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spite: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			tackle: ["6L1", "5L1", "5S0"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderfang: ["6E", "5E"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			workup: ["6L38", "5M", "5L38"],
			zenheadbutt: ["5T"],
		},
	},
	zweilous: {
		inherit: true,
		learnset: {
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			bodyslam: ["6L48", "5L48"],
			confide: ["6M"],
			crunch: ["6L25", "5L25"],
			darkpulse: ["6M", "5T"],
			doublehit: ["6L1", "5L1"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonbreath: ["6L17", "5L17"],
			dragonpulse: ["6L32", "5T", "5L32"],
			dragonrage: ["6L1", "5L1"],
			dragonrush: ["6L42", "5L42"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			facade: ["6M", "5M"],
			focusenergy: ["6L1", "5L1"],
			frustration: ["6M", "5M"],
			headbutt: ["6L12", "5L12"],
			hiddenpower: ["6M", "5M"],
			hypervoice: ["6L64", "5T", "5L64"],
			incinerate: ["6M", "5M"],
			outrage: ["6L71", "5T", "5L71"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L20", "5M", "5L20"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			scaryface: ["6L55", "5L55"],
			slam: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spite: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["5T"],
			workup: ["6L38", "5M", "5L38"],
			zenheadbutt: ["5T"],
		},
	},
	hydreigon: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aquatail: ["5T"],
			attract: ["6M", "5M"],
			bite: ["6L1", "5L1"],
			bodyslam: ["6L48", "5L48"],
			bulldoze: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L25", "6S1", "5L25"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonbreath: ["6L17", "5L17", "5S0"],
			dragonpulse: ["6L32", "5T", "5L32"],
			dragonrage: ["6L1", "5L1"],
			dragonrush: ["6L42", "6S1", "5L42"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			flamethrower: ["6M", "5M", "5S0"],
			flashcannon: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M", "5S0"],
			focusenergy: ["6L1", "5L1"],
			frustration: ["6M", "6S1", "5M"],
			gigaimpact: ["6M", "5M"],
			headbutt: ["6L12", "5L12"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L1", "5T", "5L68", "5S0"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			outrage: ["6L1", "5T", "5L79"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roar: ["6M", "6L20", "5M", "5L20"],
			rockslide: ["6M", "6S1", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			scaryface: ["6L55", "5L55"],
			signalbeam: ["5T"],
			slam: ["6L28", "5L28"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			spite: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			triattack: ["6L1", "5L1"],
			uproar: ["5T"],
			uturn: ["6M", "5M"],
			workup: ["6L38", "5M", "5L38"],
			zenheadbutt: ["5T"],
		},
	},
	larvesta: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			amnesia: ["6L80", "5L80"],
			bugbite: ["6L40", "5T", "5L40"],
			bugbuzz: ["6L70", "5L70"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			doubleedge: ["6L50", "5L50"],
			doubleteam: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			endure: ["6E", "5E"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "5M"],
			flamecharge: ["6M", "6L30", "5M", "5L30"],
			flamethrower: ["6M", "5M"],
			flamewheel: ["6L60", "5L60"],
			flareblitz: ["6L100", "5L100"],
			foresight: ["6E", "5E"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			harden: ["6E", "5E"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			leechlife: ["6L10", "5L10"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["6E", "5T", "5E"],
			morningsun: ["6E", "5E"],
			overheat: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			signalbeam: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stringshot: ["6L1", "6E", "5L1", "5E"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			takedown: ["6L20", "5L20"],
			thrash: ["6L90", "5L90"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			zenheadbutt: ["6E", "5T", "5E"],
		},
	},
	volcarona: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			amnesia: ["6L1"],
			bugbite: ["5T"],
			bugbuzz: ["6L1", "5L70", "5S1"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			doubleteam: ["6M", "5M"],
			ember: ["6L1", "5L1"],
			facade: ["6M", "5M"],
			fierydance: ["6L1", "5L100"],
			fireblast: ["6M", "5M"],
			firespin: ["6L30", "5L30", "5S0"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "5M"],
			flamewheel: ["6L1"],
			flareblitz: ["6L1"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			gust: ["6L1", "5L1", "5S0"],
			heatwave: ["6L1", "5T", "5L60"],
			hiddenpower: ["6M", "5M"],
			hurricane: ["6L1", "5L90"],
			hyperbeam: ["6M", "5M", "5S1"],
			incinerate: ["6M", "5M"],
			leechlife: ["6L1", "5L1", "5S0"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			overheat: ["6M", "5M", "5S1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			quiverdance: ["6L1", "5L59", "5S1"],
			ragepowder: ["6L1", "5L80"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			signalbeam: ["5T"],
			silverwind: ["6L50", "5L50"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stringshot: ["6L1", "5L1", "5S0"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			thrash: ["6L1"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "5M"],
			whirlwind: ["6L40", "5L40"],
			wildcharge: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	cobalion: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			block: ["5T"],
			bounce: ["5T"],
			calmmind: ["6M", "5M"],
			closecombat: ["6L1", "5L73"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doublekick: ["6L7", "5L7"],
			doubleteam: ["6M", "5M"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			helpinghand: ["6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			irondefense: ["5T"],
			ironhead: ["6L37", "6S3", "5T", "5L37", "5S0", "5S1"],
			leer: ["6L1", "5L1"],
			magnetrise: ["5T"],
			metalburst: ["6L1", "5L67"],
			metalclaw: ["6L13", "5L13"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			quickguard: ["6L1", "5L55", "5S2"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sacredsword: ["6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			takedown: ["6L19", "5L19"],
			taunt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			workup: ["6L1", "5M", "5L61", "5S2"],
			xscissor: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	terrakion: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			block: ["5T"],
			bulldoze: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			closecombat: ["6L1", "5L73"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doublekick: ["6L7", "5L7"],
			doubleteam: ["6M", "5M"],
			earthpower: ["5T"],
			earthquake: ["6M", "5M"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			helpinghand: ["6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			ironhead: ["5T"],
			leer: ["6L1", "5L1"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			quickguard: ["6L1", "5L55", "5S2"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L37", "6S3", "5M", "5L37", "5S0", "5S1"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			round: ["6M", "5M"],
			sacredsword: ["6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["6M", "5M"],
			sandstorm: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			smackdown: ["6M", "6L13", "5M", "5L13"],
			snore: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "6L67", "5M", "5L67"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			takedown: ["6L19", "5L19"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["6L1", "5M", "5L61", "5S2"],
			xscissor: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	virizion: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			block: ["5T"],
			bounce: ["5T"],
			calmmind: ["6M", "5M"],
			closecombat: ["6L1", "5L73"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doublekick: ["6L7", "5L7"],
			doubleteam: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			flash: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigadrain: ["6L37", "6S3", "5T", "5L37", "5S0", "5S1"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			helpinghand: ["6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			leafblade: ["6L1", "5L67"],
			leer: ["6L1", "5L1"],
			lightscreen: ["6M", "5M"],
			magicalleaf: ["6L13", "5L13"],
			naturepower: ["6M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			quickguard: ["6L1", "5L55", "5S2"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sacredsword: ["6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["6M", "5M"],
			seedbomb: ["5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			synthesis: ["5T"],
			takedown: ["6L19", "5L19"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["6L1", "5M", "5L61", "5S2"],
			worryseed: ["5T"],
			xscissor: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	tornadus: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "5M"],
			aerialace: ["6M", "5M"],
			agility: ["6L37", "6S3", "5L37", "5S0"],
			aircutter: ["6L25", "5L25", "5S0"],
			airslash: ["6L43", "6S3", "5L43", "5S2"],
			astonish: ["6L1", "5L1", "5S1"],
			attract: ["6M", "5M"],
			bite: ["6L13", "5L13"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L49", "6S3", "5L49"],
			darkpulse: ["6M", "6L73", "5T", "5L73"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "5M"],
			extrasensory: ["6L31", "6S3", "5L31", "5S0"],
			facade: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gust: ["6L1", "5L1", "5S1"],
			hammerarm: ["6L1", "5L79", "5S2"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M", "5S2"],
			hurricane: ["6L1", "5L67", "5S2"],
			hyperbeam: ["6M", "5M"],
			icywind: ["5T"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "6L61", "5M", "5L61"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L19", "5L19", "5S0"],
			rocksmash: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "6L7", "5M", "5L7"],
			tailwind: ["6L1", "5T", "5L55"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thrash: ["6L1", "5L85"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["6L1", "5T", "5L1", "5S1"],
			uturn: ["6M", "5M"],
		},
	},
	thundurus: {
		inherit: true,
		learnset: {
			agility: ["6L37", "6S3", "5L37", "5S0"],
			astonish: ["6L1", "5L1", "5S1"],
			attract: ["6M", "5M"],
			bite: ["6L13", "5L13"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			charge: ["6L1", "5L55"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L49", "6S3", "5L49"],
			darkpulse: ["6M", "6L73", "5T", "5L73"],
			discharge: ["6L43", "6S3", "5L43"],
			doubleteam: ["6M", "5M"],
			embargo: ["6M", "5M"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M", "5S2"],
			foulplay: ["5T"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			hammerarm: ["6L1", "5L79", "5S2"],
			healblock: ["6L31", "6S3", "5L31", "5S0"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["5T"],
			knockoff: ["5T"],
			nastyplot: ["6L1", "5L61"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			revenge: ["6L19", "5L19", "5S0"],
			rocksmash: ["6M", "5M"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			shockwave: ["6L25", "5L25", "5S0"],
			skydrop: ["6M", "5M"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "6L7", "5M", "5L7"],
			taunt: ["6M", "5M"],
			thief: ["6M", "5M"],
			thrash: ["6L1", "5L85"],
			thunder: ["6M", "6L67", "5M", "5L67", "5S2"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			thundershock: ["6L1", "5L1", "5S1"],
			thunderwave: ["6M", "5M"],
			torment: ["6M", "5M"],
			toxic: ["6M", "5M"],
			uproar: ["6L1", "5T", "5L1", "5S1"],
			uturn: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M", "5S2"],
		},
	},
	reshiram: {
		inherit: true,
		learnset: {
			ancientpower: ["6L15", "5L15"],
			blueflare: ["6L100", "5L100", "5S2"],
			confide: ["6M"],
			crunch: ["6L71", "5L71"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T", "5S2"],
			dragonbreath: ["6L29", "6S3", "5L29", "5S0"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["6L54", "5T", "5L54", "5S1"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "5M"],
			extrasensory: ["6L43", "6S3", "5L43", "5S0", "5S1"],
			facade: ["6M", "5M"],
			fireblast: ["6M", "6L78", "5M", "5L78"],
			firefang: ["6L1", "5L1"],
			flamecharge: ["6M", "5M"],
			flamethrower: ["6M", "6L22", "5M", "5L22"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			fusionflare: ["6L50", "6S3", "5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["6M", "5M"],
			heatwave: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L92", "5T", "5L92"],
			imprison: ["6L8", "5L8", "5S1"],
			incinerate: ["6M", "5M"],
			lightscreen: ["6M", "5M"],
			mist: ["5S2"],
			outrage: ["6L85", "5T", "5L85"],
			overheat: ["6M", "5M"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			slash: ["6L36", "6S3", "5L36", "5S0"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "5M"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			toxic: ["6M", "5M"],
			willowisp: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	zekrom: {
		inherit: true,
		learnset: {
			ancientpower: ["6L15", "5L15"],
			boltstrike: ["6L100", "5L100", "5S2"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			crunch: ["6L71", "5L71"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "5T"],
			dragonbreath: ["6L29", "6S3", "5L29", "5S0"],
			dragonclaw: ["6M", "6L54", "5M", "5L54", "5S1"],
			dragonpulse: ["5T"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "5M"],
			facade: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			fusionbolt: ["6L50", "6S3", "5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["6M", "5M"],
			haze: ["5S2"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L92", "5T", "5L92"],
			imprison: ["6L8", "5L8", "5S1"],
			lightscreen: ["6M", "5M"],
			magnetrise: ["5T"],
			outrage: ["6L85", "5T", "5L85", "5S2"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			slash: ["6L36", "6S3", "5L36", "5S0"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			tailwind: ["5T"],
			thunder: ["6M", "6L78", "5M", "5L78"],
			thunderbolt: ["6M", "6L22", "5M", "5L22"],
			thunderfang: ["6L1", "5L1"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			voltswitch: ["6M", "5M"],
			wildcharge: ["6M", "5M"],
			zenheadbutt: ["6L43", "6S3", "5T", "5L43", "5S0", "5S1"],
		},
	},
	landorus: {
		inherit: true,
		learnset: {
			attract: ["6M", "5M"],
			block: ["6L1", "5T", "5L1", "5S1"],
			brickbreak: ["6M", "5M"],
			bulkup: ["6M", "5M"],
			bulldoze: ["6M", "6L19", "5M", "5L19"],
			calmmind: ["6M", "5M"],
			confide: ["6M"],
			dig: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			earthpower: ["6L43", "6S2", "5T", "5L43"],
			earthquake: ["6M", "6L55", "6S3", "5M", "5L55", "5S0"],
			explosion: ["6M", "5M"],
			extrasensory: ["6L31", "6S2", "5L31"],
			facade: ["6M", "5M"],
			fissure: ["6L1", "5L67", "5S0"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			hammerarm: ["6L1", "5L79"],
			hiddenpower: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			imprison: ["6L7", "5L7"],
			irontail: ["5T"],
			knockoff: ["6S3", "5T"],
			mudshot: ["6L1", "5L1", "5S1"],
			outrage: ["6L1", "5T", "5L85"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			punishment: ["6L13", "5L13"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			rockslide: ["6M", "6L49", "6S2", "5M", "5L49", "5S0"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["6L25", "5L25"],
			rocktomb: ["6M", "6L1", "6S3", "5M", "5L1", "5S1"],
			roleplay: ["5T"],
			round: ["6M", "5M"],
			sandstorm: ["6M", "6L61", "5M", "5L61", "5S0"],
			sleeptalk: ["6M", "5T"],
			sludgebomb: ["6M", "5M"],
			sludgewave: ["6M", "5M"],
			smackdown: ["6M", "5M"],
			snore: ["5T"],
			stealthrock: ["5T"],
			stoneedge: ["6M", "6L73", "5M", "5L73"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L37", "6S2", "5M", "5L37"],
			toxic: ["6M", "5M"],
			uturn: ["6M", "6S3", "5M"],
		},
	},
	kyurem: {
		inherit: true,
		learnset: {
			ancientpower: ["6L15", "5L15"],
			blizzard: ["6M", "6L78", "5M", "5L78"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "6S3", "5T"],
			dragonbreath: ["6L29", "6S2", "5L29"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L71", "5T", "5L71", "5S0"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			glaciate: ["6L50", "6S2", "6S3", "5L50", "5S0", "5S1"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L92", "5T", "5L92"],
			icebeam: ["6M", "6L22", "5M", "5L22"],
			icywind: ["6L1", "5T", "5L1"],
			imprison: ["6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6S3", "5T"],
			lightscreen: ["6M", "5M"],
			outrage: ["6L85", "5T", "5L85"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			scaryface: ["6L43", "6S2", "6S3", "5L43", "5S1"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			slash: ["6L36", "6S2", "5L36"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	kyuremblack: {
		inherit: true,
		learnset: {
			ancientpower: ["6L15", "5L15"],
			blizzard: ["6M", "6L78", "5M", "5L78"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "6S3", "5T"],
			dragonbreath: ["6L29", "6S2", "5L29"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L71", "5T", "5L71", "5S0"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			freezeshock: ["6L50", "6S2", "6S3", "5L43", "5S0", "5S1"],
			frustration: ["6M", "5M"],
			fusionbolt: ["6L43", "6S2", "6S3", "5L50", "5S1"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L92", "5T", "5L92"],
			icebeam: ["6M", "6L22", "5M", "5L22"],
			icywind: ["6L1", "5T", "5L1"],
			imprison: ["6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6S3", "5T"],
			lightscreen: ["6M", "5M"],
			outrage: ["6L85", "5T", "5L85"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			slash: ["6L36", "6S2", "5L36"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	kyuremwhite: {
		inherit: true,
		learnset: {
			ancientpower: ["6L15", "5L15"],
			blizzard: ["6M", "6L78", "5M", "5L78"],
			confide: ["6M"],
			cut: ["6M", "5M"],
			doubleteam: ["6M", "5M"],
			dracometeor: ["6T", "6S3", "5T"],
			dragonbreath: ["6L29", "6S2", "5L29"],
			dragonclaw: ["6M", "5M"],
			dragonpulse: ["6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["6L1", "5L1"],
			dragontail: ["6M", "5M"],
			earthpower: ["5T"],
			echoedvoice: ["6M", "5M"],
			endeavor: ["6L71", "5T", "5L71", "5S0"],
			facade: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fling: ["6M", "5M"],
			fly: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			fusionflare: ["6L43", "6S2", "6S3", "5L50", "5S1"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "5M"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L92", "5T", "5L92"],
			icebeam: ["6M", "6L22", "5M", "5L22"],
			iceburn: ["6L50", "6S2", "6S3", "5L43", "5S0", "5S1"],
			icywind: ["6L1", "5T", "5L1"],
			imprison: ["6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6S3", "5T"],
			lightscreen: ["6M", "5M"],
			outrage: ["6L85", "5T", "5L85"],
			payback: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockslide: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["6M", "5M"],
			roost: ["6M", "5T"],
			round: ["6M", "5M"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			slash: ["6L36", "6S2", "5L36"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			steelwing: ["6M"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			toxic: ["6M", "5M"],
			zenheadbutt: ["5T"],
		},
	},
	keldeo: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			aquajet: ["6L1", "6S2", "6S3", "5L1", "5S0", "5S1"],
			aquatail: ["6L37", "5T", "5L37"],
			bounce: ["5T"],
			bubblebeam: ["6L13", "6S3", "5L13", "5S0"],
			calmmind: ["6M", "5M"],
			closecombat: ["6L73", "5L73"],
			confide: ["6M"],
			covet: ["5T"],
			cut: ["6M", "5M"],
			doublekick: ["6L7", "6S2", "6S3", "5L7", "5S0"],
			doubleteam: ["6M", "5M"],
			endeavor: ["5T"],
			facade: ["6M", "5M"],
			falseswipe: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			hail: ["6M", "5M"],
			helpinghand: ["6L25", "5T", "5L25"],
			hiddenpower: ["6M", "5M"],
			hydropump: ["6L67", "6S2", "5L67", "5S1"],
			hyperbeam: ["6M", "5M"],
			icywind: ["5T"],
			lastresort: ["5T"],
			leer: ["6L1", "6S2", "6S3", "5L1", "5S0"],
			poisonjab: ["6M", "5M"],
			protect: ["6M", "5M"],
			psychup: ["6M", "5M"],
			quickguard: ["6L55", "5L55"],
			raindance: ["6M", "5M"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "6L31", "5M", "5L31"],
			return: ["6M", "5M"],
			roar: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["6M", "5M"],
			sacredsword: ["6L43", "5L43", "5S1"],
			safeguard: ["6M", "5M"],
			scald: ["6M", "5M"],
			secretsword: ["6T", "5T"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			superpower: ["5T"],
			surf: ["6M", "5M"],
			swagger: ["6M", "5M"],
			swordsdance: ["6M", "6L49", "5M", "5L49", "5S1"],
			takedown: ["6L19", "5L19"],
			taunt: ["6M", "5M"],
			toxic: ["6M", "5M"],
			workup: ["6L61", "5M", "5L61"],
			xscissor: ["6M", "5M"],
		},
	},
	meloetta: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L26", "5M", "5L26"],
			brickbreak: ["6M", "5M"],
			calmmind: ["6M", "5M"],
			chargebeam: ["6M", "5M"],
			closecombat: ["6L78", "5L78", "5S1"],
			confide: ["6M"],
			confusion: ["6L11", "5L11", "5S0"],
			covet: ["5T"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M", "5M"],
			drainpunch: ["5T"],
			dreameater: ["6M", "5M"],
			dualchop: ["5T"],
			echoedvoice: ["6M", "6L36", "5M", "5L36"],
			embargo: ["6M", "5M"],
			energyball: ["6M", "5M"],
			facade: ["6M", "5M"],
			firepunch: ["5T"],
			flash: ["6M", "5M"],
			fling: ["6M", "5M"],
			focusblast: ["6M", "5M"],
			frustration: ["6M", "5M"],
			gigaimpact: ["6M", "5M"],
			grassknot: ["6M", "5M"],
			gravity: ["5T"],
			healbell: ["5T"],
			helpinghand: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "5M"],
			hypervoice: ["6L64", "5T", "5L64"],
			icepunch: ["5T"],
			knockoff: ["5T"],
			lastresort: ["5T"],
			lightscreen: ["6M", "5M"],
			lowkick: ["5T"],
			lowsweep: ["6M", "5M"],
			magiccoat: ["5T"],
			magicroom: ["5T"],
			payback: ["6M", "5M"],
			perishsong: ["6L85", "5L85"],
			poweruppunch: ["6M"],
			protect: ["6M", "5M"],
			psybeam: ["6L31", "5L31"],
			psychic: ["6M", "6L57", "5M", "5L57", "5S1"],
			psychup: ["6M", "5M"],
			psyshock: ["6M", "5M"],
			quickattack: ["6L6", "5L6", "5S0"],
			raindance: ["6M", "5M"],
			recycle: ["5T"],
			relicsong: ["6T", "5T"],
			rest: ["6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["6M", "5M"],
			rocksmash: ["6M", "5M"],
			roleplay: ["6L71", "5T", "5L71"],
			round: ["6M", "6L1", "5M", "5L1", "5S0", "5S1"],
			safeguard: ["6M", "5M"],
			shadowball: ["6M", "5M"],
			shadowclaw: ["6M", "5M"],
			signalbeam: ["5T"],
			sing: ["6L16", "5L16"],
			skillswap: ["5T"],
			sleeptalk: ["6M", "5T"],
			snatch: ["5T"],
			snore: ["5T"],
			stoneedge: ["6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["6M", "5M"],
			sunnyday: ["6M", "5M"],
			swagger: ["6M", "5M"],
			teeterdance: ["6L21", "5L21", "5S1"],
			telekinesis: ["5M"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderpunch: ["5T"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			trick: ["5T"],
			trickroom: ["6M", "5M"],
			uproar: ["5T"],
			uturn: ["6M", "6L43", "5M", "5L43"],
			wakeupslap: ["6L50", "5L50"],
			wonderroom: ["5T"],
			workup: ["5M"],
			zenheadbutt: ["5T"],
		},
	},
	genesect: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "5M"],
			blazekick: ["5S2"],
			blizzard: ["6M", "5M"],
			bugbite: ["5T"],
			bugbuzz: ["6L55", "5L55"],
			chargebeam: ["6M", "5M"],
			confide: ["6M"],
			darkpulse: ["6M", "5T"],
			doubleteam: ["6M", "5M"],
			electroweb: ["5T"],
			energyball: ["6M", "5M"],
			explosion: ["6M", "5M"],
			extremespeed: ["5S2"],
			facade: ["6M", "5M"],
			fellstinger: ["6L1"],
			flamecharge: ["6M", "6L18", "5M", "5L18"],
			flamethrower: ["6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["6M", "5M"],
			fly: ["6M", "5M"],
			frustration: ["6M", "5M"],
			furycutter: ["6L7", "5L7"],
			gigadrain: ["5T"],
			gigaimpact: ["6M", "5M"],
			gravity: ["5T"],
			gunkshot: ["5T"],
			hiddenpower: ["6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["6M", "6L73", "5M", "5L73"],
			icebeam: ["6M", "5M"],
			infestation: ["6M"],
			irondefense: ["5T"],
			ironhead: ["5T"],
			lastresort: ["5T"],
			lightscreen: ["6M", "5M"],
			lockon: ["6L11", "5L11"],
			magiccoat: ["5T"],
			magnetbomb: ["6L22", "6S3", "5L22", "5S0", "5S1"],
			magnetrise: ["6L1", "5T", "5L1"],
			metalclaw: ["6L1", "5L1"],
			metalsound: ["6L33", "5L33"],
			protect: ["6M", "5M"],
			psychic: ["6M", "5M"],
			quickattack: ["6L1", "5L1"],
			recycle: ["5T"],
			reflect: ["6M", "5M"],
			rest: ["6M", "5M"],
			return: ["6M", "5M"],
			rockpolish: ["6M", "5M"],
			round: ["6M", "5M"],
			screech: ["6L1", "5L1"],
			selfdestruct: ["6L77", "5L77"],
			shadowclaw: ["6M", "5M"],
			shiftgear: ["5S2"],
			signalbeam: ["6L40", "6S3", "5T", "5L40", "5S0", "5S1"],
			simplebeam: ["6L62", "5L62"],
			slash: ["6L29", "5L29"],
			sleeptalk: ["6M", "5T"],
			snore: ["5T"],
			solarbeam: ["6M", "6S3", "5M", "5S0", "5S1"],
			strugglebug: ["6M", "5M"],
			substitute: ["6M", "5M"],
			swagger: ["6M", "5M"],
			technoblast: ["6L1", "6S3", "5L1", "5S0", "5S1", "5S2"],
			thunder: ["6M", "5M"],
			thunderbolt: ["6M", "5M"],
			thunderwave: ["6M", "5M"],
			toxic: ["6M", "5M"],
			triattack: ["6L44", "5L44"],
			uturn: ["6M", "5M"],
			xscissor: ["6M", "6L51", "5M", "5L51"],
			zapcannon: ["6L66", "5L66"],
			zenheadbutt: ["5T"],
		},
	},
	chespin: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			bellydrum: ["6E"],
			bite: ["6L11"],
			bodyslam: ["6L42"],
			brickbreak: ["6M"],
			bulkup: ["6M", "6L39"],
			bulldoze: ["6M"],
			confide: ["6M"],
			curse: ["6E"],
			cut: ["6M"],
			defensecurl: ["6E"],
			dig: ["6M"],
			doubleteam: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			fling: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grasspledge: ["6T"],
			growl: ["6L1"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			leechseed: ["6L15"],
			lowsweep: ["6M"],
			mudshot: ["6L35"],
			naturepower: ["6M"],
			painsplit: ["6L45"],
			payback: ["6M"],
			pinmissile: ["6L18"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickguard: ["6E"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			rollout: ["6L8", "6E"],
			round: ["6M"],
			seedbomb: ["6L32"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			smackdown: ["6M"],
			solarbeam: ["6M"],
			spikes: ["6E"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			synthesis: ["6E"],
			tackle: ["6L1"],
			takedown: ["6L27"],
			taunt: ["6M"],
			toxic: ["6M"],
			vinewhip: ["6L5"],
			woodhammer: ["6L48"],
		},
	},
	quilladin: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			bite: ["6L11"],
			bodyslam: ["6L48"],
			brickbreak: ["6M"],
			bulkup: ["6M", "6L44"],
			bulldoze: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			fling: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grasspledge: ["6T"],
			growl: ["6L1"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			leechseed: ["6L15"],
			lowsweep: ["6M"],
			mudshot: ["6L39"],
			naturepower: ["6M"],
			needlearm: ["6L26"],
			painsplit: ["6L52"],
			payback: ["6M"],
			pinmissile: ["6L20"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			rollout: ["6L8"],
			round: ["6M"],
			seedbomb: ["6L35"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			smackdown: ["6M"],
			solarbeam: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L30"],
			taunt: ["6M"],
			toxic: ["6M"],
			vinewhip: ["6L5"],
			woodhammer: ["6L55"],
		},
	},
	chesnaught: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			bellydrum: ["6L1"],
			bite: ["6L11"],
			bodyslam: ["6L48"],
			brickbreak: ["6M"],
			bulkup: ["6M", "6L44"],
			bulldoze: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dragonclaw: ["6M"],
			earthquake: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			feint: ["6L1"],
			flash: ["6M"],
			fling: ["6M"],
			focusblast: ["6M"],
			frenzyplant: ["6T"],
			frustration: ["6M"],
			gigaimpact: ["6M", "6L70"],
			grassknot: ["6M"],
			grasspledge: ["6T"],
			growl: ["6L1"],
			gyroball: ["6M"],
			hammerarm: ["6L1"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hyperbeam: ["6M"],
			leechseed: ["6L15"],
			lowsweep: ["6M"],
			mudshot: ["6L41"],
			naturepower: ["6M"],
			needlearm: ["6L26"],
			painsplit: ["6L52"],
			payback: ["6M"],
			pinmissile: ["6L20"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			rollout: ["6L8"],
			round: ["6M"],
			seedbomb: ["6L35"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			smackdown: ["6M"],
			solarbeam: ["6M"],
			spikyshield: ["6L36"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L30"],
			taunt: ["6M"],
			toxic: ["6M"],
			vinewhip: ["6L5"],
			woodhammer: ["6L55"],
		},
	},
	fennekin: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			embargo: ["6M"],
			ember: ["6L5"],
			facade: ["6M"],
			fireblast: ["6M", "6L48"],
			firepledge: ["6T"],
			firespin: ["6L20"],
			flamecharge: ["6M", "6L14"],
			flamethrower: ["6M", "6L35", "6S0"],
			frustration: ["6M"],
			grassknot: ["6M"],
			heatwave: ["6E"],
			hiddenpower: ["6M", "6S0"],
			howl: ["6L11"],
			hypnosis: ["6E"],
			incinerate: ["6M"],
			lightscreen: ["6M", "6L27"],
			luckychant: ["6L25"],
			magiccoat: ["6E"],
			magicroom: ["6L46"],
			overheat: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M", "6L41"],
			psychup: ["6M"],
			psyshock: ["6M", "6L31"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1", "6S0"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M", "6L43"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thief: ["6M"],
			toxic: ["6M"],
			willowisp: ["6M", "6L38"],
			wish: ["6E"],
		},
	},
	braixen: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			embargo: ["6M"],
			ember: ["6L5"],
			facade: ["6M"],
			fireblast: ["6M", "6L55"],
			firepledge: ["6T"],
			firespin: ["6L22"],
			flamecharge: ["6M", "6L14"],
			flamethrower: ["6M", "6L41"],
			frustration: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			howl: ["6L11"],
			incinerate: ["6M"],
			lightscreen: ["6M", "6L30"],
			luckychant: ["6L27"],
			magicroom: ["6L53"],
			overheat: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L18"],
			psychic: ["6M", "6L48"],
			psychup: ["6M"],
			psyshock: ["6M", "6L34"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M", "6L51"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thief: ["6M"],
			toxic: ["6M"],
			willowisp: ["6M", "6L45"],
		},
	},
	delphox: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			blastburn: ["6T"],
			calmmind: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			embargo: ["6M"],
			ember: ["6L5"],
			facade: ["6M"],
			fireblast: ["6M", "6L61"],
			firepledge: ["6T"],
			firespin: ["6L22"],
			flamecharge: ["6M", "6L14"],
			flamethrower: ["6M", "6L42"],
			frustration: ["6M"],
			futuresight: ["6L1"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			howl: ["6L11"],
			hyperbeam: ["6M"],
			incinerate: ["6M"],
			lightscreen: ["6M", "6L30"],
			luckychant: ["6L27"],
			magicroom: ["6L58"],
			mysticalfire: ["6L36"],
			overheat: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L18"],
			psychic: ["6M", "6L51"],
			psychup: ["6M"],
			psyshock: ["6M", "6L34"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roleplay: ["6L1"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1"],
			shadowball: ["6M", "6L1"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M", "6L55"],
			swagger: ["6M"],
			switcheroo: ["6L1"],
			tailwhip: ["6L1"],
			thief: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
			willowisp: ["6M", "6L47"],
		},
	},
	froakie: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			attract: ["6M"],
			bestow: ["6E"],
			blizzard: ["6M"],
			bounce: ["6L39"],
			bubble: ["6L5", "6S0"],
			camouflage: ["6E"],
			confide: ["6M"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M", "6L43"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			fling: ["6M", "6L25"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			hydropump: ["6L48"],
			icebeam: ["6M"],
			lick: ["6L10"],
			mindreader: ["6E"],
			mudsport: ["6E"],
			pound: ["6L1", "6S0"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickattack: ["6L8"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M", "6S0"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M", "6L21"],
			scald: ["6M"],
			sleeptalk: ["6M"],
			smackdown: ["6M", "6L29"],
			smokescreen: ["6L18"],
			strength: ["6M"],
			substitute: ["6M", "6L35"],
			surf: ["6M"],
			swagger: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			toxicspikes: ["6E"],
			uturn: ["6M"],
			waterfall: ["6M"],
			waterpledge: ["6T"],
			waterpulse: ["6L14"],
			watersport: ["6E"],
		},
	},
	frogadier: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			attract: ["6M"],
			blizzard: ["6M"],
			bounce: ["6L44"],
			bubble: ["6L5"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M", "6L48"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			fling: ["6M", "6L28"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L1"],
			hiddenpower: ["6M"],
			hydropump: ["6L55"],
			icebeam: ["6M"],
			lick: ["6L10"],
			pound: ["6L1"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickattack: ["6L8"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M", "6L23"],
			scald: ["6M"],
			sleeptalk: ["6M"],
			smackdown: ["6M", "6L33"],
			smokescreen: ["6L20"],
			strength: ["6M"],
			substitute: ["6M", "6L38"],
			surf: ["6M"],
			swagger: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			waterfall: ["6M"],
			waterpledge: ["6T"],
			waterpulse: ["6L14"],
		},
	},
	greninja: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			attract: ["6M"],
			blizzard: ["6M"],
			bubble: ["6L5"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M", "6L52"],
			echoedvoice: ["6M"],
			extrasensory: ["6L49"],
			facade: ["6M"],
			feintattack: ["6L33"],
			fling: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			growl: ["6L1"],
			haze: ["6L56"],
			hiddenpower: ["6M"],
			hydrocannon: ["6T", "6S1"],
			hydropump: ["6L60", "6S0"],
			hyperbeam: ["6M"],
			icebeam: ["6M"],
			lick: ["6L10"],
			matblock: ["6L1", "6S1"],
			nightslash: ["6L1"],
			pound: ["6L1"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickattack: ["6L8"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			roleplay: ["6L1"],
			round: ["6M"],
			scald: ["6M"],
			shadowsneak: ["6L23", "6S0"],
			sleeptalk: ["6M"],
			smackdown: ["6M"],
			smokescreen: ["6L20"],
			spikes: ["6L28"],
			strength: ["6M"],
			substitute: ["6M", "6L43", "6S0"],
			surf: ["6M"],
			swagger: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			waterfall: ["6M"],
			waterpledge: ["6T"],
			waterpulse: ["6L14"],
			watershuriken: ["6L36", "6S0"],
		},
	},
	bunnelby: {
		inherit: true,
		learnset: {
			agility: ["6L1"],
			attract: ["6M"],
			bounce: ["6L38"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			bulldoze: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			defensecurl: ["6E"],
			dig: ["6M", "6L33"],
			doublekick: ["6L20"],
			doubleslap: ["6L10"],
			doubleteam: ["6M"],
			earthquake: ["6M", "6L49"],
			facade: ["6M", "6L47"],
			flail: ["6L29"],
			fling: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			leer: ["6L1"],
			mudshot: ["6L18"],
			mudslap: ["6L13"],
			naturepower: ["6M"],
			odorsleuth: ["6L25"],
			payback: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickattack: ["6L7"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			rollout: ["6E"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			smackdown: ["6M"],
			spikes: ["6E"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			superfang: ["6L42"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L15"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			wildcharge: ["6M"],
		},
	},
	diggersby: {
		inherit: true,
		learnset: {
			agility: ["6L1"],
			attract: ["6M"],
			bounce: ["6L42"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			bulldoze: ["6M", "6L1"],
			confide: ["6M"],
			cut: ["6M"],
			dig: ["6M", "6L37"],
			doublekick: ["6L20"],
			doubleteam: ["6M"],
			earthquake: ["6M", "6L57"],
			facade: ["6M", "6L53"],
			flail: ["6L31"],
			fling: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hammerarm: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			leer: ["6L1"],
			mudshot: ["6L18"],
			mudslap: ["6L13"],
			naturepower: ["6M"],
			odorsleuth: ["6L26"],
			payback: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickattack: ["6L7"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			rototiller: ["6L1"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			smackdown: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			superfang: ["6L48"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L1"],
			tackle: ["6L1"],
			takedown: ["6L15"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			wildcharge: ["6M"],
		},
	},
	fletchling: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L39"],
			aerialace: ["6M"],
			agility: ["6L13"],
			attract: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			facade: ["6M"],
			flail: ["6L16"],
			flamecharge: ["6M", "6L34"],
			fly: ["6M"],
			frustration: ["6M"],
			growl: ["6L1"],
			hiddenpower: ["6M"],
			mefirst: ["6L41"],
			naturalgift: ["6L29"],
			overheat: ["6M"],
			peck: ["6L10"],
			protect: ["6M"],
			quickattack: ["6L6"],
			quickguard: ["6E"],
			razorwind: ["6L25"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M", "6L21"],
			round: ["6M"],
			sleeptalk: ["6M"],
			snatch: ["6E"],
			steelwing: ["6M", "6L48"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			tailwind: ["6L45", "6E"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	fletchinder: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L42"],
			aerialace: ["6M"],
			agility: ["6L13"],
			attract: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			ember: ["6L17"],
			facade: ["6M"],
			fireblast: ["6M"],
			flail: ["6L16"],
			flamecharge: ["6M", "6L38"],
			flamethrower: ["6M"],
			fly: ["6M"],
			frustration: ["6M"],
			growl: ["6L1"],
			hiddenpower: ["6M"],
			incinerate: ["6M"],
			mefirst: ["6L46"],
			naturalgift: ["6L31"],
			overheat: ["6M"],
			peck: ["6L10"],
			protect: ["6M"],
			quickattack: ["6L6"],
			razorwind: ["6L27"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M", "6L25"],
			round: ["6M"],
			sleeptalk: ["6M"],
			steelwing: ["6M", "6L55"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			tailwind: ["6L51"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			willowisp: ["6M"],
		},
	},
	talonflame: {
		inherit: true,
		learnset: {
			acrobatics: ["6M", "6L44"],
			aerialace: ["6M"],
			agility: ["6L13"],
			attract: ["6M"],
			bravebird: ["6L1"],
			bulkup: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			ember: ["6L17"],
			facade: ["6M"],
			fireblast: ["6M"],
			flail: ["6L16"],
			flamecharge: ["6M", "6L39"],
			flamethrower: ["6M"],
			flareblitz: ["6L1"],
			fly: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			growl: ["6L1"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hyperbeam: ["6M"],
			incinerate: ["6M"],
			mefirst: ["6L49"],
			naturalgift: ["6L31"],
			overheat: ["6M"],
			peck: ["6L10"],
			protect: ["6M"],
			quickattack: ["6L6"],
			razorwind: ["6L27"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M", "6L25"],
			round: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			steelwing: ["6M", "6L60"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			tailwind: ["6L55"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			willowisp: ["6M"],
		},
	},
	scatterbug: {
		inherit: true,
		learnset: {
			bugbite: ["6L15"],
			poisonpowder: ["6E"],
			ragepowder: ["6E"],
			stringshot: ["6L1"],
			stunspore: ["6L6", "6E"],
			tackle: ["6L1"],
		},
	},
	spewpa: {
		inherit: true,
		learnset: {
			harden: ["6L1"],
			protect: ["6M", "6L9"],
		},
	},
	vivillon: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			aromatherapy: ["6L31"],
			attract: ["6M"],
			bugbuzz: ["6L35"],
			calmmind: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L25"],
			dreameater: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gust: ["6L1"],
			hiddenpower: ["6M"],
			hurricane: ["6L50"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L1"],
			poisonpowder: ["6L1"],
			powder: ["6L1"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			quiverdance: ["6L45"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L41"],
			sleeppowder: ["6L1"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strugglebug: ["6M", "6L12"],
			stunspore: ["6L1"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			supersonic: ["6L21"],
			swagger: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	vivillonfancy: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			aromatherapy: ["6L31"],
			attract: ["6M"],
			bugbuzz: ["6L35"],
			calmmind: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L25"],
			dreameater: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gust: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			holdhands: ["6S0"],
			hurricane: ["6L50"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L1", "6S0"],
			poisonpowder: ["6L1"],
			powder: ["6L1"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			quiverdance: ["6L45"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L41"],
			secretpower: ["6M"],
			sleeppowder: ["6L1"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strugglebug: ["6M", "6L12", "6S0"],
			stunspore: ["6L1"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			supersonic: ["6L21"],
			swagger: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	vivillonpokeball: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			aromatherapy: ["6L31"],
			attract: ["6M"],
			bugbuzz: ["6L35"],
			calmmind: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L25"],
			dreameater: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gust: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			hurricane: ["6L50"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L1", "6S0"],
			poisonpowder: ["6L1"],
			powder: ["6L1"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			quiverdance: ["6L45"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L41"],
			secretpower: ["6M"],
			sleeppowder: ["6L1"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strugglebug: ["6M", "6L12", "6S0"],
			stunspore: ["6L1", "6S0"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			supersonic: ["6L21"],
			swagger: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	litleo: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			bulldoze: ["6M"],
			confide: ["6M"],
			crunch: ["6L39"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M", "6L33"],
			ember: ["6L5"],
			endeavor: ["6L28"],
			entrainment: ["6E"],
			facade: ["6M"],
			fireblast: ["6M"],
			firefang: ["6L23"],
			firespin: ["6E"],
			flamecharge: ["6M"],
			flamethrower: ["6M", "6L36"],
			frustration: ["6M"],
			headbutt: ["6L11"],
			hiddenpower: ["6M"],
			hypervoice: ["6L43"],
			incinerate: ["6M", "6L46"],
			leer: ["6L1"],
			nobleroar: ["6L15"],
			overheat: ["6M", "6L50"],
			payback: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			snarl: ["6M"],
			snatch: ["6E"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L20"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			wildcharge: ["6M"],
			willowisp: ["6M"],
			workup: ["6L8"],
			yawn: ["6E"],
		},
	},
	pyroar: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			bulldoze: ["6M"],
			confide: ["6M"],
			crunch: ["6L42"],
			darkpulse: ["6M", "6S0"],
			dig: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M", "6L33"],
			ember: ["6L5"],
			endeavor: ["6L28"],
			facade: ["6M"],
			fireblast: ["6M", "6S0"],
			firefang: ["6L23"],
			flamecharge: ["6M"],
			flamethrower: ["6M", "6L38"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			headbutt: ["6L11"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M", "6L1"],
			hypervoice: ["6L48", "6S0"],
			incinerate: ["6M", "6L51"],
			leer: ["6L1"],
			nobleroar: ["6L15"],
			overheat: ["6M", "6L57"],
			payback: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			snarl: ["6M"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L20"],
			taunt: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			wildcharge: ["6M"],
			willowisp: ["6M"],
			workup: ["6L8"],
		},
	},
	flabebe: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L33"],
			attract: ["6M"],
			calmmind: ["6M"],
			camouflage: ["6E"],
			captivate: ["6E"],
			confide: ["6M"],
			copycat: ["6E"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L6"],
			flash: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grassyterrain: ["6L24"],
			hiddenpower: ["6M"],
			luckychant: ["6L10"],
			magicalleaf: ["6L22"],
			mistyterrain: ["6L37"],
			moonblast: ["6L41"],
			naturepower: ["6M"],
			petalblizzard: ["6L28"],
			petaldance: ["6L45"],
			protect: ["6M"],
			psychic: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L15"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M", "6L48"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			vinewhip: ["6L1"],
			wish: ["6L20"],
		},
	},
	floette: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L38"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L6"],
			flash: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grassyterrain: ["6L27"],
			hiddenpower: ["6M"],
			luckychant: ["6L10"],
			magicalleaf: ["6L25"],
			mistyterrain: ["6L43"],
			moonblast: ["6L46"],
			naturepower: ["6M"],
			petalblizzard: ["6L33"],
			petaldance: ["6L51"],
			protect: ["6M"],
			psychic: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L15"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M", "6L58"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			vinewhip: ["6L1"],
			wish: ["6L20"],
		},
	},
	floetteeternal: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L38"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L6"],
			flash: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grassyterrain: ["6L27"],
			hiddenpower: ["6M"],
			lightofruin: ["6L50"],
			luckychant: ["6L10"],
			magicalleaf: ["6L25"],
			mistyterrain: ["6L43"],
			moonblast: ["6L46"],
			naturepower: ["6M"],
			petalblizzard: ["6L33"],
			petaldance: ["6L51"],
			protect: ["6M"],
			psychic: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L15"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			secretpower: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M", "6L58"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			vinewhip: ["6L1"],
			wish: ["6L20"],
		},
	},
	florges: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L1"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			disarmingvoice: ["6L1"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			flowershield: ["6L1"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M", "6L1"],
			grassyterrain: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lightscreen: ["6M"],
			luckychant: ["6L1"],
			magicalleaf: ["6L1"],
			mistyterrain: ["6L1"],
			moonblast: ["6L1"],
			naturepower: ["6M"],
			petalblizzard: ["6L1"],
			petaldance: ["6L1"],
			protect: ["6M"],
			psychic: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			toxic: ["6M"],
			wish: ["6L1"],
		},
	},
	skiddo: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			brickbreak: ["6M"],
			bulkup: ["6M", "6L34"],
			bulldoze: ["6M", "6L26"],
			confide: ["6M"],
			defensecurl: ["6E"],
			dig: ["6M"],
			doubleedge: ["6L38"],
			doubleteam: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growth: ["6L1"],
			hiddenpower: ["6M"],
			hornleech: ["6L42"],
			leafblade: ["6L45"],
			leechseed: ["6L12"],
			milkdrink: ["6L50", "6E"],
			naturepower: ["6M"],
			payback: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L13"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rollout: ["6E"],
			round: ["6M"],
			seedbomb: ["6L30"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			synthesis: ["6L20"],
			tackle: ["6L1"],
			tailwhip: ["6L9"],
			takedown: ["6L22"],
			toxic: ["6M"],
			vinewhip: ["6L7"],
			wildcharge: ["6M"],
			worryseed: ["6L16"],
		},
	},
	gogoat: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L1"],
			attract: ["6M"],
			brickbreak: ["6M"],
			bulkup: ["6M", "6L34"],
			bulldoze: ["6M", "6L26"],
			confide: ["6M"],
			dig: ["6M"],
			doubleedge: ["6L40"],
			doubleteam: ["6M"],
			earthquake: ["6M", "6L60"],
			energyball: ["6M"],
			facade: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			growth: ["6L1"],
			hiddenpower: ["6M"],
			hornleech: ["6L47"],
			hyperbeam: ["6M"],
			leafblade: ["6L55"],
			leechseed: ["6L12"],
			milkdrink: ["6L58"],
			naturepower: ["6M"],
			payback: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L13"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			seedbomb: ["6L30"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			synthesis: ["6L20"],
			tackle: ["6L1"],
			tailwhip: ["6L9"],
			takedown: ["6L22"],
			toxic: ["6M"],
			vinewhip: ["6L7"],
			wildcharge: ["6M"],
			worryseed: ["6L16"],
		},
	},
	pancham: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			armthrust: ["6L7", "6S0"],
			attract: ["6M"],
			bodyslam: ["6L33"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			bulldoze: ["6M"],
			circlethrow: ["6L25"],
			cometpunch: ["6L15"],
			confide: ["6M"],
			crunch: ["6L39"],
			cut: ["6M"],
			darkpulse: ["6M", "6S0"],
			dig: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			entrainment: ["6L42"],
			facade: ["6M"],
			falseswipe: ["6M"],
			fling: ["6M"],
			foulplay: ["6E"],
			frustration: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			karatechop: ["6L12"],
			leer: ["6L1"],
			lowsweep: ["6M"],
			mefirst: ["6E"],
			partingshot: ["6L45"],
			payback: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quash: ["6E"],
			quickguard: ["6E"],
			raindance: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			shadowclaw: ["6M"],
			skyuppercut: ["6L48"],
			slash: ["6L20"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			stoneedge: ["6M", "6S0"],
			stormthrow: ["6E"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			torment: ["6M"],
			toxic: ["6M"],
			vitalthrow: ["6L27"],
			workup: ["6L10"],
		},
	},
	pangoro: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			armthrust: ["6L7"],
			attract: ["6M"],
			bodyslam: ["6L35"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			bulldoze: ["6M"],
			circlethrow: ["6L25"],
			cometpunch: ["6L15"],
			confide: ["6M"],
			crunch: ["6L42"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dragonclaw: ["6M"],
			earthquake: ["6M"],
			echoedvoice: ["6M"],
			embargo: ["6M"],
			entrainment: ["6L1"],
			facade: ["6M"],
			falseswipe: ["6M"],
			fling: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hammerarm: ["6L1"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			karatechop: ["6L12"],
			leer: ["6L1"],
			lowsweep: ["6M", "6L70"],
			partingshot: ["6L48"],
			payback: ["6M"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quash: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			shadowclaw: ["6M"],
			skyuppercut: ["6L52"],
			slash: ["6L20"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			snarl: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			tackle: ["6L1"],
			taunt: ["6M", "6L65"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			vitalthrow: ["6L27"],
			workup: ["6L10"],
			xscissor: ["6M"],
		},
	},
	furfrou: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			babydolleyes: ["6L9"],
			bite: ["6L22"],
			captivate: ["6E"],
			chargebeam: ["6M"],
			charm: ["6L38"],
			confide: ["6M"],
			cottonguard: ["6L48"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			growl: ["6L1"],
			headbutt: ["6L12"],
			hiddenpower: ["6M"],
			mimic: ["6E"],
			odorsleuth: ["6L27"],
			protect: ["6M"],
			raindance: ["6M"],
			refresh: ["6E"],
			rest: ["6M"],
			retaliate: ["6M", "6L33"],
			return: ["6M"],
			roar: ["6M"],
			rocksmash: ["6M"],
			roleplay: ["6E"],
			round: ["6M"],
			sandattack: ["6L5"],
			sleeptalk: ["6M"],
			snarl: ["6M"],
			substitute: ["6M"],
			suckerpunch: ["6L42"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwhip: ["6L15"],
			takedown: ["6L35"],
			thunderwave: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			wildcharge: ["6M"],
			workup: ["6E"],
		},
	},
	espurr: {
		inherit: true,
		learnset: {
			assist: ["6E"],
			attract: ["6M"],
			barrier: ["6E"],
			calmmind: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			confusion: ["6L9"],
			covet: ["6L5"],
			cut: ["6M"],
			darkpulse: ["6M"],
			disarmingvoice: ["6L22"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fakeout: ["6L19"],
			flash: ["6M"],
			frustration: ["6M"],
			hiddenpower: ["6M"],
			leer: ["6L1"],
			lightscreen: ["6M", "6L13"],
			payback: ["6M"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			psyshock: ["6M", "6L25"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trick: ["6E"],
			trickroom: ["6M"],
			yawn: ["6E"],
		},
	},
	meowstic: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			calmmind: ["6M"],
			chargebeam: ["6M"],
			charm: ["6L28"],
			confide: ["6M"],
			confusion: ["6L9"],
			covet: ["6L5"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			disarmingvoice: ["6L22"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fakeout: ["6L19"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			helpinghand: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			imprison: ["6L45"],
			leer: ["6L1"],
			lightscreen: ["6M", "6L13"],
			meanlook: ["6L1"],
			miracleeye: ["6L31"],
			mistyterrain: ["6L50"],
			payback: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M", "6L40"],
			psychup: ["6M"],
			psyshock: ["6M", "6L25"],
			quickguard: ["6L1"],
			raindance: ["6M"],
			reflect: ["6M", "6L35"],
			rest: ["6M"],
			return: ["6M"],
			roleplay: ["6L43"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1"],
			shadowball: ["6M"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			suckerpunch: ["6L48"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
		},
	},
	meowsticf: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			calmmind: ["6M"],
			chargebeam: ["6M", "6L28"],
			confide: ["6M"],
			confusion: ["6L9"],
			covet: ["6L5"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			disarmingvoice: ["6L22"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			extrasensory: ["6L35"],
			facade: ["6M"],
			fakeout: ["6L19"],
			flash: ["6M"],
			frustration: ["6M"],
			futuresight: ["6L50"],
			gigaimpact: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			leer: ["6L1"],
			lightscreen: ["6M", "6L13"],
			magicalleaf: ["6L1"],
			mefirst: ["6L1"],
			payback: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M", "6L40"],
			psychup: ["6M"],
			psyshock: ["6M", "6L25"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roleplay: ["6L43"],
			round: ["6M"],
			safeguard: ["6M"],
			scratch: ["6L1"],
			shadowball: ["6M", "6L31"],
			signalbeam: ["6L45"],
			sleeptalk: ["6M"],
			storedpower: ["6L1"],
			substitute: ["6M"],
			suckerpunch: ["6L48"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
		},
	},
	honedge: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L22"],
			attract: ["6M"],
			autotomize: ["6L18"],
			brickbreak: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			destinybond: ["6E"],
			doubleteam: ["6M"],
			facade: ["6M"],
			falseswipe: ["6M"],
			flashcannon: ["6M"],
			frustration: ["6M"],
			furycutter: ["6L5"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			irondefense: ["6L32"],
			ironhead: ["6L42"],
			metalsound: ["6L8", "6E"],
			nightslash: ["6L35"],
			powertrick: ["6L39"],
			protect: ["6M"],
			pursuit: ["6L13"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M", "6L26"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			sacredsword: ["6L47"],
			shadowclaw: ["6M"],
			shadowsneak: ["6L20", "6E"],
			slash: ["6L29"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L1"],
			tackle: ["6L1"],
			toxic: ["6M"],
			wideguard: ["6E"],
		},
	},
	doublade: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L22"],
			attract: ["6M"],
			autotomize: ["6L18"],
			brickbreak: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			facade: ["6M"],
			falseswipe: ["6M"],
			flashcannon: ["6M"],
			frustration: ["6M"],
			furycutter: ["6L5"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			irondefense: ["6L32"],
			ironhead: ["6L45"],
			metalsound: ["6L8"],
			nightslash: ["6L36"],
			powertrick: ["6L41"],
			protect: ["6M"],
			pursuit: ["6L13"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M", "6L26"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			sacredsword: ["6L51"],
			shadowclaw: ["6M"],
			shadowsneak: ["6L20"],
			slash: ["6L29"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L1"],
			tackle: ["6L1"],
			toxic: ["6M"],
		},
	},
	aegislash: {
		inherit: true,
		learnset: {
			aerialace: ["6M", "6L1"],
			attract: ["6M"],
			autotomize: ["6L1"],
			brickbreak: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			facade: ["6M"],
			falseswipe: ["6M"],
			flashcannon: ["6M", "6S0"],
			frustration: ["6M"],
			furycutter: ["6L1"],
			gigaimpact: ["6M"],
			gyroball: ["6M"],
			headsmash: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			irondefense: ["6L1"],
			ironhead: ["6L1"],
			kingsshield: ["6L1", "6S0"],
			nightslash: ["6L1"],
			powertrick: ["6L1"],
			protect: ["6M"],
			pursuit: ["6L1"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			sacredsword: ["6L1"],
			shadowball: ["6M", "6S0"],
			shadowclaw: ["6M"],
			shadowsneak: ["6L1"],
			slash: ["6L1"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L1"],
			toxic: ["6M"],
			wideguard: ["6S0"],
		},
	},
	spritzee: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L25"],
			attract: ["6M", "6L29"],
			calmmind: ["6M", "6L17"],
			captivate: ["6E"],
			chargebeam: ["6M"],
			charm: ["6L35"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			disable: ["6E"],
			disarmingvoice: ["6L50"],
			doubleteam: ["6M"],
			drainingkiss: ["6L21"],
			dreameater: ["6M"],
			echoedvoice: ["6M", "6L13"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L1"],
			flail: ["6L38"],
			flash: ["6M"],
			flashcannon: ["6M"],
			frustration: ["6M"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			lightscreen: ["6M"],
			mistyterrain: ["6L42"],
			moonblast: ["6L31"],
			odorsleuth: ["6L8"],
			protect: ["6M"],
			psychic: ["6M", "6L48"],
			psychup: ["6M"],
			raindance: ["6M"],
			reflect: ["6M"],
			refresh: ["6E"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			skillswap: ["6L44"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			sweetkiss: ["6L6"],
			sweetscent: ["6L1"],
			thunderbolt: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
			wish: ["6E"],
		},
	},
	aromatisse: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L25"],
			aromaticmist: ["6L1"],
			attract: ["6M", "6L29"],
			calmmind: ["6M", "6L17"],
			chargebeam: ["6M"],
			charm: ["6L35"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			disarmingvoice: ["6L53"],
			doubleteam: ["6M"],
			drainingkiss: ["6L21"],
			dreameater: ["6M"],
			echoedvoice: ["6M", "6L13"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L1"],
			flail: ["6L38"],
			flash: ["6M"],
			flashcannon: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gyroball: ["6M"],
			healpulse: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lightscreen: ["6M"],
			mistyterrain: ["6L42"],
			moonblast: ["6L31", "6S0"],
			odorsleuth: ["6L8"],
			protect: ["6M"],
			psychic: ["6M", "6L48"],
			psychup: ["6M", "6L64"],
			psyshock: ["6M"],
			raindance: ["6M"],
			reflect: ["6M", "6L57"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			skillswap: ["6L44"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			sweetkiss: ["6L6"],
			sweetscent: ["6L1"],
			thunder: ["6M"],
			thunderbolt: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M", "6S0"],
		},
	},
	swirlix: {
		inherit: true,
		learnset: {
			afteryou: ["6E"],
			aromatherapy: ["6L26"],
			attract: ["6M"],
			bellydrum: ["6E"],
			calmmind: ["6M"],
			confide: ["6M"],
			copycat: ["6E"],
			cottonguard: ["6L41"],
			cottonspore: ["6L17"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L31"],
			dreameater: ["6M"],
			endeavor: ["6L21"],
			energyball: ["6M", "6L36"],
			facade: ["6M"],
			fairywind: ["6L5"],
			faketears: ["6L10"],
			flamethrower: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			hiddenpower: ["6M"],
			lightscreen: ["6M", "6L58"],
			playnice: ["6L8"],
			playrough: ["6L49"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M", "6L13"],
			safeguard: ["6M", "6L67"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			sweetscent: ["6L1"],
			tackle: ["6L1"],
			thief: ["6M"],
			thunderbolt: ["6M"],
			toxic: ["6M"],
			wish: ["6L45"],
			yawn: ["6E"],
		},
	},
	slurpuff: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L26"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			cottonguard: ["6L41"],
			cottonspore: ["6L17"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L31"],
			dreameater: ["6M"],
			endeavor: ["6L21"],
			energyball: ["6M", "6L36"],
			facade: ["6M"],
			fairywind: ["6L5"],
			faketears: ["6L10"],
			flamethrower: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lightscreen: ["6M", "6L58"],
			playnice: ["6L8"],
			playrough: ["6L49"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M", "6L13"],
			safeguard: ["6M", "6L67"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			sweetscent: ["6L1"],
			tackle: ["6L1"],
			thief: ["6M"],
			thunderbolt: ["6M"],
			toxic: ["6M"],
			wish: ["6L45"],
		},
	},
	inkay: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			calmmind: ["6M"],
			camouflage: ["6E"],
			confide: ["6M"],
			constrict: ["6L1"],
			cut: ["6M"],
			darkpulse: ["6M"],
			destinybond: ["6E"],
			doubleteam: ["6M"],
			embargo: ["6M"],
			facade: ["6M"],
			flamethrower: ["6M"],
			flash: ["6M"],
			flatter: ["6E"],
			fling: ["6M"],
			foulplay: ["6L8", "6S0"],
			frustration: ["6M"],
			happyhour: ["6S0"],
			hiddenpower: ["6M"],
			hypnosis: ["6L18", "6S0"],
			lightscreen: ["6M", "6L31"],
			nightslash: ["6L46"],
			payback: ["6M", "6L27"],
			peck: ["6L1"],
			pluck: ["6L35"],
			powersplit: ["6E"],
			protect: ["6M"],
			psybeam: ["6L21"],
			psychic: ["6M"],
			psychocut: ["6L39"],
			psychup: ["6M"],
			psywave: ["6L13"],
			raindance: ["6M"],
			reflect: ["6M", "6L4"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			simplebeam: ["6E"],
			slash: ["6L43"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			superpower: ["6L48"],
			swagger: ["6M", "6L12"],
			switcheroo: ["6L23"],
			tackle: ["6L1"],
			taunt: ["6M"],
			thief: ["6M"],
			thunderbolt: ["6M"],
			topsyturvy: ["6L15", "6S0"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
		},
	},
	malamar: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			constrict: ["6L1"],
			cut: ["6M"],
			darkpulse: ["6M"],
			doubleteam: ["6M"],
			embargo: ["6M"],
			facade: ["6M", "6S0"],
			flamethrower: ["6M"],
			flash: ["6M"],
			fling: ["6M"],
			foulplay: ["6L8"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			hypnosis: ["6L18"],
			lightscreen: ["6M", "6L31"],
			nightslash: ["6L46"],
			payback: ["6M", "6L27"],
			peck: ["6L1"],
			pluck: ["6L35"],
			protect: ["6M"],
			psybeam: ["6L21"],
			psychic: ["6M"],
			psychocut: ["6L39"],
			psychup: ["6M"],
			psyshock: ["6M"],
			psywave: ["6L13"],
			raindance: ["6M"],
			reflect: ["6M", "6L4"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			reversal: ["6L1"],
			rockslide: ["6M", "6S0"],
			round: ["6M"],
			slash: ["6L43"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			superpower: ["6L1", "6S0"],
			swagger: ["6M", "6L12"],
			switcheroo: ["6L23"],
			tackle: ["6L1"],
			taunt: ["6M"],
			thief: ["6M"],
			thunderbolt: ["6M"],
			topsyturvy: ["6L15"],
			torment: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
		},
	},
	binacle: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			ancientpower: ["6L28"],
			attract: ["6M"],
			blizzard: ["6M"],
			brickbreak: ["6M"],
			bulldoze: ["6M"],
			clamp: ["6L20"],
			confide: ["6M"],
			crosschop: ["6L49"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			earthquake: ["6M"],
			embargo: ["6M"],
			facade: ["6M"],
			falseswipe: ["6M"],
			fling: ["6M"],
			frustration: ["6M"],
			furycutter: ["6L37"],
			furyswipes: ["6L10"],
			grassknot: ["6M"],
			helpinghand: ["6E"],
			hiddenpower: ["6M"],
			honeclaws: ["6M", "6L32"],
			icebeam: ["6M"],
			infestation: ["6M"],
			mudslap: ["6L18"],
			naturepower: ["6M"],
			nightslash: ["6L41"],
			payback: ["6M"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			razorshell: ["6L45"],
			rest: ["6M"],
			return: ["6M"],
			rockpolish: ["6M", "6L24"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sandattack: ["6L1"],
			sandstorm: ["6M"],
			scald: ["6M"],
			scratch: ["6L1"],
			shadowclaw: ["6M"],
			shellsmash: ["6L1"],
			slash: ["6L13"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			smackdown: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			switcheroo: ["6E"],
			swordsdance: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			tickle: ["6E"],
			torment: ["6M"],
			toxic: ["6M"],
			watergun: ["6L4"],
			watersport: ["6E"],
			withdraw: ["6L7"],
			xscissor: ["6M"],
		},
	},
	barbaracle: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			ancientpower: ["6L28"],
			attract: ["6M"],
			blizzard: ["6M"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			bulldoze: ["6M"],
			clamp: ["6L20"],
			confide: ["6M"],
			crosschop: ["6L55"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dragonclaw: ["6M"],
			earthquake: ["6M"],
			embargo: ["6M"],
			facade: ["6M"],
			falseswipe: ["6M"],
			fling: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			furycutter: ["6L37"],
			furyswipes: ["6L10"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			honeclaws: ["6M", "6L32"],
			hyperbeam: ["6M"],
			icebeam: ["6M"],
			infestation: ["6M"],
			mudslap: ["6L18"],
			naturepower: ["6M"],
			nightslash: ["6L44"],
			payback: ["6M"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			raindance: ["6M"],
			razorshell: ["6L48"],
			rest: ["6M"],
			return: ["6M"],
			rockpolish: ["6M", "6L24"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sandattack: ["6L1"],
			sandstorm: ["6M"],
			scald: ["6M"],
			scratch: ["6L1"],
			shadowclaw: ["6M"],
			shellsmash: ["6L1"],
			skullbash: ["6L1"],
			slash: ["6L13"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			smackdown: ["6M"],
			stoneedge: ["6M", "6L1"],
			strength: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			watergun: ["6L4"],
			withdraw: ["6L7"],
			xscissor: ["6M"],
		},
	},
	skrelp: {
		inherit: true,
		learnset: {
			acid: ["6L15"],
			acidarmor: ["6E"],
			aquatail: ["6L35"],
			attract: ["6M"],
			bubble: ["6L12"],
			camouflage: ["6L19"],
			confide: ["6M"],
			doubleteam: ["6M", "6L28"],
			dragonpulse: ["6L49"],
			facade: ["6M"],
			feintattack: ["6L5"],
			frustration: ["6M"],
			hail: ["6M"],
			haze: ["6E"],
			hiddenpower: ["6M"],
			hydropump: ["6L42"],
			playrough: ["6E"],
			poisontail: ["6L23"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			scald: ["6M"],
			shadowball: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M", "6L38"],
			sludgewave: ["6M"],
			smokescreen: ["6L1"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwhip: ["6L9"],
			thunderbolt: ["6M"],
			toxic: ["6M", "6L32"],
			toxicspikes: ["6E"],
			venomdrench: ["6E"],
			venoshock: ["6M"],
			waterfall: ["6M"],
			watergun: ["6L1"],
			waterpulse: ["6L25"],
		},
	},
	dragalge: {
		inherit: true,
		learnset: {
			acid: ["6L15"],
			aquatail: ["6L35"],
			attract: ["6M"],
			bubble: ["6L12"],
			camouflage: ["6L19"],
			confide: ["6M"],
			doubleteam: ["6M", "6L28"],
			dracometeor: ["6T"],
			dragonpulse: ["6L53"],
			dragontail: ["6M", "6L1"],
			facade: ["6M"],
			feintattack: ["6L5"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			hail: ["6M"],
			hiddenpower: ["6M"],
			hydropump: ["6L42"],
			hyperbeam: ["6M"],
			poisontail: ["6L23"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			scald: ["6M"],
			shadowball: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M", "6L38"],
			sludgewave: ["6M"],
			smokescreen: ["6L1"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwhip: ["6L9"],
			thunder: ["6M"],
			thunderbolt: ["6M"],
			toxic: ["6M", "6L32"],
			twister: ["6L1"],
			venoshock: ["6M"],
			waterfall: ["6M"],
			watergun: ["6L1"],
			waterpulse: ["6L25"],
		},
	},
	clauncher: {
		inherit: true,
		learnset: {
			aquajet: ["6L43", "6E"],
			attract: ["6M"],
			bubble: ["6L12"],
			bubblebeam: ["6L20"],
			confide: ["6M"],
			crabhammer: ["6L30", "6E"],
			cut: ["6M"],
			doubleteam: ["6M"],
			endure: ["6E"],
			entrainment: ["6E"],
			facade: ["6M"],
			flail: ["6L16"],
			flashcannon: ["6M"],
			frustration: ["6M"],
			helpinghand: ["6E"],
			hiddenpower: ["6M"],
			icebeam: ["6M"],
			muddywater: ["6L48"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			scald: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			smackdown: ["6M", "6L39"],
			splash: ["6L1"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L25"],
			toxic: ["6M"],
			uturn: ["6M"],
			venoshock: ["6M"],
			visegrip: ["6L9"],
			waterfall: ["6M"],
			watergun: ["6L1"],
			waterpulse: ["6L34"],
			watersport: ["6L7"],
		},
	},
	clawitzer: {
		inherit: true,
		learnset: {
			aquajet: ["6L47"],
			attract: ["6M"],
			aurasphere: ["6L1"],
			bubble: ["6L12"],
			bubblebeam: ["6L20"],
			confide: ["6M"],
			crabhammer: ["6L30"],
			cut: ["6M"],
			darkpulse: ["6M", "6L1"],
			doubleteam: ["6M"],
			dragonpulse: ["6L1"],
			facade: ["6M"],
			flail: ["6L16"],
			flashcannon: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			healpulse: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			icebeam: ["6M"],
			muddywater: ["6L53"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			scald: ["6M"],
			shadowball: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			smackdown: ["6M", "6L42"],
			splash: ["6L1"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L25"],
			toxic: ["6M"],
			uturn: ["6M"],
			venoshock: ["6M"],
			visegrip: ["6L9"],
			waterfall: ["6M"],
			watergun: ["6L1"],
			waterpulse: ["6L34"],
			watersport: ["6L7"],
		},
	},
	helioptile: {
		inherit: true,
		learnset: {
			agility: ["6E"],
			attract: ["6M"],
			bulldoze: ["6M", "6L35"],
			camouflage: ["6E"],
			charge: ["6L11"],
			chargebeam: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dragontail: ["6M"],
			electricterrain: ["6E"],
			electrify: ["6L45"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			glare: ["6E"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			lightscreen: ["6M"],
			lowsweep: ["6M"],
			mudslap: ["6L13"],
			paraboliccharge: ["6L25"],
			pound: ["6L1"],
			protect: ["6M"],
			psychup: ["6M"],
			quickattack: ["6L17"],
			raindance: ["6M"],
			razorwind: ["6L22"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M"],
			thunderbolt: ["6M", "6L49"],
			thundershock: ["6L6"],
			thunderwave: ["6M", "6L31"],
			toxic: ["6M"],
			uturn: ["6M"],
			voltswitch: ["6M", "6L40"],
			wildcharge: ["6M"],
		},
	},
	heliolisk: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			bulldoze: ["6M"],
			charge: ["6L1"],
			chargebeam: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dragontail: ["6M"],
			eerieimpulse: ["6L1"],
			electrify: ["6L1"],
			facade: ["6M"],
			flash: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lightscreen: ["6M"],
			lowsweep: ["6M"],
			paraboliccharge: ["6L1"],
			protect: ["6M"],
			psychup: ["6M"],
			quickattack: ["6L1"],
			raindance: ["6M"],
			razorwind: ["6L1"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			thunder: ["6M", "6L1"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M"],
		},
	},
	tyrunt: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			ancientpower: ["6L26"],
			attract: ["6M"],
			bide: ["6L12"],
			bite: ["6L17"],
			brickbreak: ["6M"],
			bulldoze: ["6M"],
			charm: ["6L20"],
			confide: ["6M"],
			crunch: ["6L34"],
			curse: ["6E"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonclaw: ["6M", "6L37"],
			dragondance: ["6E"],
			dragontail: ["6M", "6L30"],
			earthquake: ["6M", "6L44"],
			facade: ["6M"],
			firefang: ["6E"],
			frustration: ["6M"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			horndrill: ["6L49"],
			icefang: ["6E"],
			poisonfang: ["6E"],
			protect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M", "6L6", "6S0"],
			rockpolish: ["6M", "6E"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			stealthrock: ["6L15"],
			stomp: ["6L10", "6S0"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1", "6S0"],
			tailwhip: ["6L1", "6S0"],
			thrash: ["6L40"],
			thunderfang: ["6E"],
			toxic: ["6M"],
		},
	},
	tyrantrum: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			ancientpower: ["6L26"],
			attract: ["6M"],
			bide: ["6L12"],
			bite: ["6L17"],
			brickbreak: ["6M"],
			bulldoze: ["6M"],
			charm: ["6L20"],
			confide: ["6M"],
			crunch: ["6L34"],
			darkpulse: ["6M"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonclaw: ["6M", "6L37"],
			dragontail: ["6M", "6L30"],
			earthquake: ["6M", "6L47"],
			facade: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M", "6L75"],
			headsmash: ["6L1"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			horndrill: ["6L53"],
			hyperbeam: ["6M"],
			protect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M", "6L6"],
			rockpolish: ["6M"],
			rockslide: ["6M", "6L68"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			stealthrock: ["6L15"],
			stomp: ["6L10"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwhip: ["6L1"],
			thrash: ["6L42"],
			toxic: ["6M"],
		},
	},
	amaura: {
		inherit: true,
		learnset: {
			ancientpower: ["6L26"],
			attract: ["6M"],
			aurorabeam: ["6L20"],
			avalanche: ["6L34"],
			barrier: ["6E"],
			blizzard: ["6M", "6L65"],
			bulldoze: ["6M"],
			calmmind: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			darkpulse: ["6M"],
			discharge: ["6E"],
			doubleteam: ["6M"],
			dragontail: ["6M"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			encore: ["6L44"],
			facade: ["6M"],
			flash: ["6M"],
			flashcannon: ["6M"],
			frostbreath: ["6M"],
			frustration: ["6M"],
			growl: ["6L1", "6S0"],
			hail: ["6M", "6L38"],
			haze: ["6E"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M", "6L57"],
			icebeam: ["6M", "6L50"],
			icywind: ["6L13"],
			lightscreen: ["6M", "6L47"],
			magnetrise: ["6E"],
			mirrorcoat: ["6E"],
			mist: ["6L18"],
			naturepower: ["6M", "6L41"],
			powdersnow: ["6L1", "6S0"],
			protect: ["6M"],
			psychup: ["6M"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rockthrow: ["6L10", "6S0"],
			rocktomb: ["6M"],
			round: ["6M", "6L30"],
			safeguard: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			stoneedge: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			takedown: ["6L15"],
			thunderbolt: ["6M"],
			thunderwave: ["6M", "6L5", "6S0"],
			toxic: ["6M"],
		},
	},
	aurorus: {
		inherit: true,
		learnset: {
			ancientpower: ["6L26"],
			attract: ["6M"],
			aurorabeam: ["6L20"],
			avalanche: ["6L34"],
			blizzard: ["6M", "6L74"],
			bulldoze: ["6M"],
			calmmind: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			darkpulse: ["6M"],
			doubleteam: ["6M"],
			dragontail: ["6M"],
			dreameater: ["6M"],
			earthquake: ["6M"],
			echoedvoice: ["6M"],
			encore: ["6L46"],
			facade: ["6M"],
			flash: ["6M"],
			flashcannon: ["6M"],
			freezedry: ["6L1"],
			frostbreath: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			growl: ["6L1"],
			hail: ["6M", "6L38"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M", "6L63"],
			icebeam: ["6M", "6L56"],
			icywind: ["6L13"],
			lightscreen: ["6M", "6L50"],
			mist: ["6L18"],
			naturepower: ["6M", "6L43"],
			powdersnow: ["6L1"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rockthrow: ["6L10"],
			rocktomb: ["6M"],
			round: ["6M", "6L30"],
			safeguard: ["6M"],
			sandstorm: ["6M"],
			sleeptalk: ["6M"],
			stoneedge: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			takedown: ["6L15"],
			thunder: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M", "6L5"],
			toxic: ["6M"],
		},
	},
	sylveon: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			calmmind: ["6M"],
			celebrate: ["6S0"],
			confide: ["6M"],
			cut: ["6M"],
			dazzlinggleam: ["6M"],
			dig: ["6M"],
			disarmingvoice: ["6L1", "6S1"],
			doubleteam: ["6M"],
			drainingkiss: ["6L20", "6S1"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			fairywind: ["6L9", "6S0"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			helpinghand: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lastresort: ["6L41"],
			lightscreen: ["6M", "6L33"],
			mistyterrain: ["6L29"],
			moonblast: ["6L37"],
			protect: ["6M"],
			psychup: ["6M", "6L45"],
			psyshock: ["6M"],
			quickattack: ["6L13", "6S1"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sandattack: ["6L5", "6S0"],
			shadowball: ["6M"],
			skillswap: ["6L25"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swift: ["6L17"],
			tackle: ["6L1"],
			tailwhip: ["6L1"],
			toxic: ["6M"],
		},
	},
	hawlucha: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M", "6L16"],
			agility: ["6E"],
			allyswitch: ["6E"],
			attract: ["6M"],
			batonpass: ["6E"],
			bounce: ["6L32"],
			brickbreak: ["6M"],
			bulkup: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			detect: ["6L1"],
			dig: ["6M"],
			doubleteam: ["6M"],
			encore: ["6L20"],
			endeavor: ["6L36"],
			entrainment: ["6E"],
			facade: ["6M"],
			falseswipe: ["6M"],
			featherdance: ["6L40"],
			fling: ["6M", "6L24"],
			fly: ["6M"],
			flyingpress: ["6L28"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			hiddenpower: ["6M"],
			highjumpkick: ["6L44"],
			honeclaws: ["6M", "6L1"],
			karatechop: ["6L4"],
			lowsweep: ["6M"],
			mefirst: ["6E"],
			mudsport: ["6E"],
			payback: ["6M"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			quickguard: ["6E"],
			raindance: ["6M"],
			rest: ["6M"],
			retaliate: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			roost: ["6M", "6L12"],
			round: ["6M"],
			skyattack: ["6L48"],
			skydrop: ["6M", "6L55"],
			sleeptalk: ["6M"],
			steelwing: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			swordsdance: ["6M", "6L60"],
			tackle: ["6L1"],
			taunt: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			wingattack: ["6L8"],
			xscissor: ["6M"],
		},
	},
	dedenne: {
		inherit: true,
		learnset: {
			aerialace: ["6M"],
			attract: ["6M"],
			charge: ["6L11"],
			chargebeam: ["6M", "6L34"],
			charm: ["6L14"],
			confide: ["6M"],
			covet: ["6E"],
			cut: ["6M"],
			dig: ["6M"],
			discharge: ["6L50"],
			doubleteam: ["6M"],
			eerieimpulse: ["6E"],
			entrainment: ["6L39"],
			facade: ["6M"],
			flash: ["6M"],
			fling: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			helpinghand: ["6E"],
			hiddenpower: ["6M"],
			naturalgift: ["6E"],
			nuzzle: ["6L20"],
			paraboliccharge: ["6L17"],
			playrough: ["6L42"],
			protect: ["6M"],
			raindance: ["6M"],
			rest: ["6M", "6L30"],
			retaliate: ["6M"],
			return: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			snore: ["6L31"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwhip: ["6L1"],
			thief: ["6M"],
			thunder: ["6M", "6L45"],
			thunderbolt: ["6M"],
			thundershock: ["6L7"],
			thunderwave: ["6M", "6L23"],
			toxic: ["6M"],
			uturn: ["6M"],
			voltswitch: ["6M", "6L26"],
			wildcharge: ["6M"],
		},
	},
	carbink: {
		inherit: true,
		learnset: {
			ancientpower: ["6L31"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			explosion: ["6M"],
			facade: ["6M"],
			flail: ["6L35"],
			flash: ["6M"],
			frustration: ["6M"],
			guardsplit: ["6L27"],
			gyroball: ["6M"],
			hail: ["6M"],
			harden: ["6L1"],
			hiddenpower: ["6M"],
			lightscreen: ["6M", "6L60"],
			moonblast: ["6L50"],
			naturepower: ["6M"],
			powergem: ["6L46"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			reflect: ["6M", "6L18"],
			rest: ["6M"],
			return: ["6M"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rockthrow: ["6L5"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L70"],
			sandstorm: ["6M"],
			sharpen: ["6L8"],
			skillswap: ["6L40"],
			sleeptalk: ["6M"],
			smackdown: ["6M", "6L12"],
			stealthrock: ["6L21"],
			stoneedge: ["6M", "6L49"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			trickroom: ["6M"],
		},
	},
	goomy: {
		inherit: true,
		learnset: {
			absorb: ["6L5"],
			acidarmor: ["6E"],
			attract: ["6M"],
			bide: ["6L13"],
			bodyslam: ["6L32"],
			bubble: ["6L1"],
			confide: ["6M"],
			counter: ["6E"],
			curse: ["6E"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonbreath: ["6L18"],
			dragonpulse: ["6L42"],
			endure: ["6E"],
			facade: ["6M"],
			flail: ["6L28"],
			frustration: ["6M"],
			hiddenpower: ["6M"],
			infestation: ["6M"],
			irontail: ["6E"],
			muddywater: ["6L38"],
			poisontail: ["6E"],
			protect: ["6M", "6L9"],
			raindance: ["6M", "6L25"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			thunderbolt: ["6M"],
			toxic: ["6M"],
		},
	},
	sliggoo: {
		inherit: true,
		learnset: {
			absorb: ["6L5"],
			attract: ["6M"],
			bide: ["6L13"],
			blizzard: ["6M"],
			bodyslam: ["6L32"],
			bubble: ["6L1"],
			confide: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonbreath: ["6L18"],
			dragonpulse: ["6L47"],
			facade: ["6M"],
			flail: ["6L28"],
			frustration: ["6M"],
			hiddenpower: ["6M"],
			icebeam: ["6M"],
			infestation: ["6M"],
			muddywater: ["6L38"],
			protect: ["6M", "6L9"],
			raindance: ["6M", "6L25"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			thunderbolt: ["6M"],
			toxic: ["6M"],
		},
	},
	goodra: {
		inherit: true,
		learnset: {
			absorb: ["6L5"],
			aquatail: ["6L50"],
			attract: ["6M"],
			bide: ["6L13"],
			blizzard: ["6M"],
			bodyslam: ["6L32"],
			bubble: ["6L1"],
			bulldoze: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonbreath: ["6L18"],
			dragonpulse: ["6L47"],
			dragontail: ["6M"],
			earthquake: ["6M"],
			facade: ["6M"],
			feint: ["6L1"],
			fireblast: ["6M"],
			flail: ["6L28"],
			flamethrower: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			hail: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			icebeam: ["6M"],
			incinerate: ["6M"],
			infestation: ["6M"],
			muddywater: ["6L38"],
			outrage: ["6L1"],
			powerwhip: ["6L55"],
			protect: ["6M", "6L9"],
			raindance: ["6M", "6L25"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			thunder: ["6M"],
			thunderbolt: ["6M"],
			toxic: ["6M"],
		},
	},
	klefki: {
		inherit: true,
		learnset: {
			astonish: ["6L8"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			craftyshield: ["6L23"],
			cut: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L18"],
			facade: ["6M"],
			fairylock: ["6L1"],
			fairywind: ["6L5"],
			flashcannon: ["6M"],
			foulplay: ["6L27"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			healblock: ["6L50"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			imprison: ["6L36"],
			irondefense: ["6E"],
			lightscreen: ["6M"],
			lockon: ["6E"],
			magicroom: ["6L44"],
			metalsound: ["6L12"],
			mirrorshot: ["6L34"],
			playrough: ["6L43"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			psyshock: ["6M"],
			raindance: ["6M"],
			recycle: ["6L40"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sleeptalk: ["6M"],
			spikes: ["6L15"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			switcheroo: ["6E"],
			tackle: ["6L1"],
			thief: ["6M", "6E"],
			thunderwave: ["6M"],
			torment: ["6M", "6L32"],
			toxic: ["6M"],
		},
	},
	phantump: {
		inherit: true,
		learnset: {
			astonish: ["6L5"],
			attract: ["6M"],
			bestow: ["6E"],
			bulldoze: ["6M"],
			confide: ["6M"],
			confuseray: ["6L1"],
			curse: ["6L28"],
			cut: ["6M"],
			darkpulse: ["6M"],
			destinybond: ["6L39"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			feintattack: ["6L19"],
			forestscurse: ["6L35"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growth: ["6L8"],
			grudge: ["6E"],
			hiddenpower: ["6M"],
			hornleech: ["6L54"],
			imprison: ["6E"],
			ingrain: ["6L13"],
			leechseed: ["6L23"],
			naturepower: ["6M"],
			phantomforce: ["6L45"],
			poisonjab: ["6M"],
			protect: ["6M"],
			psychic: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			shadowball: ["6M"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			thief: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
			venomdrench: ["6E"],
			willowisp: ["6M", "6L31"],
			woodhammer: ["6L49"],
		},
	},
	trevenant: {
		inherit: true,
		learnset: {
			astonish: ["6L5"],
			attract: ["6M"],
			bulldoze: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			confuseray: ["6L1"],
			curse: ["6L28"],
			cut: ["6M"],
			darkpulse: ["6M"],
			destinybond: ["6L39"],
			dig: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			earthquake: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			feintattack: ["6L19"],
			focusblast: ["6M"],
			forestscurse: ["6L35"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			growth: ["6L8"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hornleech: ["6L1"],
			hyperbeam: ["6M"],
			ingrain: ["6L13"],
			leechseed: ["6L23"],
			naturepower: ["6M"],
			phantomforce: ["6L45"],
			poisonjab: ["6M"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psychic: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			shadowball: ["6M"],
			shadowclaw: ["6M", "6L55"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			thief: ["6M"],
			toxic: ["6M"],
			trickroom: ["6M"],
			willowisp: ["6M", "6L31"],
			woodhammer: ["6L49"],
			xscissor: ["6M"],
		},
	},
	pumpkaboo: {
		inherit: true,
		learnset: {
			astonish: ["6L1"],
			attract: ["6M"],
			bestow: ["6E"],
			bulletseed: ["6L26"],
			chargebeam: ["6M"],
			confide: ["6M"],
			confuseray: ["6L1"],
			darkpulse: ["6M"],
			destinybond: ["6E"],
			disable: ["6E"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			energyball: ["6M"],
			explosion: ["6M"],
			facade: ["6M"],
			fireblast: ["6M"],
			flamecharge: ["6M"],
			flamethrower: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			incinerate: ["6M"],
			leechseed: ["6L20"],
			lightscreen: ["6M"],
			naturepower: ["6M"],
			painsplit: ["6L42"],
			protect: ["6M"],
			psychic: ["6M"],
			razorleaf: ["6L16"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			scaryface: ["6L4"],
			seedbomb: ["6L48"],
			shadowball: ["6M", "6L36"],
			shadowsneak: ["6L30"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			trick: ["6L1"],
			trickortreat: ["6L6"],
			trickroom: ["6M"],
			willowisp: ["6M"],
			worryseed: ["6L11"],
		},
	},
	pumpkaboosuper: {
		inherit: true,
		learnset: {
			astonish: ["6S0"],
			scaryface: ["6S0"],
			shadowsneak: ["6S0"],
			trickortreat: ["6S0"],
		},
	},
	gourgeist: {
		inherit: true,
		learnset: {
			astonish: ["6L1"],
			attract: ["6M"],
			bulletseed: ["6L26"],
			chargebeam: ["6M"],
			confide: ["6M"],
			confuseray: ["6L1"],
			darkpulse: ["6M"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			energyball: ["6M"],
			explosion: ["6M", "6L1"],
			facade: ["6M"],
			fireblast: ["6M"],
			flamecharge: ["6M"],
			flamethrower: ["6M"],
			flash: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			gyroball: ["6M"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			incinerate: ["6M"],
			leechseed: ["6L20"],
			lightscreen: ["6M"],
			naturepower: ["6M"],
			painsplit: ["6L42"],
			phantomforce: ["6L1"],
			protect: ["6M"],
			psychic: ["6M"],
			razorleaf: ["6L16"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			scaryface: ["6L4"],
			seedbomb: ["6L48"],
			shadowball: ["6M", "6L36"],
			shadowsneak: ["6L30"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			solarbeam: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			thief: ["6M"],
			toxic: ["6M"],
			trick: ["6L1"],
			trickortreat: ["6L6"],
			trickroom: ["6M"],
			willowisp: ["6M"],
			worryseed: ["6L11"],
		},
	},
	bergmite: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			avalanche: ["6L39"],
			barrier: ["6E"],
			bite: ["6L1"],
			blizzard: ["6M", "6L43"],
			confide: ["6M"],
			curse: ["6L22"],
			doubleedge: ["6L49"],
			doubleteam: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			flashcannon: ["6M"],
			frostbreath: ["6M"],
			frustration: ["6M"],
			gyroball: ["6M"],
			hail: ["6M"],
			harden: ["6L1"],
			hiddenpower: ["6M"],
			iceball: ["6L30"],
			icebeam: ["6M"],
			icefang: ["6L26"],
			icywind: ["6L10"],
			mirrorcoat: ["6E"],
			mist: ["6E"],
			powdersnow: ["6L5"],
			protect: ["6M"],
			raindance: ["6M"],
			rapidspin: ["6L35"],
			recover: ["6L47", "6E"],
			rest: ["6M"],
			return: ["6M"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sharpen: ["6L20"],
			sleeptalk: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L15"],
			toxic: ["6M"],
		},
	},
	avalugg: {
		inherit: true,
		learnset: {
			attract: ["6M"],
			avalanche: ["6L42"],
			bite: ["6L1"],
			blizzard: ["6M", "6L46"],
			bulldoze: ["6M"],
			confide: ["6M"],
			crunch: ["6L1"],
			curse: ["6L22"],
			doubleedge: ["6L56"],
			doubleteam: ["6M"],
			earthquake: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			flashcannon: ["6M"],
			frostbreath: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gyroball: ["6M"],
			hail: ["6M"],
			harden: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			iceball: ["6L30"],
			icebeam: ["6M"],
			icefang: ["6L26"],
			icywind: ["6L10"],
			irondefense: ["6L1"],
			powdersnow: ["6L5"],
			protect: ["6M"],
			raindance: ["6M"],
			rapidspin: ["6L35"],
			recover: ["6L51"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			sharpen: ["6L20"],
			skullbash: ["6L1"],
			sleeptalk: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			surf: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			takedown: ["6L15"],
			toxic: ["6M"],
		},
	},
	noibat: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			agility: ["6L18"],
			aircutter: ["6L23"],
			airslash: ["6L48"],
			attract: ["6M"],
			bite: ["6L13"],
			brickbreak: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			fly: ["6M"],
			frustration: ["6M"],
			gust: ["6L11"],
			hiddenpower: ["6M"],
			hurricane: ["6L58"],
			leechlife: ["6L5"],
			outrage: ["6E"],
			protect: ["6M"],
			psychic: ["6M"],
			razorwind: ["6L31"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M", "6L27"],
			round: ["6M"],
			screech: ["6L1"],
			shadowball: ["6M"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			snatch: ["6E"],
			solarbeam: ["6M"],
			steelwing: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			superfang: ["6L43"],
			supersonic: ["6L1"],
			swagger: ["6M"],
			switcheroo: ["6E"],
			tackle: ["6L1"],
			tailwind: ["6L35", "6E"],
			taunt: ["6M"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			whirlwind: ["6L40"],
			wildcharge: ["6M"],
			wingattack: ["6L16"],
			xscissor: ["6M"],
		},
	},
	noivern: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			agility: ["6L18"],
			aircutter: ["6L23"],
			airslash: ["6L53"],
			attract: ["6M"],
			bite: ["6L13"],
			boomburst: ["6L1"],
			brickbreak: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonclaw: ["6M"],
			dragonpulse: ["6L1"],
			dreameater: ["6M"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			flamethrower: ["6M"],
			fly: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gust: ["6L11"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hurricane: ["6L1"],
			hyperbeam: ["6M"],
			leechlife: ["6L5"],
			moonlight: ["6L1"],
			protect: ["6M"],
			psychic: ["6M"],
			razorwind: ["6L31"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M", "6L27"],
			round: ["6M"],
			screech: ["6L1"],
			shadowball: ["6M"],
			shadowclaw: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M"],
			steelwing: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			superfang: ["6L43"],
			supersonic: ["6L1"],
			swagger: ["6M"],
			tackle: ["6L1"],
			tailwind: ["6L35"],
			taunt: ["6M"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
			whirlwind: ["6L40"],
			wildcharge: ["6M"],
			wingattack: ["6L16"],
			xscissor: ["6M"],
		},
	},
	xerneas: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L1", "6S1"],
			aurorabeam: ["6L10"],
			calmmind: ["6M"],
			closecombat: ["6L80"],
			confide: ["6M"],
			cut: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			flashcannon: ["6M"],
			focusblast: ["6M", "6S1"],
			frustration: ["6M"],
			geomancy: ["6L26", "6S0", "6S1"],
			gigaimpact: ["6M", "6L88"],
			grassknot: ["6M"],
			gravity: ["6L18", "6S0"],
			hail: ["6M"],
			healpulse: ["6L1"],
			hiddenpower: ["6M"],
			hornleech: ["6L55"],
			hyperbeam: ["6M"],
			ingrain: ["6L1"],
			lightscreen: ["6M", "6L5"],
			megahorn: ["6L44", "6S0"],
			mistyterrain: ["6L63"],
			moonblast: ["6L35", "6S0", "6S1"],
			naturepower: ["6M", "6L72"],
			nightslash: ["6L51"],
			outrage: ["6L93"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M", "6L59"],
			psyshock: ["6M"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			round: ["6M"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			takedown: ["6L1"],
			thunder: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			toxic: ["6M"],
		},
	},
	yveltal: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			airslash: ["6L10"],
			confide: ["6M"],
			cut: ["6M"],
			darkpulse: ["6M", "6L44", "6S0", "6S1"],
			disable: ["6L35", "6S0"],
			doubleteam: ["6M", "6L5"],
			dragonclaw: ["6M"],
			dragonrush: ["6L63"],
			dreameater: ["6M"],
			embargo: ["6M"],
			facade: ["6M"],
			fly: ["6M"],
			focusblast: ["6M", "6L72"],
			foulplay: ["6L51", "6S1"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			hiddenpower: ["6M"],
			honeclaws: ["6M"],
			hurricane: ["6L1"],
			hyperbeam: ["6M", "6L88"],
			oblivionwing: ["6L26", "6S0", "6S1"],
			phantomforce: ["6L55"],
			protect: ["6M"],
			psychic: ["6M", "6L59"],
			raindance: ["6M"],
			razorwind: ["6L1"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			roost: ["6M", "6L1"],
			round: ["6M"],
			shadowball: ["6M"],
			shadowclaw: ["6M"],
			skyattack: ["6L93"],
			skydrop: ["6M"],
			sleeptalk: ["6M"],
			snarl: ["6M", "6L18", "6S0"],
			steelwing: ["6M"],
			substitute: ["6M"],
			suckerpunch: ["6L80", "6S1"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			taunt: ["6M", "6L1"],
			thief: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	zygarde: {
		inherit: true,
		learnset: {
			bind: ["6L18"],
			bite: ["6L1"],
			brickbreak: ["6M"],
			bulldoze: ["6M", "6L1"],
			camouflage: ["6L59", "6S0"],
			coil: ["6L80"],
			confide: ["6M"],
			crunch: ["6L51", "6S0"],
			dig: ["6M", "6L10"],
			doubleteam: ["6M"],
			dracometeor: ["6T"],
			dragonbreath: ["6L1"],
			dragondance: ["6L72"],
			dragonpulse: ["6L63", "6S0"],
			dragontail: ["6M"],
			earthquake: ["6M", "6L55", "6S0"],
			extremespeed: ["6L88", "6S1"],
			facade: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			glare: ["6L1", "6S1"],
			grassknot: ["6M"],
			haze: ["6L44"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			landswrath: ["6L26", "6S1"],
			outrage: ["6L93", "6S1"],
			protect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L5"],
			sandstorm: ["6M", "6L35"],
			sleeptalk: ["6M"],
			sludgewave: ["6M"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			toxic: ["6M"],
		},
	},
	diancie: {
		inherit: true,
		learnset: {
			ancientpower: ["6L31"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			diamondstorm: ["6L50", "6S0", "6S1"],
			doubleteam: ["6M"],
			explosion: ["6M"],
			facade: ["6M"],
			flail: ["6L35"],
			flash: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			guardsplit: ["6L27"],
			gyroball: ["6M"],
			hail: ["6M"],
			harden: ["6L1"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			lightscreen: ["6M", "6L60"],
			moonblast: ["6L50", "6S0", "6S1"],
			naturepower: ["6M"],
			protect: ["6M"],
			psychic: ["6M"],
			psychup: ["6M"],
			psyshock: ["6M"],
			reflect: ["6M", "6L18", "6S0", "6S1"],
			rest: ["6M"],
			return: ["6M", "6S0", "6S1"],
			rockpolish: ["6M"],
			rockslide: ["6M"],
			rockthrow: ["6L5"],
			rocktomb: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L70"],
			sandstorm: ["6M"],
			sharpen: ["6L8"],
			skillswap: ["6L40"],
			sleeptalk: ["6M"],
			smackdown: ["6M", "6L12"],
			stealthrock: ["6L21"],
			stoneedge: ["6M", "6L49"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			trickroom: ["6M", "6L46"],
		},
	},
	hoopa: {
		inherit: true,
		learnset: {
			allyswitch: ["6L1"],
			astonish: ["6L6", "6S0"],
			brickbreak: ["6M"],
			calmmind: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			confusion: ["6L1"],
			destinybond: ["6L1"],
			doubleteam: ["6M"],
			dreameater: ["6M"],
			embargo: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			fling: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			grassknot: ["6M"],
			guardsplit: ["6L35"],
			hiddenpower: ["6M"],
			hyperbeam: ["6M"],
			hyperspacehole: ["6L1", "6S0"],
			lightscreen: ["6M", "6L19"],
			magiccoat: ["6L10"],
			phantomforce: ["6L46"],
			powersplit: ["6L29"],
			poweruppunch: ["6M"],
			protect: ["6M"],
			psybeam: ["6L15"],
			psychic: ["6M", "6L75", "6S0"],
			psychup: ["6M"],
			psyshock: ["6M"],
			quash: ["6M"],
			raindance: ["6M"],
			reflect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			shadowball: ["6M", "6L68"],
			skillswap: ["6L25"],
			sleeptalk: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			taunt: ["6M"],
			thief: ["6M"],
			thunderbolt: ["6M"],
			thunderwave: ["6M"],
			torment: ["6M"],
			toxic: ["6M"],
			trick: ["6L1"],
			trickroom: ["6M", "6L55"],
			wonderroom: ["6L50"],
		},
	},
	volcanion: {
		inherit: true,
		learnset: {
			bodyslam: ["6L46"],
			brickbreak: ["6M"],
			bulldoze: ["6M"],
			confide: ["6M"],
			cut: ["6M"],
			doubleteam: ["6M"],
			earthquake: ["6M"],
			explosion: ["6M", "6L76", "6S1"],
			facade: ["6M"],
			fireblast: ["6M"],
			flamecharge: ["6M", "6L15"],
			flamethrower: ["6M", "6S1"],
			flareblitz: ["6L1"],
			flashcannon: ["6M"],
			fling: ["6M"],
			focusblast: ["6M"],
			frustration: ["6M"],
			gigaimpact: ["6M"],
			gyroball: ["6M"],
			haze: ["6L11"],
			hiddenpower: ["6M"],
			hydropump: ["6L50", "6S0", "6S1"],
			hyperbeam: ["6M"],
			incinerate: ["6M"],
			mist: ["6L8", "6S0"],
			overheat: ["6M", "6L65", "6S0"],
			protect: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roar: ["6M"],
			rockslide: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			sandstorm: ["6M"],
			scald: ["6M", "6L32"],
			sleeptalk: ["6M"],
			sludgebomb: ["6M"],
			sludgewave: ["6M"],
			smackdown: ["6M"],
			solarbeam: ["6M"],
			steameruption: ["6L1", "6S0", "6S1"],
			stomp: ["6L28"],
			stoneedge: ["6M"],
			strength: ["6M"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			takedown: ["6L1"],
			toxic: ["6M"],
			waterpulse: ["6L21"],
			weatherball: ["6L40"],
			willowisp: ["6M"],
		},
	},
};
